import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Decimal: { input: any; output: any; }
  JSON: { input: any; output: any; }
  Upload: { input: any; output: any; }
};

export enum AbnormalStatusType {
  Pending = 'PENDING',
  SellerAccept = 'SELLER_ACCEPT',
  SellerDepute = 'SELLER_DEPUTE',
  Solved = 'SOLVED'
}

export type AccountMenuItem = {
  __typename?: 'AccountMenuItem';
  icon?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  navigation?: Maybe<NavigationType>;
  preview?: Maybe<Scalars['String']['output']>;
  previewColor?: Maybe<Scalars['String']['output']>;
};

export type AccountMenuSession = {
  __typename?: 'AccountMenuSession';
  items?: Maybe<Array<Maybe<AccountMenuItem>>>;
  name?: Maybe<Scalars['String']['output']>;
};

export type ActivatedPromotion = {
  __typename?: 'ActivatedPromotion';
  amountUsed?: Maybe<Scalars['String']['output']>;
  availability?: Maybe<Scalars['Boolean']['output']>;
  credit?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  message?: Maybe<Scalars['String']['output']>;
  minOrder?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  selected?: Maybe<Scalars['Boolean']['output']>;
  showableMessage?: Maybe<Scalars['Boolean']['output']>;
  store?: Maybe<Supplier>;
  supplierId?: Maybe<Scalars['Int']['output']>;
};

export type Admin = {
  __typename?: 'Admin';
  active?: Maybe<Scalars['Boolean']['output']>;
  balance?: Maybe<Scalars['Float']['output']>;
  balanceHold?: Maybe<Scalars['Float']['output']>;
  bankAccount?: Maybe<Scalars['String']['output']>;
  contact?: Maybe<Scalars['String']['output']>;
  deliveryCreditLimit?: Maybe<Scalars['String']['output']>;
  departmentId?: Maybe<Scalars['Int']['output']>;
  depositAmount?: Maybe<Scalars['String']['output']>;
  depositProof?: Maybe<Scalars['String']['output']>;
  disabledPackageClaim?: Maybe<Scalars['Boolean']['output']>;
  groupID?: Maybe<Scalars['Int']['output']>;
  hourPerWork?: Maybe<Scalars['Float']['output']>;
  id: Scalars['Int']['output'];
  image?: Maybe<Scalars['String']['output']>;
  isProductTeam?: Maybe<Scalars['Boolean']['output']>;
  lastScanTimestamp?: Maybe<Scalars['Float']['output']>;
  monthlyAverageRating?: Maybe<Scalars['Float']['output']>;
  monthlyRatingCount?: Maybe<Scalars['Int']['output']>;
  monthlyUniqueRating?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  partnerPermission?: Maybe<PartnerPermissionType>;
  permissions?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  position?: Maybe<Scalars['String']['output']>;
  qrCode?: Maybe<Scalars['String']['output']>;
  rankingDelivering?: Maybe<Scalars['Int']['output']>;
  rankingPackage?: Maybe<Scalars['Int']['output']>;
  rankingPickup?: Maybe<Scalars['Int']['output']>;
  rankingTransit?: Maybe<Scalars['Int']['output']>;
  recruiterId?: Maybe<Scalars['Int']['output']>;
  role?: Maybe<Scalars['String']['output']>;
  shellStoreGroup?: Maybe<Scalars['Int']['output']>;
  storeId?: Maybe<Scalars['Int']['output']>;
  superAdmin?: Maybe<Scalars['Boolean']['output']>;
  telegram?: Maybe<Scalars['String']['output']>;
  tier?: Maybe<Scalars['Int']['output']>;
  tierRate?: Maybe<Scalars['Float']['output']>;
  tipBankAccountName?: Maybe<Scalars['String']['output']>;
  tipBankAccountNumber?: Maybe<Scalars['String']['output']>;
  tipBankLink?: Maybe<Scalars['String']['output']>;
  username?: Maybe<Scalars['String']['output']>;
  warehouseIds?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  zones?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
};

export type AdminCustomerReview = {
  __typename?: 'AdminCustomerReview';
  comment?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  customer?: Maybe<CustomerBasic>;
  deliverer?: Maybe<Admin>;
  id?: Maybe<Scalars['Int']['output']>;
  rating?: Maybe<Scalars['Int']['output']>;
};

export type AdminGroup = {
  __typename?: 'AdminGroup';
  /** A default landing page for this type of group */
  dashboard?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  permissions?: Maybe<Array<Maybe<AdminGroupPermission>>>;
};

export type AdminGroupPermission = {
  __typename?: 'AdminGroupPermission';
  allowed?: Maybe<Scalars['Boolean']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  group?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  /** Short permission name */
  name?: Maybe<Scalars['String']['output']>;
};

export type AdminGroupPermissionInput = {
  allowed?: InputMaybe<Scalars['Boolean']['input']>;
  /** Permission ID */
  id?: InputMaybe<Scalars['Int']['input']>;
};

export type AdminInput = {
  deliveryCreditLimit?: InputMaybe<Scalars['String']['input']>;
  disabledPackageClaim?: InputMaybe<Scalars['Boolean']['input']>;
  telegram?: InputMaybe<Scalars['String']['input']>;
  tier?: InputMaybe<Scalars['Int']['input']>;
  tipBankAccountName?: InputMaybe<Scalars['String']['input']>;
  tipBankAccountNumber?: InputMaybe<Scalars['String']['input']>;
  tipBankLink?: InputMaybe<Scalars['String']['input']>;
  warehouseIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  zones?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};

export type AdsBannerInput = {
  navigate: Scalars['JSON']['input'];
  src: Scalars['String']['input'];
};

export type AdsBannerOutPut = {
  __typename?: 'AdsBannerOutPut';
  click?: Maybe<Scalars['Int']['output']>;
  navigate?: Maybe<Scalars['JSON']['output']>;
  reach?: Maybe<Scalars['Int']['output']>;
  src?: Maybe<Scalars['String']['output']>;
};

export enum AffiliateAvailableProductOrderBy {
  Commission = 'COMMISSION',
  CreateDate = 'CREATE_DATE',
  Supplier = 'SUPPLIER'
}

export type AffiliateBestSellerType = {
  __typename?: 'AffiliateBestSellerType';
  item?: Maybe<BasicProduct>;
  salesAmount?: Maybe<Scalars['Decimal']['output']>;
  salesQty?: Maybe<Scalars['Int']['output']>;
};

export type AffiliateClaimedInfo = {
  __typename?: 'AffiliateClaimedInfo';
  claimedDate?: Maybe<Scalars['String']['output']>;
  isClaimed?: Maybe<Scalars['Boolean']['output']>;
};

export type AffiliateCustomerOrderItemsListFilter = {
  affiliates?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Array<InputMaybe<AffiliateOrderItemStatus>>>;
  suppliers?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};

export type AffiliateCustomerOrderitemsListSearch = {
  orderUuid?: InputMaybe<Scalars['String']['input']>;
  productCode?: InputMaybe<Scalars['String']['input']>;
};

export type AffiliateDisbursement = {
  __typename?: 'AffiliateDisbursement';
  affiliate?: Maybe<Customer>;
  amount?: Maybe<Scalars['Decimal']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  exportedAt?: Maybe<Scalars['String']['output']>;
  exportedBy?: Maybe<Admin>;
  id?: Maybe<Scalars['Int']['output']>;
  orderItems?: Maybe<Array<Maybe<CustomerOrderItemAffiliate>>>;
  paidAt?: Maybe<Scalars['String']['output']>;
  paidBy?: Maybe<Admin>;
  paymentBatch?: Maybe<Scalars['Int']['output']>;
  proof?: Maybe<Scalars['String']['output']>;
  status?: Maybe<AffiliateDisbursementStatus>;
  verifiedAt?: Maybe<Scalars['String']['output']>;
  verifiedBy?: Maybe<Admin>;
};


export type AffiliateDisbursementOrderItemsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type AffiliateDisbursementList = {
  __typename?: 'AffiliateDisbursementList';
  data?: Maybe<Array<Maybe<AffiliateDisbursement>>>;
  totalAmount?: Maybe<Scalars['Decimal']['output']>;
  totalRows?: Maybe<Scalars['Int']['output']>;
};

export enum AffiliateDisbursementStatus {
  Exported = 'EXPORTED',
  Paid = 'PAID',
  Pending = 'PENDING',
  Verified = 'VERIFIED'
}

export type AffiliateInfoInput = {
  bankAccountName?: InputMaybe<Scalars['String']['input']>;
  bankAccountNumber?: InputMaybe<Scalars['String']['input']>;
  bankName?: InputMaybe<Scalars['String']['input']>;
};

export enum AffiliateOrderItemStatus {
  Cancelled = 'CANCELLED',
  Completed = 'COMPLETED',
  Delivered = 'DELIVERED',
  Paid = 'PAID',
  Unpaid = 'UNPAID'
}

export enum AffiliatePaymentStatus {
  Available = 'AVAILABLE',
  Paid = 'PAID',
  Snapshot = 'SNAPSHOT'
}

export type AffiliateProduct = {
  __typename?: 'AffiliateProduct';
  affiliate?: Maybe<Customer>;
  claimType?: Maybe<AffiliateProductClaimType>;
  commission?: Maybe<Scalars['Decimal']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  product?: Maybe<BasicProduct>;
  sales?: Maybe<SalesInfo>;
  supplier?: Maybe<Supplier>;
};

export enum AffiliateProductClaimType {
  Affiliate = 'AFFILIATE',
  Seller = 'SELLER'
}

export type AffiliateProductInput = {
  affiliateId?: InputMaybe<Scalars['Int']['input']>;
  commission?: InputMaybe<Scalars['Decimal']['input']>;
  itemId?: InputMaybe<Scalars['Int']['input']>;
  supplierId?: InputMaybe<Scalars['Int']['input']>;
};

export type AffiliateProductListFilter = {
  affiliateId?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
  supplierId?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};

export type AffiliateProductListSearch = {
  id?: InputMaybe<Scalars['Int']['input']>;
  productCode?: InputMaybe<Scalars['String']['input']>;
  productTitle?: InputMaybe<Scalars['String']['input']>;
};

export enum AffiliateProductListSortBy {
  CreatedDate = 'CREATED_DATE',
  SalesAmount = 'SALES_AMOUNT'
}

export enum AffiliateProductOrderBy {
  MostSales = 'MOST_SALES',
  RecentlyClaimed = 'RECENTLY_CLAIMED'
}

export type AffiliateProductPublicInput = {
  commission?: InputMaybe<Scalars['Float']['input']>;
  productId?: InputMaybe<Scalars['Int']['input']>;
};

export type AffiliateProductPublicItem = {
  __typename?: 'AffiliateProductPublicItem';
  commission?: Maybe<Scalars['Float']['output']>;
  createdDate?: Maybe<Scalars['String']['output']>;
  isClaimed?: Maybe<Scalars['Boolean']['output']>;
  product?: Maybe<BasicProduct>;
  requestDelete?: Maybe<Scalars['String']['output']>;
  supplier?: Maybe<Supplier>;
  updatedDate?: Maybe<Scalars['String']['output']>;
};

export type AffiliateProductSales = {
  __typename?: 'AffiliateProductSales';
  addedToCart?: Maybe<Scalars['Int']['output']>;
  earned?: Maybe<Scalars['Float']['output']>;
  lastSold?: Maybe<Scalars['String']['output']>;
  linkClicks?: Maybe<Scalars['Int']['output']>;
  orders?: Maybe<Scalars['Int']['output']>;
  paid?: Maybe<Scalars['Float']['output']>;
  product?: Maybe<DisplayProduct>;
  sales?: Maybe<Scalars['Float']['output']>;
};

export type AffiliateProductSalesList = {
  __typename?: 'AffiliateProductSalesList';
  addedToCart?: Maybe<Scalars['Int']['output']>;
  available?: Maybe<Scalars['Float']['output']>;
  earned?: Maybe<Scalars['Float']['output']>;
  linkClicks?: Maybe<Scalars['Int']['output']>;
  orders?: Maybe<Scalars['Int']['output']>;
  paid?: Maybe<Scalars['Float']['output']>;
  products?: Maybe<Array<Maybe<AffiliateProductSales>>>;
  sales?: Maybe<Scalars['Float']['output']>;
};

export type AffliateCustomerOrderItems = {
  __typename?: 'AffliateCustomerOrderItems';
  affiliateProduct?: Maybe<AffiliateProduct>;
  commission?: Maybe<Scalars['Decimal']['output']>;
  item?: Maybe<CustomerOrderItemV2>;
  status?: Maybe<AffiliateOrderItemStatus>;
};

export type Agent = {
  __typename?: 'Agent';
  active?: Maybe<Scalars['Boolean']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  distanceFromCurrentLocation?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  province?: Maybe<Scalars['String']['output']>;
  username?: Maybe<Scalars['String']['output']>;
};

export type AgentCommission = {
  __typename?: 'AgentCommission';
  commission?: Maybe<Scalars['Float']['output']>;
};

export enum AgentDisbursedStatus {
  Completed = 'COMPLETED',
  Pending = 'PENDING',
  Verified = 'VERIFIED'
}

export type AgentDisbursement = {
  __typename?: 'AgentDisbursement';
  agent?: Maybe<Admin>;
  bankInfo?: Maybe<Scalars['JSON']['output']>;
  completedAt?: Maybe<Scalars['String']['output']>;
  completedBy?: Maybe<Admin>;
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Admin>;
  id?: Maybe<Scalars['Int']['output']>;
  proofImage?: Maybe<Scalars['String']['output']>;
  status?: Maybe<AgentDisbursedStatus>;
  totalFee?: Maybe<Scalars['Decimal']['output']>;
  verifiedAt?: Maybe<Scalars['String']['output']>;
  verifiedBy?: Maybe<Admin>;
};

export type AgentFeeDetail = {
  __typename?: 'AgentFeeDetail';
  createdAt?: Maybe<Scalars['String']['output']>;
  fee?: Maybe<Scalars['Decimal']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  packageId?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type AgentFilter = {
  agentPackageStatus?: InputMaybe<AgentPackageStatus>;
  nextHubId?: InputMaybe<Scalars['Int']['input']>;
};

export type AgentList = {
  __typename?: 'AgentList';
  all?: Maybe<Array<Maybe<Agent>>>;
  nearest?: Maybe<Array<Maybe<Agent>>>;
};

export enum AgentPackageStatus {
  Arrived = 'ARRIVED',
  Draft = 'DRAFT',
  Incoming = 'INCOMING',
  Outgoing = 'OUTGOING'
}

export type AgentRegisterInput = {
  lat?: InputMaybe<Scalars['Float']['input']>;
  lng?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
};

export type AllAppVersion = {
  __typename?: 'AllAppVersion';
  business?: Maybe<AppVersion>;
  l192?: Maybe<AppVersion>;
  work?: Maybe<AppVersion>;
};

export type AppDiscoverySource = {
  deviceInfo?: InputMaybe<Scalars['String']['input']>;
  source: Scalars['String']['input'];
};

export enum AppNotificationType {
  Customer = 'CUSTOMER',
  Seller = 'SELLER'
}

export type AppVersion = {
  __typename?: 'AppVersion';
  androidLatest?: Maybe<Scalars['String']['output']>;
  canUpdate?: Maybe<Scalars['Boolean']['output']>;
  iosLatest?: Maybe<Scalars['String']['output']>;
  requireUpdate?: Maybe<Scalars['Boolean']['output']>;
};

export enum AppointedDay {
  Today = 'TODAY',
  Tomorrow = 'TOMORROW',
  Yesterday = 'YESTERDAY'
}

export type Attachment = {
  __typename?: 'Attachment';
  height?: Maybe<Scalars['Int']['output']>;
  lat?: Maybe<Scalars['String']['output']>;
  lng?: Maybe<Scalars['String']['output']>;
  orderId?: Maybe<Scalars['Int']['output']>;
  src?: Maybe<Scalars['String']['output']>;
  type?: Maybe<AttachmentType>;
  waveform?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  width?: Maybe<Scalars['Int']['output']>;
};

export type AttachmentInput = {
  height?: InputMaybe<Scalars['Int']['input']>;
  lat?: InputMaybe<Scalars['String']['input']>;
  lng?: InputMaybe<Scalars['String']['input']>;
  orderId?: InputMaybe<Scalars['Int']['input']>;
  src?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<AttachmentType>;
  waveform?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  width?: InputMaybe<Scalars['Int']['input']>;
};

export enum AttachmentType {
  Audio = 'AUDIO',
  CustomerOrder = 'CUSTOMER_ORDER',
  File = 'FILE',
  Image = 'IMAGE',
  Location = 'LOCATION',
  Package = 'PACKAGE',
  Product = 'PRODUCT'
}

export type AvailableAffiliateBalanceList = {
  __typename?: 'AvailableAffiliateBalanceList';
  affiliate?: Maybe<Customer>;
  balance?: Maybe<Scalars['Float']['output']>;
  payment?: Maybe<SupplierPaymentHistory>;
  snapshotDate?: Maybe<Scalars['String']['output']>;
  snapshotId?: Maybe<Scalars['Int']['output']>;
  transferredDate?: Maybe<Scalars['String']['output']>;
};

export type AvailableForAgentDisbursement = {
  __typename?: 'AvailableForAgentDisbursement';
  agent?: Maybe<Admin>;
  packageCount?: Maybe<Scalars['Int']['output']>;
  totalFee?: Maybe<Scalars['Decimal']['output']>;
};

export enum BalanceStatusType {
  Available = 'AVAILABLE',
  Hold = 'HOLD',
  Total = 'TOTAL'
}

export enum BalanceType {
  Available = 'AVAILABLE',
  Hold = 'HOLD',
  Total = 'TOTAL'
}

export type BankInfoInput = {
  Qrcode?: InputMaybe<Scalars['String']['input']>;
  bankAccHolderName?: InputMaybe<Scalars['String']['input']>;
  bankAccNumber?: InputMaybe<Scalars['String']['input']>;
  bankName?: InputMaybe<Scalars['String']['input']>;
};

export type BankInfomation = {
  __typename?: 'BankInfomation';
  accountName?: Maybe<Scalars['String']['output']>;
  accountNumber?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export enum BankTransferProofStatusType {
  ApprovedByAccountant = 'APPROVED_BY_ACCOUNTANT',
  ApprovedByOnline = 'APPROVED_BY_ONLINE',
  Pending = 'PENDING',
  RejectedByAccountant = 'REJECTED_BY_ACCOUNTANT',
  RejectedByOnline = 'REJECTED_BY_ONLINE'
}

export type Banner = {
  __typename?: 'Banner';
  banners?: Maybe<Array<Maybe<BannerType>>>;
  navigate?: Maybe<Scalars['JSON']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type BannerInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  image?: InputMaybe<Scalars['String']['input']>;
  navigate?: InputMaybe<Scalars['JSON']['input']>;
  priority?: InputMaybe<Scalars['Int']['input']>;
};

export type BannerMange = {
  __typename?: 'BannerMange';
  active?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  image?: Maybe<Scalars['String']['output']>;
  navigate?: Maybe<Scalars['JSON']['output']>;
  priority?: Maybe<Scalars['Int']['output']>;
};

export type BannerType = {
  __typename?: 'BannerType';
  id?: Maybe<Scalars['Int']['output']>;
  navigate?: Maybe<Scalars['JSON']['output']>;
  trackLink?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type BarcodeProduct = {
  __typename?: 'BarcodeProduct';
  code?: Maybe<Scalars['String']['output']>;
  color?: Maybe<Scalars['String']['output']>;
  itemID?: Maybe<Scalars['Int']['output']>;
  size?: Maybe<Scalars['String']['output']>;
  skuID: Scalars['Int']['output'];
};

export type BasicProduct = {
  __typename?: 'BasicProduct';
  boxSize?: Maybe<Scalars['String']['output']>;
  code?: Maybe<Scalars['String']['output']>;
  /** Get this product review from current customer */
  currentCustomerReview?: Maybe<ProductReview>;
  /** The dimension size equal x * y * z dimension */
  dimensionSize?: Maybe<Scalars['Float']['output']>;
  discount?: Maybe<Scalars['Float']['output']>;
  freeDelivery?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  inputDate?: Maybe<Scalars['String']['output']>;
  isRestock?: Maybe<Scalars['Boolean']['output']>;
  itemUrl?: Maybe<Scalars['String']['output']>;
  lastStockDate?: Maybe<Scalars['String']['output']>;
  mark?: Maybe<Scalars['String']['output']>;
  originalPicture?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['Decimal']['output']>;
  priceAfterDiscount?: Maybe<Scalars['Float']['output']>;
  ratingCount?: Maybe<Scalars['Int']['output']>;
  ratingScore?: Maybe<Scalars['Float']['output']>;
  remoted?: Maybe<Scalars['Boolean']['output']>;
  sizeStandard?: Maybe<Scalars['String']['output']>;
  sourcePrice?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  stock?: Maybe<Scalars['Int']['output']>;
  supplier?: Maybe<Supplier>;
  supplierCode?: Maybe<Scalars['String']['output']>;
  thumbnail?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  uploadedVideo?: Maybe<Scalars['String']['output']>;
  verifiedSize?: Maybe<Scalars['Boolean']['output']>;
  weight?: Maybe<Scalars['Float']['output']>;
};


export type BasicProductThumbnailArgs = {
  height?: InputMaybe<Scalars['Int']['input']>;
  width?: InputMaybe<Scalars['Int']['input']>;
};

export type BlockCustomer = {
  __typename?: 'BlockCustomer';
  blockedDate?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
};

export type Brand = {
  __typename?: 'Brand';
  active?: Maybe<Scalars['Boolean']['output']>;
  alias?: Maybe<Scalars['String']['output']>;
  banner?: Maybe<Scalars['String']['output']>;
  category?: Maybe<Array<Maybe<Category>>>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  lifeStylePicture?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  picture?: Maybe<Scalars['String']['output']>;
  status?: Maybe<BrandStatus>;
  storeCount?: Maybe<Scalars['Int']['output']>;
  tabs?: Maybe<Array<Maybe<BrandTabs>>>;
  verified?: Maybe<Scalars['Boolean']['output']>;
};

export type BrandInput = {
  alias?: InputMaybe<Scalars['String']['input']>;
  banner?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  picture?: InputMaybe<Scalars['String']['input']>;
};

export enum BrandStatus {
  Approved = 'APPROVED',
  Rejected = 'REJECTED',
  Reviewing = 'REVIEWING'
}

export type BrandTabs = {
  __typename?: 'BrandTabs';
  title?: Maybe<Scalars['String']['output']>;
  webView?: Maybe<Scalars['String']['output']>;
};

export type CallToAction = {
  __typename?: 'CallToAction';
  backgroundColor?: Maybe<Scalars['String']['output']>;
  icon?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  navigation?: Maybe<Scalars['JSON']['output']>;
  numberIndicator?: Maybe<Scalars['Int']['output']>;
  progressBackgroundColor?: Maybe<Scalars['String']['output']>;
  progressCompleteColor?: Maybe<Scalars['String']['output']>;
  progressTotal?: Maybe<Scalars['Int']['output']>;
  progressValue?: Maybe<Scalars['Int']['output']>;
  subtitle?: Maybe<Scalars['String']['output']>;
  thumbnail?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  type?: Maybe<CallToActionType>;
};

export enum CallToActionType {
  IncompleteProfile = 'INCOMPLETE_PROFILE',
  LinkAbaAccount = 'LINK_ABA_ACCOUNT',
  Other = 'OTHER',
  PackageRating = 'PACKAGE_RATING',
  ProductReview = 'PRODUCT_REVIEW',
  UpdateNewApp = 'UPDATE_NEW_APP'
}

export enum CambodiaPhoneOperator {
  Cellcard = 'CELLCARD',
  Metfone = 'METFONE',
  Seatel = 'SEATEL',
  Smart = 'SMART'
}

export type CampaignTracker = {
  __typename?: 'CampaignTracker';
  budget?: Maybe<Scalars['Decimal']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Admin>;
  end?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  initialBy?: Maybe<Admin>;
  name?: Maybe<Scalars['String']['output']>;
  page?: Maybe<Scalars['String']['output']>;
  productCount?: Maybe<Scalars['Int']['output']>;
  reference?: Maybe<Scalars['String']['output']>;
  sales?: Maybe<Scalars['String']['output']>;
  salesDeleted?: Maybe<Scalars['String']['output']>;
  sold?: Maybe<Scalars['String']['output']>;
  start?: Maybe<Scalars['String']['output']>;
  totalBudget?: Maybe<Scalars['String']['output']>;
  totalSales?: Maybe<Scalars['String']['output']>;
  totalSold?: Maybe<Scalars['String']['output']>;
};

export type CampaignTrackerInput = {
  budget?: InputMaybe<Scalars['Decimal']['input']>;
  end?: InputMaybe<Scalars['String']['input']>;
  initialBy?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['String']['input']>;
  reference?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['String']['input']>;
};

export enum CampaignTrackerOrder {
  Latest = 'LATEST',
  Sales = 'SALES',
  Score = 'SCORE'
}

export type CampaignTrackerProduct = {
  __typename?: 'CampaignTrackerProduct';
  code?: Maybe<Scalars['String']['output']>;
  currentQty?: Maybe<Scalars['Int']['output']>;
  currentRetailValue?: Maybe<Scalars['Decimal']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  initialQty?: Maybe<Scalars['Int']['output']>;
  initialRetailValue?: Maybe<Scalars['Decimal']['output']>;
  picture?: Maybe<Scalars['String']['output']>;
  productId?: Maybe<Scalars['Int']['output']>;
  sales?: Maybe<Scalars['String']['output']>;
  salesDeleted?: Maybe<Scalars['String']['output']>;
  sold?: Maybe<Scalars['String']['output']>;
};

export type Card = {
  __typename?: 'Card';
  brand: Scalars['String']['output'];
  id: Scalars['String']['output'];
  last4: Scalars['String']['output'];
};

export type Cart = {
  __typename?: 'Cart';
  actualDeliveryFee?: Maybe<Scalars['String']['output']>;
  address?: Maybe<CustomerAddress>;
  coordinate?: Maybe<MapCoordinate>;
  customerId?: Maybe<Scalars['Int']['output']>;
  deliveryAddress?: Maybe<Scalars['String']['output']>;
  deliveryFee?: Maybe<Scalars['String']['output']>;
  deliveryFeeDiscount?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Array<Maybe<CartDescription>>>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  groups?: Maybe<Array<Maybe<CartItemGroup>>>;
  isThirdParty?: Maybe<Scalars['Boolean']['output']>;
  items?: Maybe<Array<Maybe<CartItem>>>;
  note?: Maybe<Scalars['String']['output']>;
  paymentMethod?: Maybe<OnlinePaymentType>;
  paymentOptionList?: Maybe<PaymentOptionList>;
  pickup?: Maybe<Warehouse>;
  promo?: Maybe<ActivatedPromotion>;
  promoCodeDiscount?: Maybe<Scalars['Float']['output']>;
  promoComboSnipshot?: Maybe<Scalars['JSON']['output']>;
  savingPointCost?: Maybe<Scalars['Int']['output']>;
  showableMessage?: Maybe<Scalars['Boolean']['output']>;
  templateId?: Maybe<Scalars['Int']['output']>;
  total?: Maybe<Scalars['String']['output']>;
  totalBeforeDiscount?: Maybe<Scalars['String']['output']>;
  totalDiscount?: Maybe<Scalars['String']['output']>;
  totalExclusiveDiscount?: Maybe<Scalars['Float']['output']>;
  totalVolume?: Maybe<Scalars['Float']['output']>;
  totalWeight?: Maybe<Scalars['Float']['output']>;
};

export type CartDescription = {
  __typename?: 'CartDescription';
  amount?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
};

export type CartItem = {
  __typename?: 'CartItem';
  admin?: Maybe<Admin>;
  affiliateId?: Maybe<Scalars['Int']['output']>;
  code?: Maybe<Scalars['String']['output']>;
  color?: Maybe<Scalars['String']['output']>;
  /** Discount using customer discount */
  exclusiveDiscount?: Maybe<Scalars['Float']['output']>;
  id: Scalars['Int']['output'];
  inputDate?: Maybe<Scalars['String']['output']>;
  isSelected?: Maybe<Scalars['Boolean']['output']>;
  /** Discount amount from other factor besides promo code discount */
  otherDiscountAmount?: Maybe<Scalars['Float']['output']>;
  picture?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['String']['output']>;
  priceBeforeDiscount?: Maybe<Scalars['String']['output']>;
  productID?: Maybe<Scalars['Int']['output']>;
  /** Discount that come from promo code */
  promoCodeDiscountAmount?: Maybe<Scalars['Float']['output']>;
  promoComboDeliveryFee?: Maybe<Scalars['Float']['output']>;
  promoComboId?: Maybe<Scalars['Int']['output']>;
  qty?: Maybe<Scalars['Int']['output']>;
  size?: Maybe<Scalars['String']['output']>;
  skuId?: Maybe<Scalars['Int']['output']>;
  /** True if the promo code is covered by seller */
  supplierCoverPromoCode?: Maybe<Scalars['Boolean']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  titles?: Maybe<MultiLangString>;
  undeletable?: Maybe<Scalars['Boolean']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
  weight?: Maybe<Scalars['Float']['output']>;
};

export type CartItemGroup = {
  __typename?: 'CartItemGroup';
  deliveryFee?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  icon?: Maybe<Scalars['String']['output']>;
  items?: Maybe<Array<Maybe<CartItem>>>;
  title?: Maybe<Scalars['String']['output']>;
};

export type CartItemInput = {
  color: Scalars['String']['input'];
  productID: Scalars['Int']['input'];
  qty: Scalars['Int']['input'];
  size: Scalars['String']['input'];
};

export type CartItemLog = {
  __typename?: 'CartItemLog';
  color?: Maybe<Scalars['String']['output']>;
  creator?: Maybe<Admin>;
  product?: Maybe<BasicProduct>;
  qty?: Maybe<Scalars['Int']['output']>;
  size?: Maybe<Scalars['String']['output']>;
  skuId?: Maybe<Scalars['Int']['output']>;
};

export type CartLogOperation = {
  __typename?: 'CartLogOperation';
  action?: Maybe<Scalars['String']['output']>;
  cartItem?: Maybe<CartItemLog>;
};

export type CartOptionInput = {
  activatedPromoId?: InputMaybe<Scalars['Int']['input']>;
  addressId?: InputMaybe<Scalars['Int']['input']>;
  coordinate?: InputMaybe<Coordinate>;
  orderDraftId?: InputMaybe<Scalars['Int']['input']>;
  paymentMethod?: InputMaybe<OnlinePaymentType>;
  pickupId?: InputMaybe<Scalars['Int']['input']>;
  templateId?: InputMaybe<Scalars['Int']['input']>;
};

export type CartPreview = {
  __typename?: 'CartPreview';
  items?: Maybe<Array<Maybe<CartItem>>>;
  token?: Maybe<Scalars['String']['output']>;
};

export type Category = {
  __typename?: 'Category';
  active?: Maybe<Scalars['Boolean']['output']>;
  currentLanguageName?: Maybe<Scalars['String']['output']>;
  exposed?: Maybe<Scalars['Boolean']['output']>;
  icon?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  isVerified?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<MultiLangString>;
  note?: Maybe<Scalars['String']['output']>;
  order?: Maybe<Scalars['Int']['output']>;
  /** @deprecated Make the ID to Id to be consistance */
  parentID?: Maybe<Scalars['Int']['output']>;
  parentId?: Maybe<Scalars['Int']['output']>;
  rootCategory?: Maybe<Scalars['Int']['output']>;
  secondRoot?: Maybe<Scalars['Int']['output']>;
  subCategory?: Maybe<Scalars['String']['output']>;
};

export type CategoryAnalytic = {
  __typename?: 'CategoryAnalytic';
  active?: Maybe<Scalars['Int']['output']>;
  category?: Maybe<Category>;
  inStock?: Maybe<Scalars['Int']['output']>;
  sale?: Maybe<Scalars['Decimal']['output']>;
};

export type CategoryCatalogue = {
  __typename?: 'CategoryCatalogue';
  content?: Maybe<Scalars['JSON']['output']>;
  id: Scalars['Int']['output'];
  image?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type CategoryInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  exposed?: InputMaybe<Scalars['Boolean']['input']>;
  icon?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<MultiLangStringInput>;
  note?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  parentID?: InputMaybe<Scalars['Int']['input']>;
};

export type ChatChannel = {
  __typename?: 'ChatChannel';
  additionEntityInfo?: Maybe<Entity>;
  channel?: Maybe<Scalars['String']['output']>;
  entityType?: Maybe<ChatType>;
  image?: Maybe<Scalars['String']['output']>;
  lastMessage?: Maybe<ChatMessageContent>;
  lastMessageAt?: Maybe<Scalars['Int']['output']>;
  lastMessageEntity?: Maybe<Entity>;
  lastSeenMessageAt?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  onlineStatus?: Maybe<Scalars['String']['output']>;
  requiredAdminSupport?: Maybe<Scalars['Boolean']['output']>;
  supplier?: Maybe<Supplier>;
  unread?: Maybe<Scalars['Int']['output']>;
};

export type ChatChannelPartner = {
  __typename?: 'ChatChannelPartner';
  chatChannel?: Maybe<ChatChannel>;
  supplier?: Maybe<Supplier>;
};

export type ChatChannelSeen = {
  __typename?: 'ChatChannelSeen';
  entity?: Maybe<Entity>;
  lastSeenTimestamp?: Maybe<Scalars['Int']['output']>;
};

export type ChatMessage = {
  __typename?: 'ChatMessage';
  channel?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  message?: Maybe<ChatMessageContent>;
  onlineStatus?: Maybe<Scalars['String']['output']>;
  replyTo?: Maybe<ChatMessage>;
  sender?: Maybe<Entity>;
  sentBy?: Maybe<CustomerBasic>;
};

export type ChatMessageContent = {
  __typename?: 'ChatMessageContent';
  attachments?: Maybe<Array<Maybe<Attachment>>>;
  packageId?: Maybe<Scalars['Int']['output']>;
  product?: Maybe<BasicProduct>;
  productId?: Maybe<Scalars['Int']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  uuid?: Maybe<Scalars['String']['output']>;
};

export type ChatMessageInput = {
  attachments?: InputMaybe<Array<InputMaybe<AttachmentInput>>>;
  packageId?: InputMaybe<Scalars['Int']['input']>;
  productId?: InputMaybe<Scalars['Int']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
  uuid?: InputMaybe<Scalars['String']['input']>;
};

export enum ChatType {
  Customer = 'CUSTOMER',
  CustomerNonApp = 'CUSTOMER_NON_APP',
  Seller = 'SELLER'
}

export type CheckPaymentStatus = {
  __typename?: 'CheckPaymentStatus';
  /** If we have received the payment */
  internalSuccess?: Maybe<Scalars['Boolean']['output']>;
  /** Endpoint to do callback to */
  pushBackEndpoint?: Maybe<Scalars['String']['output']>;
  pushBackPayload?: Maybe<Scalars['String']['output']>;
  /** If it is success at the bank side */
  success?: Maybe<Scalars['Boolean']['output']>;
};

export enum CheckType {
  AfterCheckout = 'AFTER_CHECKOUT',
  AfterLogin = 'AFTER_LOGIN'
}

export type CheckoutInput = {
  activatedPromoID?: InputMaybe<Scalars['Int']['input']>;
  card_id?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<Location>;
  method?: InputMaybe<Scalars['String']['input']>;
  save?: InputMaybe<Scalars['Boolean']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
};

export type CheckoutV2 = {
  __typename?: 'CheckoutV2';
  orderId?: Maybe<Scalars['Int']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type ClearanceStock = {
  __typename?: 'ClearanceStock';
  active?: Maybe<Scalars['Boolean']['output']>;
  click?: Maybe<Scalars['Int']['output']>;
  createdDate?: Maybe<Scalars['String']['output']>;
  discount?: Maybe<Scalars['String']['output']>;
  endDate?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  originalDiscount?: Maybe<Scalars['String']['output']>;
  product?: Maybe<BasicProduct>;
  reach?: Maybe<Scalars['Int']['output']>;
  removeDate?: Maybe<Scalars['String']['output']>;
  sales?: Maybe<Scalars['String']['output']>;
  startData?: Maybe<Scalars['String']['output']>;
};

export type ClearanceStockInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  discount?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  itemId: Scalars['Int']['input'];
  originalDiscount?: InputMaybe<Scalars['String']['input']>;
  removeDate?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
};

export type ClearanceStockList = {
  __typename?: 'ClearanceStockList';
  data?: Maybe<Array<Maybe<ClearanceStock>>>;
  page?: Maybe<Pagination>;
};

export enum ClearanceStockStatus {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE'
}

export type Comment = {
  __typename?: 'Comment';
  commentID?: Maybe<Scalars['String']['output']>;
  content?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  facebookID?: Maybe<Scalars['String']['output']>;
  handled?: Maybe<Scalars['Boolean']['output']>;
  handledAt?: Maybe<Scalars['String']['output']>;
  handledBy?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  pageID?: Maybe<Scalars['String']['output']>;
  postID?: Maybe<Scalars['String']['output']>;
  profilePicture?: Maybe<Scalars['String']['output']>;
  type?: Maybe<FacebookPostType>;
};

export enum CommentSortType {
  Earliest = 'EARLIEST',
  Latest = 'LATEST'
}

export type Commune = {
  __typename?: 'Commune';
  communeCode?: Maybe<Scalars['String']['output']>;
  districtCode?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  provinceCode?: Maybe<Scalars['String']['output']>;
};

export type ContentImageInput = {
  color?: InputMaybe<Scalars['String']['input']>;
  src?: InputMaybe<Scalars['String']['input']>;
};

export type ContentInput = {
  appOnly?: InputMaybe<TrueFalse>;
  brandid?: InputMaybe<Scalars['Int']['input']>;
  categoryid?: InputMaybe<Scalars['Int']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  colorBinding?: InputMaybe<Scalars['String']['input']>;
  colors?: InputMaybe<Scalars['String']['input']>;
  consumable?: InputMaybe<TrueFalse>;
  description?: InputMaybe<Scalars['String']['input']>;
  dimensionHeight?: InputMaybe<Scalars['String']['input']>;
  dimensionLength: Scalars['String']['input'];
  dimensionWidth?: InputMaybe<Scalars['String']['input']>;
  images?: InputMaybe<Array<InputMaybe<ContentImageInput>>>;
  item_id?: InputMaybe<Scalars['Int']['input']>;
  keyword?: InputMaybe<Scalars['String']['input']>;
  needFreezer?: InputMaybe<TrueFalse>;
  picture?: InputMaybe<Scalars['String']['input']>;
  remoteStock?: InputMaybe<TrueFalse>;
  remoteStockDurationFrom?: InputMaybe<Scalars['Int']['input']>;
  remoteStockDurationTo?: InputMaybe<Scalars['Int']['input']>;
  returnable?: InputMaybe<TrueFalse>;
  salePrice?: InputMaybe<Scalars['String']['input']>;
  sizes?: InputMaybe<Scalars['String']['input']>;
  sku?: InputMaybe<Array<InputMaybe<ContentSkuInput>>>;
  supplierCode?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  vendorid?: InputMaybe<Scalars['Int']['input']>;
  video?: InputMaybe<Scalars['String']['input']>;
  weight?: InputMaybe<Scalars['String']['input']>;
};

export type ContentInputV2 = {
  brand_id?: InputMaybe<Scalars['Int']['input']>;
  category_id?: InputMaybe<Scalars['Int']['input']>;
  color_binding?: InputMaybe<Scalars['String']['input']>;
  colours?: InputMaybe<Scalars['String']['input']>;
  condition?: InputMaybe<ProductCondition>;
  consumable?: InputMaybe<TrueFalse>;
  description?: InputMaybe<Scalars['String']['input']>;
  dimension_height?: InputMaybe<Scalars['Float']['input']>;
  dimension_length?: InputMaybe<Scalars['Float']['input']>;
  dimension_width?: InputMaybe<Scalars['Float']['input']>;
  images?: InputMaybe<Array<InputMaybe<ContentImageInput>>>;
  item_id?: InputMaybe<Scalars['Int']['input']>;
  item_url?: InputMaybe<Scalars['String']['input']>;
  need_freezer?: InputMaybe<TrueFalse>;
  original_price?: InputMaybe<Scalars['String']['input']>;
  picture?: InputMaybe<Scalars['String']['input']>;
  remote_stock?: InputMaybe<TrueFalse>;
  remote_stock_duration_from?: InputMaybe<Scalars['Int']['input']>;
  remote_stock_duration_to?: InputMaybe<Scalars['Int']['input']>;
  returnable?: InputMaybe<TrueFalse>;
  saleprice?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['String']['input']>;
  sku_barcode?: InputMaybe<Array<InputMaybe<ContentSkuInput>>>;
  source_price?: InputMaybe<Scalars['String']['input']>;
  supplier_code?: InputMaybe<Scalars['String']['input']>;
  supplier_vendor_id?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  video?: InputMaybe<Scalars['String']['input']>;
  weight?: InputMaybe<Scalars['Float']['input']>;
};

export type ContentSkuInput = {
  barcode?: InputMaybe<Scalars['String']['input']>;
  color?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['String']['input']>;
};

export type Coordinate = {
  lat?: InputMaybe<Scalars['String']['input']>;
  lng?: InputMaybe<Scalars['String']['input']>;
};

export type CoreProduct = {
  __typename?: 'CoreProduct';
  isCore?: Maybe<Scalars['Boolean']['output']>;
  product?: Maybe<BasicProduct>;
};

export enum Currency {
  Baht = 'BAHT',
  Dong = 'DONG',
  Rmb = 'RMB',
  Usd = 'USD'
}

export type CustomPage = {
  __typename?: 'CustomPage';
  content?: Maybe<Scalars['JSON']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  index?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  priority?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<CustomPageType>;
};

export type CustomPageInput = {
  content?: InputMaybe<Scalars['JSON']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  priority?: InputMaybe<Scalars['Int']['input']>;
};

export enum CustomPageType {
  Page = 'PAGE',
  Tab = 'TAB'
}

export type CustomReport = {
  __typename?: 'CustomReport';
  description?: Maybe<Scalars['String']['output']>;
  favorite?: Maybe<Scalars['Boolean']['output']>;
  footer?: Maybe<Scalars['JSON']['output']>;
  formatter?: Maybe<Scalars['JSON']['output']>;
  group?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  isSystemReport?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  /** JSON format in string */
  params?: Maybe<Scalars['JSON']['output']>;
  query?: Maybe<Scalars['String']['output']>;
};

export type CustomReportInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  footer?: InputMaybe<Scalars['JSON']['input']>;
  formatter?: InputMaybe<Scalars['JSON']['input']>;
  group?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  params?: InputMaybe<Scalars['JSON']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
};

export type Customer = {
  __typename?: 'Customer';
  active?: Maybe<Scalars['Boolean']['output']>;
  affiliateBankInfo?: Maybe<BankInfomation>;
  affiliateId?: Maybe<Scalars['Int']['output']>;
  affiliateRegisteredDate?: Maybe<Scalars['String']['output']>;
  balance?: Maybe<Scalars['String']['output']>;
  /** @deprecated Inconsistent field case */
  balance_khr?: Maybe<Scalars['String']['output']>;
  bio?: Maybe<Scalars['String']['output']>;
  blockedInfo?: Maybe<BlockCustomer>;
  cards?: Maybe<Array<Maybe<Card>>>;
  dateOfBirth?: Maybe<Scalars['String']['output']>;
  defaultAddress?: Maybe<CustomerAddress>;
  defaultAddressId?: Maybe<Scalars['Int']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  gender?: Maybe<Gender>;
  id: Scalars['Int']['output'];
  idCard?: Maybe<Scalars['String']['output']>;
  isBetaTesting?: Maybe<Scalars['Int']['output']>;
  isSurvey?: Maybe<Scalars['Boolean']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  loan?: Maybe<Scalars['String']['output']>;
  membership?: Maybe<Scalars['String']['output']>;
  membershipType?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  profilePicture?: Maybe<Scalars['String']['output']>;
  savingPoint?: Maybe<Scalars['Float']['output']>;
  spend?: Maybe<Scalars['String']['output']>;
};

export type CustomerAdditionalStat = {
  __typename?: 'CustomerAdditionalStat';
  totalReviewCount?: Maybe<Scalars['Int']['output']>;
  totalReviewHelpfulCount?: Maybe<Scalars['Int']['output']>;
};

export type CustomerAddress = {
  __typename?: 'CustomerAddress';
  active?: Maybe<Scalars['Boolean']['output']>;
  address?: Maybe<Scalars['String']['output']>;
  agent?: Maybe<Agent>;
  agentId?: Maybe<Scalars['Int']['output']>;
  communeID?: Maybe<Scalars['Int']['output']>;
  countryID?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['Int']['output']>;
  createdBy?: Maybe<Entity>;
  customerID?: Maybe<Scalars['Int']['output']>;
  default?: Maybe<Scalars['Boolean']['output']>;
  districtID?: Maybe<Scalars['Int']['output']>;
  dropOff?: Maybe<DropPoint>;
  houseNumber?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  instruction?: Maybe<Scalars['String']['output']>;
  isDropbox?: Maybe<Scalars['Boolean']['output']>;
  isPickup?: Maybe<Scalars['Boolean']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  picture?: Maybe<Scalars['String']['output']>;
  provinceID?: Maybe<Scalars['Int']['output']>;
  provinceName?: Maybe<Scalars['String']['output']>;
  receiver?: Maybe<Scalars['String']['output']>;
  streetNumber?: Maybe<Scalars['String']['output']>;
  thirdPartyProvider?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Int']['output']>;
  updatedBy?: Maybe<Entity>;
  verified?: Maybe<Scalars['Boolean']['output']>;
  verifiedCoordinate?: Maybe<MapCoordinate>;
  verifiedPicture?: Maybe<Scalars['String']['output']>;
};

export type CustomerAddressInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  address?: InputMaybe<Scalars['String']['input']>;
  agentId?: InputMaybe<Scalars['Int']['input']>;
  houseNumber?: InputMaybe<Scalars['String']['input']>;
  instruction?: InputMaybe<Scalars['String']['input']>;
  isDropbox?: InputMaybe<Scalars['Boolean']['input']>;
  isPickup?: InputMaybe<Scalars['Boolean']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  lat?: InputMaybe<Scalars['String']['input']>;
  lng?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  picture?: InputMaybe<Scalars['String']['input']>;
  receiver?: InputMaybe<Scalars['String']['input']>;
  streetNumber?: InputMaybe<Scalars['String']['input']>;
  thirdPartyProvider?: InputMaybe<Scalars['String']['input']>;
};

export type CustomerAddressInquiry = {
  __typename?: 'CustomerAddressInquiry';
  additionalInfo?: Maybe<Scalars['String']['output']>;
  address?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  customer?: Maybe<Customer>;
  id?: Maybe<Scalars['Int']['output']>;
  lat?: Maybe<Scalars['String']['output']>;
  lng?: Maybe<Scalars['String']['output']>;
};

export type CustomerBalanceDebug = {
  __typename?: 'CustomerBalanceDebug';
  correctBalance?: Maybe<Scalars['Float']['output']>;
  currentBalance?: Maybe<Scalars['Float']['output']>;
  history?: Maybe<Array<Maybe<CustomerBalanceHistory>>>;
};

export type CustomerBalanceHistory = {
  __typename?: 'CustomerBalanceHistory';
  amount?: Maybe<Scalars['Float']['output']>;
  balance?: Maybe<Scalars['Float']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  productCode?: Maybe<Scalars['String']['output']>;
  productId?: Maybe<Scalars['Int']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
};

export type CustomerBasic = {
  __typename?: 'CustomerBasic';
  balance?: Maybe<Scalars['String']['output']>;
  chatChannel?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  image?: Maybe<Scalars['String']['output']>;
  loan?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  stats?: Maybe<CustomerAdditionalStat>;
  unreadMessage?: Maybe<UnreadMessage>;
};

export type CustomerCart = {
  __typename?: 'CustomerCart';
  admin?: Maybe<Admin>;
  createdAt?: Maybe<Scalars['String']['output']>;
  customer?: Maybe<Customer>;
  qty?: Maybe<Scalars['Int']['output']>;
};

export type CustomerCartLog = {
  __typename?: 'CustomerCartLog';
  committer?: Maybe<Admin>;
  createdAt?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  operation?: Maybe<CartLogOperation>;
};

export type CustomerEventAdded = {
  __typename?: 'CustomerEventAdded';
  payload?: Maybe<Scalars['JSON']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export enum CustomerIdType {
  CustomerId = 'CUSTOMER_ID',
  PhoneNumber = 'PHONE_NUMBER'
}

export type CustomerInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  dateOfBirth?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Gender>;
  idCard?: InputMaybe<Scalars['String']['input']>;
  membership?: InputMaybe<Scalars['String']['input']>;
  membershipType?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
};

export type CustomerLocationSuggestEntry = {
  __typename?: 'CustomerLocationSuggestEntry';
  id?: Maybe<Scalars['Int']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  type?: Maybe<CustomerLocationSuggestionType>;
};

export enum CustomerLocationSuggestionType {
  Checkout = 'CHECKOUT',
  LastSuccess = 'LAST_SUCCESS',
  VerifiedLocation = 'VERIFIED_LOCATION'
}

export type CustomerNote = {
  __typename?: 'CustomerNote';
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Admin>;
  id?: Maybe<Scalars['Int']['output']>;
  note?: Maybe<Scalars['String']['output']>;
};

export type CustomerNoteInput = {
  customerID?: InputMaybe<Scalars['Int']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
};

export type CustomerNoteTemplate = {
  __typename?: 'CustomerNoteTemplate';
  content?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  isMoneyNote?: Maybe<Scalars['Boolean']['output']>;
  type?: Maybe<CustomerNoteTemplateType>;
};

export type CustomerNoteTemplateInput = {
  content?: InputMaybe<Scalars['String']['input']>;
  isMoneyNote?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<CustomerNoteTemplateType>;
};

export enum CustomerNoteTemplateType {
  Delivery = 'DELIVERY',
  Money = 'MONEY',
  Normal = 'NORMAL'
}

export type CustomerNotification = {
  __typename?: 'CustomerNotification';
  createdAt?: Maybe<Scalars['Int']['output']>;
  data?: Maybe<Scalars['JSON']['output']>;
  heading?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  image?: Maybe<Scalars['String']['output']>;
  mode?: Maybe<ScheduledNotificationType>;
  seen?: Maybe<Scalars['Boolean']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type CustomerOrder = {
  __typename?: 'CustomerOrder';
  address?: Maybe<CustomerAddress>;
  affiliate?: Maybe<CustomerBasic>;
  approvedAt?: Maybe<Scalars['String']['output']>;
  approvedBy?: Maybe<Admin>;
  assistedBy?: Maybe<Admin>;
  completed?: Maybe<Scalars['Boolean']['output']>;
  coordLag?: Maybe<Scalars['String']['output']>;
  coordLat?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  customer?: Maybe<CustomerBasic>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  deliveryCost?: Maybe<Scalars['String']['output']>;
  discount?: Maybe<Scalars['String']['output']>;
  followedBy?: Maybe<Admin>;
  grandTotal?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  items?: Maybe<Array<Maybe<CustomerOrderItemV2>>>;
  paid?: Maybe<Scalars['Boolean']['output']>;
  paymentProof?: Maybe<Scalars['String']['output']>;
  pickup?: Maybe<Scalars['Boolean']['output']>;
  status?: Maybe<CustomerOrderStatus>;
  thread?: Maybe<Thread>;
  total?: Maybe<Scalars['String']['output']>;
  usedPayments?: Maybe<Array<Maybe<UsedCustomerPayment>>>;
  uuid?: Maybe<Scalars['String']['output']>;
  warehouse?: Maybe<Warehouse>;
};

export type CustomerOrderAddedEvent = {
  __typename?: 'CustomerOrderAddedEvent';
  isNewCheckoutAdded?: Maybe<Scalars['Boolean']['output']>;
  unclaimedOrderCount?: Maybe<Scalars['Int']['output']>;
};

export type CustomerOrderByStatus = {
  __typename?: 'CustomerOrderByStatus';
  amount?: Maybe<Scalars['Decimal']['output']>;
  item?: Maybe<Scalars['Int']['output']>;
  order?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

export type CustomerOrderCursor = {
  __typename?: 'CustomerOrderCursor';
  nodes?: Maybe<Array<Maybe<CustomerOrder>>>;
  page?: Maybe<CustomerOrderPage>;
};

export type CustomerOrderHistory = {
  __typename?: 'CustomerOrderHistory';
  checkoutSource?: Maybe<Array<Maybe<CustomerOrderSource>>>;
  deliveredAddress?: Maybe<Array<Maybe<DeliveredAddress>>>;
  orderByStatus?: Maybe<Array<Maybe<CustomerOrderByStatus>>>;
};

export type CustomerOrderInput = {
  discount?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<Scalars['String']['input']>;
  promoCodeDiscount?: InputMaybe<Scalars['String']['input']>;
  skuId?: InputMaybe<Scalars['Int']['input']>;
};

export type CustomerOrderItem = {
  __typename?: 'CustomerOrderItem';
  code?: Maybe<Scalars['String']['output']>;
  color?: Maybe<Scalars['String']['output']>;
  customerId?: Maybe<Scalars['Int']['output']>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  orderID?: Maybe<Scalars['Int']['output']>;
  picture?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['String']['output']>;
  priceBeforeDiscount?: Maybe<Scalars['String']['output']>;
  /** @deprecated Will replaced by productId */
  productID?: Maybe<Scalars['Int']['output']>;
  productId?: Maybe<Scalars['Int']['output']>;
  size?: Maybe<Scalars['String']['output']>;
  skuId?: Maybe<Scalars['Int']['output']>;
  slotId?: Maybe<Scalars['Int']['output']>;
  slotName?: Maybe<Scalars['String']['output']>;
  status?: Maybe<CustomerOrderItemStatus>;
};

export type CustomerOrderItemAffiliate = {
  __typename?: 'CustomerOrderItemAffiliate';
  affiliate?: Maybe<Customer>;
  commission?: Maybe<Scalars['Decimal']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  disbursedId?: Maybe<Scalars['Int']['output']>;
  orderItem?: Maybe<CustomerOrderItemV2>;
};

export type CustomerOrderItemFindingSuggestion = {
  __typename?: 'CustomerOrderItemFindingSuggestion';
  id?: Maybe<Scalars['Int']['output']>;
  orderItem?: Maybe<CustomerOrderItemV2>;
  qty?: Maybe<Scalars['Int']['output']>;
  slot?: Maybe<InventorySlot>;
};

export enum CustomerOrderItemStatus {
  Abandon = 'ABANDON',
  Arrived = 'ARRIVED',
  ArrivedAtAgent = 'ARRIVED_AT_AGENT',
  ArrivedAtShipper = 'ARRIVED_AT_SHIPPER',
  DamagedItem = 'DAMAGED_ITEM',
  Delivered = 'DELIVERED',
  Departed = 'DEPARTED',
  Discontinued = 'DISCONTINUED',
  Finding = 'FINDING',
  Found = 'FOUND',
  InstoreOos = 'INSTORE_OOS',
  InstoreOrder = 'INSTORE_ORDER',
  InstorePurchase = 'INSTORE_PURCHASE',
  MerchantCancelled = 'MERCHANT_CANCELLED',
  MerchantShipped = 'MERCHANT_SHIPPED',
  Oos = 'OOS',
  Ordering = 'ORDERING',
  Pickup = 'PICKUP',
  Prepared = 'PREPARED',
  Ready = 'READY',
  RequestPickup = 'REQUEST_PICKUP',
  Returned = 'RETURNED',
  Returning = 'RETURNING',
  Uncollected = 'UNCOLLECTED',
  Waiting = 'WAITING',
  WrongItem = 'WRONG_ITEM'
}

export type CustomerOrderItemStatusResult = {
  __typename?: 'CustomerOrderItemStatusResult';
  assignedSlot?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type CustomerOrderItemTracking = {
  __typename?: 'CustomerOrderItemTracking';
  deliverer?: Maybe<Admin>;
  estimationDescription?: Maybe<Scalars['String']['output']>;
  items?: Maybe<Array<Maybe<CustomerOrderItemTrackingEntry>>>;
  packageId?: Maybe<Scalars['Int']['output']>;
  progress?: Maybe<Scalars['Int']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type CustomerOrderItemTrackingEntry = {
  __typename?: 'CustomerOrderItemTrackingEntry';
  at?: Maybe<Scalars['String']['output']>;
  by?: Maybe<Admin>;
  description?: Maybe<Scalars['String']['output']>;
  fullDescription?: Maybe<Scalars['String']['output']>;
  progressPoint?: Maybe<Scalars['Int']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type CustomerOrderItemV2 = {
  __typename?: 'CustomerOrderItemV2';
  admin?: Maybe<Admin>;
  cancellable?: Maybe<Scalars['Boolean']['output']>;
  currentStatusAt?: Maybe<Scalars['String']['output']>;
  customer?: Maybe<CustomerBasic>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  deliveryAt?: Maybe<Scalars['String']['output']>;
  deliveryFee?: Maybe<Scalars['Float']['output']>;
  id: Scalars['Int']['output'];
  invoiceNumber?: Maybe<Scalars['String']['output']>;
  isLateOrder?: Maybe<LateOrderType>;
  isUnsuccessful?: Maybe<Scalars['Boolean']['output']>;
  logs?: Maybe<Array<Maybe<OrderItemLog>>>;
  order?: Maybe<CustomerOrder>;
  orderId?: Maybe<Scalars['Int']['output']>;
  package?: Maybe<Package>;
  packageId?: Maybe<Scalars['Int']['output']>;
  packages?: Maybe<Array<Maybe<Package>>>;
  pickupHub?: Maybe<Warehouse>;
  prepaidAmount?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['String']['output']>;
  priceBeforeDiscount?: Maybe<Scalars['String']['output']>;
  returnRequest?: Maybe<CustomerOrderReturn>;
  returnable?: Maybe<ReturnableCaptionType>;
  sku?: Maybe<StockKeepingUnit>;
  slot?: Maybe<CustomerSlot>;
  status?: Maybe<CustomerOrderItemStatus>;
  supplier?: Maybe<Supplier>;
  tracking?: Maybe<CustomerOrderItemTracking>;
  trackingLink?: Maybe<Scalars['String']['output']>;
  unreturnableMessage?: Maybe<Scalars['String']['output']>;
  unsucessfulReason?: Maybe<Scalars['String']['output']>;
  uuid?: Maybe<Scalars['String']['output']>;
  warranty?: Maybe<OrderWarranty>;
};

export type CustomerOrderListSummary = {
  __typename?: 'CustomerOrderListSummary';
  completed?: Maybe<Scalars['Int']['output']>;
  groupByMonth?: Maybe<Array<Maybe<CustomerOrderListSummaryGroup>>>;
  ongoing?: Maybe<Scalars['Int']['output']>;
  ongoingAttention?: Maybe<Scalars['Boolean']['output']>;
};

export type CustomerOrderListSummaryGroup = {
  __typename?: 'CustomerOrderListSummaryGroup';
  completed?: Maybe<Scalars['Int']['output']>;
  count?: Maybe<Scalars['Int']['output']>;
  month?: Maybe<Scalars['Int']['output']>;
  monthName?: Maybe<Scalars['String']['output']>;
  year?: Maybe<Scalars['Int']['output']>;
};

export enum CustomerOrderOrder {
  LargestTotalAmount = 'LARGEST_TOTAL_AMOUNT',
  Newest = 'NEWEST',
  Oldest = 'OLDEST',
  SmallestTotalAmount = 'SMALLEST_TOTAL_AMOUNT'
}

export type CustomerOrderPage = {
  __typename?: 'CustomerOrderPage';
  count?: Maybe<Scalars['Int']['output']>;
  totalAmount?: Maybe<Scalars['Float']['output']>;
  totalDeliveryFee?: Maybe<Scalars['Float']['output']>;
};

export type CustomerOrderReturn = {
  __typename?: 'CustomerOrderReturn';
  adminAcceptedAt?: Maybe<Scalars['String']['output']>;
  adminAcceptedBy?: Maybe<Admin>;
  adminRejectedAt?: Maybe<Scalars['String']['output']>;
  adminRejectedBy?: Maybe<Admin>;
  adminReturnedBy?: Maybe<Admin>;
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Admin>;
  deliveryFee?: Maybe<Scalars['Float']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  /** @deprecated use imagesProofV2 instead */
  imagesProof?: Maybe<Scalars['String']['output']>;
  imagesProofV2?: Maybe<Array<Maybe<MediaDetail>>>;
  isDiscardedAtBuyer?: Maybe<Scalars['Boolean']['output']>;
  isReported?: Maybe<Scalars['Boolean']['output']>;
  orderItem?: Maybe<CustomerOrderItemV2>;
  package?: Maybe<Package>;
  rejectedProof?: Maybe<Scalars['String']['output']>;
  rejectedReason?: Maybe<Scalars['String']['output']>;
  resolvedAt?: Maybe<Scalars['String']['output']>;
  resolvedBy?: Maybe<Admin>;
  returnedAt?: Maybe<Scalars['String']['output']>;
  returnedFee?: Maybe<Scalars['Float']['output']>;
  returnedReason?: Maybe<ReturnReasonType>;
  returnedStatus?: Maybe<ReturnStatusType>;
  sellerAcceptedAt?: Maybe<Scalars['String']['output']>;
  sellerDisputedAt?: Maybe<Scalars['String']['output']>;
  supplier?: Maybe<Supplier>;
  thirdPartyReceipt?: Maybe<Scalars['String']['output']>;
  triage?: Maybe<ReturnItemTriage>;
  triagedAt?: Maybe<Scalars['String']['output']>;
  triagedBy?: Maybe<Admin>;
};

export type CustomerOrderSource = {
  __typename?: 'CustomerOrderSource';
  amount?: Maybe<Scalars['Decimal']['output']>;
  checkoutSource?: Maybe<Scalars['String']['output']>;
  deleted?: Maybe<Scalars['Int']['output']>;
  deletedAmount?: Maybe<Scalars['Decimal']['output']>;
  items?: Maybe<Scalars['Int']['output']>;
  order?: Maybe<Scalars['Int']['output']>;
  returned?: Maybe<Scalars['Int']['output']>;
  returnedAmount?: Maybe<Scalars['Decimal']['output']>;
  sold?: Maybe<Scalars['Int']['output']>;
  soldAmount?: Maybe<Scalars['Decimal']['output']>;
};

export enum CustomerOrderStatus {
  Approved = 'APPROVED',
  Bad = 'BAD',
  Completed = 'COMPLETED',
  NeedCredit = 'NEED_CREDIT',
  None = 'NONE',
  Review = 'REVIEW'
}

export type CustomerOrderTracking = {
  __typename?: 'CustomerOrderTracking';
  attachment?: Maybe<Scalars['String']['output']>;
  date?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  trackingCode?: Maybe<Scalars['String']['output']>;
};

export type CustomerPackageInfoSummary = {
  __typename?: 'CustomerPackageInfoSummary';
  newCustomer?: Maybe<Scalars['Int']['output']>;
  newCustomerPackage?: Maybe<Scalars['Int']['output']>;
  newCustomerPackageValue?: Maybe<Scalars['Decimal']['output']>;
  returnedCustomer?: Maybe<Scalars['Int']['output']>;
  returnedCustomerPackage?: Maybe<Scalars['Int']['output']>;
  returnedCustomerPackageValue?: Maybe<Scalars['Decimal']['output']>;
  totalCustomer?: Maybe<Scalars['Int']['output']>;
  totalPackage?: Maybe<Scalars['Int']['output']>;
  totalRevenue?: Maybe<Scalars['Float']['output']>;
};

export type CustomerPaymentChart = {
  __typename?: 'CustomerPaymentChart';
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<CustomerPaymentChartType>;
};

export enum CustomerPaymentChartType {
  Bank = 'BANK',
  Cash = 'CASH',
  Discount = 'DISCOUNT'
}

export type CustomerPaymentCursor = {
  __typename?: 'CustomerPaymentCursor';
  nodes?: Maybe<Array<Maybe<CustomerPaymentHistory>>>;
  page?: Maybe<CustomerPaymentPage>;
};

export type CustomerPaymentHistory = {
  __typename?: 'CustomerPaymentHistory';
  amount?: Maybe<Scalars['String']['output']>;
  chartOfAccount?: Maybe<CustomerPaymentChart>;
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Admin>;
  customer?: Maybe<CustomerBasic>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  onlinePayment?: Maybe<OnlinePaymentInfo>;
  proof?: Maybe<Scalars['String']['output']>;
  proofAt?: Maybe<Scalars['String']['output']>;
  proofBy?: Maybe<Admin>;
  remainder?: Maybe<Scalars['String']['output']>;
};

export enum CustomerPaymentOrder {
  LargestAmount = 'LARGEST_AMOUNT',
  Newest = 'NEWEST',
  Oldest = 'OLDEST',
  SmallestAmount = 'SMALLEST_AMOUNT'
}

export type CustomerPaymentPage = {
  __typename?: 'CustomerPaymentPage';
  count?: Maybe<Scalars['Int']['output']>;
  totalAmount?: Maybe<Scalars['Float']['output']>;
};

export type CustomerProfileInput = {
  bio?: InputMaybe<Scalars['String']['input']>;
  dateOfBirth?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Gender>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  profilePicture?: InputMaybe<Scalars['String']['input']>;
};

export type CustomerRefund = {
  __typename?: 'CustomerRefund';
  accountType?: Maybe<CustomerRefundAccountType>;
  amount?: Maybe<Scalars['String']['output']>;
  bankAccountHolder?: Maybe<Scalars['String']['output']>;
  bankAccountNumber?: Maybe<Scalars['String']['output']>;
  bankName?: Maybe<Scalars['String']['output']>;
  completedAt?: Maybe<Scalars['String']['output']>;
  completedBy?: Maybe<Admin>;
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Admin>;
  creditHitoryId?: Maybe<Scalars['Int']['output']>;
  customer?: Maybe<Customer>;
  holdAt?: Maybe<Scalars['String']['output']>;
  holdBy?: Maybe<Admin>;
  id?: Maybe<Scalars['Int']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  status?: Maybe<CustomerRefundStatus>;
  transferredAt?: Maybe<Scalars['String']['output']>;
  transferredBy?: Maybe<Admin>;
  transferredProof?: Maybe<Scalars['String']['output']>;
  verifiedAt?: Maybe<Scalars['String']['output']>;
  verifiedBy?: Maybe<Admin>;
};

export enum CustomerRefundAccountType {
  Bank = 'BANK',
  Phone = 'PHONE'
}

export type CustomerRefundConnection = {
  __typename?: 'CustomerRefundConnection';
  nodes?: Maybe<Array<Maybe<CustomerRefund>>>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export enum CustomerRefundStatus {
  Cancelled = 'CANCELLED',
  Completed = 'COMPLETED',
  Hold = 'HOLD',
  Pending = 'PENDING',
  Transferred = 'TRANSFERRED',
  Verified = 'VERIFIED'
}

export type CustomerSlot = {
  __typename?: 'CustomerSlot';
  active?: Maybe<Scalars['Boolean']['output']>;
  capacityVolume?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  type?: Maybe<CustomerSlotType>;
  usedVolume?: Maybe<Scalars['String']['output']>;
  x?: Maybe<Scalars['Float']['output']>;
  y?: Maybe<Scalars['Float']['output']>;
  z?: Maybe<Scalars['Float']['output']>;
};

export type CustomerSlotInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  capacity?: InputMaybe<Scalars['Float']['input']>;
  capacityVolume?: InputMaybe<Scalars['Float']['input']>;
  name: Scalars['String']['input'];
  type: CustomerSlotType;
  warehouseId: Scalars['Int']['input'];
  x?: InputMaybe<Scalars['Float']['input']>;
  y?: InputMaybe<Scalars['Float']['input']>;
  z?: InputMaybe<Scalars['Float']['input']>;
};

export enum CustomerSlotType {
  Freezer = 'FREEZER',
  Large = 'LARGE',
  Open = 'OPEN',
  Regular = 'REGULAR'
}

export type CustomerSlots = {
  __typename?: 'CustomerSlots';
  count?: Maybe<Scalars['Int']['output']>;
  items?: Maybe<Array<Maybe<CustomerSlot>>>;
};

export type CustomerStats = {
  __typename?: 'CustomerStats';
  readyAmount?: Maybe<Scalars['Float']['output']>;
  readyCount?: Maybe<Scalars['Int']['output']>;
  returnedAmount?: Maybe<Scalars['Float']['output']>;
  returnedCount?: Maybe<Scalars['Int']['output']>;
  spent?: Maybe<Scalars['Float']['output']>;
  uncollectedAmount?: Maybe<Scalars['Float']['output']>;
  uncollectedCount?: Maybe<Scalars['Int']['output']>;
};

export type CustomerTokenType = {
  __typename?: 'CustomerTokenType';
  errorMessage?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
  token?: Maybe<Scalars['String']['output']>;
};

export type DailyInventoryFee = {
  __typename?: 'DailyInventoryFee';
  amount?: Maybe<Scalars['Float']['output']>;
  date?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
};

export enum DateType {
  CreatedDate = 'CREATED_DATE',
  SuccessDate = 'SUCCESS_DATE'
}

export enum DealCriteria {
  QtyReach = 'QTY_REACH',
  ValuesReach = 'VALUES_REACH'
}

export type DeliveredAddress = {
  __typename?: 'DeliveredAddress';
  delivered?: Maybe<Scalars['Int']['output']>;
  lat?: Maybe<Scalars['Decimal']['output']>;
  lng?: Maybe<Scalars['Decimal']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type DelivererSalary = {
  __typename?: 'DelivererSalary';
  bankAccount?: Maybe<Scalars['String']['output']>;
  basicSalary?: Maybe<Scalars['Float']['output']>;
  days?: Maybe<Array<Maybe<DelivererSalaryPerDay>>>;
  department?: Maybe<Scalars['String']['output']>;
  distanceFee?: Maybe<Scalars['Float']['output']>;
  fullName?: Maybe<Scalars['String']['output']>;
  gasolineFee?: Maybe<Scalars['Float']['output']>;
  isTransitStaff?: Maybe<Scalars['Boolean']['output']>;
  khmerName?: Maybe<Scalars['String']['output']>;
  klahanId?: Maybe<Scalars['Int']['output']>;
  nid?: Maybe<Scalars['String']['output']>;
  passport?: Maybe<Scalars['String']['output']>;
  person?: Maybe<Admin>;
  position?: Maybe<Scalars['String']['output']>;
  subDepartment?: Maybe<Scalars['String']['output']>;
  tid?: Maybe<Scalars['String']['output']>;
  topupBonus?: Maybe<Scalars['Float']['output']>;
  topupDepositBonus?: Maybe<Scalars['Float']['output']>;
  totalDeliverPackage?: Maybe<Scalars['Int']['output']>;
  totalFee?: Maybe<Scalars['Float']['output']>;
  totalPackage?: Maybe<Scalars['Int']['output']>;
  totalPackageFee?: Maybe<Scalars['Float']['output']>;
  totalPickupPackage?: Maybe<Scalars['Int']['output']>;
  totalTransitDistance?: Maybe<Scalars['Float']['output']>;
  totalTransitPackageCount?: Maybe<Scalars['Int']['output']>;
  totalTransitSalary?: Maybe<Scalars['Float']['output']>;
  totalTransitTrip?: Maybe<Scalars['Int']['output']>;
  totalUniqueLocation?: Maybe<Scalars['Float']['output']>;
};

export type DelivererSalaryPerDay = {
  __typename?: 'DelivererSalaryPerDay';
  day?: Maybe<Scalars['String']['output']>;
  distanceFee?: Maybe<Scalars['Float']['output']>;
  gasolineFee?: Maybe<Scalars['Float']['output']>;
  totalDeliverPackage?: Maybe<Scalars['Int']['output']>;
  totalFee?: Maybe<Scalars['Float']['output']>;
  totalPackage?: Maybe<Scalars['Int']['output']>;
  totalPackageFee?: Maybe<Scalars['Float']['output']>;
  totalPickupPackage?: Maybe<Scalars['Int']['output']>;
  totalTransitDistance?: Maybe<Scalars['Float']['output']>;
  totalTransitPackageCount?: Maybe<Scalars['Int']['output']>;
  totalTransitSalary?: Maybe<Scalars['Float']['output']>;
  totalTransitTrip?: Maybe<Scalars['Int']['output']>;
};

export type DeliveryAdminMetrics = {
  __typename?: 'DeliveryAdminMetrics';
  inTransitPackages?: Maybe<Scalars['Int']['output']>;
  newPackages?: Maybe<Scalars['Int']['output']>;
  readyToDeliverPackages?: Maybe<Scalars['Int']['output']>;
  toTransitPackages?: Maybe<Scalars['Int']['output']>;
};

export type DeliveryAgent = {
  __typename?: 'DeliveryAgent';
  hub?: Maybe<Warehouse>;
  user?: Maybe<Admin>;
};

export type DeliveryAgentInput = {
  bankAccountNumber?: InputMaybe<Scalars['String']['input']>;
  commune: Scalars['String']['input'];
  district: Scalars['String']['input'];
  hubLat: Scalars['String']['input'];
  hubLng: Scalars['String']['input'];
  hubName: Scalars['String']['input'];
  hubShortName: Scalars['String']['input'];
  name: Scalars['String']['input'];
  password: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
  province: Scalars['String']['input'];
};

export type DeliveryAgentMetrics = {
  __typename?: 'DeliveryAgentMetrics';
  collectedAmount?: Maybe<Scalars['Float']['output']>;
  deliveredPackages?: Maybe<Scalars['Int']['output']>;
  earnedAmount?: Maybe<Scalars['Float']['output']>;
  incomingPackages?: Maybe<Scalars['Int']['output']>;
  newPackages?: Maybe<Scalars['Int']['output']>;
  readyToDeliverPackages?: Maybe<Scalars['Int']['output']>;
};

export type DeliveryAgentUpdate = {
  bankAccountNumber?: InputMaybe<Scalars['String']['input']>;
  commune?: InputMaybe<Scalars['String']['input']>;
  district?: InputMaybe<Scalars['String']['input']>;
  hubLat?: InputMaybe<Scalars['String']['input']>;
  hubLng?: InputMaybe<Scalars['String']['input']>;
  hubName?: InputMaybe<Scalars['String']['input']>;
  hubShortName?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  province?: InputMaybe<Scalars['String']['input']>;
};

export type DeliveryLocation = {
  __typename?: 'DeliveryLocation';
  lat?: Maybe<Scalars['String']['output']>;
  lng?: Maybe<Scalars['String']['output']>;
  rule?: Maybe<Scalars['String']['output']>;
};

export type DeliveryNoteInput = {
  addressId?: InputMaybe<Scalars['Int']['input']>;
  agentId?: InputMaybe<Scalars['Int']['input']>;
  customerOrderIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  customerPayForThirdParty?: InputMaybe<Scalars['Int']['input']>;
  isPickup?: InputMaybe<Scalars['Int']['input']>;
};

export type DeliveryPerson = {
  __typename?: 'DeliveryPerson';
  id: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type DeliveryTrip = {
  __typename?: 'DeliveryTrip';
  id: Scalars['Int']['output'];
  routes?: Maybe<Array<Maybe<DeliveryTripRoute>>>;
  scanOutAt?: Maybe<Scalars['String']['output']>;
};

export type DeliveryTripRoute = {
  __typename?: 'DeliveryTripRoute';
  customerID?: Maybe<Scalars['Int']['output']>;
  deliveredAt?: Maybe<Scalars['String']['output']>;
  deliveredBy?: Maybe<Admin>;
  id: Scalars['Int']['output'];
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  thirdParty?: Maybe<Scalars['Boolean']['output']>;
};

export type DigitalWarranty = {
  __typename?: 'DigitalWarranty';
  createdDate?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  duration?: Maybe<Scalars['Int']['output']>;
  durationType?: Maybe<WarrantyDurationType>;
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  repairCenter?: Maybe<RepairCenter>;
  supplier?: Maybe<Supplier>;
  updatedDate?: Maybe<Scalars['String']['output']>;
  warrantyItems?: Maybe<Array<Maybe<BasicProduct>>>;
};


export type DigitalWarrantyWarrantyItemsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type DigitalWarrantyData = {
  description?: InputMaybe<Scalars['String']['input']>;
  duration?: InputMaybe<Scalars['Int']['input']>;
  durationType?: InputMaybe<WarrantyDurationType>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export enum DirectiveType {
  Admin = 'ADMIN',
  Agent = 'AGENT',
  Customer = 'CUSTOMER',
  Merchant = 'MERCHANT',
  SuperAdmin = 'SUPER_ADMIN'
}

export type DisbursementItem = {
  __typename?: 'DisbursementItem';
  amount?: Maybe<Scalars['Float']['output']>;
  batchId?: Maybe<Scalars['Int']['output']>;
  exchangeRate?: Maybe<Scalars['Decimal']['output']>;
  gatewayFee?: Maybe<Scalars['Decimal']['output']>;
  gatewayProof?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  log?: Maybe<Array<Maybe<DisbursementItemLog>>>;
  paymentGateway?: Maybe<Supplier>;
  paymentGatewayBank?: Maybe<Scalars['JSON']['output']>;
  proof?: Maybe<Scalars['String']['output']>;
  publicStatus?: Maybe<Scalars['String']['output']>;
  requestedDate?: Maybe<Scalars['String']['output']>;
  sellerBank?: Maybe<Scalars['JSON']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  supplier?: Maybe<Supplier>;
  transferedDate?: Maybe<Scalars['String']['output']>;
  uuid?: Maybe<Scalars['String']['output']>;
};

export type DisbursementItemList = {
  __typename?: 'DisbursementItemList';
  data?: Maybe<Array<Maybe<DisbursementItem>>>;
  records?: Maybe<Scalars['Int']['output']>;
  totalAmount?: Maybe<Scalars['Float']['output']>;
};

export type DisbursementItemLog = {
  __typename?: 'DisbursementItemLog';
  admin?: Maybe<Admin>;
  date?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export enum DisbursementStatus {
  Completed = 'COMPLETED',
  Pending = 'PENDING',
  Transfered = 'TRANSFERED',
  Transit = 'TRANSIT',
  Verified = 'VERIFIED'
}

export type DiscountCampaign = {
  __typename?: 'DiscountCampaign';
  category?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Admin>;
  discount?: Maybe<Scalars['Float']['output']>;
  endedAt?: Maybe<Scalars['String']['output']>;
  hasAppliedDiscount?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
  startedAt?: Maybe<Scalars['String']['output']>;
};

export type DiscountCampaignInput = {
  category?: InputMaybe<Scalars['Int']['input']>;
  discount?: InputMaybe<Scalars['Float']['input']>;
  endedAt?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  startedAt?: InputMaybe<Scalars['String']['input']>;
};

export enum DiscountType {
  PercentageOff = 'PERCENTAGE_OFF',
  ValueOff = 'VALUE_OFF'
}

export type DisplayProduct = {
  __typename?: 'DisplayProduct';
  additionalLabel?: Maybe<Scalars['String']['output']>;
  additionalWebview?: Maybe<Scalars['String']['output']>;
  affiliateClaimed?: Maybe<AffiliateClaimedInfo>;
  affiliateCommission?: Maybe<Scalars['Float']['output']>;
  affiliateDeepLink?: Maybe<Scalars['String']['output']>;
  availability?: Maybe<Scalars['Boolean']['output']>;
  averageRating?: Maybe<Scalars['Float']['output']>;
  brand?: Maybe<Brand>;
  category?: Maybe<Scalars['Int']['output']>;
  code?: Maybe<Scalars['String']['output']>;
  color?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  condition?: Maybe<ProductCondition>;
  descriptionHTML?: Maybe<Scalars['String']['output']>;
  digitalWarranty?: Maybe<DigitalWarranty>;
  event?: Maybe<EventCampaign>;
  id: Scalars['Int']['output'];
  isBrandProduct?: Maybe<Scalars['Boolean']['output']>;
  isInStock?: Maybe<Scalars['Boolean']['output']>;
  isL192Choice?: Maybe<Scalars['Boolean']['output']>;
  isWishList?: Maybe<Scalars['Boolean']['output']>;
  label0?: Maybe<Scalars['String']['output']>;
  label1?: Maybe<Scalars['String']['output']>;
  label2?: Maybe<Scalars['String']['output']>;
  label3?: Maybe<Scalars['String']['output']>;
  label4?: Maybe<Scalars['String']['output']>;
  multiOffersTemplate?: Maybe<MultiOffersTemplateType>;
  picture?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  priceBeforeDiscount?: Maybe<Scalars['Float']['output']>;
  promoCombo?: Maybe<PromoCombo>;
  ratingCount?: Maybe<Scalars['Int']['output']>;
  returnPolicyLink?: Maybe<Scalars['String']['output']>;
  returnable?: Maybe<Scalars['Boolean']['output']>;
  showAffiliate?: Maybe<Scalars['Boolean']['output']>;
  size?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  supplier?: Maybe<Supplier>;
  thumbnail?: Maybe<Scalars['String']['output']>;
  thumbnailSquare?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  video?: Maybe<Video>;
};


export type DisplayProductDescriptionHtmlArgs = {
  headless?: InputMaybe<Scalars['Boolean']['input']>;
};


export type DisplayProductThumbnailArgs = {
  height?: InputMaybe<Scalars['Int']['input']>;
  width?: InputMaybe<Scalars['Int']['input']>;
};

export type DisplayProductMedia = {
  __typename?: 'DisplayProductMedia';
  height?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  originalSource?: Maybe<Scalars['String']['output']>;
  src?: Maybe<Scalars['String']['output']>;
  thumbnail?: Maybe<Scalars['String']['output']>;
  type?: Maybe<DisplayProductMediaType>;
  width?: Maybe<Scalars['Int']['output']>;
};

export enum DisplayProductMediaType {
  Picture = 'PICTURE',
  Video = 'VIDEO',
  Youtube = 'YOUTUBE'
}

export type District = {
  __typename?: 'District';
  deliveryPrice?: Maybe<Scalars['String']['output']>;
  districtCode?: Maybe<Scalars['String']['output']>;
  geometry?: Maybe<Array<Maybe<MapCoordinate>>>;
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  provinceId?: Maybe<Scalars['Int']['output']>;
  useThirdParty?: Maybe<Scalars['Boolean']['output']>;
};

export type DistrictInput = {
  deliveryPrice?: InputMaybe<Scalars['String']['input']>;
  useThirdParty?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DropPoint = {
  __typename?: 'DropPoint';
  distance?: Maybe<Scalars['Int']['output']>;
  fee?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  province?: Maybe<Province>;
  provinceName?: Maybe<Scalars['String']['output']>;
  rule?: Maybe<Scalars['String']['output']>;
  zoneId?: Maybe<Scalars['Int']['output']>;
};

export type DropPointInput = {
  distance?: InputMaybe<Scalars['Int']['input']>;
  fee?: InputMaybe<Scalars['Float']['input']>;
  lat?: InputMaybe<Scalars['Float']['input']>;
  lng?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  provinceId?: InputMaybe<Scalars['Int']['input']>;
  rule?: InputMaybe<Scalars['String']['input']>;
  zoneId?: InputMaybe<Scalars['Int']['input']>;
};

export type Entity = {
  __typename?: 'Entity';
  entity?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  image?: Maybe<Scalars['String']['output']>;
  internalDisplayName?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type EventCampaign = {
  __typename?: 'EventCampaign';
  campaignBanner?: Maybe<Scalars['String']['output']>;
  campaignName?: Maybe<Scalars['String']['output']>;
  endDate?: Maybe<Scalars['String']['output']>;
  frontBanner?: Maybe<Scalars['String']['output']>;
  groupBy?: Maybe<Scalars['JSON']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  minimumDiscount?: Maybe<Scalars['Float']['output']>;
  productJoin?: Maybe<Scalars['Int']['output']>;
  registrationClosedDate?: Maybe<Scalars['String']['output']>;
  specialBanner?: Maybe<Scalars['String']['output']>;
  startDate?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  supplierJoin?: Maybe<Scalars['Int']['output']>;
};

export enum EventCampaignDiscount {
  Eightyoff = 'EIGHTYOFF',
  Fortyoff = 'FORTYOFF',
  Overeightyoff = 'OVEREIGHTYOFF',
  Sixtyoff = 'SIXTYOFF',
  Twentyoff = 'TWENTYOFF'
}

export enum EventCampaignGroupBy {
  Category = 'CATEGORY',
  Discount = 'DISCOUNT',
  Supplier = 'SUPPLIER'
}

export type EventCampaignInput = {
  campaignBanner?: InputMaybe<Scalars['String']['input']>;
  campaignName?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  frontBanner?: InputMaybe<Scalars['String']['input']>;
  minimumDiscount?: InputMaybe<Scalars['Float']['input']>;
  registrationClosedDate?: InputMaybe<Scalars['String']['input']>;
  specialBanner?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
};

export type EventCampaignItem = {
  __typename?: 'EventCampaignItem';
  eventDiscount?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  item?: Maybe<BasicProduct>;
  originalDiscount?: Maybe<Scalars['Float']['output']>;
  salesAmount?: Maybe<Scalars['Float']['output']>;
  salesQty?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<EventCampaignItemStatus>;
  supplier?: Maybe<Supplier>;
};

export type EventCampaignItemInput = {
  eventDiscount?: InputMaybe<Scalars['Float']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  itemId?: InputMaybe<Scalars['Int']['input']>;
  originalDiscount?: InputMaybe<Scalars['Float']['input']>;
  status?: InputMaybe<EventCampaignItemStatus>;
};

export enum EventCampaignItemStatus {
  Approved = 'APPROVED',
  Pending = 'PENDING',
  Rejected = 'REJECTED'
}

export enum EventCampaignStatus {
  Active = 'ACTIVE',
  Deleted = 'DELETED',
  Inactive = 'INACTIVE'
}

export type ExpressPackageItem = {
  __typename?: 'ExpressPackageItem';
  alias?: Maybe<Scalars['String']['output']>;
  sku?: Maybe<StockKeepingUnit>;
};

export type ExternalOrderInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  productCode?: InputMaybe<Scalars['String']['input']>;
  proof?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
  supplierId?: InputMaybe<Scalars['Int']['input']>;
};

export type FacebookPage = {
  __typename?: 'FacebookPage';
  facebookId?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type FacebookPageComment = {
  __typename?: 'FacebookPageComment';
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  unhandled?: Maybe<Scalars['Int']['output']>;
};

export type FacebookPost = {
  __typename?: 'FacebookPost';
  caption?: Maybe<Scalars['String']['output']>;
  products?: Maybe<Array<Maybe<BasicProduct>>>;
  supplier?: Maybe<Supplier>;
  title?: Maybe<Scalars['String']['output']>;
};

export enum FacebookPostType {
  Live = 'LIVE',
  None = 'NONE'
}

export enum FbOrderStatus {
  Deleted = 'DELETED',
  Delivered = 'DELIVERED',
  Delivering = 'DELIVERING',
  Nocoordinate = 'NOCOORDINATE',
  Paid = 'PAID',
  Print = 'PRINT',
  Sold = 'SOLD',
  Unpaid = 'UNPAID',
  Withcoordinate = 'WITHCOORDINATE'
}

export type FeatureFlags = {
  __typename?: 'FeatureFlags';
  autoPickupRangeMessage?: Maybe<Scalars['String']['output']>;
  enableAppClaimDelivery?: Maybe<Scalars['Boolean']['output']>;
  enableAutoPickup?: Maybe<Scalars['Boolean']['output']>;
  enableCustomerChat?: Maybe<Scalars['Boolean']['output']>;
  enablePackageClaim?: Maybe<Scalars['Boolean']['output']>;
  enablePickupAddress?: Maybe<Scalars['Boolean']['output']>;
  enableTimeline?: Maybe<Scalars['Boolean']['output']>;
  enableUserPost?: Maybe<Scalars['Boolean']['output']>;
  packingDivisor?: Maybe<Scalars['Int']['output']>;
  pickupPerformanceSummary?: Maybe<Scalars['String']['output']>;
  tabPing?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
};

export type FeaturedShop = {
  __typename?: 'FeaturedShop';
  items?: Maybe<Array<Maybe<Scalars['JSON']['output']>>>;
  supplier?: Maybe<Supplier>;
};

export type FilterFbl = {
  brand?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  search?: InputMaybe<Scalars['String']['input']>;
  vendor?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};

export type FilterStock = {
  end?: InputMaybe<Scalars['Int']['input']>;
  start?: InputMaybe<Scalars['Int']['input']>;
};

export type FilterSupplierRequest = {
  lastMonthOldStock?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<SortOrder>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<SortProductRequest>;
  status?: InputMaybe<SupplierStatusRequest>;
  type?: InputMaybe<SupplierProductApproved>;
};

export type FoundSkuInfoInput = {
  expiredDate?: InputMaybe<Scalars['String']['input']>;
  printedDate?: InputMaybe<Scalars['String']['input']>;
  sku?: InputMaybe<Scalars['Int']['input']>;
};

export type FrontScreenAddress = {
  __typename?: 'FrontScreenAddress';
  address?: Maybe<Scalars['String']['output']>;
  navigation?: Maybe<Scalars['JSON']['output']>;
};

export enum Gender {
  Female = 'FEMALE',
  Male = 'MALE',
  None = 'NONE'
}

export type GeneralEventAdded = {
  __typename?: 'GeneralEventAdded';
  payload?: Maybe<Scalars['JSON']['output']>;
  targetAdminId?: Maybe<Scalars['Int']['output']>;
  targetGroupId?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type GeneralEventInput = {
  payload?: InputMaybe<Scalars['JSON']['input']>;
  targetAdminId?: InputMaybe<Scalars['Int']['input']>;
  targetGroupId?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type GeoHierarchy = {
  __typename?: 'GeoHierarchy';
  commune?: Maybe<Commune>;
  district?: Maybe<District>;
  province?: Maybe<Province>;
};

export type GiveAwayCheckResult = {
  __typename?: 'GiveAwayCheckResult';
  giveAway?: Maybe<Scalars['Boolean']['output']>;
  message?: Maybe<Scalars['String']['output']>;
};

export type GoogleCachePlace = {
  __typename?: 'GoogleCachePlace';
  distance?: Maybe<Scalars['String']['output']>;
  hit?: Maybe<Scalars['Int']['output']>;
  lat?: Maybe<Scalars['String']['output']>;
  lng?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  placeId?: Maybe<Scalars['String']['output']>;
};

export type GroupBuy = {
  __typename?: 'GroupBuy';
  actived?: Maybe<Scalars['Int']['output']>;
  currentOrderQty?: Maybe<Scalars['Int']['output']>;
  discount?: Maybe<Scalars['Float']['output']>;
  endDate?: Maybe<Scalars['String']['output']>;
  moq?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  product?: Maybe<BasicProduct>;
  rollBackDiscount?: Maybe<Scalars['Float']['output']>;
  soldAmount?: Maybe<Scalars['Float']['output']>;
  soldQty?: Maybe<Scalars['Int']['output']>;
  startDate?: Maybe<Scalars['String']['output']>;
};

export type GroupBuyEdit = {
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  discount?: InputMaybe<Scalars['Float']['input']>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  itemId?: InputMaybe<Scalars['Int']['input']>;
  moq?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  rollBackDiscount?: InputMaybe<Scalars['Float']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
};

export type GroupBuyList = {
  __typename?: 'GroupBuyList';
  data?: Maybe<Array<Maybe<GroupBuy>>>;
  page?: Maybe<Pagination>;
};

export type GroupBuyNew = {
  discount?: InputMaybe<Scalars['Float']['input']>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  itemId?: InputMaybe<Scalars['Int']['input']>;
  moq?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  rollBackDiscount?: InputMaybe<Scalars['Float']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
};

export type HubPackage = {
  __typename?: 'HubPackage';
  hub?: Maybe<Warehouse>;
  packages?: Maybe<Array<Maybe<Package>>>;
};

export type HubRouteInput = {
  connectedHubIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  fee?: InputMaybe<Scalars['Decimal']['input']>;
  hubId: Scalars['Int']['input'];
};

export type ImagePackage = {
  __typename?: 'ImagePackage';
  barcode?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  otherFields?: Maybe<Scalars['JSON']['output']>;
  supplier?: Maybe<Supplier>;
  url?: Maybe<Scalars['String']['output']>;
};

export type ImagePackageCreated = {
  __typename?: 'ImagePackageCreated';
  total?: Maybe<Scalars['Int']['output']>;
};

export enum ImagePackageStatus {
  Deleted = 'DELETED',
  Filled = 'FILLED',
  Pending = 'PENDING'
}

export type InTransitPackageBreakdown = {
  __typename?: 'InTransitPackageBreakdown';
  driver?: Maybe<Admin>;
  nextHubs?: Maybe<Array<Maybe<HubPackage>>>;
};

export type InventoryRemoval = {
  __typename?: 'InventoryRemoval';
  adminProcessed?: Maybe<Admin>;
  adminSentOut?: Maybe<Admin>;
  discardedAt?: Maybe<Scalars['String']['output']>;
  discardedBy?: Maybe<Admin>;
  id?: Maybe<Scalars['String']['output']>;
  inputDate?: Maybe<Scalars['String']['output']>;
  packageGroup?: Maybe<Array<Maybe<PackageGroup>>>;
  processedDate?: Maybe<Scalars['String']['output']>;
  proof?: Maybe<Scalars['String']['output']>;
  sentOutDate?: Maybe<Scalars['String']['output']>;
  status?: Maybe<InventoryRemovalStatus>;
  supplier?: Maybe<Supplier>;
};

export type InventoryRemovalItem = {
  __typename?: 'InventoryRemovalItem';
  color?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  product?: Maybe<BasicProduct>;
  qty?: Maybe<Scalars['Int']['output']>;
  removalId?: Maybe<Scalars['String']['output']>;
  removedQty?: Maybe<Scalars['Int']['output']>;
  size?: Maybe<Scalars['String']['output']>;
  skuId?: Maybe<Scalars['Int']['output']>;
};

export type InventoryRemovalList = {
  __typename?: 'InventoryRemovalList';
  data?: Maybe<Array<Maybe<InventoryRemoval>>>;
  page?: Maybe<Pagination>;
};

export enum InventoryRemovalStatus {
  Discarded = 'DISCARDED',
  Pending = 'PENDING',
  Processed = 'PROCESSED',
  SentOut = 'SENT_OUT'
}

export type InventoryRemovalStatusItem = {
  id?: InputMaybe<Scalars['Int']['input']>;
  removed?: InputMaybe<Scalars['Int']['input']>;
};

export type InventorySlot = {
  __typename?: 'InventorySlot';
  floor?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
  used?: Maybe<Scalars['Int']['output']>;
  warehouse?: Maybe<Scalars['Int']['output']>;
};

export type InventorySlotInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  used?: InputMaybe<Scalars['Int']['input']>;
  warehouse?: InputMaybe<Scalars['Int']['input']>;
};

export type InventorySlotList = {
  __typename?: 'InventorySlotList';
  data?: Maybe<Array<Maybe<InventorySlot>>>;
  page?: Maybe<Pagination>;
};

export type InventorySummary = {
  __typename?: 'InventorySummary';
  fee?: Maybe<Scalars['String']['output']>;
  totalItem?: Maybe<Scalars['String']['output']>;
  totalUnit?: Maybe<Scalars['String']['output']>;
  totalVolume?: Maybe<Scalars['String']['output']>;
};

export type ItemDiscount = {
  __typename?: 'ItemDiscount';
  discount?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  item?: Maybe<Scalars['JSON']['output']>;
  original_discount?: Maybe<Scalars['String']['output']>;
};

export type ItemDiscountCampaign = {
  __typename?: 'ItemDiscountCampaign';
  actived?: Maybe<Scalars['Boolean']['output']>;
  end_date?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  start_date?: Maybe<Scalars['String']['output']>;
};

export type ItemDiscountInput = {
  campaign_id?: InputMaybe<Scalars['Int']['input']>;
  discount?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  item_id?: InputMaybe<Scalars['Int']['input']>;
  original_discount?: InputMaybe<Scalars['String']['input']>;
};

export type ItemLive = {
  __typename?: 'ItemLive';
  fee?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  isLive?: Maybe<Scalars['Boolean']['output']>;
  log?: Maybe<Array<Maybe<ItemLiveLog>>>;
  product?: Maybe<Product>;
  status?: Maybe<ItemLiveStatus>;
  supplier?: Maybe<Supplier>;
  url?: Maybe<Scalars['String']['output']>;
};

export type ItemLiveInput = {
  fee: Scalars['String']['input'];
  itemid: Scalars['Int']['input'];
};

export type ItemLiveLog = {
  __typename?: 'ItemLiveLog';
  text?: Maybe<Scalars['String']['output']>;
};

export enum ItemLiveStatus {
  Approved = 'APPROVED',
  Canceled = 'CANCELED',
  Pending = 'PENDING',
  Rejected = 'REJECTED'
}

export enum KhmerloadNewsCategory {
  CelebrityEntertainment = 'celebrity_entertainment',
  Knowledge = 'knowledge',
  Novels = 'novels',
  Social = 'social',
  Sports = 'sports',
  Technology = 'technology',
  Vehicle = 'vehicle'
}

export enum KindOfNotification {
  All = 'ALL',
  Normal = 'NORMAL',
  Repeated = 'REPEATED'
}

export type LateOrderType = {
  __typename?: 'LateOrderType';
  isLate?: Maybe<Scalars['Boolean']['output']>;
  message?: Maybe<Scalars['String']['output']>;
};

export type LatePackageDetail = {
  __typename?: 'LatePackageDetail';
  description?: Maybe<Scalars['String']['output']>;
  package?: Maybe<Package>;
  transactionDate?: Maybe<Scalars['String']['output']>;
};

export type LegacyDeliveryNote = {
  __typename?: 'LegacyDeliveryNote';
  id?: Maybe<Scalars['Int']['output']>;
  returnedItems?: Maybe<Array<Maybe<CustomerOrderItemV2>>>;
};

export type LinkedPayment = {
  __typename?: 'LinkedPayment';
  cardType?: Maybe<Scalars['String']['output']>;
  expireAt?: Maybe<Scalars['Int']['output']>;
  icon?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  maskNumber?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  type?: Maybe<LinkedPaymentType>;
};

export enum LinkedPaymentType {
  Aba = 'ABA',
  AbaCard = 'ABA_CARD',
  AbaMasterCard = 'ABA_MASTER_CARD',
  AbaVisaCard = 'ABA_VISA_CARD',
  Amk = 'AMK'
}

export type LiveShopping = {
  __typename?: 'LiveShopping';
  createdAt?: Maybe<Scalars['String']['output']>;
  dash?: Maybe<Scalars['String']['output']>;
  ended?: Maybe<Scalars['Boolean']['output']>;
  hls?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  items?: Maybe<Array<Maybe<DisplayProduct>>>;
  liveAt?: Maybe<Scalars['String']['output']>;
  liveAtInTimestamp?: Maybe<Scalars['Int']['output']>;
  liveChatChannelId?: Maybe<Scalars['String']['output']>;
  liveSubscribed?: Maybe<Scalars['Int']['output']>;
  rtmp?: Maybe<Scalars['String']['output']>;
  store?: Maybe<Supplier>;
  streamKey?: Maybe<Scalars['String']['output']>;
  thumbnail?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type LiveShoppingInput = {
  ended?: InputMaybe<Scalars['Boolean']['input']>;
  liveAt?: InputMaybe<Scalars['String']['input']>;
  productIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  thumbnail?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type LiveStockStatus = {
  __typename?: 'LiveStockStatus';
  available?: Maybe<Scalars['Int']['output']>;
  creator?: Maybe<Admin>;
  date?: Maybe<Scalars['String']['output']>;
  drafting?: Maybe<Scalars['Int']['output']>;
  finding?: Maybe<Scalars['Int']['output']>;
  product?: Maybe<DisplayProduct>;
  sku?: Maybe<StockKeepingUnit>;
  stock?: Maybe<Scalars['Int']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  waiting?: Maybe<Scalars['Int']['output']>;
};

export type Location = {
  addressID?: InputMaybe<Scalars['Int']['input']>;
  coordinate?: InputMaybe<Coordinate>;
};

export type LoginActivity = {
  __typename?: 'LoginActivity';
  admin?: Maybe<Admin>;
  createdAt?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  ip?: Maybe<Scalars['String']['output']>;
  ipAddressDescription?: Maybe<Scalars['String']['output']>;
  safe?: Maybe<Scalars['Boolean']['output']>;
};

export enum LoginBankEnum {
  Amk = 'AMK'
}

export type LoginStatus = {
  __typename?: 'LoginStatus';
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
  token?: Maybe<Scalars['String']['output']>;
};

export type LoginSupplierResponse = {
  __typename?: 'LoginSupplierResponse';
  message?: Maybe<Scalars['String']['output']>;
  status?: Maybe<LoginSupplierResponseStatus>;
  success?: Maybe<Scalars['Boolean']['output']>;
  token?: Maybe<Scalars['String']['output']>;
  useDeliveryService?: Maybe<Scalars['Boolean']['output']>;
};

export enum LoginSupplierResponseStatus {
  CompanyExist = 'COMPANY_EXIST',
  Exists = 'EXISTS',
  Expired = 'EXPIRED',
  Forget = 'FORGET',
  Inactive = 'INACTIVE',
  NotVerify = 'NOT_VERIFY',
  Pending = 'PENDING',
  Rejected = 'REJECTED',
  Reviewed = 'REVIEWED',
  Verified = 'VERIFIED'
}

export type LoginlessAddedEvent = {
  __typename?: 'LoginlessAddedEvent';
  activePendingCount?: Maybe<Scalars['Int']['output']>;
  isNewCheckoutAdded?: Maybe<Scalars['Boolean']['output']>;
};

export type LoginlessEvent = {
  __typename?: 'LoginlessEvent';
  id?: Maybe<Scalars['Int']['output']>;
  payload?: Maybe<Scalars['JSON']['output']>;
  type?: Maybe<LoginlessEventType>;
};

export enum LoginlessEventType {
  Added = 'ADDED',
  Approved = 'APPROVED',
  Rejected = 'REJECTED',
  Review = 'REVIEW',
  Unreachable = 'UNREACHABLE'
}

export type LoginlessOrder = {
  __typename?: 'LoginlessOrder';
  address?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  customerName?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  lastReviewAt?: Maybe<Scalars['Float']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  referral?: Maybe<Scalars['String']['output']>;
  status?: Maybe<LoginlessOrderStatus>;
  total?: Maybe<Scalars['Decimal']['output']>;
  unreachableAt?: Maybe<Scalars['String']['output']>;
  unreachableCount?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Admin>;
};

export type LoginlessOrderApproveResponse = {
  __typename?: 'LoginlessOrderApproveResponse';
  customerId?: Maybe<Scalars['Int']['output']>;
  orderId?: Maybe<Scalars['Int']['output']>;
};

export type LoginlessOrderItem = {
  __typename?: 'LoginlessOrderItem';
  code?: Maybe<Scalars['String']['output']>;
  color?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  picture?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['String']['output']>;
  priceBeforeDiscount?: Maybe<Scalars['String']['output']>;
  productId?: Maybe<Scalars['Int']['output']>;
  size?: Maybe<Scalars['String']['output']>;
  skuId?: Maybe<Scalars['Int']['output']>;
};

export type LoginlessOrderItemInput = {
  skuId: Scalars['Int']['input'];
};

export enum LoginlessOrderRejectReason {
  InvalidPhoneNumber = 'INVALID_PHONE_NUMBER',
  Other = 'OTHER',
  TestBuying = 'TEST_BUYING',
  Unreachable = 'UNREACHABLE',
  WrongPhoneNumber = 'WRONG_PHONE_NUMBER'
}

export enum LoginlessOrderStatus {
  Approved = 'APPROVED',
  Pending = 'PENDING',
  Rejected = 'REJECTED'
}

export type LuckyDraw = {
  __typename?: 'LuckyDraw';
  active?: Maybe<Scalars['Boolean']['output']>;
  cost?: Maybe<Scalars['Int']['output']>;
  cover?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Admin>;
  description?: Maybe<Scalars['String']['output']>;
  endedAt?: Maybe<Scalars['String']['output']>;
  expired?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  joined?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  ongoing?: Maybe<Scalars['Boolean']['output']>;
  participants?: Maybe<Scalars['Int']['output']>;
  published?: Maybe<Scalars['Boolean']['output']>;
  startedAt?: Maybe<Scalars['String']['output']>;
  thumbnail?: Maybe<Scalars['String']['output']>;
  winner?: Maybe<CustomerBasic>;
};

export type LuckyDrawInput = {
  cost?: InputMaybe<Scalars['Int']['input']>;
  cover?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['String']['input']>;
  createdBy?: InputMaybe<Scalars['Int']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  endedAt?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  published?: InputMaybe<Scalars['Boolean']['input']>;
  startedAt?: InputMaybe<Scalars['String']['input']>;
  thumbnail?: InputMaybe<Scalars['String']['input']>;
  winner?: InputMaybe<Scalars['Int']['input']>;
};

export type MapCoordinate = {
  __typename?: 'MapCoordinate';
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
};

export type MapCoordinateInput = {
  lat?: InputMaybe<Scalars['Float']['input']>;
  lng?: InputMaybe<Scalars['Float']['input']>;
};

export type MapMultipolygon = {
  __typename?: 'MapMultipolygon';
  fillColor?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  polygon?: Maybe<Array<Maybe<MapPolygon>>>;
  tag?: Maybe<Scalars['String']['output']>;
};

export type MapPlaceLoationResponse = {
  __typename?: 'MapPlaceLoationResponse';
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
};

export type MapPlaceSuggestion = {
  __typename?: 'MapPlaceSuggestion';
  googlePlace?: Maybe<GoogleCachePlace>;
  name?: Maybe<Scalars['String']['output']>;
  placeId?: Maybe<Scalars['String']['output']>;
};

export type MapPolygon = {
  __typename?: 'MapPolygon';
  fillColor?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  polygon?: Maybe<Array<Maybe<MapCoordinate>>>;
  tag?: Maybe<Scalars['String']['output']>;
};

export type MapSuggestionLatLngResponse = {
  __typename?: 'MapSuggestionLatLngResponse';
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  placeId?: Maybe<Scalars['String']['output']>;
};

export type MassDiscountInput = {
  option?: InputMaybe<MassDiscountOption>;
  percentage?: InputMaybe<Scalars['Decimal']['input']>;
};

export enum MassDiscountOption {
  Add = 'ADD',
  Overwrite = 'OVERWRITE',
  Subtract = 'SUBTRACT'
}

export type MassPriceInput = {
  option?: InputMaybe<MassPriceOption>;
  percentage?: InputMaybe<Scalars['Decimal']['input']>;
};

export enum MassPriceOption {
  Add = 'ADD',
  Subtract = 'SUBTRACT'
}

export type MassProductInput = {
  discount?: InputMaybe<MassDiscountInput>;
  price?: InputMaybe<MassPriceInput>;
  renewPublishDate?: InputMaybe<Scalars['Boolean']['input']>;
  returnable?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MassUpload = {
  __typename?: 'MassUpload';
  createdAt?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  progress?: Maybe<Scalars['Int']['output']>;
  reference?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type MassUploadDetail = {
  __typename?: 'MassUploadDetail';
  batch?: Maybe<MassUpload>;
  errors?: Maybe<Scalars['JSON']['output']>;
  products?: Maybe<Array<Maybe<Product>>>;
  uploadedProducts?: Maybe<Array<Maybe<MassUploadItem>>>;
};

export type MassUploadItem = {
  __typename?: 'MassUploadItem';
  id?: Maybe<Scalars['Int']['output']>;
  productId?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  supplierCode?: Maybe<Scalars['String']['output']>;
};

export type MassUploadResponse = {
  __typename?: 'MassUploadResponse';
  batchId?: Maybe<Scalars['Int']['output']>;
};

export type Media = {
  __typename?: 'Media';
  createdBy?: Maybe<Admin>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  deletedBy?: Maybe<Admin>;
  id?: Maybe<Scalars['Int']['output']>;
  inputDate?: Maybe<Scalars['String']['output']>;
  link?: Maybe<Scalars['String']['output']>;
  mediaType?: Maybe<MediaType>;
  payload?: Maybe<Scalars['String']['output']>;
  position?: Maybe<Scalars['Int']['output']>;
  purpose?: Maybe<Scalars['Int']['output']>;
  thumbnail?: Maybe<Scalars['String']['output']>;
};

export type MediaDataInput = {
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  link?: InputMaybe<Scalars['String']['input']>;
  mediaType?: InputMaybe<MediaType>;
  payload?: InputMaybe<Scalars['String']['input']>;
  purpose?: InputMaybe<Scalars['Int']['input']>;
  thumbnail?: InputMaybe<Scalars['String']['input']>;
};

export type MediaDetail = {
  __typename?: 'MediaDetail';
  createdAt?: Maybe<Scalars['String']['output']>;
  fileSizeKbyte?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  lenghtSecond?: Maybe<Scalars['Int']['output']>;
  thumbnailUrl?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type MediaInput = {
  fileSizeKbyte?: InputMaybe<Scalars['Int']['input']>;
  lenghtSecond?: InputMaybe<Scalars['Int']['input']>;
  thumbnailUrl?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export enum MediaType {
  Picture = 'PICTURE',
  Video = 'VIDEO'
}

export type MercantAnnouncementInput = {
  contentInMarkdown?: InputMaybe<Scalars['String']['input']>;
  pushNotification?: InputMaybe<Scalars['Boolean']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type Merchant = {
  __typename?: 'Merchant';
  abaLink?: Maybe<Scalars['String']['output']>;
  address?: Maybe<Scalars['String']['output']>;
  approvedBy?: Maybe<Scalars['Int']['output']>;
  approvedDate?: Maybe<Scalars['String']['output']>;
  balance?: Maybe<Scalars['String']['output']>;
  bankAccountHoldName?: Maybe<Scalars['String']['output']>;
  bankAccountNumber?: Maybe<Scalars['String']['output']>;
  bankName?: Maybe<Scalars['String']['output']>;
  banner?: Maybe<Scalars['String']['output']>;
  canRequestPickup?: Maybe<SupplierRequestPickupAbility>;
  contact?: Maybe<Scalars['String']['output']>;
  coordLat?: Maybe<Scalars['String']['output']>;
  coordLng?: Maybe<Scalars['String']['output']>;
  emails?: Maybe<Scalars['String']['output']>;
  enabledChat?: Maybe<Scalars['Boolean']['output']>;
  fiscalCodeNumber?: Maybe<Scalars['String']['output']>;
  frontStoreImage?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  isMoreSecurity?: Maybe<Scalars['Boolean']['output']>;
  isSeller?: Maybe<Scalars['Boolean']['output']>;
  level?: Maybe<Scalars['Int']['output']>;
  logo?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  origin?: Maybe<Origin>;
  ownerName?: Maybe<Scalars['String']['output']>;
  ownerNumber?: Maybe<Scalars['String']['output']>;
  ownerType?: Maybe<Scalars['String']['output']>;
  paidRegister?: Maybe<Scalars['Boolean']['output']>;
  pos?: Maybe<Scalars['Boolean']['output']>;
  prefix?: Maybe<Scalars['String']['output']>;
  recruiterId?: Maybe<Scalars['Int']['output']>;
  registerNumber?: Maybe<Scalars['String']['output']>;
  role?: Maybe<Scalars['String']['output']>;
  telegram?: Maybe<Scalars['String']['output']>;
  telegramGroupId?: Maybe<Scalars['String']['output']>;
  userType?: Maybe<Scalars['String']['output']>;
  vat?: Maybe<Scalars['String']['output']>;
  verifiedBankAccount?: Maybe<Scalars['String']['output']>;
};

export type MerchantAnnouncement = {
  __typename?: 'MerchantAnnouncement';
  contentInMarkdown?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Admin>;
  id?: Maybe<Scalars['Int']['output']>;
  pushNotification?: Maybe<Scalars['Boolean']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type MerchantBrand = {
  __typename?: 'MerchantBrand';
  alias?: Maybe<Scalars['String']['output']>;
  banner?: Maybe<Scalars['String']['output']>;
  brand?: Maybe<Scalars['Boolean']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  picture?: Maybe<Scalars['String']['output']>;
  requested?: Maybe<Scalars['Boolean']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  supplier?: Maybe<Supplier>;
};

export type MerchantInput = {
  abaLink?: InputMaybe<Scalars['String']['input']>;
  address?: InputMaybe<Scalars['String']['input']>;
  bankAccountHoldName?: InputMaybe<Scalars['String']['input']>;
  bankAccountNumber?: InputMaybe<Scalars['String']['input']>;
  bankName?: InputMaybe<Scalars['String']['input']>;
  banner?: InputMaybe<Scalars['String']['input']>;
  categoryIds?: InputMaybe<Scalars['String']['input']>;
  contact?: InputMaybe<Scalars['String']['input']>;
  coordLat?: InputMaybe<Scalars['String']['input']>;
  coordLng?: InputMaybe<Scalars['String']['input']>;
  emails?: InputMaybe<Scalars['String']['input']>;
  fiscalCodeNumber?: InputMaybe<Scalars['String']['input']>;
  frontStoreImage?: InputMaybe<Scalars['String']['input']>;
  logo?: InputMaybe<Scalars['String']['input']>;
  ownerName?: InputMaybe<Scalars['String']['input']>;
  ownerNumber?: InputMaybe<Scalars['String']['input']>;
  ownerType?: InputMaybe<Scalars['String']['input']>;
  storeName?: InputMaybe<Scalars['String']['input']>;
  vat?: InputMaybe<Scalars['String']['input']>;
  verifiedBankAccount?: InputMaybe<Scalars['String']['input']>;
};

export type MerchantOrder = {
  __typename?: 'MerchantOrder';
  code?: Maybe<Scalars['String']['output']>;
  coid?: Maybe<Scalars['Int']['output']>;
  color?: Maybe<Scalars['String']['output']>;
  customerID?: Maybe<Scalars['Int']['output']>;
  dateArrived?: Maybe<Scalars['String']['output']>;
  dateDelivery?: Maybe<Scalars['String']['output']>;
  dateMerchantShipped?: Maybe<Scalars['String']['output']>;
  dateOutOfStock?: Maybe<Scalars['String']['output']>;
  datePrepared?: Maybe<Scalars['String']['output']>;
  dateReady?: Maybe<Scalars['String']['output']>;
  dateRequestPickup?: Maybe<Scalars['String']['output']>;
  dateReturn?: Maybe<Scalars['String']['output']>;
  dateReturning?: Maybe<Scalars['String']['output']>;
  dateShipperSent?: Maybe<Scalars['String']['output']>;
  dateUncollected?: Maybe<Scalars['String']['output']>;
  inPickupCoverage?: Maybe<Scalars['Int']['output']>;
  itemID?: Maybe<Scalars['Int']['output']>;
  orderDate?: Maybe<Scalars['String']['output']>;
  orderID?: Maybe<Scalars['Int']['output']>;
  orderedDate?: Maybe<Scalars['String']['output']>;
  ostatus?: Maybe<Scalars['Int']['output']>;
  packageDateArrived?: Maybe<Scalars['String']['output']>;
  packageDateMerchantShipped?: Maybe<Scalars['String']['output']>;
  packageDatePrepared?: Maybe<Scalars['String']['output']>;
  packageDateRequestPickup?: Maybe<Scalars['String']['output']>;
  packageDateShipperSent?: Maybe<Scalars['String']['output']>;
  picture?: Maybe<Scalars['String']['output']>;
  requestedPickup?: Maybe<Scalars['Int']['output']>;
  size?: Maybe<Scalars['String']['output']>;
  supplier?: Maybe<Scalars['Int']['output']>;
  supplier_code?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['JSON']['output']>;
  totalItem?: Maybe<Scalars['Int']['output']>;
  totalItemAfterPrepared?: Maybe<Scalars['Int']['output']>;
  totalItemOutOfStock?: Maybe<Scalars['Int']['output']>;
  totalItemPrepared?: Maybe<Scalars['Int']['output']>;
  tracking?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type MerchantOrderItem = {
  __typename?: 'MerchantOrderItem';
  code?: Maybe<Scalars['String']['output']>;
  color?: Maybe<Scalars['String']['output']>;
  commission?: Maybe<Scalars['Float']['output']>;
  currentStock?: Maybe<Scalars['Int']['output']>;
  customerID?: Maybe<Scalars['Int']['output']>;
  deliveryFee?: Maybe<Scalars['Float']['output']>;
  discount?: Maybe<Scalars['Float']['output']>;
  fbl?: Maybe<Scalars['Boolean']['output']>;
  fullPrice?: Maybe<Scalars['Float']['output']>;
  handlingFee?: Maybe<Scalars['Float']['output']>;
  itemID?: Maybe<Scalars['Int']['output']>;
  log?: Maybe<Array<Maybe<OrderItemLog>>>;
  orderDate?: Maybe<Scalars['String']['output']>;
  package?: Maybe<Package>;
  packageId?: Maybe<Scalars['Int']['output']>;
  picture?: Maybe<Scalars['String']['output']>;
  prepaidAmount?: Maybe<Scalars['Float']['output']>;
  remoteStock?: Maybe<Scalars['Boolean']['output']>;
  size?: Maybe<Scalars['String']['output']>;
  skuStock?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<CustomerOrderItemStatus>;
  supplier?: Maybe<Supplier>;
  supplierCode?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  trackingNumber?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  uuid?: Maybe<Scalars['String']['output']>;
};

export type MerchantSponsorCampaign = {
  __typename?: 'MerchantSponsorCampaign';
  amount?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  finishedAt?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  rate?: Maybe<Scalars['String']['output']>;
  status?: Maybe<MerchantSponsorCampaignStatus>;
  totalImpression?: Maybe<Scalars['Int']['output']>;
  totalRemaining?: Maybe<Scalars['Int']['output']>;
};

export enum MerchantSponsorCampaignStatus {
  Approved = 'APPROVED',
  Deleted = 'DELETED',
  Paused = 'PAUSED',
  Pending = 'PENDING',
  Rejected = 'REJECTED'
}

export type MerchantSponsorItem = {
  __typename?: 'MerchantSponsorItem';
  code?: Maybe<Scalars['String']['output']>;
  impression?: Maybe<Scalars['Int']['output']>;
  itemId?: Maybe<Scalars['Int']['output']>;
  picture?: Maybe<Scalars['String']['output']>;
  remaining?: Maybe<Scalars['Int']['output']>;
  supplierCode?: Maybe<Scalars['String']['output']>;
};

export type MerchantStore = {
  __typename?: 'MerchantStore';
  categoryList?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  logo?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type MerchantTopup = {
  __typename?: 'MerchantTopup';
  amount?: Maybe<Scalars['String']['output']>;
  date?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  merchant?: Maybe<Supplier>;
};

export type MerchantTotalOrder = {
  __typename?: 'MerchantTotalOrder';
  status?: Maybe<Scalars['String']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
};

export enum MoneyBatchTransferStatus {
  Pending = 'PENDING',
  Reviewed = 'REVIEWED'
}

export type MoneyTransferBatch = {
  __typename?: 'MoneyTransferBatch';
  bankTransferList?: Maybe<Array<Maybe<UnverifiedBankTransfer>>>;
  createdDate?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  paymentProof?: Maybe<Scalars['String']['output']>;
  reviewedDate?: Maybe<Scalars['String']['output']>;
  status?: Maybe<MoneyBatchTransferStatus>;
};

export type MultiLangString = {
  __typename?: 'MultiLangString';
  en?: Maybe<Scalars['String']['output']>;
  km?: Maybe<Scalars['String']['output']>;
  zh?: Maybe<Scalars['String']['output']>;
};

export type MultiLangStringInput = {
  en?: InputMaybe<Scalars['String']['input']>;
  km?: InputMaybe<Scalars['String']['input']>;
  zh?: InputMaybe<Scalars['String']['input']>;
};

export type MultiOffersTemplateInput = {
  brandId?: InputMaybe<Scalars['Int']['input']>;
  categoryId?: InputMaybe<Scalars['Int']['input']>;
  color?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description?: InputMaybe<MultiLanguageInput>;
  media?: InputMaybe<Array<InputMaybe<MediaInput>>>;
  size?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title?: InputMaybe<MultiLanguageInput>;
};

export type MultiOffersTemplateType = {
  __typename?: 'MultiOffersTemplateType';
  brandId?: Maybe<Brand>;
  categoryId?: Maybe<Category>;
  color?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Admin>;
  deletedAt?: Maybe<Scalars['String']['output']>;
  deletedBy?: Maybe<Admin>;
  description?: Maybe<MultiLanguageType>;
  id?: Maybe<Scalars['Int']['output']>;
  media?: Maybe<Array<Maybe<MediaDetail>>>;
  productOffers?: Maybe<Array<Maybe<BasicProduct>>>;
  size?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  thumbnail?: Maybe<Scalars['String']['output']>;
  title?: Maybe<MultiLanguageType>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Admin>;
};


export type MultiOffersTemplateTypeProductOffersArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  activatePromotion?: Maybe<ActivatedPromotion>;
  addAddress?: Maybe<Scalars['Int']['output']>;
  addCampaignTrackerProduct?: Maybe<Scalars['Int']['output']>;
  addCartItem?: Maybe<UpdateCartResponse>;
  addItemLive?: Maybe<Scalars['Boolean']['output']>;
  addMedia?: Maybe<Scalars['Boolean']['output']>;
  addNewStore?: Maybe<MyStore>;
  addOrderTrackingCode?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated payment is added in customerBalanceService */
  addPayment?: Maybe<Payment>;
  addProductChoice?: Maybe<Scalars['Boolean']['output']>;
  addProductGroupItem?: Maybe<Scalars['Boolean']['output']>;
  addSavingPoint?: Maybe<Scalars['Boolean']['output']>;
  addStaffBalance?: Maybe<Scalars['Boolean']['output']>;
  addStaffDeposit?: Maybe<Scalars['Boolean']['output']>;
  addStockTransaction?: Maybe<Scalars['Int']['output']>;
  addSupplier?: Maybe<Scalars['Boolean']['output']>;
  addSupplierCustomer?: Maybe<Scalars['Boolean']['output']>;
  addSupplierFee?: Maybe<Scalars['Int']['output']>;
  addToReplenishmentWishlist?: Maybe<Scalars['Int']['output']>;
  addWishList?: Maybe<Scalars['Boolean']['output']>;
  adminDisburseForReferrer?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  adminFollowStore?: Maybe<Scalars['Boolean']['output']>;
  applyDiscountCampaign?: Maybe<Scalars['Boolean']['output']>;
  approveCustomerOrder?: Maybe<Scalars['Boolean']['output']>;
  approveEventCampaignItem?: Maybe<Scalars['Boolean']['output']>;
  approveLoginlessOrder?: Maybe<LoginlessOrderApproveResponse>;
  approveProductUploadDraft?: Maybe<Scalars['Boolean']['output']>;
  approveSellerAdsItem?: Maybe<Scalars['Boolean']['output']>;
  approveSupplier?: Maybe<Scalars['Boolean']['output']>;
  approveSupplierProductRequest?: Maybe<Scalars['Boolean']['output']>;
  arriveSupplierShipmentAtShipper?: Maybe<Scalars['JSON']['output']>;
  attachAffiliateReferral?: Maybe<Scalars['Boolean']['output']>;
  attachNotificationToken?: Maybe<Scalars['Boolean']['output']>;
  attachPackageBarcode?: Maybe<Scalars['Boolean']['output']>;
  attachPackageTracker?: Maybe<Scalars['Boolean']['output']>;
  attachPaymentProof?: Maybe<Scalars['Boolean']['output']>;
  attachProductRecycleWithPackage?: Maybe<Scalars['Boolean']['output']>;
  attachShipmentTrackingCode?: Maybe<Scalars['Boolean']['output']>;
  attachSupplierReferral?: Maybe<Scalars['Boolean']['output']>;
  autoAssignPackagePickup?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  bannerCreate?: Maybe<Scalars['Boolean']['output']>;
  bannerUpdate?: Maybe<Scalars['Boolean']['output']>;
  bindNodeToPackage?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  blockCustomer?: Maybe<Scalars['Int']['output']>;
  blockUser?: Maybe<Scalars['Boolean']['output']>;
  blockUserPost?: Maybe<Scalars['Boolean']['output']>;
  broadcastCustomerOrder?: Maybe<Scalars['Boolean']['output']>;
  calculateCustomerOrderItemSupplierCommission?: Maybe<Scalars['Boolean']['output']>;
  cancelCustomerRefund?: Maybe<Scalars['Boolean']['output']>;
  cancelSupplierRestockingSku?: Maybe<Scalars['Boolean']['output']>;
  changeCustomerOrderAddress?: Maybe<Scalars['Boolean']['output']>;
  changeCustomerOrderDeliveryFee?: Maybe<Scalars['Boolean']['output']>;
  changeCustomerOrderItemStatus?: Maybe<CustomerOrderItemStatusResult>;
  changeCustomerPassword?: Maybe<Scalars['Boolean']['output']>;
  changeMediaPosition?: Maybe<Scalars['Boolean']['output']>;
  changeMerchantPassword?: Maybe<Scalars['Boolean']['output']>;
  changeSellerAccountPhoneNumber?: Maybe<Scalars['Boolean']['output']>;
  changeStatusItemLive?: Maybe<Scalars['Boolean']['output']>;
  changeStatusSellerAdsCampaignResolver?: Maybe<Scalars['Boolean']['output']>;
  changeSupplierPassword?: Maybe<Scalars['Boolean']['output']>;
  checkToGiveAwaySpinPoint?: Maybe<GiveAwayCheckResult>;
  checkValidNode?: Maybe<Scalars['JSON']['output']>;
  checkout?: Maybe<Scalars['Boolean']['output']>;
  checkoutOrderDraft?: Maybe<Scalars['Boolean']['output']>;
  checkoutV2?: Maybe<CheckoutV2>;
  /** @deprecated Product is no longer claimed by affiliate */
  claimAffiliateProduct?: Maybe<Scalars['String']['output']>;
  claimDeliveryPackage?: Maybe<Scalars['Boolean']['output']>;
  claimPackage?: Maybe<Scalars['Boolean']['output']>;
  completeProductRecycle?: Maybe<Scalars['Boolean']['output']>;
  completeThreadCommentTask?: Maybe<ThreadComment>;
  createAffiliateProductPublish?: Maybe<Scalars['Boolean']['output']>;
  createAgentDisbursement?: Maybe<Scalars['Int']['output']>;
  createAppDiscoverySource?: Maybe<Scalars['Boolean']['output']>;
  createBarcode?: Maybe<Sku>;
  createCampaignTracker?: Maybe<Scalars['Int']['output']>;
  createCategory?: Maybe<Scalars['Boolean']['output']>;
  createClearanceStock?: Maybe<ResponseStatus>;
  createCoreProduct?: Maybe<Scalars['Boolean']['output']>;
  createCustomPage?: Maybe<Scalars['Int']['output']>;
  createCustomReport?: Maybe<Scalars['Int']['output']>;
  createCustomer?: Maybe<Scalars['Int']['output']>;
  createCustomerAddressInquiry?: Maybe<Scalars['Boolean']['output']>;
  createCustomerNote?: Maybe<Scalars['Boolean']['output']>;
  createCustomerNoteTemplate?: Maybe<Scalars['Int']['output']>;
  createCustomerOrder?: Maybe<Scalars['Int']['output']>;
  createCustomerOrderReturnPackage?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  createCustomerRefund?: Maybe<Scalars['Boolean']['output']>;
  createCustomerReturn?: Maybe<Scalars['Boolean']['output']>;
  createCustomerSlot?: Maybe<Scalars['Int']['output']>;
  createDeliveryAgent: Scalars['Int']['output'];
  createDeliveryNote?: Maybe<Scalars['Int']['output']>;
  createDigitalWarranty?: Maybe<Scalars['Int']['output']>;
  createDiscountCampaign?: Maybe<Scalars['Int']['output']>;
  createDropPoint: Scalars['Int']['output'];
  /** @deprecated Unused featured */
  createFacebookPage: Scalars['Int']['output'];
  createGroupBuy?: Maybe<Scalars['Boolean']['output']>;
  createImagePackage?: Maybe<Scalars['Boolean']['output']>;
  createInventorySlot?: Maybe<Scalars['Int']['output']>;
  createLiveShopping?: Maybe<Scalars['Int']['output']>;
  createLoginlessOrder?: Maybe<Scalars['Int']['output']>;
  createLuckyDraw?: Maybe<Scalars['Int']['output']>;
  createMassUpload?: Maybe<MassUploadResponse>;
  createMerchantAnnouncement?: Maybe<Scalars['Int']['output']>;
  createMoneyTransferBatch?: Maybe<Scalars['Int']['output']>;
  createMultiOffersTemplate?: Maybe<Scalars['Int']['output']>;
  createNewStore?: Maybe<Supplier>;
  createNotificationSchedule?: Maybe<Scalars['Int']['output']>;
  createNotificationSegment?: Maybe<Scalars['Int']['output']>;
  createOrderDraft?: Maybe<Scalars['Int']['output']>;
  createOrderTemplate?: Maybe<Scalars['Int']['output']>;
  createPackageC2C?: Maybe<Scalars['Int']['output']>;
  createPackageNote?: Maybe<Scalars['Int']['output']>;
  createPackageV2?: Maybe<Scalars['Int']['output']>;
  createPackageV3?: Maybe<PackageCreateResponse>;
  createPackageV4?: Maybe<PackageCreateResponse>;
  createPartnerAdsDisbursement?: Maybe<Scalars['Int']['output']>;
  createPostRelation?: Maybe<Scalars['Boolean']['output']>;
  createProductGroup?: Maybe<Scalars['Boolean']['output']>;
  createPromotion?: Maybe<Scalars['Boolean']['output']>;
  createPromotionCampaign?: Maybe<Scalars['Boolean']['output']>;
  createPurchaseOrder?: Maybe<Scalars['Int']['output']>;
  createReturningPackageFrom?: Maybe<Scalars['Int']['output']>;
  createSellerAdsCampaign: Scalars['Int']['output'];
  createSellerAdsCampaignItem: Scalars['Int']['output'];
  createSellerFrontBannerAdsV2?: Maybe<Scalars['Int']['output']>;
  createSellerPackage?: Maybe<Scalars['Boolean']['output']>;
  createSellerProductAdsV2?: Maybe<Scalars['Int']['output']>;
  createSellerProductBannerAdsV2?: Maybe<Scalars['Int']['output']>;
  createShopRequest?: Maybe<Scalars['Int']['output']>;
  createSpinReward?: Maybe<Scalars['Int']['output']>;
  createSupplierAddress?: Maybe<Scalars['Int']['output']>;
  createSupplierAffiliateProduct?: Maybe<Scalars['Int']['output']>;
  createSupplierCustorderItem?: Maybe<Scalars['Boolean']['output']>;
  createSupplierInventoryRemoval?: Maybe<Scalars['JSON']['output']>;
  createSupplierLogisticShipper?: Maybe<Scalars['JSON']['output']>;
  createSupplierMediaFolder?: Maybe<Scalars['Int']['output']>;
  createSupplierProductRequest?: Maybe<Scalars['Int']['output']>;
  createSupplierProductViewTab?: Maybe<Scalars['Int']['output']>;
  createSupplierRestockingSku?: Maybe<Scalars['Boolean']['output']>;
  createSupplierVendor?: Maybe<Scalars['Int']['output']>;
  createThreadComment?: Maybe<ThreadComment>;
  createUserPost?: Maybe<Scalars['Int']['output']>;
  createUserPostComment?: Maybe<Scalars['Int']['output']>;
  deleteAddress?: Maybe<Scalars['Boolean']['output']>;
  deleteAffiliateProductPublish?: Maybe<Scalars['Boolean']['output']>;
  /** This is used for our offline who always do double checkout. It will remove the order and return back the old stock */
  deleteCustomerOrder?: Maybe<Scalars['Boolean']['output']>;
  deleteCustomerOrderItem?: Maybe<Scalars['Boolean']['output']>;
  deleteDeliveryAgent?: Maybe<Scalars['Boolean']['output']>;
  deleteDigitalWarranty?: Maybe<Scalars['Boolean']['output']>;
  deleteMultiOffersTemplate?: Maybe<Scalars['Boolean']['output']>;
  deleteNotificationSchedule?: Maybe<Scalars['Boolean']['output']>;
  deleteOrderDraft?: Maybe<Scalars['Boolean']['output']>;
  deleteSellerAdsItem?: Maybe<Scalars['Boolean']['output']>;
  deleteSupplier?: Maybe<Scalars['Boolean']['output']>;
  deleteSupplierAffiliateProduct?: Maybe<Scalars['Boolean']['output']>;
  deleteSupplierDisbursement?: Maybe<Scalars['Boolean']['output']>;
  deleteSupplierMediaFile?: Maybe<Scalars['Boolean']['output']>;
  deleteSupplierMediaFolder?: Maybe<Scalars['Boolean']['output']>;
  deleteUserCommentPost?: Maybe<Scalars['Boolean']['output']>;
  deleteUserPost?: Maybe<Scalars['Boolean']['output']>;
  disbursementRequest?: Maybe<Scalars['String']['output']>;
  doSpin?: Maybe<WinSpinReward>;
  editGroupBuy?: Maybe<Scalars['Boolean']['output']>;
  editItemLive?: Maybe<Scalars['Boolean']['output']>;
  eventCampaignCreate?: Maybe<Scalars['Boolean']['output']>;
  eventCampaignEdit?: Maybe<Scalars['Boolean']['output']>;
  eventCampaignJoin?: Maybe<Scalars['JSON']['output']>;
  exchangeSavingPointToSpinPoint?: Maybe<Scalars['Boolean']['output']>;
  exportAffiliateDisburseemnt?: Maybe<Scalars['Boolean']['output']>;
  exportPartnerAdsDisburseemnt?: Maybe<Scalars['Boolean']['output']>;
  exportReferrerDisbursement?: Maybe<Scalars['Boolean']['output']>;
  exportSupplierDisbursement?: Maybe<Scalars['Boolean']['output']>;
  fixPackageIssue?: Maybe<Scalars['Boolean']['output']>;
  fixingCustomerDeliveryFee?: Maybe<Scalars['Boolean']['output']>;
  followCustomerOrder?: Maybe<Scalars['Boolean']['output']>;
  followStore?: Maybe<Scalars['Boolean']['output']>;
  followUser?: Maybe<Scalars['Boolean']['output']>;
  forceNotificationSegmentUpdate?: Maybe<Scalars['Boolean']['output']>;
  forceUpdatePackage?: Maybe<Scalars['Boolean']['output']>;
  forgetSupplierPassword?: Maybe<LoginSupplierResponse>;
  foundShopRequestFinding?: Maybe<Scalars['Boolean']['output']>;
  generateCustomerPaymentLog?: Maybe<Scalars['JSON']['output']>;
  generateCustomerTokenByPhone?: Maybe<CustomerTokenType>;
  generatePackageBarcode?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  generatePackageInvoice?: Maybe<Scalars['Boolean']['output']>;
  generateTOTP?: Maybe<Scalars['String']['output']>;
  generateToken?: Maybe<Scalars['String']['output']>;
  generateVip125PaymentLink?: Maybe<Scalars['JSON']['output']>;
  grantCustomReportPermission?: Maybe<Scalars['Boolean']['output']>;
  /** Marked comment as handled */
  handledComment?: Maybe<Scalars['Boolean']['output']>;
  increaseLoginlessOrderUnreachable?: Maybe<Scalars['Boolean']['output']>;
  joinLuckyDraw?: Maybe<Scalars['Boolean']['output']>;
  likeUserComment?: Maybe<Scalars['Boolean']['output']>;
  likeUserPost?: Maybe<Scalars['Boolean']['output']>;
  logActivity?: Maybe<Scalars['Boolean']['output']>;
  logStaffLocation?: Maybe<Scalars['Boolean']['output']>;
  loginAdministrator?: Maybe<Scalars['String']['output']>;
  loginAffiliate?: Maybe<LoginStatus>;
  loginAgent?: Maybe<Scalars['String']['output']>;
  loginBankCustomer?: Maybe<Scalars['String']['output']>;
  loginSupplier?: Maybe<LoginSupplierResponse>;
  logout?: Maybe<Scalars['Boolean']['output']>;
  makeACopyProduct?: Maybe<Scalars['Int']['output']>;
  markAgentDisbursementPaid?: Maybe<Scalars['Boolean']['output']>;
  markCartItemSelected?: Maybe<Scalars['Boolean']['output']>;
  markChannelRequiredSupport?: Maybe<Scalars['Boolean']['output']>;
  markChannelSeen?: Maybe<Scalars['Boolean']['output']>;
  markCustomPage?: Maybe<Scalars['Boolean']['output']>;
  markCustomerNotificationSeen?: Maybe<Scalars['Boolean']['output']>;
  markCustomerSkill?: Maybe<Scalars['Boolean']['output']>;
  markDonotShowClickToDoorMessage?: Maybe<Scalars['Boolean']['output']>;
  markFacebookPost?: Maybe<Scalars['Boolean']['output']>;
  markFavoriteCustomReport?: Maybe<Scalars['Boolean']['output']>;
  markOrderDraft?: Maybe<Scalars['Boolean']['output']>;
  markPackageDelivered?: Maybe<Scalars['Boolean']['output']>;
  markPackageReturning?: Maybe<Scalars['Boolean']['output']>;
  markPackageStatus?: Maybe<Scalars['Boolean']['output']>;
  markProductReviewHelpful?: Maybe<Scalars['Boolean']['output']>;
  markRestockingSku?: Maybe<Scalars['Boolean']['output']>;
  markSellerNotificationSeen?: Maybe<Scalars['Boolean']['output']>;
  markSupplierShipmentAsArrived?: Maybe<Scalars['Boolean']['output']>;
  markSupplierShipperToDeparted?: Maybe<Scalars['Boolean']['output']>;
  markUnreachableCustomer?: Maybe<Scalars['Boolean']['output']>;
  massUpdateProduct?: Maybe<Scalars['Boolean']['output']>;
  merchantAddTrackingNumber?: Maybe<Scalars['Boolean']['output']>;
  merchantAddTrackingNumberOrderShipped?: Maybe<Scalars['Boolean']['output']>;
  merchantAppendSupplyBrand?: Maybe<Scalars['Boolean']['output']>;
  merchantCreateBrand?: Maybe<Scalars['Boolean']['output']>;
  merchantCreateDiscountItem?: Maybe<Scalars['Boolean']['output']>;
  merchantCreateSponsor?: Maybe<Scalars['Boolean']['output']>;
  merchantInactiveDiscountCampaign?: Maybe<Scalars['Boolean']['output']>;
  merchantProductShipment?: Maybe<Scalars['String']['output']>;
  merchantProductShipmentUpdate?: Maybe<Scalars['String']['output']>;
  merchantRequestPickupShipment?: Maybe<Scalars['Boolean']['output']>;
  merchantSponsorCancel?: Maybe<Scalars['Boolean']['output']>;
  merchantUpdateBrand?: Maybe<Scalars['Boolean']['output']>;
  merchantUpdateDiscount?: Maybe<Scalars['Boolean']['output']>;
  moveSupplierMediaFile?: Maybe<Scalars['Boolean']['output']>;
  moveSupplierMediaFolder?: Maybe<Scalars['Boolean']['output']>;
  notifyCustomerPromoCode?: Maybe<Scalars['Boolean']['output']>;
  oos?: Maybe<Scalars['Boolean']['output']>;
  payAffiliateCommission?: Maybe<Scalars['Boolean']['output']>;
  payAffiliateDisbursement?: Maybe<Scalars['Boolean']['output']>;
  payPartnerAdsDisbursement?: Maybe<Scalars['Boolean']['output']>;
  payReferrerDisbursement?: Maybe<Scalars['Boolean']['output']>;
  paySupplierDisbursement?: Maybe<Scalars['Boolean']['output']>;
  payTransitDisbursement?: Maybe<Scalars['Boolean']['output']>;
  precomputeHubRoute?: Maybe<Scalars['Boolean']['output']>;
  preorderListExport?: Maybe<Scalars['Int']['output']>;
  productChoiceChangeStatus?: Maybe<Scalars['Boolean']['output']>;
  publicUpload: UploadedFile;
  pushGeneralEvent?: Maybe<Scalars['Boolean']['output']>;
  randomLuckyDrawWinner?: Maybe<Scalars['Int']['output']>;
  receivePaymentNotify?: Maybe<ReceivePaymentResponse>;
  reconcilePaymentLogQueue?: Maybe<Scalars['Boolean']['output']>;
  recordFrontBannerClick?: Maybe<Scalars['Boolean']['output']>;
  recordSpecialProductClick?: Maybe<Scalars['Boolean']['output']>;
  refreshSetting?: Maybe<Scalars['Boolean']['output']>;
  registerAffiliate?: Maybe<Scalars['Boolean']['output']>;
  registerCustomer?: Maybe<Scalars['Int']['output']>;
  /** @deprecated change to use registerSupplier instead */
  registerMerchant?: Maybe<Scalars['Boolean']['output']>;
  registerStaff?: Maybe<Scalars['String']['output']>;
  /** @deprecated change to use registerSupplier instead */
  registerStore?: Maybe<SellerRegisterReseller>;
  registerSupplier?: Maybe<LoginSupplierResponse>;
  rejectLoginlessOrder?: Maybe<Scalars['Boolean']['output']>;
  rejectProductUploadDraft?: Maybe<Scalars['Boolean']['output']>;
  rejectSellerAdsItem?: Maybe<Scalars['Boolean']['output']>;
  rejectSupplier?: Maybe<Scalars['Boolean']['output']>;
  removeCampaignTrackerProduct?: Maybe<Scalars['Boolean']['output']>;
  removeCartItem?: Maybe<Scalars['Boolean']['output']>;
  removeCoreProduct?: Maybe<Scalars['Boolean']['output']>;
  removeEventCampaignItem?: Maybe<Scalars['Boolean']['output']>;
  removeFromReplenishmentWishlist?: Maybe<Scalars['Boolean']['output']>;
  removeImagePackage?: Maybe<Scalars['Boolean']['output']>;
  removeLinkedPayment?: Maybe<Scalars['Boolean']['output']>;
  removeLuckyDrawParticipant?: Maybe<Scalars['Boolean']['output']>;
  removeProductGroupItem?: Maybe<Scalars['Boolean']['output']>;
  removeProductReview?: Maybe<Scalars['Boolean']['output']>;
  removeSellerTelegramGroup?: Maybe<Scalars['Boolean']['output']>;
  removeSupplierProductViewTab?: Maybe<Scalars['Boolean']['output']>;
  removeWishList?: Maybe<Scalars['Boolean']['output']>;
  renameSupplierMediaFile?: Maybe<Scalars['Boolean']['output']>;
  renameSupplierMediaFolder?: Maybe<Scalars['Boolean']['output']>;
  reportUser?: Maybe<Scalars['Boolean']['output']>;
  reportUserPost?: Maybe<Scalars['Boolean']['output']>;
  requestAgentRegister?: Maybe<Scalars['Boolean']['output']>;
  requestCustomerVerification?: Maybe<RequestCustomerVerificationResponse>;
  requestDeactivateAccount?: Maybe<Scalars['Boolean']['output']>;
  requestLinkedPayment?: Maybe<RequestPaymentLink>;
  requestPackagePickup?: Maybe<Scalars['Boolean']['output']>;
  requestPayment?: Maybe<RequestPaymentResponse>;
  requestPickupPackage?: Maybe<Scalars['String']['output']>;
  requestSettlementPackage?: Maybe<Scalars['Int']['output']>;
  requestSupplierOrderPickup?: Maybe<Scalars['Int']['output']>;
  resendSecretCode?: Maybe<SellerResendResult>;
  resendSupplierOtp?: Maybe<LoginSupplierResponse>;
  resetPassword?: Maybe<SellerRegisterReseller>;
  resetSupplierPassword?: Maybe<Scalars['Boolean']['output']>;
  reverseDiscountCampaign?: Maybe<Scalars['Boolean']['output']>;
  reversePackageStatus?: Maybe<Scalars['Boolean']['output']>;
  reviewLockLoginlessOrder?: Maybe<Scalars['Boolean']['output']>;
  reviewMoneyTransferBatch?: Maybe<Scalars['Boolean']['output']>;
  reviewStaffRegistration?: Maybe<Scalars['Boolean']['output']>;
  revokeCustomReportPermission?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Replaced by cartV2 */
  saveCheckoutOption?: Maybe<Scalars['Boolean']['output']>;
  saveProductTag?: Maybe<Scalars['Boolean']['output']>;
  scanMerchantPickup?: Maybe<Scalars['Boolean']['output']>;
  scanPackageIn?: Maybe<ScanInPackageResponse>;
  scanPackageOut?: Maybe<ScanOutPackageResponse>;
  scanShipmentToReceive?: Maybe<Scalars['Boolean']['output']>;
  scanTransitIn?: Maybe<Scalars['Boolean']['output']>;
  scanWalkInPackage?: Maybe<Package>;
  sendAppNotification?: Maybe<Scalars['Boolean']['output']>;
  sendCodeVerify?: Maybe<Scalars['JSON']['output']>;
  sendCustomerNotificationByRest?: Maybe<Scalars['Boolean']['output']>;
  sendLuckyDrawNotification?: Maybe<Scalars['Boolean']['output']>;
  sendMerchantAnnouncementNotification?: Maybe<Scalars['Boolean']['output']>;
  sendMessage?: Maybe<ChatMessage>;
  sendNotification?: Maybe<Scalars['Boolean']['output']>;
  sendOneTimePassword?: Maybe<Scalars['Boolean']['output']>;
  sendPubSubNotify?: Maybe<Scalars['Boolean']['output']>;
  sendScheduledNotification?: Maybe<Scalars['Boolean']['output']>;
  sendSupplierEvent?: Maybe<Scalars['Boolean']['output']>;
  sendTelegramMessage?: Maybe<Scalars['Boolean']['output']>;
  setAdminGroupPermission?: Maybe<Scalars['Boolean']['output']>;
  setDefaultAddress?: Maybe<Scalars['Boolean']['output']>;
  setProductAliasCode?: Maybe<Scalars['Boolean']['output']>;
  setProductRestock?: Maybe<Scalars['Boolean']['output']>;
  setProductSupplierStockAliasCode?: Maybe<Scalars['Boolean']['output']>;
  setProductWarranty?: Maybe<Scalars['Boolean']['output']>;
  setSetting?: Maybe<Scalars['Boolean']['output']>;
  setStatusShipment?: Maybe<Scalars['Boolean']['output']>;
  setStatusSupplierProductRequest?: Maybe<Scalars['Boolean']['output']>;
  setSupplierDefaultAddress?: Maybe<Scalars['Boolean']['output']>;
  setSupplierMassRemoteStock?: Maybe<Scalars['Boolean']['output']>;
  setSupplierPassword?: Maybe<Scalars['Boolean']['output']>;
  setTypeSupplierProductApproved?: Maybe<Scalars['Boolean']['output']>;
  settleSellerCashCollection?: Maybe<Scalars['Boolean']['output']>;
  settleWithSettlementPackageRequest?: Maybe<Scalars['Boolean']['output']>;
  settleWithThirdPartyPackage?: Maybe<Scalars['Boolean']['output']>;
  setupSellerTelegramGroup?: Maybe<Scalars['Boolean']['output']>;
  shippedPackage?: Maybe<Scalars['String']['output']>;
  snapshotAffiliateBalance?: Maybe<Scalars['Boolean']['output']>;
  specialProductCreate?: Maybe<Scalars['Boolean']['output']>;
  specialProductUpdate?: Maybe<Scalars['Boolean']['output']>;
  submitPackageServiceReview?: Maybe<Scalars['Boolean']['output']>;
  submitPaymentLink?: Maybe<Scalars['Boolean']['output']>;
  submitProductReport?: Maybe<Scalars['Boolean']['output']>;
  submitProductReview?: Maybe<Scalars['Boolean']['output']>;
  subscribeVIP?: Maybe<Scalars['Boolean']['output']>;
  supplierChangePasswordDisbursement?: Maybe<Scalars['Boolean']['output']>;
  supplierChangePosCustomerOrderStatus?: Maybe<Scalars['Boolean']['output']>;
  supplierEnableDisableDisbursementSecurity?: Maybe<Scalars['Boolean']['output']>;
  supplierMassUpdatePriceDiscountItem?: Maybe<Scalars['Boolean']['output']>;
  supplierPromoComboCreate?: Maybe<Scalars['Boolean']['output']>;
  supplierPromoComboDelete?: Maybe<Scalars['Boolean']['output']>;
  supplierPromoComboSuspended?: Maybe<Scalars['Boolean']['output']>;
  supplierPromoComboUpdate?: Maybe<Scalars['Boolean']['output']>;
  supplierRemoveFileUploadResolver?: Maybe<Scalars['Boolean']['output']>;
  supplierUploadFileResovler?: Maybe<Scalars['Boolean']['output']>;
  supplierVerifyCode?: Maybe<Scalars['JSON']['output']>;
  suspendSellerAdsV2?: Maybe<Scalars['Boolean']['output']>;
  toggleMultiOfferTemplateWhiteList?: Maybe<Scalars['Boolean']['output']>;
  togglePartnerSeller?: Maybe<Scalars['Boolean']['output']>;
  toggleProductAsTemplate?: Maybe<Scalars['Boolean']['output']>;
  toggleSupplierChat?: Maybe<Scalars['Boolean']['output']>;
  topupPhoneBalance?: Maybe<Scalars['Boolean']['output']>;
  trackExternalOrder?: Maybe<Scalars['Boolean']['output']>;
  trackUserPostInteraction?: Maybe<Scalars['Boolean']['output']>;
  unblockCustomer?: Maybe<Scalars['Boolean']['output']>;
  undoCustomerOrderItemStatus?: Maybe<Scalars['Boolean']['output']>;
  unsubscribeVIP?: Maybe<Scalars['Boolean']['output']>;
  updateAbnormalShipmentStatus?: Maybe<Scalars['Boolean']['output']>;
  updateAddress?: Maybe<Scalars['Boolean']['output']>;
  updateAdmin?: Maybe<Scalars['Boolean']['output']>;
  updateAffiliateProductPublish?: Maybe<Scalars['Boolean']['output']>;
  updateCampaignTracker?: Maybe<Scalars['Boolean']['output']>;
  updateCartItemQty?: Maybe<Scalars['Boolean']['output']>;
  updateCategory?: Maybe<Scalars['Boolean']['output']>;
  updateClearanceStock?: Maybe<ResponseStatus>;
  updateCustomPage?: Maybe<Scalars['Boolean']['output']>;
  updateCustomReport?: Maybe<Scalars['Boolean']['output']>;
  updateCustomer?: Maybe<Scalars['Boolean']['output']>;
  updateCustomerNote?: Maybe<Scalars['Boolean']['output']>;
  updateCustomerNoteTemplate?: Maybe<Scalars['Boolean']['output']>;
  updateCustomerPassword?: Maybe<Scalars['Boolean']['output']>;
  updateCustomerPaymentOptionBlockStatus?: Maybe<Scalars['Boolean']['output']>;
  updateCustomerProfile?: Maybe<Scalars['Boolean']['output']>;
  updateCustomerRefundStatus?: Maybe<Scalars['Boolean']['output']>;
  updateCustomerReturn?: Maybe<Scalars['Boolean']['output']>;
  updateCustomerReturnStatus?: Maybe<Scalars['Boolean']['output']>;
  updateCustomerSlot?: Maybe<Scalars['Boolean']['output']>;
  updateDeliveryAgent?: Maybe<Scalars['Boolean']['output']>;
  updateDigitalWarranty?: Maybe<Scalars['Boolean']['output']>;
  updateDiscountCampaign?: Maybe<Scalars['Boolean']['output']>;
  updateDistrict?: Maybe<Scalars['Boolean']['output']>;
  updateDropPoint?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Unused featured */
  updateFacebookPage?: Maybe<Scalars['Boolean']['output']>;
  updateFrontScreenMenuList?: Maybe<Scalars['Boolean']['output']>;
  updateInventorySlot?: Maybe<Scalars['Boolean']['output']>;
  updateKhmerloadAdsProductClick?: Maybe<Scalars['Boolean']['output']>;
  updateLiveShopping?: Maybe<Scalars['Boolean']['output']>;
  updateLuckyDraw?: Maybe<Scalars['Boolean']['output']>;
  updateMedia?: Maybe<Scalars['Boolean']['output']>;
  updateMerchantAnnouncement?: Maybe<Scalars['Int']['output']>;
  updateMerchantInfo?: Maybe<Scalars['Boolean']['output']>;
  updateMultiOffersTemplate?: Maybe<Scalars['Boolean']['output']>;
  updateNotificationSchedule?: Maybe<Scalars['Boolean']['output']>;
  updateNotificationSegment?: Maybe<Scalars['Boolean']['output']>;
  updateOrderDraft?: Maybe<Scalars['Boolean']['output']>;
  updateOrderTemplate?: Maybe<Scalars['Boolean']['output']>;
  updatePackageNote?: Maybe<Scalars['Boolean']['output']>;
  updatePackageV2?: Maybe<Scalars['Boolean']['output']>;
  updatePayment?: Maybe<Scalars['Boolean']['output']>;
  updateProduct?: Maybe<Scalars['Boolean']['output']>;
  updateProductGroup?: Maybe<Scalars['Boolean']['output']>;
  updateProductRecycleStatus?: Maybe<Scalars['JSON']['output']>;
  updatePromotion?: Maybe<Scalars['Boolean']['output']>;
  updatePromotionCampaign?: Maybe<Scalars['Boolean']['output']>;
  updatePurchaseOrder?: Maybe<Scalars['Boolean']['output']>;
  updateSKU?: Maybe<Scalars['Boolean']['output']>;
  updateSellerAdsCampaign?: Maybe<Scalars['Boolean']['output']>;
  updateSellerAdsCampaignItem?: Maybe<Scalars['Boolean']['output']>;
  updateSellerFrontBannerAdsV2?: Maybe<Scalars['Boolean']['output']>;
  updateSellerPackage?: Maybe<Scalars['Boolean']['output']>;
  updateSellerProductAdsV2?: Maybe<Scalars['Boolean']['output']>;
  updateSellerProductBannerAdsV2?: Maybe<Scalars['Boolean']['output']>;
  updateShopRequest?: Maybe<Scalars['Boolean']['output']>;
  updateSpinReward?: Maybe<Scalars['Boolean']['output']>;
  updateStatusInventoryRemoval?: Maybe<Scalars['Boolean']['output']>;
  updateSupplier?: Maybe<Scalars['Boolean']['output']>;
  updateSupplierAddress?: Maybe<Scalars['Boolean']['output']>;
  updateSupplierAffiliateProduct?: Maybe<Scalars['Boolean']['output']>;
  updateSupplierCustomer?: Maybe<Scalars['Boolean']['output']>;
  updateSupplierFacebookOrderStatus?: Maybe<Scalars['Boolean']['output']>;
  updateSupplierInfo?: Maybe<Scalars['Boolean']['output']>;
  updateSupplierInventoryRemoval?: Maybe<Scalars['JSON']['output']>;
  updateSupplierMoreInformation?: Maybe<Scalars['JSON']['output']>;
  updateSupplierProduct?: Maybe<Scalars['Boolean']['output']>;
  updateSupplierProductRequest?: Maybe<Scalars['JSON']['output']>;
  updateSupplierProductViewTab?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Will merged with updateSupplier resolver in the future */
  updateSupplierSetting?: Maybe<Scalars['Boolean']['output']>;
  updateSupplierVendor?: Maybe<Scalars['Boolean']['output']>;
  updateUserComment?: Maybe<Scalars['Boolean']['output']>;
  updateUserPost?: Maybe<Scalars['Boolean']['output']>;
  updateWarehouse?: Maybe<Scalars['Boolean']['output']>;
  upload: UploadedFile;
  uploadBankTransferProof?: Maybe<Scalars['Boolean']['output']>;
  uploadSupplierProductRequest?: Maybe<Scalars['Int']['output']>;
  verifyAffiliateDisbursement?: Maybe<Scalars['Boolean']['output']>;
  verifyAgentDisbursement?: Maybe<Scalars['Boolean']['output']>;
  verifyCustomer?: Maybe<VerifyCustomerResponse>;
  verifyCustomerOrderBankTransfer?: Maybe<Scalars['Boolean']['output']>;
  verifyCustomerOrderBankTransferFromAccounting?: Maybe<Scalars['Boolean']['output']>;
  verifyDisbursementSecurity?: Maybe<Scalars['JSON']['output']>;
  verifyEmailMerchant?: Maybe<Scalars['String']['output']>;
  verifyOneTimePassword?: Maybe<Scalars['Boolean']['output']>;
  verifyPackageAddress?: Maybe<Scalars['Boolean']['output']>;
  verifyPackageAttempt?: Maybe<Scalars['Boolean']['output']>;
  verifyPartnerAdsDisbursement?: Maybe<Scalars['Boolean']['output']>;
  verifyProductAvailability?: Maybe<Scalars['Boolean']['output']>;
  verifyProductDiscount?: Maybe<Scalars['JSON']['output']>;
  verifyReferrerDisbursement?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated change to use verifySupplierOTP instead */
  verifyRegistration?: Maybe<SellerVerifyResult>;
  verifyResetPassword?: Maybe<SellerVerifyResult>;
  verifySeller?: Maybe<Scalars['Boolean']['output']>;
  verifyStaffBalance?: Maybe<Scalars['Boolean']['output']>;
  verifySupplierDisbursement?: Maybe<Scalars['Boolean']['output']>;
  verifySupplierOtp?: Maybe<LoginSupplierResponse>;
  voidCustomerPayment?: Maybe<Scalars['Boolean']['output']>;
  voidPackage?: Maybe<Scalars['Boolean']['output']>;
};


export type MutationActivatePromotionArgs = {
  checkAmountWithCart?: InputMaybe<Scalars['Boolean']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  customerId?: InputMaybe<Scalars['Int']['input']>;
  orderDraftId?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationAddAddressArgs = {
  address?: InputMaybe<Scalars['String']['input']>;
  customerId?: InputMaybe<Scalars['Int']['input']>;
  data?: InputMaybe<CustomerAddressInput>;
  lat?: InputMaybe<Scalars['String']['input']>;
  lng?: InputMaybe<Scalars['String']['input']>;
};


export type MutationAddCampaignTrackerProductArgs = {
  campaignId: Scalars['Int']['input'];
  productId: Scalars['Int']['input'];
};


export type MutationAddCartItemArgs = {
  adminId?: InputMaybe<Scalars['Int']['input']>;
  item?: InputMaybe<CartItemInput>;
  trackerIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};


export type MutationAddItemLiveArgs = {
  data?: InputMaybe<ItemLiveInput>;
};


export type MutationAddMediaArgs = {
  data?: InputMaybe<MediaDataInput>;
};


export type MutationAddNewStoreArgs = {
  password: Scalars['String']['input'];
  username: Scalars['String']['input'];
};


export type MutationAddOrderTrackingCodeArgs = {
  trackingCode?: InputMaybe<Scalars['String']['input']>;
  uuid?: InputMaybe<Scalars['String']['input']>;
};


export type MutationAddPaymentArgs = {
  payment?: InputMaybe<PaymentInput>;
};


export type MutationAddProductChoiceArgs = {
  itemid: Scalars['Int']['input'];
};


export type MutationAddProductGroupItemArgs = {
  id: Scalars['Int']['input'];
  itemId: Scalars['Int']['input'];
};


export type MutationAddSavingPointArgs = {
  customerID: Scalars['Int']['input'];
  point?: InputMaybe<Scalars['Float']['input']>;
};


export type MutationAddStaffBalanceArgs = {
  amount: Scalars['Float']['input'];
  proofAttachment?: InputMaybe<Scalars['String']['input']>;
  proofTransactionId?: InputMaybe<Scalars['String']['input']>;
  staffId: Scalars['Int']['input'];
  type?: InputMaybe<StaffBalanceType>;
};


export type MutationAddStaffDepositArgs = {
  amount: Scalars['Float']['input'];
  proof?: InputMaybe<Scalars['String']['input']>;
  staffId: Scalars['Int']['input'];
};


export type MutationAddStockTransactionArgs = {
  transactions?: InputMaybe<Array<InputMaybe<StockTransactionInput>>>;
};


export type MutationAddSupplierArgs = {
  active: Scalars['Boolean']['input'];
  address: Scalars['String']['input'];
  banner: Scalars['String']['input'];
  contact: Scalars['String']['input'];
  emails: Scalars['String']['input'];
  exposed: Scalars['Boolean']['input'];
  isSeller: Scalars['Boolean']['input'];
  lat?: InputMaybe<Scalars['String']['input']>;
  lng?: InputMaybe<Scalars['String']['input']>;
  logo: Scalars['String']['input'];
  name: Scalars['String']['input'];
  note: Scalars['String']['input'];
  origin: Origin;
  password: Scalars['String']['input'];
  prefix: Scalars['String']['input'];
  role: SupplierRole;
  sellerType: SellerType;
  username?: InputMaybe<Scalars['String']['input']>;
};


export type MutationAddSupplierCustomerArgs = {
  data: SupplierCustomerInput;
};


export type MutationAddSupplierFeeArgs = {
  amount: Scalars['Decimal']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  supplierId: Scalars['Int']['input'];
};


export type MutationAddToReplenishmentWishlistArgs = {
  itemid: Scalars['Int']['input'];
};


export type MutationAddWishListArgs = {
  productId: Scalars['Int']['input'];
};


export type MutationAdminDisburseForReferrerArgs = {
  referrerIds: Array<InputMaybe<Scalars['Int']['input']>>;
};


export type MutationAdminFollowStoreArgs = {
  followed: Scalars['Boolean']['input'];
  id: Scalars['Int']['input'];
};


export type MutationApplyDiscountCampaignArgs = {
  id: Scalars['Int']['input'];
};


export type MutationApproveCustomerOrderArgs = {
  id: Scalars['Int']['input'];
  markedAsPaid?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationApproveEventCampaignItemArgs = {
  eventId: Scalars['Int']['input'];
  productId?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  status?: InputMaybe<EventCampaignItemStatus>;
  supplierId?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};


export type MutationApproveLoginlessOrderArgs = {
  id: Scalars['Int']['input'];
};


export type MutationApproveProductUploadDraftArgs = {
  data: ContentInput;
  id: Scalars['Int']['input'];
  supplierId: Scalars['Int']['input'];
};


export type MutationApproveSellerAdsItemArgs = {
  activity?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
};


export type MutationApproveSupplierArgs = {
  id: Scalars['Int']['input'];
};


export type MutationApproveSupplierProductRequestArgs = {
  id: Scalars['Int']['input'];
};


export type MutationArriveSupplierShipmentAtShipperArgs = {
  receivedItems?: InputMaybe<Array<InputMaybe<ShipmentItem>>>;
  shipmentId?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationAttachAffiliateReferralArgs = {
  affiliateId: Scalars['Int']['input'];
};


export type MutationAttachNotificationTokenArgs = {
  notificationToken?: InputMaybe<Scalars['String']['input']>;
  oneSignalId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationAttachPackageBarcodeArgs = {
  barcode?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
};


export type MutationAttachPackageTrackerArgs = {
  id: Scalars['Int']['input'];
  tracker?: InputMaybe<Scalars['String']['input']>;
};


export type MutationAttachPaymentProofArgs = {
  paymentId: Scalars['Int']['input'];
  proof: Scalars['String']['input'];
};


export type MutationAttachProductRecycleWithPackageArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
  packageId?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationAttachShipmentTrackingCodeArgs = {
  logonly?: InputMaybe<Scalars['Boolean']['input']>;
  reference: Scalars['String']['input'];
  trackingCode: Scalars['String']['input'];
};


export type MutationAttachSupplierReferralArgs = {
  supplierId: Scalars['Int']['input'];
};


export type MutationAutoAssignPackagePickupArgs = {
  delivererId: Scalars['Int']['input'];
  hub: Scalars['Int']['input'];
  packageNumber?: InputMaybe<Scalars['Int']['input']>;
  useRecommendNumber?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationBannerCreateArgs = {
  data?: InputMaybe<BannerInput>;
};


export type MutationBannerUpdateArgs = {
  data?: InputMaybe<BannerInput>;
  id: Scalars['Int']['input'];
};


export type MutationBindNodeToPackageArgs = {
  nodes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  packageId: Scalars['Int']['input'];
};


export type MutationBlockCustomerArgs = {
  id: Scalars['Int']['input'];
  message?: InputMaybe<Scalars['JSON']['input']>;
};


export type MutationBlockUserArgs = {
  block?: InputMaybe<Scalars['Boolean']['input']>;
  userId: Scalars['Int']['input'];
};


export type MutationBlockUserPostArgs = {
  block?: InputMaybe<Scalars['Boolean']['input']>;
  postId: Scalars['Int']['input'];
};


export type MutationBroadcastCustomerOrderArgs = {
  newOrder?: Scalars['Boolean']['input'];
};


export type MutationCalculateCustomerOrderItemSupplierCommissionArgs = {
  customerOrderId: Scalars['Int']['input'];
};


export type MutationCancelCustomerRefundArgs = {
  refundId: Scalars['Int']['input'];
};


export type MutationCancelSupplierRestockingSkuArgs = {
  id?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};


export type MutationChangeCustomerOrderAddressArgs = {
  addressId: Scalars['Int']['input'];
  orderId: Scalars['Int']['input'];
};


export type MutationChangeCustomerOrderDeliveryFeeArgs = {
  fee?: InputMaybe<Scalars['Float']['input']>;
  orderId: Scalars['Int']['input'];
};


export type MutationChangeCustomerOrderItemStatusArgs = {
  foundFromSlot?: InputMaybe<Scalars['Int']['input']>;
  foundSkuInfo?: InputMaybe<FoundSkuInfoInput>;
  id?: InputMaybe<Scalars['Int']['input']>;
  orderId?: InputMaybe<Scalars['String']['input']>;
  returnedReasonId?: InputMaybe<Scalars['Int']['input']>;
  status: CustomerOrderItemStatus;
  uuid?: InputMaybe<Scalars['String']['input']>;
};


export type MutationChangeCustomerPasswordArgs = {
  newPassword: Scalars['String']['input'];
};


export type MutationChangeMediaPositionArgs = {
  fromId?: InputMaybe<Scalars['Int']['input']>;
  toId?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationChangeMerchantPasswordArgs = {
  newPassword: Scalars['String']['input'];
  oldPassword: Scalars['String']['input'];
};


export type MutationChangeSellerAccountPhoneNumberArgs = {
  newPhoneNumber: Scalars['String']['input'];
};


export type MutationChangeStatusItemLiveArgs = {
  FinishDate?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  liveDate?: InputMaybe<Scalars['String']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
  status: ItemLiveStatus;
  url?: InputMaybe<Scalars['String']['input']>;
};


export type MutationChangeStatusSellerAdsCampaignResolverArgs = {
  id: Scalars['Int']['input'];
  status: SellerAdsCampaignStatus;
};


export type MutationChangeSupplierPasswordArgs = {
  newPassword: Scalars['String']['input'];
  verifyToken: Scalars['String']['input'];
};


export type MutationCheckToGiveAwaySpinPointArgs = {
  type: CheckType;
};


export type MutationCheckValidNodeArgs = {
  node: Scalars['String']['input'];
};


export type MutationCheckoutArgs = {
  orderDraftId?: InputMaybe<Scalars['Int']['input']>;
  paidSecretCode?: InputMaybe<Scalars['String']['input']>;
  param?: InputMaybe<CheckoutInput>;
  paymentProof?: InputMaybe<Scalars['String']['input']>;
  pickupId?: InputMaybe<Scalars['Int']['input']>;
  snapshotId?: InputMaybe<Scalars['Int']['input']>;
  useSavedOption?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationCheckoutOrderDraftArgs = {
  id: Scalars['Int']['input'];
};


export type MutationCheckoutV2Args = {
  orderDraftId?: InputMaybe<Scalars['Int']['input']>;
  paidSecretCode?: InputMaybe<Scalars['String']['input']>;
  param?: InputMaybe<CheckoutInput>;
  paymentProof?: InputMaybe<Scalars['String']['input']>;
  pickupId?: InputMaybe<Scalars['Int']['input']>;
  snapshotId?: InputMaybe<Scalars['Int']['input']>;
  useSavedOption?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationClaimAffiliateProductArgs = {
  itemid?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationClaimDeliveryPackageArgs = {
  adminId?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['Int']['input'];
};


export type MutationClaimPackageArgs = {
  adminId?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['Int']['input'];
};


export type MutationCompleteProductRecycleArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationCompleteThreadCommentTaskArgs = {
  commentId: Scalars['Int']['input'];
};


export type MutationCreateAffiliateProductPublishArgs = {
  data?: InputMaybe<Array<InputMaybe<AffiliateProductPublicInput>>>;
};


export type MutationCreateAgentDisbursementArgs = {
  agentId: Scalars['Int']['input'];
};


export type MutationCreateAppDiscoverySourceArgs = {
  data?: InputMaybe<AppDiscoverySource>;
};


export type MutationCreateBarcodeArgs = {
  color: Scalars['String']['input'];
  productID: Scalars['Int']['input'];
  size: Scalars['String']['input'];
};


export type MutationCreateCampaignTrackerArgs = {
  data: CampaignTrackerInput;
};


export type MutationCreateCategoryArgs = {
  data?: InputMaybe<CategoryInput>;
};


export type MutationCreateClearanceStockArgs = {
  data?: InputMaybe<Array<InputMaybe<ClearanceStockInput>>>;
};


export type MutationCreateCoreProductArgs = {
  itemId?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};


export type MutationCreateCustomPageArgs = {
  data?: InputMaybe<CustomPageInput>;
};


export type MutationCreateCustomReportArgs = {
  data?: InputMaybe<CustomReportInput>;
};


export type MutationCreateCustomerArgs = {
  name?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateCustomerAddressInquiryArgs = {
  additionalInfo?: InputMaybe<Scalars['String']['input']>;
  address?: InputMaybe<Scalars['String']['input']>;
  lat?: InputMaybe<Scalars['String']['input']>;
  lng?: InputMaybe<Scalars['String']['input']>;
  phoneNumber: Scalars['String']['input'];
};


export type MutationCreateCustomerNoteArgs = {
  data?: InputMaybe<CustomerNoteInput>;
};


export type MutationCreateCustomerNoteTemplateArgs = {
  data?: InputMaybe<CustomerNoteTemplateInput>;
};


export type MutationCreateCustomerOrderArgs = {
  activatedPromoID?: InputMaybe<Scalars['Int']['input']>;
  addressId?: InputMaybe<Scalars['Int']['input']>;
  customerId: Scalars['Int']['input'];
  deliveryFee?: InputMaybe<Scalars['Float']['input']>;
  fromSlotId?: InputMaybe<Scalars['Int']['input']>;
  items?: InputMaybe<Array<InputMaybe<CustomerOrderInput>>>;
  storeId?: InputMaybe<Scalars['Int']['input']>;
  useCustomerCreditAmount?: InputMaybe<Scalars['Float']['input']>;
  usePaymentChartId?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationCreateCustomerOrderReturnPackageArgs = {
  id: Array<InputMaybe<Scalars['Int']['input']>>;
};


export type MutationCreateCustomerRefundArgs = {
  accountType: CustomerRefundAccountType;
  amount?: InputMaybe<Scalars['String']['input']>;
  bankAccountHolder?: InputMaybe<Scalars['String']['input']>;
  bankAccountNumber?: InputMaybe<Scalars['String']['input']>;
  bankName?: InputMaybe<Scalars['String']['input']>;
  customerId?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateCustomerReturnArgs = {
  coid: Scalars['Int']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  imagesProofV2?: InputMaybe<Array<InputMaybe<MediaInput>>>;
  returnReason: ReturnReasonType;
  returnedFee: Scalars['Float']['input'];
};


export type MutationCreateCustomerSlotArgs = {
  data: CustomerSlotInput;
};


export type MutationCreateDeliveryAgentArgs = {
  input?: InputMaybe<DeliveryAgentInput>;
};


export type MutationCreateDeliveryNoteArgs = {
  customerId: Scalars['Int']['input'];
  data?: InputMaybe<DeliveryNoteInput>;
};


export type MutationCreateDigitalWarrantyArgs = {
  data?: InputMaybe<DigitalWarrantyData>;
};


export type MutationCreateDiscountCampaignArgs = {
  data?: InputMaybe<DiscountCampaignInput>;
};


export type MutationCreateDropPointArgs = {
  data?: InputMaybe<DropPointInput>;
};


export type MutationCreateFacebookPageArgs = {
  facebookId: Scalars['String']['input'];
  name: Scalars['String']['input'];
};


export type MutationCreateGroupBuyArgs = {
  data?: InputMaybe<GroupBuyNew>;
};


export type MutationCreateImagePackageArgs = {
  barcode?: InputMaybe<Scalars['String']['input']>;
  image: Scalars['String']['input'];
  otherFields?: InputMaybe<PackageInput>;
};


export type MutationCreateInventorySlotArgs = {
  data?: InputMaybe<InventorySlotInput>;
};


export type MutationCreateLiveShoppingArgs = {
  data: LiveShoppingInput;
};


export type MutationCreateLoginlessOrderArgs = {
  address?: InputMaybe<Scalars['String']['input']>;
  customerName?: InputMaybe<Scalars['String']['input']>;
  deliveryFee?: InputMaybe<Scalars['String']['input']>;
  deliveryLocation?: InputMaybe<Scalars['Int']['input']>;
  items?: InputMaybe<Array<InputMaybe<LoginlessOrderItemInput>>>;
  lat?: InputMaybe<Scalars['String']['input']>;
  lng?: InputMaybe<Scalars['String']['input']>;
  phoneNumber: Scalars['String']['input'];
  referral?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateLuckyDrawArgs = {
  data: LuckyDrawInput;
};


export type MutationCreateMassUploadArgs = {
  products: Scalars['JSON']['input'];
  reference?: InputMaybe<Scalars['String']['input']>;
  supplierId: Scalars['Int']['input'];
};


export type MutationCreateMerchantAnnouncementArgs = {
  data: MercantAnnouncementInput;
};


export type MutationCreateMultiOffersTemplateArgs = {
  data: MultiOffersTemplateInput;
};


export type MutationCreateNewStoreArgs = {
  storeName: Scalars['String']['input'];
};


export type MutationCreateNotificationScheduleArgs = {
  data: NotificationScheduleInput;
};


export type MutationCreateNotificationSegmentArgs = {
  data: NotificationSegmentInput;
};


export type MutationCreateOrderDraftArgs = {
  addressId: Scalars['Int']['input'];
  autoCheckout?: InputMaybe<Scalars['Boolean']['input']>;
  customerId: Scalars['Int']['input'];
  customerPayThirdParty?: InputMaybe<Scalars['Boolean']['input']>;
  deliveryFee?: InputMaybe<Scalars['String']['input']>;
  items?: InputMaybe<Array<InputMaybe<OrderDraftItemInput>>>;
  note?: InputMaybe<Scalars['String']['input']>;
  promoCodeId?: InputMaybe<Scalars['Int']['input']>;
  uploaded?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationCreateOrderTemplateArgs = {
  data: OrderTemplateInput;
};


export type MutationCreatePackageC2CArgs = {
  fromAddressId: Scalars['Int']['input'];
  toAddressId: Scalars['Int']['input'];
  toCustomerId: Scalars['Int']['input'];
};


export type MutationCreatePackageNoteArgs = {
  attempt?: InputMaybe<Scalars['Boolean']['input']>;
  data: PackageNoteInput;
  packageId: Scalars['Int']['input'];
};


export type MutationCreatePackageV2Args = {
  data: PackageInput;
  fromImageId?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationCreatePackageV3Args = {
  options?: InputMaybe<PackageOptionsInput>;
  receiver: PackageEntityV2Input;
  sender?: InputMaybe<PackageEntityV2Input>;
};


export type MutationCreatePackageV4Args = {
  input: PackageV4Input;
};


export type MutationCreatePostRelationArgs = {
  postId1?: InputMaybe<Scalars['Int']['input']>;
  postId2?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationCreateProductGroupArgs = {
  data: ProductGroupInput;
};


export type MutationCreatePromotionArgs = {
  data?: InputMaybe<PromotionInput>;
};


export type MutationCreatePromotionCampaignArgs = {
  data?: InputMaybe<PromotionCampaignInput>;
};


export type MutationCreatePurchaseOrderArgs = {
  name?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateReturningPackageFromArgs = {
  attachedBarcode?: InputMaybe<Scalars['String']['input']>;
  packageId: Scalars['Int']['input'];
};


export type MutationCreateSellerAdsCampaignArgs = {
  data: SellerAdsCampaignInput;
};


export type MutationCreateSellerAdsCampaignItemArgs = {
  campaignId: Scalars['Int']['input'];
  data: SellerAdsCampaignItemInput;
};


export type MutationCreateSellerFrontBannerAdsV2Args = {
  banner: AdsBannerInput;
  data: SellerAdsV2Input;
};


export type MutationCreateSellerPackageArgs = {
  nodeId?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationCreateSellerProductAdsV2Args = {
  data: SellerAdsV2Input;
  items: Array<InputMaybe<Scalars['Int']['input']>>;
};


export type MutationCreateSellerProductBannerAdsV2Args = {
  banner: AdsBannerInput;
  data: SellerAdsV2Input;
};


export type MutationCreateShopRequestArgs = {
  data: ShopRequestInput;
};


export type MutationCreateSpinRewardArgs = {
  data: SpinRewardInput;
};


export type MutationCreateSupplierAddressArgs = {
  data?: InputMaybe<SupplierAddressInput>;
};


export type MutationCreateSupplierAffiliateProductArgs = {
  data: AffiliateProductInput;
};


export type MutationCreateSupplierCustorderItemArgs = {
  data?: InputMaybe<SupplierCustorder>;
};


export type MutationCreateSupplierInventoryRemovalArgs = {
  data?: InputMaybe<Array<InputMaybe<ProductShipmentInput>>>;
};


export type MutationCreateSupplierLogisticShipperArgs = {
  referenceCode?: InputMaybe<Scalars['String']['input']>;
  trackingCode: Scalars['String']['input'];
};


export type MutationCreateSupplierMediaFolderArgs = {
  folderId?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateSupplierProductRequestArgs = {
  admin_id?: InputMaybe<Scalars['Int']['input']>;
  content?: InputMaybe<Scalars['JSON']['input']>;
  supplierId?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationCreateSupplierProductViewTabArgs = {
  name: Scalars['String']['input'];
  variables?: InputMaybe<Scalars['JSON']['input']>;
};


export type MutationCreateSupplierRestockingSkuArgs = {
  data?: InputMaybe<Array<InputMaybe<RestockingSku>>>;
};


export type MutationCreateSupplierVendorArgs = {
  data?: InputMaybe<SupplierVendorInput>;
};


export type MutationCreateThreadCommentArgs = {
  attachments?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  content: Scalars['String']['input'];
  followUpAt?: InputMaybe<Scalars['Int']['input']>;
  threadId: Scalars['ID']['input'];
  type?: InputMaybe<ThreadCommentType>;
};


export type MutationCreateUserPostArgs = {
  data?: InputMaybe<UserPostInput>;
};


export type MutationCreateUserPostCommentArgs = {
  commentId?: InputMaybe<Scalars['Int']['input']>;
  data?: InputMaybe<UserPostCommentInput>;
  postId?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationDeleteAddressArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDeleteAffiliateProductPublishArgs = {
  data?: InputMaybe<Array<InputMaybe<AffiliateProductPublicInput>>>;
};


export type MutationDeleteCustomerOrderArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDeleteCustomerOrderItemArgs = {
  actionByMerchant?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['Int']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
};


export type MutationDeleteDeliveryAgentArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDeleteDigitalWarrantyArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDeleteMultiOffersTemplateArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDeleteNotificationScheduleArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDeleteOrderDraftArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationDeleteSellerAdsItemArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDeleteSupplierAffiliateProductArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDeleteSupplierDisbursementArgs = {
  disburseId: Scalars['Int']['input'];
};


export type MutationDeleteSupplierMediaFileArgs = {
  fileId: Scalars['Int']['input'];
};


export type MutationDeleteSupplierMediaFolderArgs = {
  folderId: Scalars['Int']['input'];
};


export type MutationDeleteUserCommentPostArgs = {
  commentId: Scalars['Int']['input'];
};


export type MutationDeleteUserPostArgs = {
  postId: Scalars['Int']['input'];
};


export type MutationDisbursementRequestArgs = {
  password?: InputMaybe<Scalars['String']['input']>;
};


export type MutationDoSpinArgs = {
  spinRewardIds: Array<InputMaybe<Scalars['Int']['input']>>;
};


export type MutationEditGroupBuyArgs = {
  data?: InputMaybe<GroupBuyEdit>;
  id: Scalars['Int']['input'];
};


export type MutationEditItemLiveArgs = {
  data?: InputMaybe<ItemLiveInput>;
  id: Scalars['Int']['input'];
};


export type MutationEventCampaignCreateArgs = {
  data?: InputMaybe<EventCampaignInput>;
};


export type MutationEventCampaignEditArgs = {
  data?: InputMaybe<EventCampaignInput>;
  id: Scalars['Int']['input'];
};


export type MutationEventCampaignJoinArgs = {
  data?: InputMaybe<Array<InputMaybe<EventCampaignItemInput>>>;
  eventCampaignId: Scalars['Int']['input'];
  supplierId: Scalars['Int']['input'];
};


export type MutationExchangeSavingPointToSpinPointArgs = {
  savingPoint: Scalars['Int']['input'];
};


export type MutationExportAffiliateDisburseemntArgs = {
  ids: Array<InputMaybe<Scalars['Int']['input']>>;
};


export type MutationExportPartnerAdsDisburseemntArgs = {
  ids: Array<InputMaybe<Scalars['Int']['input']>>;
};


export type MutationExportReferrerDisbursementArgs = {
  ids: Array<InputMaybe<Scalars['Int']['input']>>;
};


export type MutationExportSupplierDisbursementArgs = {
  disburseIds: Array<InputMaybe<Scalars['Int']['input']>>;
};


export type MutationFixPackageIssueArgs = {
  fee?: InputMaybe<Scalars['Float']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  type: PackageIssueType;
};


export type MutationFixingCustomerDeliveryFeeArgs = {
  customerId: Scalars['Int']['input'];
  fee?: InputMaybe<Scalars['Float']['input']>;
};


export type MutationFollowCustomerOrderArgs = {
  id: Scalars['Int']['input'];
  staffId?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationFollowStoreArgs = {
  status?: InputMaybe<Scalars['Boolean']['input']>;
  storeId: Scalars['Int']['input'];
};


export type MutationFollowUserArgs = {
  id: Scalars['Int']['input'];
  status?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationForceNotificationSegmentUpdateArgs = {
  id: Scalars['Int']['input'];
};


export type MutationForceUpdatePackageArgs = {
  data?: InputMaybe<PackageForceInput>;
  id: Scalars['Int']['input'];
};


export type MutationForgetSupplierPasswordArgs = {
  username: Scalars['String']['input'];
};


export type MutationFoundShopRequestFindingArgs = {
  id: Scalars['Int']['input'];
  slotId: Scalars['Int']['input'];
};


export type MutationGenerateCustomerPaymentLogArgs = {
  customerId?: InputMaybe<Scalars['Int']['input']>;
  option?: InputMaybe<Scalars['String']['input']>;
  stopId?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationGenerateCustomerTokenByPhoneArgs = {
  phoneNumber: Scalars['String']['input'];
};


export type MutationGeneratePackageBarcodeArgs = {
  amount: Scalars['Int']['input'];
};


export type MutationGeneratePackageInvoiceArgs = {
  supplierId: Scalars['Int']['input'];
};


export type MutationGenerateVip125PaymentLinkArgs = {
  code?: InputMaybe<Array<Scalars['String']['input']>>;
  fbId: Scalars['String']['input'];
  fbName: Scalars['String']['input'];
  fbPageId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationGrantCustomReportPermissionArgs = {
  customReportID: Scalars['Int']['input'];
  groupID: Scalars['Int']['input'];
};


export type MutationHandledCommentArgs = {
  id: Scalars['Int']['input'];
};


export type MutationIncreaseLoginlessOrderUnreachableArgs = {
  id: Scalars['Int']['input'];
};


export type MutationJoinLuckyDrawArgs = {
  id: Scalars['Int']['input'];
};


export type MutationLikeUserCommentArgs = {
  commentId: Scalars['Int']['input'];
  like?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationLikeUserPostArgs = {
  like?: InputMaybe<Scalars['Boolean']['input']>;
  postId: Scalars['Int']['input'];
};


export type MutationLogActivityArgs = {
  activity: Scalars['String']['input'];
};


export type MutationLogStaffLocationArgs = {
  lat?: InputMaybe<Scalars['Float']['input']>;
  lng?: InputMaybe<Scalars['Float']['input']>;
};


export type MutationLoginAdministratorArgs = {
  otp?: InputMaybe<Scalars['Int']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};


export type MutationLoginAffiliateArgs = {
  password: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
};


export type MutationLoginAgentArgs = {
  password?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};


export type MutationLoginBankCustomerArgs = {
  bankCustomerId?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  secretCode?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<LoginBankEnum>;
};


export type MutationLoginSupplierArgs = {
  password: Scalars['String']['input'];
  username: Scalars['String']['input'];
};


export type MutationLogoutArgs = {
  token: Scalars['String']['input'];
};


export type MutationMakeACopyProductArgs = {
  itemid: Scalars['Int']['input'];
};


export type MutationMarkAgentDisbursementPaidArgs = {
  id: Scalars['Int']['input'];
  proofImage: Scalars['String']['input'];
};


export type MutationMarkCartItemSelectedArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  select?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationMarkChannelRequiredSupportArgs = {
  channel: Scalars['String']['input'];
  requiredSupport: Scalars['Boolean']['input'];
};


export type MutationMarkChannelSeenArgs = {
  channel: Scalars['String']['input'];
};


export type MutationMarkCustomPageArgs = {
  id: Scalars['Int']['input'];
  index?: InputMaybe<Scalars['Int']['input']>;
  type: CustomPageType;
};


export type MutationMarkCustomerNotificationSeenArgs = {
  batchId?: InputMaybe<Scalars['Int']['input']>;
  notificationId?: InputMaybe<Scalars['Int']['input']>;
  seen?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationMarkCustomerSkillArgs = {
  customerID: Scalars['Int']['input'];
  learnt: Scalars['Boolean']['input'];
  skill: Scalars['String']['input'];
};


export type MutationMarkDonotShowClickToDoorMessageArgs = {
  mark?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationMarkFacebookPostArgs = {
  postID: Scalars['String']['input'];
  type: FacebookPostType;
};


export type MutationMarkFavoriteCustomReportArgs = {
  favorite: Scalars['Boolean']['input'];
  id: Scalars['Int']['input'];
};


export type MutationMarkOrderDraftArgs = {
  draftId: Scalars['Int']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
};


export type MutationMarkPackageDeliveredArgs = {
  cash?: InputMaybe<Scalars['Float']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  lat?: InputMaybe<Scalars['String']['input']>;
  lng?: InputMaybe<Scalars['String']['input']>;
};


export type MutationMarkPackageReturningArgs = {
  id: Scalars['Int']['input'];
  undo?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationMarkPackageStatusArgs = {
  cash?: InputMaybe<Scalars['Float']['input']>;
  id: Scalars['Int']['input'];
  lat?: InputMaybe<Scalars['String']['input']>;
  lng?: InputMaybe<Scalars['String']['input']>;
  status: PackageStatus;
};


export type MutationMarkProductReviewHelpfulArgs = {
  helpful: Scalars['Boolean']['input'];
  id: Scalars['Int']['input'];
};


export type MutationMarkRestockingSkuArgs = {
  restocking?: InputMaybe<Scalars['Boolean']['input']>;
  skuIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};


export type MutationMarkSellerNotificationSeenArgs = {
  id: Scalars['Int']['input'];
};


export type MutationMarkSupplierShipmentAsArrivedArgs = {
  shipmentId: Scalars['Int']['input'];
  warehouseId?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationMarkSupplierShipperToDepartedArgs = {
  trackingCode: Scalars['String']['input'];
};


export type MutationMarkUnreachableCustomerArgs = {
  customerID: Scalars['Int']['input'];
  skill?: InputMaybe<Scalars['String']['input']>;
};


export type MutationMassUpdateProductArgs = {
  data: MassProductInput;
  id: Array<InputMaybe<Scalars['Int']['input']>>;
};


export type MutationMerchantAddTrackingNumberArgs = {
  shipmentid: Scalars['Int']['input'];
  tracking: Scalars['String']['input'];
};


export type MutationMerchantAddTrackingNumberOrderShippedArgs = {
  coid: Scalars['Int']['input'];
  tracking_input: Scalars['String']['input'];
};


export type MutationMerchantAppendSupplyBrandArgs = {
  id: Scalars['Int']['input'];
};


export type MutationMerchantCreateBrandArgs = {
  data?: InputMaybe<BrandInput>;
};


export type MutationMerchantCreateDiscountItemArgs = {
  data?: InputMaybe<Array<InputMaybe<ItemDiscountInput>>>;
  end_date: Scalars['String']['input'];
  start_date: Scalars['String']['input'];
};


export type MutationMerchantCreateSponsorArgs = {
  amount?: InputMaybe<Scalars['String']['input']>;
  itemIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
};


export type MutationMerchantInactiveDiscountCampaignArgs = {
  campaign_id: Scalars['Int']['input'];
};


export type MutationMerchantProductShipmentArgs = {
  data?: InputMaybe<Array<InputMaybe<ProductShipmentInput>>>;
};


export type MutationMerchantProductShipmentUpdateArgs = {
  data?: InputMaybe<Array<InputMaybe<ProductShipmentInput>>>;
  shipmentId: Scalars['Int']['input'];
};


export type MutationMerchantRequestPickupShipmentArgs = {
  arrivedAtHubId?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  packageBarcode?: InputMaybe<Scalars['String']['input']>;
};


export type MutationMerchantSponsorCancelArgs = {
  campaign_id: Scalars['Int']['input'];
};


export type MutationMerchantUpdateBrandArgs = {
  data?: InputMaybe<BrandInput>;
  id: Scalars['Int']['input'];
};


export type MutationMerchantUpdateDiscountArgs = {
  campaign_id: Scalars['Int']['input'];
  data?: InputMaybe<Array<InputMaybe<ItemDiscountInput>>>;
  delete_id?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  end_date: Scalars['String']['input'];
  start_date: Scalars['String']['input'];
};


export type MutationMoveSupplierMediaFileArgs = {
  fileId: Scalars['Int']['input'];
  folderId: Scalars['Int']['input'];
};


export type MutationMoveSupplierMediaFolderArgs = {
  folderId: Scalars['Int']['input'];
  parentId: Scalars['Int']['input'];
};


export type MutationOosArgs = {
  coid?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationPayAffiliateCommissionArgs = {
  affiliateId: Scalars['Int']['input'];
  proof: Scalars['String']['input'];
  snapshotId: Scalars['Int']['input'];
};


export type MutationPayAffiliateDisbursementArgs = {
  id: Scalars['Int']['input'];
  proof: Scalars['String']['input'];
};


export type MutationPayPartnerAdsDisbursementArgs = {
  id: Scalars['Int']['input'];
  proof: Scalars['String']['input'];
};


export type MutationPayReferrerDisbursementArgs = {
  id: Scalars['Int']['input'];
  proof: Scalars['String']['input'];
};


export type MutationPaySupplierDisbursementArgs = {
  disburseId: Scalars['Int']['input'];
  proof: Scalars['String']['input'];
};


export type MutationPayTransitDisbursementArgs = {
  disburseId: Scalars['Int']['input'];
  exchangeRate: Scalars['Decimal']['input'];
  fee?: InputMaybe<Scalars['Decimal']['input']>;
  proof: Scalars['String']['input'];
};


export type MutationPrecomputeHubRouteArgs = {
  hubData: Array<HubRouteInput>;
};


export type MutationPreorderListExportArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};


export type MutationProductChoiceChangeStatusArgs = {
  id: Scalars['Int']['input'];
  status: LoginlessOrderStatus;
};


export type MutationPublicUploadArgs = {
  file: Scalars['Upload']['input'];
};


export type MutationPushGeneralEventArgs = {
  event?: InputMaybe<GeneralEventInput>;
};


export type MutationRandomLuckyDrawWinnerArgs = {
  id: Scalars['Int']['input'];
};


export type MutationReceivePaymentNotifyArgs = {
  hash?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  reference: Scalars['String']['input'];
};


export type MutationReconcilePaymentLogQueueArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationRecordFrontBannerClickArgs = {
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type MutationRecordSpecialProductClickArgs = {
  id: Scalars['Int']['input'];
};


export type MutationRegisterAffiliateArgs = {
  data?: InputMaybe<AffiliateInfoInput>;
};


export type MutationRegisterCustomerArgs = {
  customerName: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
};


export type MutationRegisterMerchantArgs = {
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
  supname: Scalars['String']['input'];
};


export type MutationRegisterStaffArgs = {
  data?: InputMaybe<StaffRegistrationInfoInput>;
};


export type MutationRegisterStoreArgs = {
  address: Scalars['String']['input'];
  lat: Scalars['String']['input'];
  lng: Scalars['String']['input'];
  name: Scalars['String']['input'];
  password: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
  username: Scalars['String']['input'];
};


export type MutationRegisterSupplierArgs = {
  data?: InputMaybe<SupplierRegisterInput>;
};


export type MutationRejectLoginlessOrderArgs = {
  id: Scalars['Int']['input'];
  reason: LoginlessOrderRejectReason;
};


export type MutationRejectProductUploadDraftArgs = {
  id: Scalars['Int']['input'];
  reason: Scalars['String']['input'];
};


export type MutationRejectSellerAdsItemArgs = {
  id: Scalars['Int']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
};


export type MutationRejectSupplierArgs = {
  id: Scalars['Int']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
};


export type MutationRemoveCampaignTrackerProductArgs = {
  id: Scalars['Int']['input'];
};


export type MutationRemoveCartItemArgs = {
  adminId?: InputMaybe<Scalars['Int']['input']>;
  cartItemID: Scalars['Int']['input'];
};


export type MutationRemoveCoreProductArgs = {
  itemId?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};


export type MutationRemoveEventCampaignItemArgs = {
  campaignId: Scalars['Int']['input'];
  id: Scalars['Int']['input'];
};


export type MutationRemoveFromReplenishmentWishlistArgs = {
  itemid: Scalars['Int']['input'];
};


export type MutationRemoveImagePackageArgs = {
  id: Scalars['Int']['input'];
};


export type MutationRemoveLinkedPaymentArgs = {
  linkedPaymentId: Scalars['Int']['input'];
};


export type MutationRemoveLuckyDrawParticipantArgs = {
  customerID: Scalars['Int']['input'];
  luckyDrawID: Scalars['Int']['input'];
};


export type MutationRemoveProductGroupItemArgs = {
  id: Scalars['Int']['input'];
  itemId: Scalars['Int']['input'];
};


export type MutationRemoveProductReviewArgs = {
  id: Scalars['Int']['input'];
};


export type MutationRemoveSupplierProductViewTabArgs = {
  id: Scalars['Int']['input'];
};


export type MutationRemoveWishListArgs = {
  productId: Scalars['Int']['input'];
};


export type MutationRenameSupplierMediaFileArgs = {
  fileId: Scalars['Int']['input'];
  name: Scalars['String']['input'];
};


export type MutationRenameSupplierMediaFolderArgs = {
  folderId: Scalars['Int']['input'];
  name: Scalars['String']['input'];
};


export type MutationReportUserArgs = {
  type?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['Int']['input'];
};


export type MutationReportUserPostArgs = {
  postId: Scalars['Int']['input'];
  type?: InputMaybe<Scalars['String']['input']>;
};


export type MutationRequestAgentRegisterArgs = {
  data?: InputMaybe<AgentRegisterInput>;
};


export type MutationRequestCustomerVerificationArgs = {
  phoneNumber: Scalars['String']['input'];
  type: RequestCustomerVerificationType;
};


export type MutationRequestDeactivateAccountArgs = {
  password?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
};


export type MutationRequestLinkedPaymentArgs = {
  type: OnlinePaymentLinkType;
};


export type MutationRequestPackagePickupArgs = {
  disableAutoAssign?: InputMaybe<Scalars['Boolean']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  scheduleAt?: InputMaybe<Scalars['String']['input']>;
  supplierId?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationRequestPaymentArgs = {
  autoCheckoutAfterReceive?: InputMaybe<Scalars['Boolean']['input']>;
  cartOption?: InputMaybe<CartOptionInput>;
  linkedPaymentId?: InputMaybe<Scalars['Int']['input']>;
  type: OnlinePaymentType;
  useCartAmount?: InputMaybe<Scalars['Boolean']['input']>;
  useCustomerBalance?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationRequestPickupPackageArgs = {
  orderID: Scalars['Int']['input'];
};


export type MutationRequestSettlementPackageArgs = {
  packageIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  sellerId?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationRequestSupplierOrderPickupArgs = {
  customerOrderItemId: Scalars['Int']['input'];
};


export type MutationResendSecretCodeArgs = {
  verifyToken?: InputMaybe<Scalars['String']['input']>;
};


export type MutationResendSupplierOtpArgs = {
  verifyForgeted?: InputMaybe<Scalars['Boolean']['input']>;
  verifyToken: Scalars['String']['input'];
};


export type MutationResetPasswordArgs = {
  username: Scalars['String']['input'];
};


export type MutationResetSupplierPasswordArgs = {
  newPassword: Scalars['String']['input'];
};


export type MutationReverseDiscountCampaignArgs = {
  id: Scalars['Int']['input'];
};


export type MutationReversePackageStatusArgs = {
  packageId: Scalars['Int']['input'];
  status?: InputMaybe<PackageStatus>;
};


export type MutationReviewLockLoginlessOrderArgs = {
  id: Scalars['Int']['input'];
};


export type MutationReviewMoneyTransferBatchArgs = {
  approvedIds: Array<InputMaybe<Scalars['Int']['input']>>;
  batchId: Scalars['Int']['input'];
  proof: Scalars['String']['input'];
  rejectedIds: Array<InputMaybe<Scalars['Int']['input']>>;
};


export type MutationReviewStaffRegistrationArgs = {
  id: Scalars['Int']['input'];
  reviewStatus: ReviewStatus;
};


export type MutationRevokeCustomReportPermissionArgs = {
  customReportID: Scalars['Int']['input'];
  groupID: Scalars['Int']['input'];
};


export type MutationSaveCheckoutOptionArgs = {
  activatedPromoId?: InputMaybe<Scalars['Int']['input']>;
  addressId?: InputMaybe<Scalars['Int']['input']>;
  coordination?: InputMaybe<Coordinate>;
  pickupId?: InputMaybe<Scalars['Int']['input']>;
  trackerIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};


export type MutationSaveProductTagArgs = {
  id: Scalars['Int']['input'];
  tags: Scalars['String']['input'];
};


export type MutationScanMerchantPickupArgs = {
  barcode: Scalars['String']['input'];
};


export type MutationScanPackageInArgs = {
  barcode: Scalars['String']['input'];
  warehouseId?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationScanPackageOutArgs = {
  barcode: Scalars['String']['input'];
  enforceDelivererId?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationScanShipmentToReceiveArgs = {
  packageId: Scalars['Int']['input'];
};


export type MutationScanTransitInArgs = {
  qrCode?: InputMaybe<Scalars['String']['input']>;
};


export type MutationScanWalkInPackageArgs = {
  barcode?: InputMaybe<Scalars['String']['input']>;
  createPacakgeGroup?: InputMaybe<Scalars['Boolean']['input']>;
  packageId?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationSendAppNotificationArgs = {
  badgeCount?: InputMaybe<Scalars['Int']['input']>;
  customerId?: InputMaybe<Scalars['Int']['input']>;
  payload?: InputMaybe<Scalars['JSON']['input']>;
  sellerId?: InputMaybe<Scalars['Int']['input']>;
  subtitle?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  type: AppNotificationType;
};


export type MutationSendCodeVerifyArgs = {
  input: Scalars['String']['input'];
};


export type MutationSendCustomerNotificationByRestArgs = {
  customerIdType?: InputMaybe<CustomerIdType>;
  customerIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  data?: InputMaybe<Scalars['JSON']['input']>;
  heading?: InputMaybe<Scalars['String']['input']>;
  notificationType?: InputMaybe<NotificationType>;
  title?: InputMaybe<Scalars['String']['input']>;
};


export type MutationSendLuckyDrawNotificationArgs = {
  heading?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  luckyDrawId: Scalars['Int']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
};


export type MutationSendMerchantAnnouncementNotificationArgs = {
  id: Scalars['Int']['input'];
  segment?: InputMaybe<SellerSegment>;
};


export type MutationSendMessageArgs = {
  channel: Scalars['String']['input'];
  message: ChatMessageInput;
  replyTo?: InputMaybe<Scalars['Int']['input']>;
  sentBy?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationSendNotificationArgs = {
  data?: InputMaybe<Scalars['JSON']['input']>;
  heading?: InputMaybe<Scalars['String']['input']>;
  mode?: InputMaybe<ScheduledNotificationType>;
  segmentId?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};


export type MutationSendOneTimePasswordArgs = {
  phoneNumber: Scalars['String']['input'];
};


export type MutationSendPubSubNotifyArgs = {
  channel: Scalars['String']['input'];
  content?: InputMaybe<Scalars['JSON']['input']>;
};


export type MutationSendScheduledNotificationArgs = {
  id: Scalars['Int']['input'];
};


export type MutationSendSupplierEventArgs = {
  message?: InputMaybe<Scalars['String']['input']>;
  payload?: InputMaybe<Scalars['JSON']['input']>;
  supplierId: Array<InputMaybe<Scalars['Int']['input']>>;
  type: Scalars['String']['input'];
};


export type MutationSendTelegramMessageArgs = {
  channel: Scalars['String']['input'];
  message: TelegramMessageInput;
};


export type MutationSetAdminGroupPermissionArgs = {
  groupID: Scalars['Int']['input'];
  permissions?: InputMaybe<Array<InputMaybe<AdminGroupPermissionInput>>>;
};


export type MutationSetDefaultAddressArgs = {
  id: Scalars['Int']['input'];
};


export type MutationSetProductAliasCodeArgs = {
  code: Scalars['String']['input'];
  id: Scalars['Int']['input'];
};


export type MutationSetProductRestockArgs = {
  id: Scalars['Int']['input'];
};


export type MutationSetProductSupplierStockAliasCodeArgs = {
  qty: Scalars['Int']['input'];
  skuid: Scalars['Int']['input'];
};


export type MutationSetProductWarrantyArgs = {
  itemids?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  set?: InputMaybe<Scalars['Boolean']['input']>;
  warrantyId?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationSetSettingArgs = {
  option: SettingType;
  value: Scalars['String']['input'];
};


export type MutationSetStatusShipmentArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<ProductShipStatus>;
};


export type MutationSetStatusSupplierProductRequestArgs = {
  id: Scalars['Int']['input'];
  status?: InputMaybe<SupplierStatusRequest>;
};


export type MutationSetSupplierDefaultAddressArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationSetSupplierMassRemoteStockArgs = {
  remoteStock: Scalars['Boolean']['input'];
};


export type MutationSetSupplierPasswordArgs = {
  password: Scalars['String']['input'];
  verifyToken: Scalars['String']['input'];
};


export type MutationSetTypeSupplierProductApprovedArgs = {
  data?: InputMaybe<OfferInput>;
  id: Scalars['Int']['input'];
  status?: InputMaybe<SupplierProductApproved>;
};


export type MutationSettleSellerCashCollectionArgs = {
  sellerId: Scalars['Int']['input'];
};


export type MutationSettleWithSettlementPackageRequestArgs = {
  attachment: Scalars['String']['input'];
  settlementRequestId: Scalars['Int']['input'];
};


export type MutationSettleWithThirdPartyPackageArgs = {
  cashCollected?: InputMaybe<Scalars['Decimal']['input']>;
  packageId: Scalars['Int']['input'];
};


export type MutationSetupSellerTelegramGroupArgs = {
  groupId: Scalars['String']['input'];
};


export type MutationShippedPackageArgs = {
  orderID: Scalars['Int']['input'];
  supplier: Scalars['Int']['input'];
};


export type MutationSnapshotAffiliateBalanceArgs = {
  affiliateIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};


export type MutationSpecialProductCreateArgs = {
  data?: InputMaybe<SpecialProductInput>;
};


export type MutationSpecialProductUpdateArgs = {
  data?: InputMaybe<SpecialProductInput>;
  id: Scalars['Int']['input'];
};


export type MutationSubmitPackageServiceReviewArgs = {
  data: PackageServiceReviewInput;
  uuid?: InputMaybe<Scalars['String']['input']>;
};


export type MutationSubmitPaymentLinkArgs = {
  data?: InputMaybe<SupplierCustorder>;
  posOrderId: Scalars['Int']['input'];
};


export type MutationSubmitProductReportArgs = {
  productId: Scalars['Int']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
  returnId?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationSubmitProductReviewArgs = {
  attachments?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  comment: Scalars['String']['input'];
  productId: Scalars['Int']['input'];
  rating: Scalars['Int']['input'];
};


export type MutationSupplierChangePasswordDisbursementArgs = {
  password: Scalars['String']['input'];
};


export type MutationSupplierChangePosCustomerOrderStatusArgs = {
  coid: Scalars['Int']['input'];
  packageId?: InputMaybe<Scalars['Int']['input']>;
  paidAmount?: InputMaybe<Scalars['Float']['input']>;
  status: SupplierCustorderItemStatus;
};


export type MutationSupplierEnableDisableDisbursementSecurityArgs = {
  enable: Scalars['Boolean']['input'];
  passwordDisbursement: Scalars['String']['input'];
};


export type MutationSupplierMassUpdatePriceDiscountItemArgs = {
  data: Array<InputMaybe<ProductUpdateItem>>;
};


export type MutationSupplierPromoComboCreateArgs = {
  data: PromoComboInput;
};


export type MutationSupplierPromoComboDeleteArgs = {
  id: Scalars['Int']['input'];
};


export type MutationSupplierPromoComboSuspendedArgs = {
  id: Scalars['Int']['input'];
};


export type MutationSupplierPromoComboUpdateArgs = {
  data: PromoComboInput;
  id: Scalars['Int']['input'];
};


export type MutationSupplierRemoveFileUploadResolverArgs = {
  index?: InputMaybe<Scalars['Int']['input']>;
  supplierId: Scalars['Int']['input'];
  url: Scalars['String']['input'];
};


export type MutationSupplierUploadFileResovlerArgs = {
  supplierId: Scalars['Int']['input'];
  url: Scalars['String']['input'];
};


export type MutationSupplierVerifyCodeArgs = {
  code: Scalars['String']['input'];
};


export type MutationSuspendSellerAdsV2Args = {
  id: Scalars['Int']['input'];
};


export type MutationTogglePartnerSellerArgs = {
  supplierId: Scalars['Int']['input'];
};


export type MutationToggleProductAsTemplateArgs = {
  itemId?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationTopupPhoneBalanceArgs = {
  amountInCent: Scalars['Int']['input'];
  operator?: InputMaybe<CambodiaPhoneOperator>;
  phoneNumber: Scalars['String']['input'];
};


export type MutationTrackExternalOrderArgs = {
  data?: InputMaybe<ExternalOrderInput>;
};


export type MutationTrackUserPostInteractionArgs = {
  duration: Scalars['Int']['input'];
  postId: Scalars['Int']['input'];
  totalVideoDuration?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationUnblockCustomerArgs = {
  id: Scalars['Int']['input'];
};


export type MutationUndoCustomerOrderItemStatusArgs = {
  fromStatus: CustomerOrderItemStatus;
  id?: InputMaybe<Scalars['Int']['input']>;
  toStatus: CustomerOrderItemStatus;
};


export type MutationUnsubscribeVipArgs = {
  customerID: Scalars['Int']['input'];
};


export type MutationUpdateAbnormalShipmentStatusArgs = {
  shipmentId?: InputMaybe<Scalars['Int']['input']>;
  solution?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<AbnormalStatusType>;
};


export type MutationUpdateAddressArgs = {
  address?: InputMaybe<Scalars['String']['input']>;
  data?: InputMaybe<CustomerAddressInput>;
  id: Scalars['Int']['input'];
  lat?: InputMaybe<Scalars['String']['input']>;
  lng?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateAdminArgs = {
  data: AdminInput;
  id: Scalars['Int']['input'];
};


export type MutationUpdateAffiliateProductPublishArgs = {
  data?: InputMaybe<Array<InputMaybe<AffiliateProductPublicInput>>>;
};


export type MutationUpdateCampaignTrackerArgs = {
  data: CampaignTrackerInput;
  id: Scalars['Int']['input'];
};


export type MutationUpdateCartItemQtyArgs = {
  adminId?: InputMaybe<Scalars['Int']['input']>;
  cartItemID: Scalars['Int']['input'];
  qty: Scalars['Int']['input'];
};


export type MutationUpdateCategoryArgs = {
  data?: InputMaybe<CategoryInput>;
};


export type MutationUpdateClearanceStockArgs = {
  data?: InputMaybe<ClearanceStockInput>;
  id?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationUpdateCustomPageArgs = {
  data?: InputMaybe<CustomPageInput>;
  id: Scalars['Int']['input'];
};


export type MutationUpdateCustomReportArgs = {
  data?: InputMaybe<CustomReportInput>;
  id: Scalars['Int']['input'];
};


export type MutationUpdateCustomerArgs = {
  data: CustomerInput;
  id?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationUpdateCustomerNoteArgs = {
  data?: InputMaybe<CustomerNoteInput>;
  id?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationUpdateCustomerNoteTemplateArgs = {
  data?: InputMaybe<CustomerNoteTemplateInput>;
  id?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationUpdateCustomerPasswordArgs = {
  newPassword: Scalars['String']['input'];
  oldPassword: Scalars['String']['input'];
};


export type MutationUpdateCustomerPaymentOptionBlockStatusArgs = {
  blockedStatus?: InputMaybe<Array<InputMaybe<PaymentOptionBlockStatusInput>>>;
  customerId: Scalars['Int']['input'];
};


export type MutationUpdateCustomerProfileArgs = {
  data: CustomerProfileInput;
};


export type MutationUpdateCustomerRefundStatusArgs = {
  refundId: Scalars['Int']['input'];
  status: CustomerRefundStatus;
  transferredProof?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateCustomerReturnArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  imagesProofV2?: InputMaybe<Array<InputMaybe<MediaInput>>>;
  packageId?: InputMaybe<Scalars['Int']['input']>;
  returnReason?: InputMaybe<ReturnReasonType>;
  returnedFee?: InputMaybe<Scalars['Float']['input']>;
  thirdPartyReceipt?: InputMaybe<Scalars['String']['input']>;
  triage?: InputMaybe<ReturnItemTriage>;
};


export type MutationUpdateCustomerReturnStatusArgs = {
  id: Scalars['Int']['input'];
  isDiscardedAtBuyer?: InputMaybe<Scalars['Boolean']['input']>;
  rejectedProof?: InputMaybe<Scalars['String']['input']>;
  rejectedReason?: InputMaybe<Scalars['String']['input']>;
  resolvedProps?: InputMaybe<OrderReturnResolveredProps>;
  returnedStatus: ReturnStatusType;
};


export type MutationUpdateCustomerSlotArgs = {
  data?: InputMaybe<CustomerSlotInput>;
  id: Scalars['Int']['input'];
};


export type MutationUpdateDeliveryAgentArgs = {
  id: Scalars['Int']['input'];
  input?: InputMaybe<DeliveryAgentUpdate>;
};


export type MutationUpdateDigitalWarrantyArgs = {
  data?: InputMaybe<DigitalWarrantyData>;
  id: Scalars['Int']['input'];
};


export type MutationUpdateDiscountCampaignArgs = {
  data?: InputMaybe<DiscountCampaignInput>;
  id: Scalars['Int']['input'];
};


export type MutationUpdateDistrictArgs = {
  data: DistrictInput;
  id: Scalars['Int']['input'];
};


export type MutationUpdateDropPointArgs = {
  data?: InputMaybe<DropPointInput>;
  id: Scalars['Int']['input'];
};


export type MutationUpdateFacebookPageArgs = {
  facebookId: Scalars['String']['input'];
  name: Scalars['String']['input'];
};


export type MutationUpdateFrontScreenMenuListArgs = {
  menuList?: InputMaybe<Scalars['JSON']['input']>;
};


export type MutationUpdateInventorySlotArgs = {
  data?: InputMaybe<InventorySlotInput>;
};


export type MutationUpdateKhmerloadAdsProductClickArgs = {
  itemid: Scalars['Int']['input'];
};


export type MutationUpdateLiveShoppingArgs = {
  data: LiveShoppingInput;
  id: Scalars['Int']['input'];
};


export type MutationUpdateLuckyDrawArgs = {
  data: LuckyDrawInput;
  id: Scalars['Int']['input'];
};


export type MutationUpdateMediaArgs = {
  data?: InputMaybe<MediaDataInput>;
  id?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationUpdateMerchantAnnouncementArgs = {
  data: MercantAnnouncementInput;
  id: Scalars['Int']['input'];
};


export type MutationUpdateMerchantInfoArgs = {
  data?: InputMaybe<MerchantInput>;
};


export type MutationUpdateMultiOffersTemplateArgs = {
  data: MultiOffersTemplateInput;
  id: Scalars['Int']['input'];
};


export type MutationUpdateNotificationScheduleArgs = {
  data: NotificationScheduleInput;
  id: Scalars['Int']['input'];
};


export type MutationUpdateNotificationSegmentArgs = {
  data: NotificationSegmentInput;
  id: Scalars['Int']['input'];
};


export type MutationUpdateOrderDraftArgs = {
  addressId: Scalars['Int']['input'];
  autoCheckout?: InputMaybe<Scalars['Boolean']['input']>;
  customerId: Scalars['Int']['input'];
  customerPayThirdParty?: InputMaybe<Scalars['Boolean']['input']>;
  deliveryFee?: InputMaybe<Scalars['String']['input']>;
  items?: InputMaybe<Array<InputMaybe<OrderDraftItemInput>>>;
  note?: InputMaybe<Scalars['String']['input']>;
  orderDraftId: Scalars['Int']['input'];
  promoCodeId?: InputMaybe<Scalars['Int']['input']>;
  uploaded?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationUpdateOrderTemplateArgs = {
  data: OrderTemplateInput;
  id: Scalars['Int']['input'];
};


export type MutationUpdatePackageNoteArgs = {
  data: PackageNoteInput;
  packageNoteId: Scalars['Int']['input'];
};


export type MutationUpdatePackageV2Args = {
  data: PackageInput;
  id: Scalars['Int']['input'];
  uuid?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdatePaymentArgs = {
  data?: InputMaybe<PaymentInputV2>;
  paymentId: Scalars['Int']['input'];
};


export type MutationUpdateProductArgs = {
  data: ProductInput;
  id: Scalars['Int']['input'];
};


export type MutationUpdateProductGroupArgs = {
  data: ProductGroupInput;
  id: Scalars['Int']['input'];
};


export type MutationUpdateProductRecycleStatusArgs = {
  uuid?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdatePromotionArgs = {
  data?: InputMaybe<PromotionInput>;
  id: Scalars['Int']['input'];
};


export type MutationUpdatePromotionCampaignArgs = {
  data?: InputMaybe<PromotionCampaignInput>;
  id: Scalars['Int']['input'];
};


export type MutationUpdatePurchaseOrderArgs = {
  id: Scalars['Int']['input'];
  order?: InputMaybe<PurchaseOrderInput>;
};


export type MutationUpdateSkuArgs = {
  data: SkuInput;
  id: Scalars['Int']['input'];
};


export type MutationUpdateSellerAdsCampaignArgs = {
  data: SellerAdsCampaignInput;
  id: Scalars['Int']['input'];
};


export type MutationUpdateSellerAdsCampaignItemArgs = {
  data: SellerAdsCampaignItemInput;
  id: Scalars['Int']['input'];
};


export type MutationUpdateSellerFrontBannerAdsV2Args = {
  banner: AdsBannerInput;
  data: SellerAdsV2Input;
  id: Scalars['Int']['input'];
};


export type MutationUpdateSellerPackageArgs = {
  nodeId?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  packageId: Scalars['Int']['input'];
};


export type MutationUpdateSellerProductAdsV2Args = {
  data: SellerAdsV2Input;
  id: Scalars['Int']['input'];
  items: Array<InputMaybe<Scalars['Int']['input']>>;
};


export type MutationUpdateSellerProductBannerAdsV2Args = {
  banner: AdsBannerInput;
  data: SellerAdsV2Input;
  id: Scalars['Int']['input'];
};


export type MutationUpdateShopRequestArgs = {
  data: ShopRequestInput;
  id: Scalars['Int']['input'];
};


export type MutationUpdateSpinRewardArgs = {
  data: SpinRewardInput;
  id: Scalars['Int']['input'];
};


export type MutationUpdateStatusInventoryRemovalArgs = {
  data?: InputMaybe<Array<InputMaybe<InventoryRemovalStatusItem>>>;
  id: Scalars['Int']['input'];
  proof?: InputMaybe<Scalars['String']['input']>;
  status: InventoryRemovalStatus;
};


export type MutationUpdateSupplierArgs = {
  data?: InputMaybe<SupplierInput>;
  id: Scalars['Int']['input'];
};


export type MutationUpdateSupplierAddressArgs = {
  data?: InputMaybe<SupplierAddressInput>;
  id: Scalars['Int']['input'];
};


export type MutationUpdateSupplierAffiliateProductArgs = {
  data: AffiliateProductInput;
  id: Scalars['Int']['input'];
};


export type MutationUpdateSupplierCustomerArgs = {
  data?: InputMaybe<SupplierCustomerInput>;
  id: Scalars['Int']['input'];
};


export type MutationUpdateSupplierFacebookOrderStatusArgs = {
  orderId: Scalars['Int']['input'];
  status: SupplierCustorderStatus;
};


export type MutationUpdateSupplierInfoArgs = {
  bankAccountHolderName: Scalars['String']['input'];
  bankAccountNumber: Scalars['String']['input'];
  bankName: Scalars['String']['input'];
  companyRegisterNumber: Scalars['String']['input'];
  fiscalCodeNumber: Scalars['String']['input'];
  id: Scalars['Int']['input'];
  ownerIDNumber: Scalars['String']['input'];
  ownerIDType: Scalars['String']['input'];
  ownerName: Scalars['String']['input'];
  vat: Scalars['String']['input'];
  wechatID: Scalars['String']['input'];
};


export type MutationUpdateSupplierInventoryRemovalArgs = {
  data?: InputMaybe<Array<InputMaybe<ProductShipmentInput>>>;
  removalId?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationUpdateSupplierMoreInformationArgs = {
  data?: InputMaybe<SupplierMoreInformationInput>;
  supplierId?: InputMaybe<Scalars['Int']['input']>;
  verifyToken: Scalars['String']['input'];
};


export type MutationUpdateSupplierProductArgs = {
  data: ProductInput;
  itemId: Scalars['Int']['input'];
};


export type MutationUpdateSupplierProductRequestArgs = {
  admin_id?: InputMaybe<Scalars['Int']['input']>;
  content?: InputMaybe<Scalars['JSON']['input']>;
  id: Scalars['Int']['input'];
  status: Scalars['Int']['input'];
  supplierId?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationUpdateSupplierProductViewTabArgs = {
  id: Scalars['Int']['input'];
  name: Scalars['String']['input'];
  variables?: InputMaybe<Scalars['JSON']['input']>;
};


export type MutationUpdateSupplierSettingArgs = {
  chargeDeliveryFee: Scalars['Boolean']['input'];
  chargeHandlingFee: Scalars['Boolean']['input'];
  chargePickupFee: Scalars['Boolean']['input'];
  freeInventoryFee: Scalars['Boolean']['input'];
  holdDuration: Scalars['Int']['input'];
  id: Scalars['Int']['input'];
  isBrandedStore: Scalars['Boolean']['input'];
  isPaymentGateway: Scalars['Boolean']['input'];
  paymentGatewayID?: InputMaybe<Scalars['Int']['input']>;
  prepaidPickup: Scalars['Boolean']['input'];
  shipperID?: InputMaybe<Scalars['Int']['input']>;
  unlimitedShipment: Scalars['Boolean']['input'];
};


export type MutationUpdateSupplierVendorArgs = {
  data?: InputMaybe<SupplierVendorInput>;
  id: Scalars['Int']['input'];
};


export type MutationUpdateUserCommentArgs = {
  commentId?: InputMaybe<Scalars['Int']['input']>;
  data?: InputMaybe<UserPostCommentInput>;
  postId?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationUpdateUserPostArgs = {
  data?: InputMaybe<UserPostInput>;
  postId: Scalars['Int']['input'];
};


export type MutationUpdateWarehouseArgs = {
  data?: InputMaybe<WarehouseInput>;
  id: Scalars['Int']['input'];
};


export type MutationUploadArgs = {
  file: Scalars['Upload']['input'];
  option?: InputMaybe<UploadAdditionalOptions>;
};


export type MutationUploadBankTransferProofArgs = {
  amount?: InputMaybe<Scalars['String']['input']>;
  khAmount?: InputMaybe<Scalars['String']['input']>;
  paymentType?: InputMaybe<PaymentType>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  proofLink?: InputMaybe<Scalars['String']['input']>;
  secretCode?: InputMaybe<Scalars['String']['input']>;
  service?: InputMaybe<PaymentServiceType>;
  supplierId?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationUploadSupplierProductRequestArgs = {
  admin_id?: InputMaybe<Scalars['Int']['input']>;
  content: Scalars['JSON']['input'];
  item_id?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationVerifyAffiliateDisbursementArgs = {
  id: Scalars['Int']['input'];
};


export type MutationVerifyAgentDisbursementArgs = {
  id: Scalars['Int']['input'];
};


export type MutationVerifyCustomerArgs = {
  otp?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  type: RequestCustomerVerificationType;
};


export type MutationVerifyCustomerOrderBankTransferArgs = {
  alreadyInput?: InputMaybe<Scalars['Boolean']['input']>;
  approved: Scalars['Boolean']['input'];
  bankTransactionId?: InputMaybe<Scalars['String']['input']>;
  orderId: Scalars['Int']['input'];
  payment?: InputMaybe<PaymentInputV2>;
};


export type MutationVerifyCustomerOrderBankTransferFromAccountingArgs = {
  approved?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['Int']['input'];
};


export type MutationVerifyDisbursementSecurityArgs = {
  disbursementPassword?: InputMaybe<Scalars['String']['input']>;
};


export type MutationVerifyEmailMerchantArgs = {
  email: Scalars['String']['input'];
};


export type MutationVerifyOneTimePasswordArgs = {
  phoneNumber: Scalars['String']['input'];
  secretCode: Scalars['Int']['input'];
};


export type MutationVerifyPackageAddressArgs = {
  data?: InputMaybe<VerifyPackageAddressInput>;
  packageId: Scalars['Int']['input'];
};


export type MutationVerifyPackageAttemptArgs = {
  packageLogId: Scalars['Int']['input'];
};


export type MutationVerifyPartnerAdsDisbursementArgs = {
  id: Scalars['Int']['input'];
};


export type MutationVerifyProductAvailabilityArgs = {
  data?: InputMaybe<Array<InputMaybe<ProductAvailability>>>;
};


export type MutationVerifyProductDiscountArgs = {
  discount: Scalars['String']['input'];
  skuId: Scalars['Int']['input'];
};


export type MutationVerifyReferrerDisbursementArgs = {
  id: Scalars['Int']['input'];
};


export type MutationVerifyRegistrationArgs = {
  isSeller?: InputMaybe<Scalars['Boolean']['input']>;
  secretCode?: InputMaybe<Scalars['String']['input']>;
  verifyToken?: InputMaybe<Scalars['String']['input']>;
};


export type MutationVerifyResetPasswordArgs = {
  secretCode?: InputMaybe<Scalars['String']['input']>;
  verifyToken: Scalars['String']['input'];
};


export type MutationVerifySellerArgs = {
  supplierId: Scalars['Int']['input'];
};


export type MutationVerifyStaffBalanceArgs = {
  id: Scalars['Int']['input'];
};


export type MutationVerifySupplierDisbursementArgs = {
  disburseId: Scalars['Int']['input'];
};


export type MutationVerifySupplierOtpArgs = {
  isSeller?: InputMaybe<Scalars['Boolean']['input']>;
  secretCode: Scalars['String']['input'];
  verifyForgeted?: InputMaybe<Scalars['Boolean']['input']>;
  verifyToken: Scalars['String']['input'];
};


export type MutationVoidCustomerPaymentArgs = {
  paymentId: Scalars['Int']['input'];
};


export type MutationVoidPackageArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};

export type MyStore = {
  __typename?: 'MyStore';
  store?: Maybe<Supplier>;
  unreadMessage?: Maybe<Scalars['Int']['output']>;
};

export type NavigationType = {
  __typename?: 'NavigationType';
  payload?: Maybe<Scalars['JSON']['output']>;
  screen?: Maybe<Scalars['String']['output']>;
};

export type NewArrivalCategory = {
  __typename?: 'NewArrivalCategory';
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type NewArrivalFilter = {
  endPrice?: InputMaybe<Scalars['Int']['input']>;
  isChoice?: InputMaybe<Scalars['Boolean']['input']>;
  rating?: InputMaybe<Scalars['Int']['input']>;
  showAll?: InputMaybe<Scalars['Boolean']['input']>;
  startPrice?: InputMaybe<Scalars['Int']['input']>;
};

export type NodeSellerPackage = {
  __typename?: 'NodeSellerPackage';
  color?: Maybe<Scalars['String']['output']>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  deletedDate?: Maybe<Scalars['String']['output']>;
  departedDate?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  nodeId?: Maybe<Scalars['String']['output']>;
  orderDate?: Maybe<Scalars['String']['output']>;
  product?: Maybe<BasicProduct>;
  receive?: Maybe<Scalars['Int']['output']>;
  sent?: Maybe<Scalars['Int']['output']>;
  shipDate?: Maybe<Scalars['String']['output']>;
  size?: Maybe<Scalars['String']['output']>;
  status?: Maybe<CustomerOrderItemStatus>;
  uuid?: Maybe<Scalars['String']['output']>;
};

export type NotificationDelivery = {
  __typename?: 'NotificationDelivery';
  createdAt?: Maybe<Scalars['String']['output']>;
  data?: Maybe<Scalars['JSON']['output']>;
  delivery?: Maybe<NotificationDeliveryDetail>;
  heading?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  segmentName?: Maybe<Scalars['String']['output']>;
  sent?: Maybe<Scalars['Int']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type NotificationDeliveryDetail = {
  __typename?: 'NotificationDeliveryDetail';
  converted?: Maybe<Scalars['Int']['output']>;
  failed?: Maybe<Scalars['Int']['output']>;
  sent?: Maybe<Scalars['Int']['output']>;
};

export type NotificationSchedule = {
  __typename?: 'NotificationSchedule';
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Admin>;
  data?: Maybe<Scalars['JSON']['output']>;
  deletedAt?: Maybe<Scalars['String']['output']>;
  deletedBy?: Maybe<Admin>;
  id?: Maybe<Scalars['Int']['output']>;
  mode?: Maybe<ScheduledNotificationType>;
  phoneNumber?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  repeatedType?: Maybe<RepeatedType>;
  repeatedValue?: Maybe<Scalars['Int']['output']>;
  scheduleAt?: Maybe<Scalars['String']['output']>;
  segmentId?: Maybe<Scalars['Int']['output']>;
  segmentName?: Maybe<Scalars['String']['output']>;
  sent?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Admin>;
};

export type NotificationScheduleInput = {
  data?: InputMaybe<Scalars['JSON']['input']>;
  notificationType?: InputMaybe<ScheduledNotificationType>;
  phoneNumber?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  repeatedType?: InputMaybe<RepeatedType>;
  repeatedValue?: InputMaybe<Scalars['Int']['input']>;
  scheduleAt?: InputMaybe<Scalars['String']['input']>;
  segmentId?: InputMaybe<Scalars['Int']['input']>;
};

export type NotificationSegment = {
  __typename?: 'NotificationSegment';
  condition?: Maybe<Scalars['JSON']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  order?: Maybe<Scalars['Int']['output']>;
  schedule?: Maybe<Scalars['String']['output']>;
  size?: Maybe<Scalars['Int']['output']>;
  updatedEndedAt?: Maybe<Scalars['String']['output']>;
  updatedStartedAt?: Maybe<Scalars['String']['output']>;
};

export type NotificationSegmentInput = {
  condition?: InputMaybe<Scalars['JSON']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  schedule?: InputMaybe<Scalars['String']['input']>;
};

export type OfferInput = {
  discount?: InputMaybe<Scalars['Float']['input']>;
  price?: InputMaybe<Scalars['Float']['input']>;
};

export type OnlinePaymentInfo = {
  __typename?: 'OnlinePaymentInfo';
  credit?: Maybe<Scalars['Decimal']['output']>;
  customer?: Maybe<CustomerBasic>;
  id?: Maybe<Scalars['Int']['output']>;
  inputDate?: Maybe<Scalars['String']['output']>;
  orderId?: Maybe<Scalars['Int']['output']>;
  paid?: Maybe<Scalars['Boolean']['output']>;
  paymentMethod?: Maybe<Scalars['String']['output']>;
};

export enum OnlinePaymentLinkType {
  AbaAof = 'ABA_AOF',
  AbaCof = 'ABA_COF',
  AmkAof = 'AMK_AOF'
}

export enum OnlinePaymentType {
  Aba = 'ABA',
  AbaAof = 'ABA_AOF',
  AbaCof = 'ABA_COF',
  AbaDeeplink = 'ABA_DEEPLINK',
  Acleda = 'ACLEDA',
  AcledaXpay = 'ACLEDA_XPAY',
  AmkAof = 'AMK_AOF',
  AmkDeeplink = 'AMK_DEEPLINK',
  AmkH5 = 'AMK_H5',
  BankTransfer = 'BANK_TRANSFER',
  Huione = 'HUIONE',
  PayLater = 'PAY_LATER',
  Phillip = 'PHILLIP',
  Shinhan = 'SHINHAN',
  Truemoney = 'TRUEMONEY',
  Wing = 'WING'
}

export type OnlineStaffPerformance = {
  __typename?: 'OnlineStaffPerformance';
  admin?: Maybe<Admin>;
  ranking?: Maybe<Scalars['Int']['output']>;
  score?: Maybe<Scalars['Float']['output']>;
  totalApprovedAmount?: Maybe<Scalars['Float']['output']>;
  totalApprovedItem?: Maybe<Scalars['Int']['output']>;
};

export type OnlinemartReportInput = {
  DESC?: InputMaybe<Scalars['Boolean']['input']>;
  end?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<OnlinemartReportOrderBy>;
  productCode?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  reportType?: InputMaybe<OnlinemartReportType>;
  start?: InputMaybe<Scalars['String']['input']>;
  supplierIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};

export enum OnlinemartReportOrderBy {
  AdsSpent = 'ADS_SPENT',
  DeliveredDate = 'DELIVERED_DATE',
  OrderedDate = 'ORDERED_DATE',
  Sales = 'SALES',
  SalesQty = 'SALES_QTY',
  StockQty = 'STOCK_QTY'
}

export enum OnlinemartReportType {
  Inventory = 'INVENTORY',
  Product = 'PRODUCT',
  Sales = 'SALES'
}

export type OrderDraftItem = {
  __typename?: 'OrderDraftItem';
  discount?: Maybe<Scalars['String']['output']>;
  draftId?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  item?: Maybe<BasicProduct>;
  price?: Maybe<Scalars['String']['output']>;
  qty?: Maybe<Scalars['Int']['output']>;
  sku?: Maybe<StockKeepingUnit>;
  skuId?: Maybe<Scalars['Int']['output']>;
};

export type OrderDraftItemInput = {
  discount?: InputMaybe<Scalars['String']['input']>;
  qty: Scalars['Int']['input'];
  skuId: Scalars['Int']['input'];
};

export enum OrderDraftStatus {
  Checkout = 'CHECKOUT',
  Pending = 'PENDING'
}

export type OrderDraftType = {
  __typename?: 'OrderDraftType';
  address?: Maybe<CustomerAddress>;
  admin?: Maybe<Admin>;
  autoCheckout?: Maybe<Scalars['Boolean']['output']>;
  customer?: Maybe<CustomerBasic>;
  customerPayThirdParty?: Maybe<Scalars['Boolean']['output']>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  deliveryFee?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  inputDate?: Maybe<Scalars['String']['output']>;
  items?: Maybe<Array<Maybe<OrderDraftItem>>>;
  note?: Maybe<Scalars['String']['output']>;
  promoCodeId?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<OrderDraftStatus>;
  total?: Maybe<Scalars['String']['output']>;
  uploaded?: Maybe<Scalars['Boolean']['output']>;
};

export type OrderItemDetail = {
  __typename?: 'OrderItemDetail';
  amount?: Maybe<Scalars['Float']['output']>;
  commission?: Maybe<Scalars['Float']['output']>;
  deliveryFee?: Maybe<Scalars['Float']['output']>;
  discount?: Maybe<Scalars['Float']['output']>;
  handlingFee?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  orderDate?: Maybe<Scalars['String']['output']>;
  orderId?: Maybe<Scalars['String']['output']>;
  orderUUID?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  sku?: Maybe<StockKeepingUnit>;
  status?: Maybe<CustomerOrderItemStatus>;
};

export type OrderItemLog = {
  __typename?: 'OrderItemLog';
  date?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
};

export enum OrderItemStats {
  AwaitingPayment = 'AWAITING_PAYMENT',
  AwaitingPrepare = 'AWAITING_PREPARE',
  Delivering = 'DELIVERING',
  Finding = 'FINDING',
  Found = 'FOUND',
  PickupRequested = 'PICKUP_REQUESTED',
  Prepared = 'PREPARED',
  Ready = 'READY',
  Returning = 'RETURNING',
  Shipping = 'SHIPPING'
}

export type OrderReturnResolveredProps = {
  amountToAddToBuyer?: InputMaybe<Scalars['Decimal']['input']>;
  amountToDeductFromSeller?: InputMaybe<Scalars['Decimal']['input']>;
};

export type OrderTemplate = {
  __typename?: 'OrderTemplate';
  active?: Maybe<Scalars['Boolean']['output']>;
  code?: Maybe<Scalars['String']['output']>;
  currentUsed?: Maybe<Scalars['Int']['output']>;
  expiredAt?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  isExpired?: Maybe<Scalars['Boolean']['output']>;
  items?: Maybe<Array<Maybe<OrderTemplateItem>>>;
  maxCustomerUsed?: Maybe<Scalars['Int']['output']>;
  maxUsed?: Maybe<Scalars['Int']['output']>;
  qrCode?: Maybe<Scalars['String']['output']>;
  savingPointCost?: Maybe<Scalars['Int']['output']>;
  supplier?: Maybe<Supplier>;
  type?: Maybe<OrderTemplateType>;
};

export type OrderTemplateInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  expiredAt?: InputMaybe<Scalars['String']['input']>;
  items?: InputMaybe<Array<InputMaybe<OrderTemplateItemInput>>>;
  maxCustomerUsed?: InputMaybe<Scalars['Int']['input']>;
  maxUsed?: InputMaybe<Scalars['Int']['input']>;
};

export type OrderTemplateItem = {
  __typename?: 'OrderTemplateItem';
  id?: Maybe<Scalars['Int']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  qty?: Maybe<Scalars['Int']['output']>;
  sku?: Maybe<Sku>;
  stockKeepingUnit?: Maybe<StockKeepingUnit>;
};

export type OrderTemplateItemInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
  price?: InputMaybe<Scalars['Float']['input']>;
  qty?: InputMaybe<Scalars['Int']['input']>;
  skuId?: InputMaybe<Scalars['Int']['input']>;
};

export enum OrderTemplateType {
  Bundle = 'BUNDLE',
  Exchange = 'EXCHANGE'
}

export type OrderWarranty = {
  __typename?: 'OrderWarranty';
  coid?: Maybe<Scalars['Int']['output']>;
  dayLeft?: Maybe<Scalars['Int']['output']>;
  expiredDate?: Maybe<Scalars['String']['output']>;
  repairCenter?: Maybe<RepairCenter>;
  warranty?: Maybe<DigitalWarranty>;
};

export enum Origin {
  China = 'China',
  Local = 'Local',
  SouthKorea = 'SouthKorea',
  Thailand = 'Thailand',
  Vietnam = 'Vietnam'
}

export type OriginalSupplierSetting = {
  __typename?: 'OriginalSupplierSetting';
  id?: Maybe<Scalars['Int']['output']>;
  settingOption?: Maybe<Scalars['String']['output']>;
  settingValue?: Maybe<Scalars['String']['output']>;
  supplierId?: Maybe<Scalars['Int']['output']>;
};

export type Package = {
  __typename?: 'Package';
  additionalInstruction?: Maybe<Scalars['String']['output']>;
  addressId?: Maybe<Scalars['Int']['output']>;
  addressName?: Maybe<Scalars['String']['output']>;
  agent?: Maybe<Agent>;
  agentId?: Maybe<Scalars['Int']['output']>;
  appointedAt?: Maybe<Scalars['String']['output']>;
  attachedBarcodeAt?: Maybe<Scalars['String']['output']>;
  attempt?: Maybe<Scalars['Int']['output']>;
  barcode?: Maybe<Scalars['String']['output']>;
  barcodeInitial?: Maybe<Scalars['String']['output']>;
  canCreateReturn?: Maybe<Scalars['Boolean']['output']>;
  cash?: Maybe<Scalars['Float']['output']>;
  cashCollected?: Maybe<Scalars['Float']['output']>;
  changeLogs?: Maybe<Array<Maybe<PackageAuditLog>>>;
  claimDeliveryAt?: Maybe<Scalars['String']['output']>;
  claimDeliveryBy?: Maybe<Admin>;
  claimPickupAt?: Maybe<Scalars['String']['output']>;
  claimPickupBy?: Maybe<Admin>;
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Admin>;
  currentWarehouse?: Maybe<Warehouse>;
  customer?: Maybe<CustomerBasic>;
  customerChatChannel?: Maybe<Scalars['String']['output']>;
  customerName?: Maybe<Scalars['String']['output']>;
  customerPayForThirdParty?: Maybe<Scalars['Boolean']['output']>;
  deliveryNoteId?: Maybe<Scalars['Int']['output']>;
  distanceInKmFromCurrentLocation?: Maybe<Scalars['Float']['output']>;
  /** @deprecated We will longer maintain this field */
  dropPoint?: Maybe<DropPoint>;
  dropboxInstruction?: Maybe<Scalars['String']['output']>;
  fee?: Maybe<Scalars['Float']['output']>;
  finalWarehouse?: Maybe<Warehouse>;
  fromCustomer?: Maybe<Customer>;
  hasReturningItem?: Maybe<Scalars['Boolean']['output']>;
  hasStock?: Maybe<Scalars['Boolean']['output']>;
  houseNumber?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  isCancelRequestPickup?: Maybe<Scalars['Boolean']['output']>;
  isDropbox?: Maybe<Scalars['Boolean']['output']>;
  isFinal?: Maybe<Scalars['Boolean']['output']>;
  isPickup?: Maybe<Scalars['Boolean']['output']>;
  isPrepayment?: Maybe<Scalars['Boolean']['output']>;
  isReceiverPay?: Maybe<Scalars['Boolean']['output']>;
  isReturning?: Maybe<Scalars['Boolean']['output']>;
  isSettledWithHq?: Maybe<Scalars['Boolean']['output']>;
  isSettledWithHub?: Maybe<Scalars['Boolean']['output']>;
  isSettledWithSeller?: Maybe<Scalars['Boolean']['output']>;
  isThirdPartyCod?: Maybe<Scalars['Boolean']['output']>;
  items?: Maybe<Array<Maybe<CustomerOrderItemV2>>>;
  lastTransitAt?: Maybe<Scalars['String']['output']>;
  lastTransitBy?: Maybe<Admin>;
  lat?: Maybe<Scalars['String']['output']>;
  legacyDeliveryNote?: Maybe<LegacyDeliveryNote>;
  lng?: Maybe<Scalars['String']['output']>;
  logs?: Maybe<Array<Maybe<PackageLog>>>;
  nextWarehouse?: Maybe<Warehouse>;
  noteFlags?: Maybe<PackageNoteFlagList>;
  /** @deprecated We will longer maintain this field */
  noteList?: Maybe<Array<Maybe<CustomerNote>>>;
  notes?: Maybe<Array<Maybe<PackageNote>>>;
  overSize?: Maybe<Scalars['Boolean']['output']>;
  packageWithLabel?: Maybe<ImagePackage>;
  picture?: Maybe<Scalars['String']['output']>;
  postFee?: Maybe<Scalars['Float']['output']>;
  provinceId?: Maybe<Scalars['Int']['output']>;
  receiver?: Maybe<PackageEntity>;
  requestPickupAt?: Maybe<Scalars['String']['output']>;
  returningFromPackageId?: Maybe<Scalars['Int']['output']>;
  returningRefs?: Maybe<Array<Maybe<Package>>>;
  sender?: Maybe<PackageEntity>;
  settlementWithSeller?: Maybe<SettlementWithSeller>;
  sourceWarehouse?: Maybe<Warehouse>;
  status?: Maybe<PackageStatus>;
  stockItems?: Maybe<Array<Maybe<PackageStockItem>>>;
  streetNumber?: Maybe<Scalars['String']['output']>;
  successAt?: Maybe<Scalars['String']['output']>;
  successLat?: Maybe<Scalars['String']['output']>;
  successLng?: Maybe<Scalars['String']['output']>;
  supplier?: Maybe<Supplier>;
  telegram?: Maybe<Scalars['String']['output']>;
  thirdPartyProvider?: Maybe<Scalars['String']['output']>;
  thirdPartyService?: Maybe<Scalars['Int']['output']>;
  thirdPartyTracker?: Maybe<Scalars['String']['output']>;
  toAgent?: Maybe<Agent>;
  trackingUrl?: Maybe<Scalars['String']['output']>;
  transferOnDelivered?: Maybe<Scalars['Boolean']['output']>;
  type?: Maybe<PackageType>;
  useInsurance?: Maybe<Scalars['Boolean']['output']>;
  uuid?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
  weight?: Maybe<Scalars['Float']['output']>;
  x?: Maybe<Scalars['Int']['output']>;
  y?: Maybe<Scalars['Int']['output']>;
  z?: Maybe<Scalars['Int']['output']>;
};

export type PackageAddedEvent = {
  __typename?: 'PackageAddedEvent';
  count?: Maybe<Scalars['Int']['output']>;
  isNewPackageAdded?: Maybe<Scalars['Boolean']['output']>;
};

export type PackageAuditLog = {
  __typename?: 'PackageAuditLog';
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Admin>;
  id?: Maybe<Scalars['Int']['output']>;
  originalValue?: Maybe<Scalars['JSON']['output']>;
  updatedValue?: Maybe<Scalars['JSON']['output']>;
};

export type PackageBreakdown = {
  __typename?: 'PackageBreakdown';
  agent?: Maybe<Array<Maybe<PackageBreakdownByAgent>>>;
  l192App?: Maybe<Array<Maybe<Package>>>;
  seller?: Maybe<Array<Maybe<PackageBreakdownBySeller>>>;
};

export type PackageBreakdownByAgent = {
  __typename?: 'PackageBreakdownByAgent';
  agent?: Maybe<Admin>;
  packages?: Maybe<Array<Maybe<Package>>>;
};

export type PackageBreakdownBySeller = {
  __typename?: 'PackageBreakdownBySeller';
  packages?: Maybe<Array<Maybe<Package>>>;
  seller?: Maybe<Supplier>;
};

export type PackageCreateResponse = {
  __typename?: 'PackageCreateResponse';
  id: Scalars['Int']['output'];
};

export enum PackageCreatedWith {
  UiV1 = 'UI_V1',
  UiV2 = 'UI_V2'
}

export type PackageCustomer = {
  __typename?: 'PackageCustomer';
  customer?: Maybe<CustomerBasic>;
  value?: Maybe<Scalars['Decimal']['output']>;
};

export type PackageDelivererMonitor = {
  __typename?: 'PackageDelivererMonitor';
  deliverer?: Maybe<Admin>;
  id?: Maybe<Scalars['Int']['output']>;
  packages?: Maybe<Array<Maybe<Package>>>;
};

export type PackageEntity = {
  __typename?: 'PackageEntity';
  addressName?: Maybe<Scalars['String']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
};

export type PackageEntityInput = {
  addressName?: InputMaybe<Scalars['String']['input']>;
  lat?: InputMaybe<Scalars['Float']['input']>;
  lng?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
};

export type PackageEntityV2Input = {
  addressName?: InputMaybe<Scalars['String']['input']>;
  customerAddressId?: InputMaybe<Scalars['Int']['input']>;
  customerId?: InputMaybe<Scalars['Int']['input']>;
  fromImage?: InputMaybe<Scalars['String']['input']>;
  lat?: InputMaybe<Scalars['Float']['input']>;
  lng?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  supplierId?: InputMaybe<Scalars['Int']['input']>;
  warehouseId?: InputMaybe<Scalars['Int']['input']>;
};

export type PackageForceInput = {
  finalHub?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<PackageType>;
};

export type PackageGroup = {
  __typename?: 'PackageGroup';
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Admin>;
  groupId?: Maybe<Scalars['Int']['output']>;
  package?: Maybe<Package>;
  referrence?: Maybe<Scalars['String']['output']>;
};

export type PackageInfoSummary = {
  __typename?: 'PackageInfoSummary';
  cashBack?: Maybe<Scalars['Decimal']['output']>;
  delivered?: Maybe<Scalars['Int']['output']>;
  deliveredValue?: Maybe<Scalars['Decimal']['output']>;
  ongoing?: Maybe<Scalars['Int']['output']>;
  ongoingValue?: Maybe<Scalars['Decimal']['output']>;
  returned?: Maybe<Scalars['Int']['output']>;
  returnedValue?: Maybe<Scalars['Decimal']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
  totalValue?: Maybe<Scalars['Decimal']['output']>;
};

export type PackageInput = {
  additionalInstruction?: InputMaybe<Scalars['String']['input']>;
  addressName?: InputMaybe<Scalars['String']['input']>;
  appointedAt?: InputMaybe<Scalars['String']['input']>;
  cash?: InputMaybe<Scalars['Float']['input']>;
  cashCollected?: InputMaybe<Scalars['Float']['input']>;
  createdWith?: InputMaybe<PackageCreatedWith>;
  customerId?: InputMaybe<Scalars['Int']['input']>;
  customerName?: InputMaybe<Scalars['String']['input']>;
  customerOrderItemIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  customerPayForThirdParty?: InputMaybe<Scalars['Boolean']['input']>;
  fee?: InputMaybe<Scalars['Float']['input']>;
  fixedFee?: InputMaybe<Scalars['Boolean']['input']>;
  /** This is only used for INTERNAL type */
  fromHub?: InputMaybe<Scalars['Int']['input']>;
  hasReturningItem?: InputMaybe<Scalars['Boolean']['input']>;
  hasStock?: InputMaybe<Scalars['Boolean']['input']>;
  isImagePackage?: InputMaybe<Scalars['Boolean']['input']>;
  isReceiverPay?: InputMaybe<Scalars['Boolean']['input']>;
  items?: InputMaybe<Array<InputMaybe<PackageItemInput>>>;
  lat?: InputMaybe<Scalars['String']['input']>;
  lng?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  pickupHub?: InputMaybe<Scalars['Int']['input']>;
  postFee?: InputMaybe<Scalars['Float']['input']>;
  provinceId?: InputMaybe<Scalars['Int']['input']>;
  sender?: InputMaybe<PackageEntityInput>;
  telegram?: InputMaybe<Scalars['String']['input']>;
  thirdPartyProvider?: InputMaybe<Scalars['String']['input']>;
  thirdPartyService?: InputMaybe<Scalars['Int']['input']>;
  /** This is only used for INTERNAL type */
  toHub?: InputMaybe<Scalars['Int']['input']>;
  transferOnDelivered?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<PackageType>;
  useAgentIfAvailable?: InputMaybe<Scalars['Boolean']['input']>;
  useInsurance?: InputMaybe<Scalars['Boolean']['input']>;
  value?: InputMaybe<Scalars['Float']['input']>;
  weight?: InputMaybe<Scalars['Float']['input']>;
  x?: InputMaybe<Scalars['Int']['input']>;
  y?: InputMaybe<Scalars['Int']['input']>;
  z?: InputMaybe<Scalars['Int']['input']>;
};

export type PackageInvoice = {
  __typename?: 'PackageInvoice';
  amount?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  fromDate?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  packageQty?: Maybe<Scalars['Int']['output']>;
  supplier?: Maybe<Supplier>;
  toDate?: Maybe<Scalars['String']['output']>;
};

export type PackageInvoiceDetail = {
  __typename?: 'PackageInvoiceDetail';
  packageList?: Maybe<Array<Maybe<Package>>>;
  summaryInvoice?: Maybe<PackageInvoice>;
};

export enum PackageIssueType {
  PackageFee = 'PACKAGE_FEE',
  ReversedDeliveredToDelivering = 'REVERSED_DELIVERED_TO_DELIVERING'
}

export type PackageItemInput = {
  qty?: InputMaybe<Scalars['Int']['input']>;
  skuId?: InputMaybe<Scalars['Int']['input']>;
};

export enum PackageListSort {
  AppointedTime = 'APPOINTED_TIME',
  Id = 'ID',
  SuccessDate = 'SUCCESS_DATE'
}

export type PackageLog = {
  __typename?: 'PackageLog';
  attachment?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Admin>;
  id: Scalars['Int']['output'];
  isAutoAssigned?: Maybe<Scalars['Boolean']['output']>;
  status?: Maybe<PackageStatus>;
  verifiedAt?: Maybe<Scalars['String']['output']>;
  verifiedBy?: Maybe<Admin>;
  warehouse?: Maybe<Warehouse>;
};

export type PackageNote = {
  __typename?: 'PackageNote';
  attachment?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Admin>;
  flag?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  message?: Maybe<Scalars['String']['output']>;
};

export enum PackageNoteFlag {
  Accident = 'ACCIDENT',
  Attempt = 'ATTEMPT',
  Delivered = 'DELIVERED',
  LocationChange = 'LOCATION_CHANGE',
  Rain = 'RAIN',
  TimeChange = 'TIME_CHANGE',
  Unreachable = 'UNREACHABLE'
}

export type PackageNoteFlagList = {
  __typename?: 'PackageNoteFlagList';
  accident?: Maybe<Scalars['Int']['output']>;
  attempt?: Maybe<Scalars['Int']['output']>;
  locationChanged?: Maybe<Scalars['Int']['output']>;
  rain?: Maybe<Scalars['Int']['output']>;
  timeChanged?: Maybe<Scalars['Int']['output']>;
  unreachable?: Maybe<Scalars['Int']['output']>;
};

export type PackageNoteInput = {
  attachment?: InputMaybe<Scalars['String']['input']>;
  flag?: InputMaybe<PackageNoteFlag>;
  message?: InputMaybe<Scalars['String']['input']>;
};

export type PackageOptionsInput = {
  customerOrderItemIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  instruction?: InputMaybe<Scalars['String']['input']>;
};

export type PackagePriceEstimation = {
  __typename?: 'PackagePriceEstimation';
  agent?: Maybe<Agent>;
  agentPrice?: Maybe<Scalars['Float']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  thirdPartyProviderFee?: Maybe<Array<Maybe<ThirdPartyProviderFee>>>;
  /** @deprecated replace with thirdPartyProviderFee */
  thirdPartyProviders?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  trafficLevel?: Maybe<Scalars['Int']['output']>;
  trafficMessage?: Maybe<Scalars['String']['output']>;
};

export type PackageReportItem = {
  __typename?: 'PackageReportItem';
  date?: Maybe<Scalars['String']['output']>;
  draft?: Maybe<Scalars['Int']['output']>;
  fee?: Maybe<Scalars['String']['output']>;
  gmv?: Maybe<Scalars['String']['output']>;
  newSeller?: Maybe<Scalars['Int']['output']>;
  requestPickup?: Maybe<Scalars['Int']['output']>;
  returned?: Maybe<Scalars['Int']['output']>;
  success?: Maybe<Scalars['Int']['output']>;
  thirdParty?: Maybe<Scalars['Int']['output']>;
  totalPackageCreated?: Maybe<Scalars['Int']['output']>;
  totalUndeletedPackage?: Maybe<Scalars['Int']['output']>;
  undeletedGmv?: Maybe<Scalars['String']['output']>;
  uniqueSeller?: Maybe<Scalars['Int']['output']>;
};

export type PackageServiceReviewInput = {
  attitude?: InputMaybe<Scalars['Int']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  packaging?: InputMaybe<Scalars['Int']['input']>;
  speed?: InputMaybe<Scalars['Int']['input']>;
};

export enum PackageSettlementOption {
  Postpaid = 'POSTPAID',
  Prepaid = 'PREPAID'
}

export enum PackageStatus {
  Abandoned = 'ABANDONED',
  Arrived = 'ARRIVED',
  Attempt = 'ATTEMPT',
  ClaimDelivery = 'CLAIM_DELIVERY',
  ClaimPickup = 'CLAIM_PICKUP',
  Deleted = 'DELETED',
  Delivered = 'DELIVERED',
  Delivering = 'DELIVERING',
  Draft = 'DRAFT',
  MarkReturning = 'MARK_RETURNING',
  Pickup = 'PICKUP',
  RequestPickup = 'REQUEST_PICKUP',
  ScheduleRequestPickup = 'SCHEDULE_REQUEST_PICKUP',
  Transit = 'TRANSIT',
  WithAgent = 'WITH_AGENT',
  WithTaxi = 'WITH_TAXI'
}

export type PackageStockItem = {
  __typename?: 'PackageStockItem';
  id?: Maybe<Scalars['Int']['output']>;
  packageId?: Maybe<Scalars['Int']['output']>;
  qty?: Maybe<Scalars['Int']['output']>;
  sku?: Maybe<StockKeepingUnit>;
};

export enum PackageThirdParty {
  Jnt = 'JNT'
}

export type PackageTransitLog = {
  __typename?: 'PackageTransitLog';
  createdAt?: Maybe<Scalars['String']['output']>;
  deliverer?: Maybe<Admin>;
  hub?: Maybe<Warehouse>;
  id?: Maybe<Scalars['Int']['output']>;
  packageCount?: Maybe<Scalars['Int']['output']>;
};

export enum PackageType {
  Delivery = 'DELIVERY',
  Internal = 'INTERNAL',
  OrderPickup = 'ORDER_PICKUP',
  Pickup = 'PICKUP',
  Shipment = 'SHIPMENT',
  ThirdParty = 'THIRD_PARTY'
}

export type PackageV4Input = {
  packageImage?: InputMaybe<Scalars['String']['input']>;
  packageV1Input?: InputMaybe<PackageInput>;
  receiverHubId?: InputMaybe<Scalars['Int']['input']>;
  senderBankInfo?: InputMaybe<BankInfoInput>;
  senderPhoneNumber?: InputMaybe<Scalars['String']['input']>;
};

export type PackagesByStatus = {
  __typename?: 'PackagesByStatus';
  packages?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

export type Pagination = {
  __typename?: 'Pagination';
  current?: Maybe<Scalars['Int']['output']>;
  size?: Maybe<Scalars['Int']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type PaginationInput = {
  cacheTotalRow?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type PartnerAdsDisbursement = {
  __typename?: 'PartnerAdsDisbursement';
  adsItems?: Maybe<Array<Maybe<SellerAdsV2Output>>>;
  amount?: Maybe<Scalars['Decimal']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  exportedAt?: Maybe<Scalars['String']['output']>;
  exportedBy?: Maybe<Admin>;
  id?: Maybe<Scalars['Int']['output']>;
  paidAt?: Maybe<Scalars['String']['output']>;
  paidBy?: Maybe<Admin>;
  partner?: Maybe<Customer>;
  paymentBatch?: Maybe<Scalars['Int']['output']>;
  proof?: Maybe<Scalars['String']['output']>;
  status?: Maybe<AffiliateDisbursementStatus>;
  verifiedAt?: Maybe<Scalars['String']['output']>;
  verifiedBy?: Maybe<Admin>;
};


export type PartnerAdsDisbursementAdsItemsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type PartnerAdsDisbursementList = {
  __typename?: 'PartnerAdsDisbursementList';
  data?: Maybe<Array<Maybe<PartnerAdsDisbursement>>>;
  totalAmount?: Maybe<Scalars['Decimal']['output']>;
  totalRows?: Maybe<Scalars['Int']['output']>;
};

export type PartnerSeller = {
  __typename?: 'PartnerSeller';
  enabled?: Maybe<Scalars['Boolean']['output']>;
  inputDate?: Maybe<Scalars['String']['output']>;
  partnerId?: Maybe<Scalars['Int']['output']>;
  supplier?: Maybe<Supplier>;
  supplierToken?: Maybe<Scalars['String']['output']>;
};

export type PartnerShop = {
  __typename?: 'PartnerShop';
  color?: Maybe<Scalars['String']['output']>;
  supplier?: Maybe<Supplier>;
};

export type PartnerStaff = {
  __typename?: 'PartnerStaff';
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  order?: Maybe<Array<Maybe<PartnerSummaryOrder>>>;
  parnterPermission?: Maybe<Scalars['String']['output']>;
};

export type PartnerSummaryOrder = {
  __typename?: 'PartnerSummaryOrder';
  count?: Maybe<Scalars['Int']['output']>;
  done?: Maybe<Scalars['Int']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  total?: Maybe<Scalars['String']['output']>;
};

export type Payment = {
  __typename?: 'Payment';
  amount?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  transactionType?: Maybe<Scalars['Int']['output']>;
};

export type PaymentChartOfAccount = {
  __typename?: 'PaymentChartOfAccount';
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type PaymentDetailWithRemainder = {
  __typename?: 'PaymentDetailWithRemainder';
  paymentLog?: Maybe<Array<Maybe<PaymentLogDetail>>>;
  remainder?: Maybe<Scalars['Decimal']['output']>;
};

export type PaymentInput = {
  amount: Scalars['String']['input'];
  customerId: Scalars['Int']['input'];
  description: Scalars['String']['input'];
  transactionType: Scalars['Int']['input'];
};

export type PaymentInputV2 = {
  amount?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  transactionType?: InputMaybe<Scalars['Int']['input']>;
};

export type PaymentLogDetail = {
  __typename?: 'PaymentLogDetail';
  amount?: Maybe<Scalars['Decimal']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  customer?: Maybe<Customer>;
  id?: Maybe<Scalars['Int']['output']>;
  order?: Maybe<CustomerOrder>;
  orderReturn?: Maybe<CustomerOrderReturn>;
  orderitem?: Maybe<CustomerOrderItemV2>;
  paymentHistory?: Maybe<CustomerPaymentHistory>;
  reason?: Maybe<Scalars['String']['output']>;
  refund?: Maybe<CustomerRefund>;
};

export enum PaymentLogId {
  Coid = 'coid',
  CredithistoryId = 'credithistory_id',
  OrderId = 'order_id',
  RefundId = 'refund_id',
  ReturnId = 'return_id'
}

export enum PaymentMethod {
  BankTransfer = 'BANK_TRANSFER',
  Cash = 'CASH',
  MoneyTransfer = 'MONEY_TRANSFER',
  None = 'NONE',
  TradeReceivable = 'TRADE_RECEIVABLE'
}

export type PaymentOption = {
  __typename?: 'PaymentOption';
  availableAtVersion?: Maybe<Scalars['String']['output']>;
  caption?: Maybe<Scalars['String']['output']>;
  image?: Maybe<Scalars['String']['output']>;
  navigation?: Maybe<Scalars['JSON']['output']>;
  promotionCaption?: Maybe<Scalars['String']['output']>;
  promotionColor?: Maybe<Scalars['String']['output']>;
  subImage?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  type?: Maybe<OnlinePaymentType>;
};

export type PaymentOptionBlockStatus = {
  __typename?: 'PaymentOptionBlockStatus';
  blocked?: Maybe<Scalars['Boolean']['output']>;
  paymentOptionType?: Maybe<PaymentOptionType>;
};

export type PaymentOptionBlockStatusInput = {
  blocked?: InputMaybe<Scalars['Boolean']['input']>;
  paymentOptionType?: InputMaybe<PaymentOptionType>;
};

export type PaymentOptionList = {
  __typename?: 'PaymentOptionList';
  options?: Maybe<Array<Maybe<PaymentOption>>>;
};

export enum PaymentOptionType {
  Aba = 'ABA',
  AbaDeeplink = 'ABA_DEEPLINK',
  Acleda = 'ACLEDA',
  AcledaXpay = 'ACLEDA_XPAY',
  AmkDeeplink = 'AMK_DEEPLINK',
  BankTransfer = 'BANK_TRANSFER',
  Phillip = 'PHILLIP',
  Shinhan = 'SHINHAN',
  Truemoney = 'TRUEMONEY',
  Wing = 'WING'
}

export type PaymentReceivedResponse = {
  __typename?: 'PaymentReceivedResponse';
  received?: Maybe<Scalars['Boolean']['output']>;
};

export enum PaymentServiceType {
  Emoney = 'EMONEY',
  Truemoney = 'TRUEMONEY',
  Wing = 'WING'
}

export enum PaymentType {
  AdvertisingFee = 'ADVERTISING_FEE',
  AffiliateFee = 'AFFILIATE_FEE',
  CustomerBalance = 'CUSTOMER_BALANCE',
  LinkPay = 'LINK_PAY'
}

export type PosCart = {
  __typename?: 'PosCart';
  errorMessage?: Maybe<Scalars['String']['output']>;
  isAppliedPromoCode?: Maybe<Scalars['Boolean']['output']>;
  items?: Maybe<Array<Maybe<PosCartItem>>>;
};

export type PosCartItem = {
  __typename?: 'PosCartItem';
  discount?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['String']['output']>;
  promoCodeDiscount?: Maybe<Scalars['String']['output']>;
  sku?: Maybe<StockKeepingUnit>;
};

export type Product = {
  __typename?: 'Product';
  addToCart?: Maybe<Scalars['Int']['output']>;
  boxSize?: Maybe<Scalars['String']['output']>;
  brand?: Maybe<Brand>;
  category?: Maybe<Category>;
  categoryId?: Maybe<Scalars['Int']['output']>;
  clicks?: Maybe<Scalars['Int']['output']>;
  code?: Maybe<Scalars['String']['output']>;
  color?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  discount?: Maybe<Scalars['Float']['output']>;
  discountApp?: Maybe<Scalars['Float']['output']>;
  discountGold?: Maybe<Scalars['Float']['output']>;
  discountMax?: Maybe<Scalars['Float']['output']>;
  discountRate?: Maybe<Scalars['Float']['output']>;
  firstSold?: Maybe<Scalars['String']['output']>;
  followedBy?: Maybe<Admin>;
  id?: Maybe<Scalars['Int']['output']>;
  inputDate?: Maybe<Scalars['String']['output']>;
  isCore?: Maybe<Scalars['Boolean']['output']>;
  isRestock?: Maybe<Scalars['Boolean']['output']>;
  lastSold?: Maybe<Scalars['String']['output']>;
  lastStockIn?: Maybe<Scalars['String']['output']>;
  mostSoldMonth?: Maybe<Scalars['String']['output']>;
  mostSoldPerMonth?: Maybe<Scalars['Int']['output']>;
  picture?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  productSourceLink?: Maybe<Scalars['String']['output']>;
  reach?: Maybe<Scalars['Int']['output']>;
  requestDate?: Maybe<Scalars['String']['output']>;
  returnedRate?: Maybe<Scalars['Float']['output']>;
  revenue?: Maybe<Scalars['Float']['output']>;
  shipmentId?: Maybe<Scalars['Int']['output']>;
  size?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  sku?: Maybe<Array<Maybe<Sku>>>;
  skuList?: Maybe<Array<Maybe<StockKeepingUnit>>>;
  soldQty?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  stockQty?: Maybe<Scalars['Int']['output']>;
  storeSourceLink?: Maybe<Scalars['String']['output']>;
  supplier?: Maybe<Supplier>;
  supplierCode?: Maybe<Scalars['String']['output']>;
  supplierId?: Maybe<Scalars['Int']['output']>;
  title?: Maybe<MultiLangString>;
  totalRow?: Maybe<Scalars['Int']['output']>;
  transactionCount?: Maybe<Scalars['Int']['output']>;
  uncollectedRate?: Maybe<Scalars['Float']['output']>;
  uploadDate?: Maybe<Scalars['String']['output']>;
  uploadedVideo?: Maybe<Scalars['String']['output']>;
  weight?: Maybe<Scalars['Float']['output']>;
};

export type ProductAdsV2Output = {
  __typename?: 'ProductAdsV2Output';
  click?: Maybe<Scalars['Int']['output']>;
  item?: Maybe<BasicProduct>;
  reach?: Maybe<Scalars['Int']['output']>;
  salesAmount?: Maybe<Scalars['Decimal']['output']>;
  salesQty?: Maybe<Scalars['Int']['output']>;
};

export type ProductAvailability = {
  itemid?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<SupplierProductApproved>;
};

export type ProductAvailable = {
  __typename?: 'ProductAvailable';
  data?: Maybe<Array<Maybe<Product>>>;
  page?: Maybe<Pagination>;
};

export type ProductChoice = {
  __typename?: 'ProductChoice';
  approvedBy?: Maybe<Scalars['Int']['output']>;
  approvedDate?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  inputDate?: Maybe<Scalars['String']['output']>;
  product?: Maybe<Product>;
  rejectdBy?: Maybe<Scalars['Int']['output']>;
  rejectedDate?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  supplier?: Maybe<Scalars['Int']['output']>;
};

export type ProductCommissionFee = {
  __typename?: 'ProductCommissionFee';
  commission?: Maybe<Scalars['Float']['output']>;
  deliveryFee?: Maybe<Scalars['Float']['output']>;
  handlingFee?: Maybe<Scalars['Float']['output']>;
};

export enum ProductCondition {
  New = 'NEW',
  SecondHand = 'SECOND_HAND'
}

export type ProductDefaultValue = {
  __typename?: 'ProductDefaultValue';
  appOnly?: Maybe<TrueFalse>;
  categoryid?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  colors?: Maybe<Scalars['String']['output']>;
  consumable?: Maybe<TrueFalse>;
  description?: Maybe<Scalars['String']['output']>;
  needFreezer?: Maybe<TrueFalse>;
  remoteStock?: Maybe<TrueFalse>;
  remoteStockDurationFrom?: Maybe<Scalars['Int']['output']>;
  remoteStockDurationTo?: Maybe<Scalars['Int']['output']>;
  returnable?: Maybe<TrueFalse>;
  salePrice?: Maybe<Scalars['String']['output']>;
  sizes?: Maybe<Scalars['String']['output']>;
  supplierCode?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  video?: Maybe<Scalars['String']['output']>;
  weight?: Maybe<Scalars['String']['output']>;
  x?: Maybe<Scalars['String']['output']>;
  y?: Maybe<Scalars['String']['output']>;
  z: Scalars['String']['output'];
};

export type ProductGroup = {
  __typename?: 'ProductGroup';
  id?: Maybe<Scalars['Int']['output']>;
  itemsCount?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  products?: Maybe<Array<Maybe<BasicProduct>>>;
};

export type ProductGroupInput = {
  code?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  itemId?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type ProductInput = {
  categoryId?: InputMaybe<Scalars['Int']['input']>;
  dimensionHeight?: InputMaybe<Scalars['Decimal']['input']>;
  dimensionLength?: InputMaybe<Scalars['Decimal']['input']>;
  dimensionWidth?: InputMaybe<Scalars['Decimal']['input']>;
  discount?: InputMaybe<Scalars['Float']['input']>;
  discountApp?: InputMaybe<Scalars['Float']['input']>;
  discountGold?: InputMaybe<Scalars['Float']['input']>;
  discountMax?: InputMaybe<Scalars['Float']['input']>;
  followedBy?: InputMaybe<Scalars['Int']['input']>;
  freeDelivery?: InputMaybe<Scalars['Boolean']['input']>;
  itemVerified?: InputMaybe<Scalars['Boolean']['input']>;
  title?: InputMaybe<MultiLangStringInput>;
  uploadedVideo?: InputMaybe<Scalars['String']['input']>;
  weight?: InputMaybe<Scalars['Decimal']['input']>;
};

export enum ProductLabel {
  IsBrandProduct = 'isBrandProduct',
  IsL192Choice = 'isL192Choice'
}

export type ProductLabelTab = {
  __typename?: 'ProductLabelTab';
  productType: Scalars['String']['output'];
  tabNames: Array<Maybe<Scalars['String']['output']>>;
};

export type ProductListCountTab = {
  __typename?: 'ProductListCountTab';
  approved?: Maybe<Scalars['Int']['output']>;
  rejected?: Maybe<Scalars['Int']['output']>;
  restocking?: Maybe<Scalars['Int']['output']>;
  reviewing?: Maybe<Scalars['Int']['output']>;
  toRestock?: Maybe<Scalars['Int']['output']>;
  unverified?: Maybe<Scalars['Int']['output']>;
};

export type ProductListFilter = {
  brandId?: InputMaybe<Scalars['Int']['input']>;
  coreProduct?: InputMaybe<Scalars['Boolean']['input']>;
  followedBy?: InputMaybe<Scalars['Int']['input']>;
  isFollowed?: InputMaybe<Scalars['Boolean']['input']>;
  isShortTitle?: InputMaybe<Scalars['Boolean']['input']>;
  sellerOrigin?: InputMaybe<Array<InputMaybe<SellerOrigin>>>;
  sellerRole?: InputMaybe<Array<InputMaybe<SellerRole>>>;
  sellerType?: InputMaybe<Array<InputMaybe<SellerType>>>;
  supplierId?: InputMaybe<Scalars['Int']['input']>;
};

export type ProductListFilterV2 = {
  brand?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  coreProduct?: InputMaybe<Scalars['Boolean']['input']>;
  fbLastPostGte?: InputMaybe<Scalars['Int']['input']>;
  gteDiscount?: InputMaybe<Scalars['Int']['input']>;
  gtePrice?: InputMaybe<Scalars['Decimal']['input']>;
  gteStock?: InputMaybe<Scalars['Int']['input']>;
  inCompletedTitle?: InputMaybe<Scalars['Boolean']['input']>;
  isRemoted?: InputMaybe<Scalars['Boolean']['input']>;
  isTemplate?: InputMaybe<Scalars['Boolean']['input']>;
  lastCampaignCreated?: InputMaybe<Scalars['Int']['input']>;
  lteDiscount?: InputMaybe<Scalars['Int']['input']>;
  ltePrice?: InputMaybe<Scalars['Decimal']['input']>;
  lteStock?: InputMaybe<Scalars['Int']['input']>;
  mark?: InputMaybe<Array<InputMaybe<SupplierProductApproved>>>;
  productScore?: InputMaybe<ProductScoreFilter>;
  sales?: InputMaybe<SalesFilter>;
  selectedBy?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  sellerOrigin?: InputMaybe<Array<InputMaybe<SellerOrigin>>>;
  sellerRole?: InputMaybe<Array<InputMaybe<SellerRole>>>;
  sellerType?: InputMaybe<Array<InputMaybe<SellerType>>>;
  status?: InputMaybe<Array<InputMaybe<ProductStatus>>>;
  stockInAfter?: InputMaybe<Scalars['String']['input']>;
  stockInBefore?: InputMaybe<Scalars['String']['input']>;
  supplierId?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  vendor?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};

export type ProductListResult = {
  __typename?: 'ProductListResult';
  data?: Maybe<Array<Maybe<ProductV2>>>;
  pagination?: Maybe<Pagination>;
};

export enum ProductListType {
  Approved = 'APPROVED',
  ReplenishemntWishlist = 'REPLENISHEMNT_WISHLIST',
  Replenishment = 'REPLENISHMENT',
  Template = 'TEMPLATE',
  ToRestock = 'TO_RESTOCK',
  Unverified = 'UNVERIFIED'
}

export type ProductOption = {
  __typename?: 'ProductOption';
  colorList?: Maybe<Array<Maybe<ProductOptionColor>>>;
  defaultColor?: Maybe<Scalars['String']['output']>;
  defaultSize?: Maybe<Scalars['String']['output']>;
  deliveryAddress?: Maybe<Scalars['String']['output']>;
  deliveryFee?: Maybe<Scalars['Float']['output']>;
  remoteDuration?: Maybe<RemoteDuration>;
  remoteStock?: Maybe<Scalars['Boolean']['output']>;
  showColor?: Maybe<Scalars['Boolean']['output']>;
  showSize?: Maybe<Scalars['Boolean']['output']>;
  sizeStandard?: Maybe<ProductSizeStandard>;
};

export type ProductOptionColor = {
  __typename?: 'ProductOptionColor';
  actualQty?: Maybe<Scalars['Int']['output']>;
  colorCode?: Maybe<Scalars['String']['output']>;
  image?: Maybe<Scalars['String']['output']>;
  qty?: Maybe<Scalars['Int']['output']>;
  sizeList?: Maybe<Array<Maybe<ProductOptionSize>>>;
  type?: Maybe<ProductOptionDisplayType>;
  value?: Maybe<Scalars['String']['output']>;
};

export enum ProductOptionDisplayType {
  Color = 'COLOR',
  Image = 'IMAGE',
  Text = 'TEXT'
}

export type ProductOptionSize = {
  __typename?: 'ProductOptionSize';
  actualQty?: Maybe<Scalars['Int']['output']>;
  colorCode?: Maybe<Scalars['String']['output']>;
  deliveryTime?: Maybe<Scalars['String']['output']>;
  enabled?: Maybe<Scalars['Boolean']['output']>;
  image?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  priceBeforeDiscount?: Maybe<Scalars['Float']['output']>;
  qty?: Maybe<Scalars['Int']['output']>;
  sizeDescription?: Maybe<Scalars['String']['output']>;
  skuId?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<ProductOptionDisplayType>;
  value?: Maybe<Scalars['String']['output']>;
};

export enum ProductOrderBy {
  Date = 'DATE',
  Id = 'ID',
  NewStock = 'NEW_STOCK',
  Rating = 'RATING',
  Sales = 'SALES',
  Stock = 'STOCK'
}

export type ProductOrderByInput = {
  field?: InputMaybe<ProductOrderBy>;
  sortBy?: InputMaybe<SortOrder>;
  value?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};

export type ProductPrice = {
  __typename?: 'ProductPrice';
  salePrice?: Maybe<Scalars['Decimal']['output']>;
  sellerPrice?: Maybe<Scalars['Decimal']['output']>;
};

export type ProductQuantity = {
  __typename?: 'ProductQuantity';
  color?: Maybe<Scalars['String']['output']>;
  itemid?: Maybe<Scalars['Int']['output']>;
  productCode?: Maybe<Scalars['String']['output']>;
  qty?: Maybe<Scalars['Int']['output']>;
  size?: Maybe<Scalars['String']['output']>;
  skuid?: Maybe<Scalars['Int']['output']>;
  supplierCode?: Maybe<Scalars['String']['output']>;
};

export type ProductRanking = {
  __typename?: 'ProductRanking';
  product?: Maybe<BasicProduct>;
  sales?: Maybe<Scalars['String']['output']>;
  supplier?: Maybe<Supplier>;
};

export type ProductRawJson = {
  __typename?: 'ProductRawJson';
  brand_id?: Maybe<Scalars['Int']['output']>;
  brand_logo?: Maybe<Scalars['String']['output']>;
  brand_name?: Maybe<Scalars['String']['output']>;
  code?: Maybe<Scalars['String']['output']>;
  color?: Maybe<Scalars['String']['output']>;
  delivery_time?: Maybe<Scalars['String']['output']>;
  discount_percentage?: Maybe<Scalars['Float']['output']>;
  height?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  is_ads?: Maybe<Scalars['Boolean']['output']>;
  is_brand_product?: Maybe<Scalars['Boolean']['output']>;
  is_square_picture?: Maybe<Scalars['Boolean']['output']>;
  keyword?: Maybe<Scalars['String']['output']>;
  l192_choice?: Maybe<Scalars['Boolean']['output']>;
  madeInCambodia?: Maybe<Scalars['Boolean']['output']>;
  navigate?: Maybe<Scalars['JSON']['output']>;
  picture?: Maybe<Scalars['String']['output']>;
  picture_full?: Maybe<Scalars['String']['output']>;
  picture_responsive?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  price_before_discount?: Maybe<Scalars['Float']['output']>;
  product_label?: Maybe<Scalars['String']['output']>;
  promotion_image?: Maybe<Scalars['String']['output']>;
  rating?: Maybe<Scalars['Float']['output']>;
  rating_count?: Maybe<Scalars['Int']['output']>;
  show_promotion?: Maybe<Scalars['Boolean']['output']>;
  size?: Maybe<Scalars['String']['output']>;
  specialProduct?: Maybe<Array<Maybe<SpecialProductlist>>>;
  stock?: Maybe<Scalars['Boolean']['output']>;
  stock_qty?: Maybe<Scalars['Int']['output']>;
  stock_status?: Maybe<Scalars['Int']['output']>;
  stock_status_label?: Maybe<Scalars['String']['output']>;
  supplier_id?: Maybe<Scalars['Int']['output']>;
  supplier_logo?: Maybe<Scalars['String']['output']>;
  supplier_name?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  video?: Maybe<Scalars['String']['output']>;
  warrantyId?: Maybe<Scalars['Int']['output']>;
  width?: Maybe<Scalars['Int']['output']>;
};

export type ProductRecycle = {
  __typename?: 'ProductRecycle';
  adminCompleted?: Maybe<Admin>;
  adminRecycled?: Maybe<Admin>;
  adminRestock?: Maybe<Admin>;
  adminReturn?: Maybe<Admin>;
  adminSave?: Maybe<Admin>;
  dateCompleted?: Maybe<Scalars['String']['output']>;
  dateRecycle?: Maybe<Scalars['String']['output']>;
  dateRestock?: Maybe<Scalars['String']['output']>;
  dateReturn?: Maybe<Scalars['String']['output']>;
  dateSave?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  orderItem?: Maybe<CustomerOrderItemV2>;
  package?: Maybe<Package>;
  status?: Maybe<ProductRecycleStatusType>;
  supplier?: Maybe<Supplier>;
};

export enum ProductRecycleStatusType {
  Completed = 'COMPLETED',
  Recycled = 'RECYCLED',
  Restock = 'RESTOCK',
  Returned = 'RETURNED',
  Save = 'SAVE'
}

export type ProductReview = {
  __typename?: 'ProductReview';
  attachments?: Maybe<Array<Maybe<ProductReviewAttachment>>>;
  comment?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  createdAtTimestamp?: Maybe<Scalars['Int']['output']>;
  customer?: Maybe<CustomerBasic>;
  hasMarkedHelpful?: Maybe<Scalars['Boolean']['output']>;
  helpful?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  product?: Maybe<DisplayProduct>;
  productId?: Maybe<Scalars['Int']['output']>;
  rating?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
};

export type ProductReviewAttachment = {
  __typename?: 'ProductReviewAttachment';
  review?: Maybe<ProductReview>;
  src?: Maybe<Scalars['String']['output']>;
  thumbnail?: Maybe<Scalars['String']['output']>;
};

export type ProductReviewInfo = {
  __typename?: 'ProductReviewInfo';
  rating?: Maybe<Scalars['Decimal']['output']>;
  reviews?: Maybe<Scalars['Int']['output']>;
};

export type ProductReviewOverview = {
  __typename?: 'ProductReviewOverview';
  averageRating?: Maybe<Scalars['Float']['output']>;
  hasCurrentUserPurchased?: Maybe<Scalars['Boolean']['output']>;
  ratingTotalBreakdown?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  totalReview?: Maybe<Scalars['Int']['output']>;
};

export type ProductReviewRankItem = {
  __typename?: 'ProductReviewRankItem';
  averageRating?: Maybe<Scalars['Float']['output']>;
  product?: Maybe<DisplayProduct>;
  ratingCount?: Maybe<Scalars['Int']['output']>;
  score?: Maybe<Scalars['Float']['output']>;
};

export type ProductReviewReport = {
  __typename?: 'ProductReviewReport';
  count?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  topSupplierList?: Maybe<Array<Maybe<ProductReviewSupplierSummary>>>;
};


export type ProductReviewReportTopSupplierListArgs = {
  limit: Scalars['Int']['input'];
};

export type ProductReviewSupplierSummary = {
  __typename?: 'ProductReviewSupplierSummary';
  average?: Maybe<Scalars['Float']['output']>;
  count?: Maybe<Scalars['Int']['output']>;
  supplier?: Maybe<Supplier>;
};

export type ProductScoreFilter = {
  description?: InputMaybe<ScoreStatus>;
  picture?: InputMaybe<ScoreStatus>;
  title?: InputMaybe<ScoreStatus>;
  video?: InputMaybe<ScoreStatus>;
};

export type ProductSearch = {
  code?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  tag?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ProductSearchCorrection = {
  __typename?: 'ProductSearchCorrection';
  correctText?: Maybe<Scalars['String']['output']>;
  originalText?: Maybe<Scalars['String']['output']>;
};

export type ProductSearchDrilldown = {
  __typename?: 'ProductSearchDrilldown';
  brandList?: Maybe<Array<Maybe<Brand>>>;
  categoryList?: Maybe<Array<Maybe<Category>>>;
};

export type ProductSearchFilter = {
  brandId?: InputMaybe<Scalars['Int']['input']>;
  categoryId?: InputMaybe<Scalars['Int']['input']>;
  inStockOnly?: InputMaybe<Scalars['Boolean']['input']>;
  keyword?: InputMaybe<Scalars['String']['input']>;
  madeInCambodia?: InputMaybe<Scalars['Boolean']['input']>;
  maxPrice?: InputMaybe<Scalars['Float']['input']>;
  minDiscount?: InputMaybe<Scalars['Int']['input']>;
  minPrice?: InputMaybe<Scalars['Float']['input']>;
  productCondition?: InputMaybe<ProductCondition>;
  stockQtyGte?: InputMaybe<Scalars['Int']['input']>;
  stockQtyLte?: InputMaybe<Scalars['Int']['input']>;
  storeId?: InputMaybe<Scalars['Int']['input']>;
};

export type ProductSearchResult = {
  __typename?: 'ProductSearchResult';
  correction?: Maybe<ProductSearchCorrection>;
  filter?: Maybe<ProductSearchDrilldown>;
  items?: Maybe<Array<Maybe<ProductRawJson>>>;
  page?: Maybe<Scalars['Int']['output']>;
  sponsoredItems?: Maybe<Array<Maybe<ProductRawJson>>>;
  suggestedCategory?: Maybe<Array<Maybe<Category>>>;
};

export enum ProductSearchSort {
  Cheapest = 'CHEAPEST',
  Latest = 'LATEST',
  MostExpensive = 'MOST_EXPENSIVE',
  Popular = 'POPULAR'
}

export enum ProductShipStatus {
  Deleted = 'DELETED',
  Shipped = 'SHIPPED'
}

export type ProductShipmentInput = {
  color?: InputMaybe<Scalars['String']['input']>;
  item_id?: InputMaybe<Scalars['Int']['input']>;
  qty?: InputMaybe<Scalars['Int']['input']>;
  size?: InputMaybe<Scalars['String']['input']>;
  sku_id?: InputMaybe<Scalars['Int']['input']>;
};

export type ProductSizeInput = {
  itemid?: InputMaybe<Scalars['Int']['input']>;
  qty?: InputMaybe<Scalars['Int']['input']>;
};

export type ProductSizeStandard = {
  __typename?: 'ProductSizeStandard';
  name?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type ProductSku = {
  __typename?: 'ProductSku';
  availability?: Maybe<Scalars['Int']['output']>;
  code?: Maybe<Scalars['String']['output']>;
  color?: Maybe<Scalars['String']['output']>;
  colorList?: Maybe<Array<Maybe<ProductOptionColor>>>;
  currentLanguageTitle?: Maybe<Scalars['String']['output']>;
  customer?: Maybe<Scalars['JSON']['output']>;
  discount?: Maybe<Scalars['Float']['output']>;
  discountApp?: Maybe<Scalars['Float']['output']>;
  discountGold?: Maybe<Scalars['Float']['output']>;
  discountMax?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  order?: Maybe<Scalars['JSON']['output']>;
  origin?: Maybe<Origin>;
  payment?: Maybe<Scalars['JSON']['output']>;
  picture?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  remoteStock?: Maybe<Scalars['Boolean']['output']>;
  size?: Maybe<Scalars['String']['output']>;
  skuId?: Maybe<Scalars['Int']['output']>;
  stockQty?: Maybe<Scalars['Int']['output']>;
  supplier?: Maybe<Supplier>;
  title?: Maybe<MultiLangString>;
  weight?: Maybe<Scalars['Float']['output']>;
  x?: Maybe<Scalars['Float']['output']>;
  y?: Maybe<Scalars['Float']['output']>;
  z?: Maybe<Scalars['Float']['output']>;
};

export enum ProductStatus {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE'
}

export type ProductStockLocation = {
  __typename?: 'ProductStockLocation';
  qty?: Maybe<Scalars['Int']['output']>;
  slot?: Maybe<InventorySlot>;
};

export type ProductStockStatus = {
  __typename?: 'ProductStockStatus';
  color?: Maybe<Scalars['String']['output']>;
  finding?: Maybe<Scalars['Int']['output']>;
  size?: Maybe<Scalars['String']['output']>;
  skuId?: Maybe<Scalars['Int']['output']>;
};

export type ProductUpdateItem = {
  discontinue?: InputMaybe<Scalars['Float']['input']>;
  discount?: InputMaybe<Scalars['Float']['input']>;
  itemid?: InputMaybe<Scalars['Int']['input']>;
  price?: InputMaybe<Scalars['Float']['input']>;
};

export type ProductV2 = {
  __typename?: 'ProductV2';
  addToCart?: Maybe<Scalars['Int']['output']>;
  avgCost?: Maybe<Scalars['Decimal']['output']>;
  boxSize?: Maybe<Scalars['String']['output']>;
  brand?: Maybe<Brand>;
  category?: Maybe<Category>;
  clicks?: Maybe<Scalars['Int']['output']>;
  code?: Maybe<Scalars['String']['output']>;
  color?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  discount?: Maybe<Scalars['Float']['output']>;
  discountApp?: Maybe<Scalars['Float']['output']>;
  discountGold?: Maybe<Scalars['Float']['output']>;
  discountMax?: Maybe<Scalars['Float']['output']>;
  discountRate?: Maybe<Scalars['Float']['output']>;
  firstSold?: Maybe<Scalars['String']['output']>;
  followedBy?: Maybe<Admin>;
  id?: Maybe<Scalars['Int']['output']>;
  inputDate?: Maybe<Scalars['String']['output']>;
  isCore?: Maybe<Scalars['Boolean']['output']>;
  isRestock?: Maybe<Scalars['Boolean']['output']>;
  lastSold?: Maybe<Scalars['String']['output']>;
  lastStockIn?: Maybe<Scalars['String']['output']>;
  mark?: Maybe<Scalars['String']['output']>;
  mostSoldMonth?: Maybe<Scalars['String']['output']>;
  mostSoldPerMonth?: Maybe<Scalars['Int']['output']>;
  picture?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  productReview?: Maybe<ProductReviewInfo>;
  productSourceLink?: Maybe<Scalars['String']['output']>;
  reach?: Maybe<Scalars['Int']['output']>;
  remoted?: Maybe<Scalars['Boolean']['output']>;
  returnedRate?: Maybe<Scalars['Float']['output']>;
  revenue?: Maybe<Scalars['Float']['output']>;
  salesInFilter?: Maybe<Scalars['Decimal']['output']>;
  selectedBy?: Maybe<Admin>;
  sellerPrice?: Maybe<Scalars['Float']['output']>;
  size?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  skuList?: Maybe<Array<Maybe<StockKeepingUnit>>>;
  soldQty?: Maybe<Scalars['Int']['output']>;
  srcProductLink?: Maybe<Scalars['String']['output']>;
  srcStoreLink?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  stockQty?: Maybe<Scalars['Int']['output']>;
  storeSourceLink?: Maybe<Scalars['String']['output']>;
  supplier?: Maybe<Supplier>;
  supplierCode?: Maybe<Scalars['String']['output']>;
  tags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  templateDownload?: Maybe<Scalars['Int']['output']>;
  title?: Maybe<MultiLangString>;
  transactionCount?: Maybe<Scalars['Int']['output']>;
  uncollectedRate?: Maybe<Scalars['Float']['output']>;
  uploadDate?: Maybe<Scalars['String']['output']>;
  uploadedVideo?: Maybe<Scalars['String']['output']>;
  vendor?: Maybe<SupplierVendor>;
  verifiedDate?: Maybe<Scalars['String']['output']>;
  weight?: Maybe<Scalars['Float']['output']>;
};

export type PromoCombo = {
  __typename?: 'PromoCombo';
  availableQty?: Maybe<Scalars['Int']['output']>;
  checkoutQty?: Maybe<Scalars['Int']['output']>;
  dealCriteria?: Maybe<DealCriteria>;
  discountTier?: Maybe<Array<Maybe<DiscountTier>>>;
  discountType?: Maybe<DiscountType>;
  endDate?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  minOrder?: Maybe<Scalars['Int']['output']>;
  products?: Maybe<Array<Maybe<PromoComboItems>>>;
  promoName?: Maybe<Scalars['String']['output']>;
  saleQty?: Maybe<Scalars['Int']['output']>;
  scope?: Maybe<PromoComboScope>;
  startDate?: Maybe<Scalars['String']['output']>;
  status?: Maybe<PromoComboStatus>;
  supplier?: Maybe<Supplier>;
};


export type PromoComboProductsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type PromoComboGift = {
  __typename?: 'PromoComboGift';
  qty?: Maybe<Scalars['Int']['output']>;
  sku?: Maybe<Sku>;
};

export type PromoComboInput = {
  availableQty?: InputMaybe<Scalars['Int']['input']>;
  campaignProduct?: InputMaybe<Scalars['String']['input']>;
  dealCriteria?: InputMaybe<DealCriteria>;
  discountTier?: InputMaybe<Array<InputMaybe<DiscountTierInput>>>;
  discountType?: InputMaybe<DiscountType>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  minOrder?: InputMaybe<Scalars['Int']['input']>;
  promoName?: InputMaybe<Scalars['String']['input']>;
  saleQty?: InputMaybe<Scalars['Int']['input']>;
  scope?: InputMaybe<PromoComboScope>;
  startDate?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<PromoComboStatus>;
};

export type PromoComboItems = {
  __typename?: 'PromoComboItems';
  comboId?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  item?: Maybe<DisplayProduct>;
  itemRawJson?: Maybe<ProductRawJson>;
};

export type PromoComboList = {
  __typename?: 'PromoComboList';
  data?: Maybe<Array<Maybe<PromoCombo>>>;
  page?: Maybe<Pagination>;
};

export enum PromoComboScope {
  EntireShop = 'ENTIRE_SHOP',
  SpecificProduct = 'SPECIFIC_PRODUCT'
}

export type PromoComboSkuInput = {
  qty?: InputMaybe<Scalars['Int']['input']>;
  skuId?: InputMaybe<Scalars['Int']['input']>;
};

export enum PromoComboStatus {
  Expired = 'EXPIRED',
  NotStart = 'NOT_START',
  OnGoing = 'ON_GOING',
  Suspended = 'SUSPENDED'
}

export type Promotion = {
  __typename?: 'Promotion';
  active?: Maybe<Scalars['Boolean']['output']>;
  code?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['Int']['output']>;
  credit?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  hasCurrentCustomerActivated?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  maxUsed?: Maybe<Scalars['Int']['output']>;
  minOrder?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  promoCampaign?: Maybe<PromotionCampaign>;
  store?: Maybe<Supplier>;
  summary?: Maybe<PromotionSummary>;
};

export type PromotionCampaign = {
  __typename?: 'PromotionCampaign';
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Admin>;
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  promoCode?: Maybe<Array<Maybe<Promotion>>>;
  summary?: Maybe<PromotionSummary>;
  supplier?: Maybe<Supplier>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Admin>;
};

export type PromotionCampaignCreator = {
  __typename?: 'PromotionCampaignCreator';
  admins?: Maybe<Array<Maybe<Admin>>>;
  suppliers?: Maybe<Array<Maybe<Supplier>>>;
};

export type PromotionCampaignFilter = {
  admin?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  supplierId?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};

export type PromotionCampaignInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type PromotionCampaignSearch = {
  name?: InputMaybe<Scalars['String']['input']>;
};

export type PromotionInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  campaignId?: InputMaybe<Scalars['Int']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  createdBy?: InputMaybe<Scalars['Int']['input']>;
  credit?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  maxUsed?: InputMaybe<Scalars['Int']['input']>;
  minOrder?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type PromotionList = {
  __typename?: 'PromotionList';
  data?: Maybe<Array<Maybe<Promotion>>>;
  page?: Maybe<Pagination>;
};

export type PromotionReport = {
  __typename?: 'PromotionReport';
  breakDownByDate?: Maybe<Array<Maybe<PromotionReportItem>>>;
  summary?: Maybe<PromotionSummary>;
};

export type PromotionReportItem = {
  __typename?: 'PromotionReportItem';
  date?: Maybe<Scalars['String']['output']>;
  summary?: Maybe<PromotionSummary>;
};

export type PromotionSummary = {
  __typename?: 'PromotionSummary';
  totalDeliveredCount?: Maybe<Scalars['Int']['output']>;
  totalItemCount?: Maybe<Scalars['Int']['output']>;
  totalItemValue?: Maybe<Scalars['String']['output']>;
  totalReadyCount?: Maybe<Scalars['Int']['output']>;
  totalSavingCost?: Maybe<Scalars['String']['output']>;
  totalUndeletedItemCount?: Maybe<Scalars['Int']['output']>;
  totalUndeletedItemValue?: Maybe<Scalars['String']['output']>;
  totalUndeletedOrderCount?: Maybe<Scalars['Int']['output']>;
};

export type PromotionTopItem = {
  __typename?: 'PromotionTopItem';
  code?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
  summary?: Maybe<PromotionSummary>;
};

export type Province = {
  __typename?: 'Province';
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  provinceCode?: Maybe<Scalars['String']['output']>;
};

export type PurchaseOrder = {
  __typename?: 'PurchaseOrder';
  arrivedAt?: Maybe<Scalars['String']['output']>;
  arrivedBy?: Maybe<Admin>;
  completedAt?: Maybe<Scalars['String']['output']>;
  completedBy?: Maybe<Admin>;
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Admin>;
  creditAmount?: Maybe<Scalars['String']['output']>;
  creditAmountCurrency?: Maybe<Currency>;
  creditType?: Maybe<PurchaseOrderCreditType>;
  creditUnit?: Maybe<Scalars['Int']['output']>;
  exchangeRate?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  invoiceAmount?: Maybe<Scalars['String']['output']>;
  invoiceAt?: Maybe<Scalars['String']['output']>;
  invoiceFile?: Maybe<Scalars['String']['output']>;
  invoiceNumber?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  orderAmount?: Maybe<Scalars['String']['output']>;
  orderAmountCurrency?: Maybe<Currency>;
  orderDetail?: Maybe<Scalars['String']['output']>;
  orderFile?: Maybe<Scalars['String']['output']>;
  orderQty?: Maybe<Scalars['Int']['output']>;
  paymentAt?: Maybe<Scalars['String']['output']>;
  paymentBy?: Maybe<Admin>;
  paymentFile?: Maybe<Scalars['String']['output']>;
  paymentMethod?: Maybe<PaymentMethod>;
  processingAt?: Maybe<Scalars['String']['output']>;
  processingBy?: Maybe<Admin>;
  shippedAt?: Maybe<Scalars['String']['output']>;
  shippedBy?: Maybe<Admin>;
  shippingAmount?: Maybe<Scalars['String']['output']>;
  shippingAmountCurrency?: Maybe<Currency>;
  shippingFile?: Maybe<Scalars['String']['output']>;
  shippingNumber?: Maybe<Scalars['String']['output']>;
  shippingQty?: Maybe<Scalars['Int']['output']>;
  stage?: Maybe<PurchaseOrderStage>;
  supplierFile?: Maybe<Scalars['String']['output']>;
  tags?: Maybe<Array<Maybe<Tag>>>;
  totalAmount?: Maybe<Scalars['String']['output']>;
  totalQty?: Maybe<Scalars['Int']['output']>;
  totalTransactionVolume?: Maybe<Scalars['String']['output']>;
  transactionList?: Maybe<Array<Maybe<StockTransaction>>>;
  type?: Maybe<PurchaseOrderType>;
  voidAt?: Maybe<Scalars['String']['output']>;
  voidBy?: Maybe<Admin>;
  volume?: Maybe<Scalars['String']['output']>;
};

export type PurchaseOrderAggregate = {
  __typename?: 'PurchaseOrderAggregate';
  count?: Maybe<Scalars['Int']['output']>;
  creditValue?: Maybe<Scalars['Float']['output']>;
  invoiceValue?: Maybe<Scalars['Float']['output']>;
};

export enum PurchaseOrderCreditType {
  Missing = 'MISSING',
  Surplus = 'SURPLUS'
}

export type PurchaseOrderFilterInput = {
  invoiceDateEnd?: InputMaybe<Scalars['String']['input']>;
  invoiceDateStart?: InputMaybe<Scalars['String']['input']>;
  invoiceNumber?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<PurchaseOrderFilterOrder>;
  paid?: InputMaybe<Scalars['Boolean']['input']>;
  shippingNumber?: InputMaybe<Scalars['String']['input']>;
  stage?: InputMaybe<Array<InputMaybe<PurchaseOrderStage>>>;
  tag?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<PurchaseOrderType>;
};

export enum PurchaseOrderFilterOrder {
  Created = 'CREATED',
  Invoice = 'INVOICE'
}

export type PurchaseOrderInput = {
  creditAmount?: InputMaybe<Scalars['String']['input']>;
  creditAmountCurrency?: InputMaybe<Currency>;
  creditType?: InputMaybe<PurchaseOrderCreditType>;
  creditUnit?: InputMaybe<Scalars['Int']['input']>;
  exchangeRate?: InputMaybe<Scalars['String']['input']>;
  invoiceAmount?: InputMaybe<Scalars['String']['input']>;
  invoiceAt?: InputMaybe<Scalars['String']['input']>;
  invoiceFile?: InputMaybe<Scalars['String']['input']>;
  invoiceNumber?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  orderAmount?: InputMaybe<Scalars['String']['input']>;
  orderAmountCurrency?: InputMaybe<Currency>;
  orderDetail?: InputMaybe<Scalars['String']['input']>;
  orderFile?: InputMaybe<Scalars['String']['input']>;
  orderQty?: InputMaybe<Scalars['Int']['input']>;
  paymentFile?: InputMaybe<Scalars['String']['input']>;
  paymentMethod?: InputMaybe<PaymentMethod>;
  shippingAmount?: InputMaybe<Scalars['String']['input']>;
  shippingAmountCurrency?: InputMaybe<Currency>;
  shippingFile?: InputMaybe<Scalars['String']['input']>;
  shippingNumber?: InputMaybe<Scalars['String']['input']>;
  shippingQty?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<PurchaseOrderStage>;
  supplierFile?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  type?: InputMaybe<PurchaseOrderType>;
  volumne?: InputMaybe<Scalars['String']['input']>;
};

export type PurchaseOrderList = {
  __typename?: 'PurchaseOrderList';
  aggregate?: Maybe<PurchaseOrderAggregate>;
  data?: Maybe<Array<Maybe<PurchaseOrder>>>;
  page?: Maybe<Pagination>;
};

export type PurchaseOrderLog = {
  __typename?: 'PurchaseOrderLog';
  after?: Maybe<Scalars['JSON']['output']>;
  before?: Maybe<Scalars['JSON']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Admin>;
};

export enum PurchaseOrderStage {
  Arrived = 'ARRIVED',
  Completed = 'COMPLETED',
  Created = 'CREATED',
  Processing = 'PROCESSING',
  Shipped = 'SHIPPED',
  Void = 'VOID'
}

export enum PurchaseOrderType {
  FblVendor = 'FBL_VENDOR',
  InternalSeller = 'INTERNAL_SELLER',
  InternalSellerDeposit = 'INTERNAL_SELLER_DEPOSIT',
  Normal = 'NORMAL'
}

export type Query = {
  __typename?: 'Query';
  abandonedCartCustomerList?: Maybe<Scalars['JSON']['output']>;
  accountDeactivationPending?: Maybe<Scalars['Boolean']['output']>;
  accountMenu?: Maybe<Array<Maybe<AccountMenuSession>>>;
  admin?: Maybe<Admin>;
  adminCustomerReviewList?: Maybe<Array<Maybe<AdminCustomerReview>>>;
  adminGroupList?: Maybe<Array<Maybe<AdminGroup>>>;
  adminList?: Maybe<Array<Maybe<Admin>>>;
  affiliateAvailableBalance?: Maybe<Scalars['String']['output']>;
  affiliateBestSeller?: Maybe<Array<Maybe<AffiliateBestSellerType>>>;
  affiliateCustomerOrderItemsList?: Maybe<Array<Maybe<AffliateCustomerOrderItems>>>;
  affiliateDibursementDetail?: Maybe<AffiliateDisbursement>;
  affiliateDisbursementList?: Maybe<AffiliateDisbursementList>;
  affiliatePaymentList?: Maybe<Array<Maybe<AvailableAffiliateBalanceList>>>;
  affiliateProductPublish?: Maybe<AffiliateProductPublicItem>;
  affiliateProductPublishList?: Maybe<Array<Maybe<AffiliateProductPublicItem>>>;
  affiliateProductSalesList?: Maybe<AffiliateProductSalesList>;
  affiliateSuppliersList?: Maybe<Array<Maybe<Supplier>>>;
  agentCommission?: Maybe<AgentCommission>;
  agentDisbursementList?: Maybe<Array<Maybe<AgentDisbursement>>>;
  agentEarnAmountList?: Maybe<Array<Maybe<AgentFeeDetail>>>;
  agentFeeDetailList?: Maybe<Array<Maybe<AgentFeeDetail>>>;
  agentList?: Maybe<AgentList>;
  appDiscoverySource?: Maybe<Scalars['JSON']['output']>;
  appVersion?: Maybe<AllAppVersion>;
  availableCustomerSpinPoint?: Maybe<Scalars['Int']['output']>;
  availableForAgentDisbursement?: Maybe<Array<Maybe<AvailableForAgentDisbursement>>>;
  banner?: Maybe<BannerMange>;
  bannerList?: Maybe<Array<Maybe<BannerMange>>>;
  brand?: Maybe<Brand>;
  brandList?: Maybe<Array<Maybe<Brand>>>;
  brandSalesAnalytic?: Maybe<Scalars['JSON']['output']>;
  brokerTransactionList?: Maybe<Array<Maybe<SupplierPaymentHistory>>>;
  buildPosCart?: Maybe<PosCart>;
  calculateCrawledProductPrice?: Maybe<Scalars['Float']['output']>;
  calculateProductPrice?: Maybe<ProductPrice>;
  callToActionList?: Maybe<Array<Maybe<CallToAction>>>;
  campaignTracker?: Maybe<CampaignTracker>;
  campaignTrackerList?: Maybe<Array<Maybe<CampaignTracker>>>;
  campaignTrackerProductList?: Maybe<Array<Maybe<CampaignTrackerProduct>>>;
  /** @deprecated Replaced by cartV2 */
  cart?: Maybe<Cart>;
  cartThread?: Maybe<Thread>;
  cartV2?: Maybe<Cart>;
  category?: Maybe<Category>;
  categoryAnalytics?: Maybe<Array<Maybe<CategoryAnalytic>>>;
  categoryCatalogue?: Maybe<Array<Maybe<CategoryCatalogue>>>;
  categoryList?: Maybe<Array<Maybe<Category>>>;
  chatChannel?: Maybe<Array<Maybe<ChatMessage>>>;
  chatChannelList?: Maybe<Array<Maybe<ChatChannel>>>;
  chatChannelPartnerList?: Maybe<Array<Maybe<ChatChannelPartner>>>;
  chatChannelSeenList?: Maybe<Array<Maybe<ChatChannelSeen>>>;
  checkCustomerPassword?: Maybe<Scalars['Boolean']['output']>;
  checkPaymentStatus?: Maybe<CheckPaymentStatus>;
  clearanceStockList?: Maybe<ClearanceStockList>;
  codeProductByCode?: Maybe<Array<Maybe<BasicProduct>>>;
  commentList?: Maybe<Array<Maybe<Comment>>>;
  communeList?: Maybe<Array<Maybe<Commune>>>;
  coreProductList?: Maybe<Array<Maybe<CoreProduct>>>;
  crawlExternalProduct?: Maybe<Scalars['JSON']['output']>;
  currentAgent?: Maybe<Agent>;
  customPage?: Maybe<CustomPage>;
  customPageList?: Maybe<Array<Maybe<CustomPage>>>;
  customReport?: Maybe<CustomReport>;
  customReportList?: Maybe<Array<Maybe<CustomReport>>>;
  customReportPermission?: Maybe<Array<Maybe<AdminGroup>>>;
  customer?: Maybe<Customer>;
  customerAddressInquiry?: Maybe<Array<Maybe<CustomerAddressInquiry>>>;
  customerAddressList?: Maybe<Array<Maybe<CustomerAddress>>>;
  customerCartList?: Maybe<Array<Maybe<CustomerCart>>>;
  customerCartLog?: Maybe<Array<Maybe<CustomerCartLog>>>;
  customerCartPreview?: Maybe<Array<Maybe<CartPreview>>>;
  customerCurrentBalance?: Maybe<Scalars['String']['output']>;
  customerLinkedPaymentList?: Maybe<Array<Maybe<LinkedPayment>>>;
  customerList?: Maybe<Array<Maybe<Customer>>>;
  customerLocationSuggestion?: Maybe<Array<Maybe<CustomerLocationSuggestEntry>>>;
  customerNote?: Maybe<CustomerNote>;
  customerNoteList?: Maybe<Array<Maybe<CustomerNote>>>;
  customerNoteTemplate?: Maybe<CustomerNoteTemplate>;
  customerNoteTemplateList?: Maybe<Array<Maybe<CustomerNoteTemplate>>>;
  customerNotificationList?: Maybe<Array<Maybe<CustomerNotification>>>;
  customerOrder?: Maybe<CustomerOrder>;
  customerOrderHistory?: Maybe<CustomerOrderHistory>;
  customerOrderItem?: Maybe<CustomerOrderItemV2>;
  customerOrderItemCount?: Maybe<Scalars['JSON']['output']>;
  customerOrderItemList?: Maybe<Array<Maybe<CustomerOrderItemV2>>>;
  customerOrderList?: Maybe<Array<Maybe<CustomerOrder>>>;
  customerOrderListSummary?: Maybe<CustomerOrderListSummary>;
  customerOrderReturn?: Maybe<Array<Maybe<CustomerOrderReturn>>>;
  customerOrderTracking?: Maybe<Array<Maybe<CustomerOrderTracking>>>;
  /** This is the latest way of query the customer order */
  customerOrders?: Maybe<CustomerOrderCursor>;
  customerPayment?: Maybe<CustomerPaymentHistory>;
  customerPaymentHistory?: Maybe<Array<Maybe<CustomerPaymentHistory>>>;
  customerPaymentOptionBlockStatus?: Maybe<Array<Maybe<PaymentOptionBlockStatus>>>;
  customerPayments?: Maybe<CustomerPaymentCursor>;
  customerRefund?: Maybe<CustomerRefund>;
  customerRefundList?: Maybe<CustomerRefundConnection>;
  customerSlot?: Maybe<CustomerSlot>;
  customerSlotList?: Maybe<CustomerSlots>;
  customerStats?: Maybe<CustomerStats>;
  customerUnreadMessageCount?: Maybe<Scalars['Int']['output']>;
  debug?: Maybe<Scalars['JSON']['output']>;
  debugCustomerBalance?: Maybe<CustomerBalanceDebug>;
  deliveredPackageList?: Maybe<Array<Maybe<Package>>>;
  delivererSalary?: Maybe<DelivererSalary>;
  delivererSalaryList?: Maybe<Array<Maybe<DelivererSalary>>>;
  deliveryAdminMetrics?: Maybe<DeliveryAdminMetrics>;
  deliveryAgentList?: Maybe<Array<Maybe<DeliveryAgent>>>;
  deliveryAgentMetrics?: Maybe<DeliveryAgentMetrics>;
  deliveryCustomerLocation?: Maybe<Array<Maybe<DeliveryTripRoute>>>;
  deliveryPersonKPI?: Maybe<Scalars['JSON']['output']>;
  deliveryPersonList?: Maybe<Array<Maybe<DeliveryPerson>>>;
  deliveryTermsAndCondition?: Maybe<Setting>;
  deliveryTripList?: Maybe<Array<Maybe<DeliveryTrip>>>;
  digitalWarrantyList?: Maybe<Array<Maybe<DigitalWarranty>>>;
  disbursementCompleteList?: Maybe<Array<Maybe<Scalars['JSON']['output']>>>;
  disbursementDetail?: Maybe<Array<Maybe<Scalars['JSON']['output']>>>;
  disbursementList?: Maybe<Array<Maybe<Scalars['JSON']['output']>>>;
  disbursementLog?: Maybe<Array<Maybe<Scalars['JSON']['output']>>>;
  disbursementProcessingList?: Maybe<Array<Maybe<Scalars['JSON']['output']>>>;
  disbursementRequestDetail?: Maybe<Array<Maybe<Scalars['JSON']['output']>>>;
  discountCampaign?: Maybe<DiscountCampaign>;
  discountCampaignList?: Maybe<Array<Maybe<DiscountCampaign>>>;
  displayProduct?: Maybe<DisplayProduct>;
  displayProductBySku?: Maybe<Array<Maybe<ProductSku>>>;
  displayProductMediaList?: Maybe<Array<Maybe<DisplayProductMedia>>>;
  displayProductOption?: Maybe<ProductOption>;
  distanceDifference?: Maybe<Scalars['Float']['output']>;
  district?: Maybe<District>;
  districtList?: Maybe<Array<Maybe<District>>>;
  dollarToRielExchangeRate?: Maybe<Scalars['String']['output']>;
  dropPoint?: Maybe<DropPoint>;
  dropPointByAddress?: Maybe<DropPoint>;
  dropPointByLatLng?: Maybe<DropPoint>;
  dropPointList?: Maybe<Array<Maybe<DropPoint>>>;
  employee?: Maybe<Admin>;
  estimatePackagePrice?: Maybe<PackagePriceEstimation>;
  estimatePackagePriceByProduct?: Maybe<PackagePriceEstimation>;
  eventCampaignDetail?: Maybe<EventCampaign>;
  eventCampaignDetailList?: Maybe<Array<Maybe<EventCampaignItem>>>;
  eventCampaignList?: Maybe<Array<Maybe<EventCampaign>>>;
  eventCampaignProductList?: Maybe<Array<Maybe<ProductRawJson>>>;
  eventCampaignProductValidation?: Maybe<Scalars['JSON']['output']>;
  exchangeSavingPointToSpinPointRate?: Maybe<Scalars['JSON']['output']>;
  exportedPreorderList?: Maybe<Scalars['JSON']['output']>;
  expressPackageItems?: Maybe<Array<Maybe<ExpressPackageItem>>>;
  facebookPageList?: Maybe<Array<Maybe<FacebookPageComment>>>;
  /** @deprecated Unused featured */
  facebookPages?: Maybe<Array<Maybe<FacebookPage>>>;
  facebookProductPost?: Maybe<FacebookPost>;
  featureFlags?: Maybe<FeatureFlags>;
  /** @deprecated It will be replaced by social feature */
  feeds?: Maybe<Scalars['JSON']['output']>;
  frontPageBanner?: Maybe<Banner>;
  frontScreenBrandForYou?: Maybe<Array<Maybe<ProductRawJson>>>;
  frontScreenBrandList?: Maybe<Array<Maybe<Brand>>>;
  frontScreenCategoryForYou?: Maybe<Array<Maybe<CategoryCatalogue>>>;
  frontScreenCustomerAddress?: Maybe<FrontScreenAddress>;
  frontScreenDealForYou?: Maybe<Array<Maybe<ProductRawJson>>>;
  frontScreenFeatureStoreList?: Maybe<Array<Maybe<FeaturedShop>>>;
  frontScreenMadeInCambodia?: Maybe<Array<Maybe<ProductRawJson>>>;
  frontScreenMenuList?: Maybe<Scalars['JSON']['output']>;
  frontScreenPartnerStore?: Maybe<Array<Maybe<PartnerShop>>>;
  frontScreenQuickAccessMenu?: Maybe<Scalars['JSON']['output']>;
  frontScreenStoreForYou?: Maybe<Array<Maybe<ProductRawJson>>>;
  geoHierarchyByLatLng?: Maybe<GeoHierarchy>;
  geocodeAddress?: Maybe<Scalars['String']['output']>;
  getProductLabelList?: Maybe<Array<Maybe<BasicProduct>>>;
  getProductLabelTab?: Maybe<ProductLabelTab>;
  getProductUnitByBarcode?: Maybe<BarcodeProduct>;
  getPromotionCampaign?: Maybe<PromotionCampaign>;
  getPromotionList?: Maybe<Array<Maybe<ActivatedPromotion>>>;
  getProvince?: Maybe<Scalars['String']['output']>;
  groupBuyList?: Maybe<GroupBuyList>;
  historyPosCustorder?: Maybe<Array<Maybe<SupplierPosCustorder>>>;
  imagePackages?: Maybe<Array<Maybe<ImagePackage>>>;
  inventorySlot?: Maybe<InventorySlot>;
  inventorySlotList?: Maybe<InventorySlotList>;
  isMultiOfferTemplateWhiteList?: Maybe<Scalars['Boolean']['output']>;
  isSellerPhoneNumberAvailable?: Maybe<Scalars['Boolean']['output']>;
  khmerloadAdsContent?: Maybe<Array<Maybe<ProductRawJson>>>;
  lastUpdatedProductList?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  latePackageList?: Maybe<Array<Maybe<LatePackageDetail>>>;
  listProductChoice?: Maybe<Array<Maybe<ProductChoice>>>;
  listSellerPackage?: Maybe<SellerPackageList>;
  liveShopping?: Maybe<LiveShopping>;
  liveShoppingList?: Maybe<Array<Maybe<LiveShopping>>>;
  liveStockStatus?: Maybe<Array<Maybe<LiveStockStatus>>>;
  localDeliveryTimeZone?: Maybe<Scalars['String']['output']>;
  loginActivityReport?: Maybe<Array<Maybe<LoginActivity>>>;
  loginlessOrder?: Maybe<LoginlessOrder>;
  loginlessOrderItemList?: Maybe<Array<Maybe<LoginlessOrderItem>>>;
  loginlessOrderList?: Maybe<Array<Maybe<LoginlessOrder>>>;
  luckyDraw?: Maybe<LuckyDraw>;
  luckyDrawAvailableCustomer?: Maybe<LuckyDrawCustomerInformation>;
  luckyDrawList?: Maybe<Array<Maybe<LuckyDraw>>>;
  luckyDrawParticipant?: Maybe<Array<Maybe<CustomerBasic>>>;
  mapPlaceLocation?: Maybe<MapPlaceLoationResponse>;
  mapSuggestionLatLng?: Maybe<Array<Maybe<MapSuggestionLatLngResponse>>>;
  mapSuggestionPlace?: Maybe<Array<Maybe<MapPlaceSuggestion>>>;
  massUpload?: Maybe<MassUploadDetail>;
  massUploadList?: Maybe<Array<Maybe<MassUpload>>>;
  me?: Maybe<Customer>;
  mediaList?: Maybe<Array<Maybe<Media>>>;
  merchant?: Maybe<Merchant>;
  merchantAllSale?: Maybe<SaleSummary>;
  merchantAnnouncement?: Maybe<MerchantAnnouncement>;
  merchantAnnouncementList?: Maybe<Array<Maybe<MerchantAnnouncement>>>;
  merchantAvailableDetail?: Maybe<Scalars['JSON']['output']>;
  /** @deprecated Will replaced by brand resolver */
  merchantBrand?: Maybe<MerchantBrand>;
  merchantBrandAllList?: Maybe<Scalars['JSON']['output']>;
  merchantBrandApproveList?: Maybe<Array<Maybe<MerchantBrand>>>;
  /** @deprecated Will replaced by brandList resolver */
  merchantBrandList?: Maybe<Array<Maybe<MerchantBrand>>>;
  merchantBrandRejectList?: Maybe<Array<Maybe<MerchantBrand>>>;
  merchantBrandRequestList?: Maybe<Array<Maybe<MerchantBrand>>>;
  merchantCheckSupplierList?: Maybe<Scalars['JSON']['output']>;
  merchantCustorderList?: Maybe<Scalars['JSON']['output']>;
  merchantDeliveryLocation?: Maybe<Array<Maybe<DeliveryLocation>>>;
  merchantDisbursementProcessingDetailList?: Maybe<Scalars['JSON']['output']>;
  merchantDisbursmentPaidDetailList?: Maybe<Scalars['JSON']['output']>;
  merchantDiscountItem?: Maybe<Scalars['JSON']['output']>;
  merchantDiscountItemCampaign?: Maybe<Array<Maybe<ItemDiscountCampaign>>>;
  merchantHoldDetail?: Maybe<Scalars['JSON']['output']>;
  merchantInventoryFBL?: Maybe<Array<Maybe<Scalars['JSON']['output']>>>;
  merchantInventorySummary?: Maybe<InventorySummary>;
  /** @deprecated No longer supported */
  merchantLogisticInfo?: Maybe<Scalars['String']['output']>;
  merchantOnGoingOrderList?: Maybe<Scalars['JSON']['output']>;
  merchantOrderByItem?: Maybe<Array<Maybe<Scalars['JSON']['output']>>>;
  merchantOrderList?: Maybe<Array<Maybe<MerchantOrderItem>>>;
  merchantOrderListBeta?: Maybe<Array<Maybe<MerchantOrderItem>>>;
  merchantOrderToPrepareList?: Maybe<Array<Maybe<MerchantOrder>>>;
  merchantOrderTotalBeta?: Maybe<Array<Maybe<MerchantTotalOrder>>>;
  merchantPreparedOrdersList?: Maybe<Array<Maybe<MerchantOrder>>>;
  merchantProductAvailableList?: Maybe<ProductAvailable>;
  merchantProductQuantityList?: Maybe<Array<Maybe<ProductQuantity>>>;
  /** @deprecated no long use */
  merchantProductView?: Maybe<Array<Maybe<Scalars['JSON']['output']>>>;
  /** @deprecated no long use */
  merchantProductViewDate?: Maybe<Array<Maybe<Scalars['JSON']['output']>>>;
  merchantSaleAllTime?: Maybe<Array<Maybe<Scalars['JSON']['output']>>>;
  merchantSaleDay?: Maybe<Array<Maybe<Scalars['JSON']['output']>>>;
  merchantSaleSummary?: Maybe<Array<Maybe<SaleSummary>>>;
  merchantSaleSummaryChartBeta?: Maybe<Scalars['JSON']['output']>;
  merchantSaleSummaryReport?: Maybe<Array<Maybe<Scalars['JSON']['output']>>>;
  merchantSearchProduct?: Maybe<Scalars['JSON']['output']>;
  merchantShipmentDetail?: Maybe<Array<Maybe<Product>>>;
  merchantShipmentItemHistory?: Maybe<Scalars['JSON']['output']>;
  merchantShipmentList?: Maybe<Array<Maybe<ShipmentProduct>>>;
  merchantShippedOrdersList?: Maybe<Array<Maybe<MerchantOrder>>>;
  merchantSponsor?: Maybe<MerchantSponsorCampaign>;
  merchantSponsorDetail?: Maybe<Array<Maybe<MerchantSponsorItem>>>;
  merchantSponsorList?: Maybe<Array<Maybe<MerchantSponsorCampaign>>>;
  merchantStoreList?: Maybe<Array<Maybe<MerchantStore>>>;
  merchantSuggestColor?: Maybe<Scalars['JSON']['output']>;
  merchantSuggestSize?: Maybe<Scalars['JSON']['output']>;
  merchantTopupList?: Maybe<Array<Maybe<MerchantTopup>>>;
  merchantTotalDetail?: Maybe<Scalars['JSON']['output']>;
  merchantTotalHoldBalance?: Maybe<TotalHoldBalance>;
  merchantTotalOrderManagement?: Maybe<Scalars['JSON']['output']>;
  merchantVolumeItem?: Maybe<Array<Maybe<Scalars['JSON']['output']>>>;
  moneyTransferBatch?: Maybe<Array<Maybe<MoneyTransferBatch>>>;
  multiOffersTemplateDetail?: Maybe<MultiOffersTemplateType>;
  multiOffersTemplateList?: Maybe<Array<Maybe<MultiOffersTemplateType>>>;
  myActivatedPromotionList?: Maybe<Array<Maybe<ActivatedPromotion>>>;
  myStoreList?: Maybe<Array<Maybe<MyStore>>>;
  newArrivalCategoryList?: Maybe<Array<Maybe<NewArrivalCategory>>>;
  newArrivalProductList?: Maybe<Array<Maybe<ProductRawJson>>>;
  newPackageBreakdown?: Maybe<PackageBreakdown>;
  nextHubsPackage?: Maybe<Array<Maybe<NextHubsPackage>>>;
  notificationDeliveryList?: Maybe<Array<Maybe<NotificationDelivery>>>;
  notificationSchedule?: Maybe<NotificationSchedule>;
  notificationScheduleList?: Maybe<Array<Maybe<NotificationSchedule>>>;
  notificationSegment?: Maybe<NotificationSegment>;
  notificationSegmentList?: Maybe<Array<Maybe<NotificationSegment>>>;
  notificationStatus?: Maybe<Scalars['JSON']['output']>;
  numberToWords?: Maybe<Scalars['String']['output']>;
  onlineStaffPerformance?: Maybe<OnlineStaffPerformance>;
  onlineStaffPerformanceList?: Maybe<Array<Maybe<OnlineStaffPerformance>>>;
  onlinemartReport?: Maybe<Scalars['JSON']['output']>;
  orderDraft?: Maybe<OrderDraftType>;
  orderDraftList?: Maybe<Array<Maybe<OrderDraftType>>>;
  orderTemplate?: Maybe<OrderTemplate>;
  orderTemplateList?: Maybe<Array<Maybe<OrderTemplate>>>;
  ordersByLiveCampaignId?: Maybe<Array<Maybe<MerchantOrderItem>>>;
  package?: Maybe<Package>;
  packageBlockingArea?: Maybe<Array<Maybe<MapMultipolygon>>>;
  packageCountByStatus?: Maybe<Array<Maybe<PackagesByStatus>>>;
  packageCustomerList?: Maybe<Array<Maybe<PackageCustomer>>>;
  packageDelivererMonitor?: Maybe<Array<Maybe<PackageDelivererMonitor>>>;
  packageInvoiceDetail?: Maybe<PackageInvoiceDetail>;
  packageInvoiceList?: Maybe<Array<Maybe<PackageInvoice>>>;
  packageItemList?: Maybe<Array<Maybe<CustomerOrderItem>>>;
  packageList?: Maybe<Array<Maybe<Package>>>;
  packageListInternal?: Maybe<Array<Maybe<Package>>>;
  packagePerformanceReport?: Maybe<Scalars['JSON']['output']>;
  packageReport?: Maybe<Array<Maybe<PackageReportItem>>>;
  packageTransitLogs?: Maybe<Array<Maybe<PackageTransitLog>>>;
  page?: Maybe<Scalars['JSON']['output']>;
  pageBeta?: Maybe<Scalars['JSON']['output']>;
  partnerAdsDibursementDetail?: Maybe<PartnerAdsDisbursement>;
  partnerAdsDisbursementList?: Maybe<PartnerAdsDisbursementList>;
  partnerSeller?: Maybe<PartnerSeller>;
  partnerSellerList?: Maybe<Array<Maybe<PartnerSeller>>>;
  partnerStaffList?: Maybe<Array<Maybe<PartnerStaff>>>;
  partnerSummaryOrder?: Maybe<Array<Maybe<PartnerSummaryOrder>>>;
  paymentChartOfAccountList?: Maybe<Array<Maybe<PaymentChartOfAccount>>>;
  paymentLogDetail?: Maybe<PaymentDetailWithRemainder>;
  paymentLogDetailByTransactionType?: Maybe<Array<Maybe<PaymentLogDetail>>>;
  /** @deprecated Replace by paymentOptions */
  paymentOptionList?: Maybe<Scalars['JSON']['output']>;
  paymentOptions?: Maybe<PaymentOptionList>;
  paymentReceived?: Maybe<PaymentReceivedResponse>;
  preorderList?: Maybe<Scalars['JSON']['output']>;
  preorderListByExportID?: Maybe<Scalars['JSON']['output']>;
  product?: Maybe<Product>;
  productByCode?: Maybe<Product>;
  productClearanceStockByCode?: Maybe<Array<Maybe<ClearanceStock>>>;
  productCommissionFee?: Maybe<ProductCommissionFee>;
  productGroup?: Maybe<ProductGroup>;
  productGroupList?: Maybe<Array<Maybe<ProductGroup>>>;
  productImageSearch?: Maybe<Scalars['String']['output']>;
  productImageSearchResult?: Maybe<Array<Maybe<ProductRawJson>>>;
  productList?: Maybe<Array<Maybe<Product>>>;
  productListCount?: Maybe<ProductListCountTab>;
  productListV2?: Maybe<ProductListResult>;
  productRecycle?: Maybe<Array<Maybe<ProductRecycle>>>;
  productReview?: Maybe<ProductReview>;
  productReviewAttachmentList?: Maybe<Array<Maybe<ProductReviewAttachment>>>;
  productReviewList?: Maybe<Array<Maybe<ProductReview>>>;
  productReviewOverview?: Maybe<ProductReviewOverview>;
  productReviewRankList?: Maybe<Array<Maybe<ProductReviewRankItem>>>;
  productReviewReport?: Maybe<ProductReviewReport>;
  productSalesAnalyticList?: Maybe<Scalars['JSON']['output']>;
  productSearch?: Maybe<ProductSearchResult>;
  productSearchLegacy?: Maybe<Scalars['JSON']['output']>;
  productSearchSponsored?: Maybe<Scalars['JSON']['output']>;
  productSkuBarcode?: Maybe<Scalars['JSON']['output']>;
  productStock?: Maybe<Array<Maybe<StockKeepingUnit>>>;
  productStockStatus?: Maybe<Array<Maybe<ProductStockStatus>>>;
  promotion?: Maybe<Promotion>;
  promotionCampaign?: Maybe<PromotionCampaign>;
  promotionCampaignCreators?: Maybe<PromotionCampaignCreator>;
  promotionCampaignList?: Maybe<Array<Maybe<PromotionCampaign>>>;
  promotionList?: Maybe<Array<Maybe<Promotion>>>;
  promotionReport?: Maybe<PromotionReport>;
  promotionTopList?: Maybe<Array<Maybe<PromotionTopItem>>>;
  provinceList?: Maybe<Array<Maybe<Province>>>;
  purchaseOrder?: Maybe<PurchaseOrder>;
  purchaseOrderList?: Maybe<PurchaseOrderList>;
  purchaseOrderLog?: Maybe<Array<Maybe<PurchaseOrderLog>>>;
  readyToDeliverPackageBreakdown?: Maybe<Array<Maybe<HubPackage>>>;
  /** @deprecated Will replaced by brand resolver */
  recommendBrand?: Maybe<Array<Maybe<MerchantBrand>>>;
  recommendCustomerCategoryList?: Maybe<Array<Maybe<Category>>>;
  recommendCustomerProductList?: Maybe<Scalars['JSON']['output']>;
  recommendCustomerProductListV2?: Maybe<Scalars['JSON']['output']>;
  recommendFeaturedShop?: Maybe<FeaturedShop>;
  recommendFeaturedShopList?: Maybe<Array<Maybe<Supplier>>>;
  recommendProductCategoryList?: Maybe<Scalars['JSON']['output']>;
  recommendProductListByCategory?: Maybe<Array<Maybe<ProductRawJson>>>;
  recommendProductRestock?: Maybe<Scalars['JSON']['output']>;
  recommendRelatedProductList?: Maybe<Scalars['JSON']['output']>;
  recommendStore?: Maybe<RecommendStore>;
  recommendUserPosts?: Maybe<UserPostPagination>;
  referralListByReferrer?: Maybe<Array<Maybe<Supplier>>>;
  referrerAvailableEarningBalance?: Maybe<Array<Maybe<ReferrerAvailableEarningBalance>>>;
  referrerDisbursement?: Maybe<Array<Maybe<ReferrerDisbursement>>>;
  /** @deprecated Will replaced by customerLocationSuggestion */
  reportCheckoutLocation?: Maybe<Array<Maybe<ReportCheckoutLocationEntry>>>;
  reportCohort?: Maybe<Scalars['JSON']['output']>;
  reportDeliveryFeeList?: Maybe<Scalars['JSON']['output']>;
  reportFBLSaleList?: Maybe<Scalars['JSON']['output']>;
  reportGMV?: Maybe<Array<Maybe<ReportGmvEntry>>>;
  reportInventorySaleList?: Maybe<Scalars['JSON']['output']>;
  reportInvoiceList?: Maybe<Scalars['JSON']['output']>;
  reportLiveProductList?: Maybe<Scalars['JSON']['output']>;
  reportMerchantTotalSales?: Maybe<ReportMerchantTotalSale>;
  reportMonthlyReturnedCustomer?: Maybe<Scalars['JSON']['output']>;
  reportOfflineKPI?: Maybe<Array<Maybe<ReportOfflineKpiEntry>>>;
  reportOtherSaleList?: Maybe<Scalars['JSON']['output']>;
  reportPipeline?: Maybe<Scalars['JSON']['output']>;
  reportSale?: Maybe<Scalars['JSON']['output']>;
  reportSaleByCategory?: Maybe<Scalars['JSON']['output']>;
  reportSaleList?: Maybe<Scalars['JSON']['output']>;
  reportSearchBreakdown?: Maybe<Scalars['JSON']['output']>;
  reportServiceFeeList?: Maybe<Scalars['JSON']['output']>;
  reportStockKPI?: Maybe<Scalars['JSON']['output']>;
  reportedProductList?: Maybe<Array<Maybe<ReportedProduct>>>;
  /** Return data in JSON format string */
  runCustomReport?: Maybe<Scalars['JSON']['output']>;
  salesDetailBySalesStatus?: Maybe<SalesDetailBySalesStatusList>;
  searchPost?: Maybe<UserPostPagination>;
  searchProductTag?: Maybe<Scalars['String']['output']>;
  searchSuggestion?: Maybe<SearchSuggestion>;
  selectedSpinReward?: Maybe<Array<Maybe<SpinReward>>>;
  sellerAdsCampaign?: Maybe<SellerAdsCampaign>;
  sellerAdsCampaigns?: Maybe<Array<Maybe<SellerAdsCampaign>>>;
  sellerAdsItems?: Maybe<Array<Maybe<SellerAdsCampaignItem>>>;
  sellerAdsV2Detail?: Maybe<SellerAdsV2Output>;
  sellerAdsV2List?: Maybe<Array<Maybe<SellerAdsV2Output>>>;
  sellerLiveCampaignList?: Maybe<SellerLiveCampaignList>;
  sellerMenu?: Maybe<Scalars['JSON']['output']>;
  sellerNotificationList?: Maybe<Array<Maybe<SellerNotification>>>;
  sellerPackage?: Maybe<SellerPackage>;
  sellerSalesByDay?: Maybe<Array<Maybe<SellerSalesByDay>>>;
  sellerSalesSummaryDashboard?: Maybe<Scalars['JSON']['output']>;
  serviceList?: Maybe<Array<Maybe<ServiceItem>>>;
  setting?: Maybe<Scalars['String']['output']>;
  settingList?: Maybe<Array<Maybe<Setting>>>;
  settlementWithSeller?: Maybe<SettlementWithSeller>;
  settlementWithSellerList?: Maybe<Array<Maybe<SettlementWithSeller>>>;
  shipmentCountByStatus?: Maybe<Scalars['JSON']['output']>;
  shipmentTrackingCode?: Maybe<Array<Maybe<TrackingCode>>>;
  shipmentTrackingCodeList?: Maybe<Array<Maybe<TrackingCodeList>>>;
  showClickToDoorMessage?: Maybe<ShowClickToDoorMessage>;
  /** @deprecated Replace by skuV2 */
  sku?: Maybe<Sku>;
  skuList?: Maybe<Array<Maybe<Sku>>>;
  skuV2?: Maybe<StockKeepingUnit>;
  specialProduct?: Maybe<SpecialProduct>;
  specialProductList?: Maybe<Array<Maybe<SpecialProduct>>>;
  spinRewardDetail?: Maybe<SpinReward>;
  spinRewardList?: Maybe<Array<Maybe<SpinReward>>>;
  staffBalanceLog?: Maybe<Array<Maybe<StaffBalance>>>;
  staffDepositList?: Maybe<Array<Maybe<StaffDeposit>>>;
  staffLocationLog?: Maybe<Array<Maybe<StaffLocation>>>;
  staffOpenAndCloseBalance?: Maybe<StaffOpenAndCloseBalance>;
  staffRegistrationList?: Maybe<Array<Maybe<StaffRegistrationInfo>>>;
  stats?: Maybe<Scalars['JSON']['output']>;
  stockTransactionList?: Maybe<Array<Maybe<StockTransactionV2>>>;
  storeBrandList?: Maybe<Array<Maybe<FeaturedShop>>>;
  successPackageLocation?: Maybe<Array<Maybe<SuccessPackageLocation>>>;
  suggestCustomerOrderItemFindingSlot?: Maybe<Array<Maybe<CustomerOrderItemFindingSuggestion>>>;
  suggestShopRequestFindingSlot?: Maybe<Array<Maybe<ShopRequestFindingSuggestion>>>;
  suggestSupplierCustomerAddress?: Maybe<Array<Maybe<SupplierCustomerAddress>>>;
  suggestedPublicPromotionList?: Maybe<Array<Maybe<Promotion>>>;
  supplier?: Maybe<Supplier>;
  supplierAddress?: Maybe<SupplierAddress>;
  supplierAddressList?: Maybe<Array<Maybe<SupplierAddress>>>;
  supplierAffiliate?: Maybe<Customer>;
  supplierAffiliateList?: Maybe<Array<Maybe<Customer>>>;
  supplierAffiliateProductList?: Maybe<Array<Maybe<AffiliateProduct>>>;
  supplierAvailableCategory?: Maybe<Array<Maybe<Category>>>;
  supplierBalanceSummary?: Maybe<SupplierBalanceSummary>;
  supplierBankChangeLog?: Maybe<Array<Maybe<SupplierBankChangeLog>>>;
  supplierBrandList?: Maybe<Array<Maybe<MerchantBrand>>>;
  supplierByPhone?: Maybe<Supplier>;
  supplierClickThroughRateByDate?: Maybe<Scalars['JSON']['output']>;
  supplierClickThroughRateByProduct?: Maybe<Array<Maybe<SupplierClickThroughRate>>>;
  supplierCohort?: Maybe<Scalars['JSON']['output']>;
  supplierCustomer?: Maybe<Scalars['JSON']['output']>;
  supplierCustomerList?: Maybe<Scalars['JSON']['output']>;
  supplierDisbursementAvailableList?: Maybe<Array<Maybe<SupplierDisbursementItem>>>;
  supplierDisbursementDetail?: Maybe<Array<Maybe<SupplierDisbursementItem>>>;
  /** @deprecated Will replaced by supplierDisbursementAvailableList resolver */
  supplierDisbursementList?: Maybe<SupplierDisbursementList>;
  supplierEarningBalance?: Maybe<SupplierEarningBalance>;
  supplierFacebookOrder?: Maybe<SupplierProductAliasCode>;
  supplierFbOrderList?: Maybe<Array<Maybe<SupplierFbOrder>>>;
  supplierFeeList?: Maybe<Array<Maybe<SupplierFeeItem>>>;
  supplierHoldBalance?: Maybe<SupplierHoldList>;
  supplierInternalDisbursementList?: Maybe<DisbursementItemList>;
  supplierInventoryFBLVTWO?: Maybe<SupplierFblInventoryList>;
  supplierInventoryMonitor?: Maybe<SupplierInventoryMonitorList>;
  supplierInventoryRemoval?: Maybe<InventoryRemovalList>;
  supplierInventoryRemovalItem?: Maybe<Array<Maybe<InventoryRemovalItem>>>;
  supplierInventoryStatus?: Maybe<SupplierInventoryInfo>;
  supplierInventoryStorageFeeDaily?: Maybe<SupplierInventoryStorageFeeDailyList>;
  supplierItemLive?: Maybe<ItemLive>;
  supplierItemLiveList?: Maybe<Array<Maybe<ItemLive>>>;
  supplierList?: Maybe<Array<Maybe<Supplier>>>;
  supplierListFromConsolidate?: Maybe<Array<Maybe<SupplierConlidate>>>;
  supplierListUploadDraft?: Maybe<Array<Maybe<SupplierUploadDraftList>>>;
  supplierLocalShipperList?: Maybe<SupplierLocalShipperList>;
  supplierMediaFolder?: Maybe<SupplierMediaFolderList>;
  /** @deprecated Will be replaced by SupplierBalanceSummaryResolver and supplierDisbursementAvailableList */
  supplierOrderBalance?: Maybe<SupplierBalance>;
  supplierOrderCountByStatus?: Maybe<Scalars['JSON']['output']>;
  supplierOrderDetail?: Maybe<OrderItemDetail>;
  supplierOrderList?: Maybe<Array<Maybe<SupplierOrderList>>>;
  supplierOrderListV2?: Maybe<SupplierOrderListResult>;
  supplierPackageSalesReport?: Maybe<SupplierPackageSalesReport>;
  supplierPosCustomerOrder?: Maybe<Array<Maybe<SupplierPosCustorder>>>;
  supplierProductAliasCode?: Maybe<Scalars['JSON']['output']>;
  supplierProductDefaultValue?: Maybe<ProductDefaultValue>;
  supplierProductDraft?: Maybe<SupplierProductRequest>;
  supplierProductID?: Maybe<Array<Maybe<SupplierProductRequest>>>;
  supplierProductPerformance?: Maybe<SupplierProductPerformanceList>;
  supplierProductRanking?: Maybe<Array<Maybe<ProductRanking>>>;
  supplierProductRequest?: Maybe<SupplierProductRequest>;
  supplierProductRequestList?: Maybe<SupplierProductRequestList>;
  supplierProductValidation?: Maybe<Scalars['JSON']['output']>;
  supplierProductValidationV2?: Maybe<ValidationResult>;
  supplierProductViewTab?: Maybe<Scalars['JSON']['output']>;
  supplierPromoComboDetail?: Maybe<PromoCombo>;
  supplierPromoComboList?: Maybe<PromoComboList>;
  supplierReachClickSalesInfo?: Maybe<Array<Maybe<SupplierReachClickSales>>>;
  supplierReachClickSalesProduct?: Maybe<Array<Maybe<SupplierReachClickSalesProduct>>>;
  supplierRegisterReview?: Maybe<SupplierMoreInformation>;
  supplierRestockingSku?: Maybe<RestockingList>;
  supplierSaleDailyList?: Maybe<SupplierSaleDailyList>;
  supplierSaleSummary?: Maybe<SupplierSale>;
  supplierSalesReport?: Maybe<Scalars['JSON']['output']>;
  supplierSearchProductByCode?: Maybe<Scalars['JSON']['output']>;
  supplierSetting?: Maybe<SupplierSetting>;
  supplierSettingList?: Maybe<Scalars['JSON']['output']>;
  supplierShipmentAndPurchaseOrderReceived?: Maybe<SupplierShipmentAndPurchaseOrderReceivedList>;
  supplierShipmentDetail?: Maybe<ShipmentDetail>;
  supplierShipmentList?: Maybe<ShipmentProductList>;
  supplierShipperList?: Maybe<Array<Maybe<SupplierShipper>>>;
  supplierTagSuggestList?: Maybe<Scalars['JSON']['output']>;
  supplierTopUpBalanceList?: Maybe<SupplierTopUpBalanceList>;
  supplierTotalBalance?: Maybe<SupplierTotalList>;
  supplierVendor?: Maybe<SupplierVendor>;
  supplierVendorList?: Maybe<Array<Maybe<SupplierVendor>>>;
  tagList?: Maybe<Array<Maybe<Tag>>>;
  thirdPartyTrackingData?: Maybe<Scalars['JSON']['output']>;
  thread?: Maybe<Thread>;
  threadComments?: Maybe<Array<Maybe<ThreadComment>>>;
  toTransitPackageBreakdown?: Maybe<Array<Maybe<TransitPackageBreakdown>>>;
  topReviewerList?: Maybe<Array<Maybe<CustomerBasic>>>;
  transitPackageBreakdown?: Maybe<Array<Maybe<InTransitPackageBreakdown>>>;
  transitPackageCountByNextHub?: Maybe<Array<Maybe<NextHubsPackage>>>;
  unsettlePackagePayments?: Maybe<Array<Maybe<UnsettlePackagePayment>>>;
  unverifiedBankTransferList?: Maybe<Array<Maybe<UnverifiedBankTransfer>>>;
  urlToPayload?: Maybe<Scalars['JSON']['output']>;
  userPostCommentList?: Maybe<Array<Maybe<UserPostComment>>>;
  userPostList?: Maybe<UserPostPagination>;
  userProfile?: Maybe<UserProfile>;
  validToken?: Maybe<Scalars['Boolean']['output']>;
  validateNewSellerAccountPhoneNumber?: Maybe<Scalars['Boolean']['output']>;
  warehouseList?: Maybe<Array<Maybe<Warehouse>>>;
  wishlist?: Maybe<Array<Maybe<Wishlist>>>;
};


export type QueryAbandonedCartCustomerListArgs = {
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
};


export type QueryAdminCustomerReviewListArgs = {
  delivererId?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  useCurrentMonth?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryAdminGroupListArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryAdminListArgs = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryAffiliateBestSellerArgs = {
  endDate?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAffiliateCustomerOrderItemsListArgs = {
  filters?: InputMaybe<AffiliateCustomerOrderItemsListFilter>;
  search?: InputMaybe<AffiliateCustomerOrderitemsListSearch>;
};


export type QueryAffiliateDibursementDetailArgs = {
  id: Scalars['Int']['input'];
};


export type QueryAffiliateDisbursementListArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  status: AffiliateDisbursementStatus;
};


export type QueryAffiliatePaymentListArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<AffiliatePaymentStatus>;
};


export type QueryAffiliateProductPublishArgs = {
  productId: Scalars['Int']['input'];
};


export type QueryAffiliateProductPublishListArgs = {
  direction?: InputMaybe<SortOrder>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<AffiliateAvailableProductOrderBy>;
  requestDelete?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<SearchAffiliateProduct>;
};


export type QueryAffiliateProductSalesListArgs = {
  end?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  needSummary?: InputMaybe<Scalars['Boolean']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<AffiliateProductOrderBy>;
  start?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAgentDisbursementListArgs = {
  agentId?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<AgentDisbursedStatus>;
};


export type QueryAgentEarnAmountListArgs = {
  endDate: Scalars['String']['input'];
  startDate: Scalars['String']['input'];
};


export type QueryAgentFeeDetailListArgs = {
  agentId: Scalars['Int']['input'];
  disbursedId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryAgentListArgs = {
  distanceInKm?: InputMaybe<Scalars['Int']['input']>;
  lat?: InputMaybe<Scalars['String']['input']>;
  lng?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAvailableForAgentDisbursementArgs = {
  agentId?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryBannerArgs = {
  id: Scalars['Int']['input'];
};


export type QueryBannerListArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryBrandArgs = {
  id: Scalars['Int']['input'];
};


export type QueryBrandListArgs = {
  limit?: Scalars['Int']['input'];
  merchantId?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  offset?: Scalars['Int']['input'];
  owned?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<BrandStatus>;
  verified?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryBrandSalesAnalyticArgs = {
  end: Scalars['String']['input'];
  id: Scalars['Int']['input'];
  start: Scalars['String']['input'];
};


export type QueryBrokerTransactionListArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryBuildPosCartArgs = {
  activatedPromoID?: InputMaybe<Scalars['Int']['input']>;
  cartItem: Array<InputMaybe<CustomerOrderInput>>;
  customerId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryCalculateCrawledProductPriceArgs = {
  link?: InputMaybe<Scalars['String']['input']>;
  productSize?: InputMaybe<Scalars['Float']['input']>;
};


export type QueryCalculateProductPriceArgs = {
  salePrice?: InputMaybe<Scalars['Decimal']['input']>;
  sellerPrice?: InputMaybe<Scalars['Decimal']['input']>;
  supplierId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryCampaignTrackerArgs = {
  id: Scalars['Int']['input'];
};


export type QueryCampaignTrackerListArgs = {
  budgetFrom?: InputMaybe<Scalars['Float']['input']>;
  budgetTo?: InputMaybe<Scalars['Float']['input']>;
  createdBy?: InputMaybe<Scalars['Int']['input']>;
  end?: InputMaybe<Scalars['String']['input']>;
  initialBy?: InputMaybe<Scalars['Int']['input']>;
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
  order?: InputMaybe<SortOrder>;
  orderBy?: InputMaybe<CampaignTrackerOrder>;
  page?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCampaignTrackerProductListArgs = {
  id: Scalars['Int']['input'];
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
};


export type QueryCartArgs = {
  activatedPromoID?: InputMaybe<Scalars['Int']['input']>;
  location?: InputMaybe<Location>;
  pickupId?: InputMaybe<Scalars['Int']['input']>;
  useDefaultAddress?: InputMaybe<Scalars['Boolean']['input']>;
  useSavedOption?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryCartThreadArgs = {
  token: Scalars['String']['input'];
};


export type QueryCartV2Args = {
  option?: InputMaybe<CartOptionInput>;
};


export type QueryCategoryArgs = {
  id: Scalars['Int']['input'];
};


export type QueryCategoryAnalyticsArgs = {
  categoryId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryCategoryListArgs = {
  parentId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryChatChannelArgs = {
  before?: InputMaybe<Scalars['Int']['input']>;
  channel: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  partner?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryChatChannelListArgs = {
  adminAsSeller?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  partnerHoldSellerIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  requiredSupport?: InputMaybe<Scalars['Boolean']['input']>;
  showAdminDirectMessage?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<ChatType>;
};


export type QueryChatChannelPartnerListArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryChatChannelSeenListArgs = {
  channel: Scalars['String']['input'];
};


export type QueryCheckCustomerPasswordArgs = {
  password: Scalars['String']['input'];
};


export type QueryCheckPaymentStatusArgs = {
  id: Scalars['Int']['input'];
};


export type QueryClearanceStockListArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Array<InputMaybe<ClearanceStockStatus>>>;
};


export type QueryCodeProductByCodeArgs = {
  code?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryCommentListArgs = {
  date?: InputMaybe<Scalars['String']['input']>;
  handled?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  pageID?: InputMaybe<Scalars['String']['input']>;
  replied?: InputMaybe<Scalars['Boolean']['input']>;
  sort?: InputMaybe<CommentSortType>;
  type?: InputMaybe<FacebookPostType>;
};


export type QueryCommuneListArgs = {
  districtCode?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCoreProductListArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryCrawlExternalProductArgs = {
  link?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCustomPageArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryCustomReportArgs = {
  id: Scalars['Int']['input'];
};


export type QueryCustomReportPermissionArgs = {
  id: Scalars['Int']['input'];
};


export type QueryCustomerArgs = {
  id: Scalars['Int']['input'];
};


export type QueryCustomerAddressInquiryArgs = {
  customerId: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
  offSet: Scalars['Int']['input'];
};


export type QueryCustomerAddressListArgs = {
  customerID?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryCustomerCartListArgs = {
  adminId?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryCustomerCartLogArgs = {
  orderId?: InputMaybe<Scalars['Int']['input']>;
  token?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCustomerCartPreviewArgs = {
  customerID: Scalars['Int']['input'];
};


export type QueryCustomerCurrentBalanceArgs = {
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCustomerListArgs = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCustomerLocationSuggestionArgs = {
  checkoutLimit?: InputMaybe<Scalars['Int']['input']>;
  customerId: Scalars['Int']['input'];
  lastSuccessLimit?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryCustomerNoteArgs = {
  id: Scalars['Int']['input'];
};


export type QueryCustomerNoteListArgs = {
  customerID: Scalars['Int']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryCustomerNoteTemplateArgs = {
  id: Scalars['Int']['input'];
};


export type QueryCustomerNoteTemplateListArgs = {
  order?: InputMaybe<SortOrder>;
};


export type QueryCustomerNotificationListArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  mode?: InputMaybe<ScheduledNotificationType>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryCustomerOrderArgs = {
  id: Scalars['Int']['input'];
};


export type QueryCustomerOrderHistoryArgs = {
  id: Scalars['Int']['input'];
};


export type QueryCustomerOrderItemArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
  invoiceNumber?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCustomerOrderItemListArgs = {
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  from?: InputMaybe<Scalars['String']['input']>;
  likelyAbandon?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
  packageId?: InputMaybe<Scalars['Int']['input']>;
  pickupHub?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  skuId?: InputMaybe<Scalars['Int']['input']>;
  sortOrder?: InputMaybe<SortOrder>;
  stat?: InputMaybe<OrderItemStats>;
  status?: InputMaybe<Array<InputMaybe<CustomerOrderItemStatus>>>;
  to?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCustomerOrderListArgs = {
  completed?: InputMaybe<Scalars['Boolean']['input']>;
  customerId?: InputMaybe<Scalars['Int']['input']>;
  isUnclaim?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  orderId?: InputMaybe<Scalars['Int']['input']>;
  pickup?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<Array<InputMaybe<CustomerOrderStatus>>>;
  unverifiedBankTransfer?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryCustomerOrderReturnArgs = {
  coid?: InputMaybe<Scalars['Int']['input']>;
  customerId?: InputMaybe<Scalars['Int']['input']>;
  isCompletedReturned?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  packageCode?: InputMaybe<Scalars['String']['input']>;
  returnId?: InputMaybe<Scalars['Int']['input']>;
  returnedStatus?: InputMaybe<Array<InputMaybe<ReturnStatusType>>>;
  search?: InputMaybe<Scalars['String']['input']>;
  withReturningPackage?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryCustomerOrderTrackingArgs = {
  orderItemId: Scalars['Int']['input'];
};


export type QueryCustomerOrdersArgs = {
  customerId?: InputMaybe<Scalars['Int']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  from?: InputMaybe<Scalars['String']['input']>;
  hasAddress?: InputMaybe<Scalars['Boolean']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  needFollowup?: InputMaybe<Scalars['Boolean']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<CustomerOrderOrder>;
  status?: InputMaybe<Array<InputMaybe<CustomerOrderStatus>>>;
  to?: InputMaybe<Scalars['String']['input']>;
  viaAffiliateSite?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryCustomerPaymentArgs = {
  id: Scalars['Int']['input'];
};


export type QueryCustomerPaymentHistoryArgs = {
  customerID: Scalars['Int']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryCustomerPaymentOptionBlockStatusArgs = {
  customerId: Scalars['Int']['input'];
};


export type QueryCustomerPaymentsArgs = {
  chartOfAccountIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  customerId?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Scalars['String']['input']>;
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
  orderBy?: InputMaybe<CustomerPaymentOrder>;
  to?: InputMaybe<Scalars['String']['input']>;
  tokenId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryCustomerRefundArgs = {
  id: Scalars['Int']['input'];
};


export type QueryCustomerRefundListArgs = {
  customerId?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<SortOrder>;
  status?: InputMaybe<Array<InputMaybe<CustomerRefundStatus>>>;
};


export type QueryCustomerSlotArgs = {
  id: Scalars['Int']['input'];
};


export type QueryCustomerSlotListArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryCustomerStatsArgs = {
  id: Scalars['Int']['input'];
};


export type QueryDebugCustomerBalanceArgs = {
  id: Scalars['Int']['input'];
  includeUnrecognized?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryDeliveredPackageListArgs = {
  endDate: Scalars['String']['input'];
  startDate: Scalars['String']['input'];
};


export type QueryDelivererSalaryArgs = {
  end?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  start?: InputMaybe<Scalars['String']['input']>;
};


export type QueryDelivererSalaryListArgs = {
  end: Scalars['String']['input'];
  start: Scalars['String']['input'];
  transit?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryDeliveryAdminMetricsArgs = {
  endDate: Scalars['String']['input'];
  startDate: Scalars['String']['input'];
};


export type QueryDeliveryAgentListArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryDeliveryAgentMetricsArgs = {
  endDate: Scalars['String']['input'];
  startDate: Scalars['String']['input'];
};


export type QueryDeliveryCustomerLocationArgs = {
  customerID: Scalars['Int']['input'];
};


export type QueryDeliveryPersonKpiArgs = {
  deliveryID?: InputMaybe<Scalars['Int']['input']>;
  end: Scalars['String']['input'];
  owner?: InputMaybe<Scalars['Boolean']['input']>;
  start: Scalars['String']['input'];
};


export type QueryDeliveryTripListArgs = {
  date?: InputMaybe<Scalars['String']['input']>;
  deliveryID: Scalars['Int']['input'];
};


export type QueryDigitalWarrantyListArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryDisbursementCompleteListArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryDisbursementDetailArgs = {
  disbursementUUID: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryDisbursementListArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryDisbursementLogArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryDisbursementProcessingListArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryDiscountCampaignArgs = {
  id: Scalars['Int']['input'];
};


export type QueryDiscountCampaignListArgs = {
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
};


export type QueryDisplayProductArgs = {
  id: Scalars['Int']['input'];
  referral?: InputMaybe<Scalars['JSON']['input']>;
};


export type QueryDisplayProductBySkuArgs = {
  code?: InputMaybe<Scalars['String']['input']>;
  paymentLink?: InputMaybe<Scalars['String']['input']>;
  sku?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};


export type QueryDisplayProductMediaListArgs = {
  id: Scalars['Int']['input'];
};


export type QueryDisplayProductOptionArgs = {
  id: Scalars['Int']['input'];
  lat?: InputMaybe<Scalars['String']['input']>;
  lng?: InputMaybe<Scalars['String']['input']>;
  mustIncludeSkuId?: Scalars['Boolean']['input'];
  ship?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryDistanceDifferenceArgs = {
  lat1?: InputMaybe<Scalars['Float']['input']>;
  lat2?: InputMaybe<Scalars['Float']['input']>;
  lng1?: InputMaybe<Scalars['Float']['input']>;
  lng2?: InputMaybe<Scalars['Float']['input']>;
};


export type QueryDistrictArgs = {
  id: Scalars['Int']['input'];
};


export type QueryDistrictListArgs = {
  coveredByInternal?: InputMaybe<Scalars['Boolean']['input']>;
  provinceCode?: InputMaybe<Scalars['String']['input']>;
  provinceId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryDropPointArgs = {
  id: Scalars['Int']['input'];
};


export type QueryDropPointByAddressArgs = {
  addressID?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryDropPointByLatLngArgs = {
  lat?: InputMaybe<Scalars['String']['input']>;
  lng?: InputMaybe<Scalars['String']['input']>;
};


export type QueryEmployeeArgs = {
  id: Scalars['Int']['input'];
};


export type QueryEstimatePackagePriceArgs = {
  data?: InputMaybe<PackageInput>;
  includeTraffic?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryEstimatePackagePriceByProductArgs = {
  coordinate?: InputMaybe<Coordinate>;
  customerPayForThirdParty?: InputMaybe<Scalars['Boolean']['input']>;
  includeTraffic?: InputMaybe<Scalars['Boolean']['input']>;
  multiplier?: InputMaybe<Scalars['Float']['input']>;
  products?: InputMaybe<Array<InputMaybe<ProductSizeInput>>>;
};


export type QueryEventCampaignDetailArgs = {
  groupBy?: InputMaybe<EventCampaignGroupBy>;
  id: Scalars['Int']['input'];
};


export type QueryEventCampaignDetailListArgs = {
  id: Scalars['Int']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  rootCategory?: InputMaybe<Scalars['Int']['input']>;
  supplierId?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};


export type QueryEventCampaignListArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  registered?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<Array<InputMaybe<EventCampaignStatus>>>;
  upcoming?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryEventCampaignProductListArgs = {
  discount?: InputMaybe<EventCampaignDiscount>;
  eventId: Scalars['Int']['input'];
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
  rootCategory?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryEventCampaignProductValidationArgs = {
  campaignId: Scalars['Int']['input'];
  discount: Scalars['Float']['input'];
  itemId: Scalars['Int']['input'];
};


export type QueryExportedPreorderListArgs = {
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
};


export type QueryExpressPackageItemsArgs = {
  supplierId: Scalars['Int']['input'];
};


export type QueryFacebookProductPostArgs = {
  productId: Array<InputMaybe<Scalars['Int']['input']>>;
};


export type QueryFeedsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryFrontScreenBrandForYouArgs = {
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
};


export type QueryFrontScreenDealForYouArgs = {
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
};


export type QueryFrontScreenFeatureStoreListArgs = {
  listType?: InputMaybe<SellerListType>;
};


export type QueryFrontScreenMadeInCambodiaArgs = {
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
};


export type QueryFrontScreenStoreForYouArgs = {
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
};


export type QueryGeoHierarchyByLatLngArgs = {
  lat: Scalars['String']['input'];
  lng: Scalars['String']['input'];
};


export type QueryGeocodeAddressArgs = {
  lat?: InputMaybe<Scalars['String']['input']>;
  lng?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetProductLabelListArgs = {
  Category?: InputMaybe<Scalars['Int']['input']>;
  Label: ProductLabel;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetProductLabelTabArgs = {
  Label: ProductLabel;
};


export type QueryGetProductUnitByBarcodeArgs = {
  barcode?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetPromotionCampaignArgs = {
  code: Scalars['String']['input'];
};


export type QueryGetPromotionListArgs = {
  customerID?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetProvinceArgs = {
  lat: Scalars['Float']['input'];
  lng: Scalars['Float']['input'];
};


export type QueryGroupBuyListArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryHistoryPosCustorderArgs = {
  cusId: Scalars['Int']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryImagePackagesArgs = {
  status?: InputMaybe<ImagePackageStatus>;
  supplierId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryInventorySlotArgs = {
  id: Scalars['Int']['input'];
};


export type QueryInventorySlotListArgs = {
  page: Scalars['Int']['input'];
  size: Scalars['Int']['input'];
};


export type QueryIsSellerPhoneNumberAvailableArgs = {
  phoneNumber: Scalars['String']['input'];
};


export type QueryKhmerloadAdsContentArgs = {
  category?: InputMaybe<KhmerloadNewsCategory>;
};


export type QueryLastUpdatedProductListArgs = {
  lastDate: Scalars['String']['input'];
  productIds: Array<InputMaybe<Scalars['Int']['input']>>;
};


export type QueryLatePackageListArgs = {
  lateInHour: Scalars['Int']['input'];
};


export type QueryListProductChoiceArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<LoginlessOrderStatus>;
};


export type QueryListSellerPackageArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryLiveShoppingArgs = {
  id: Scalars['Int']['input'];
};


export type QueryLiveShoppingListArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryLiveStockStatusArgs = {
  productCodes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sku?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};


export type QueryLoginActivityReportArgs = {
  end: Scalars['String']['input'];
  start: Scalars['String']['input'];
};


export type QueryLoginlessOrderArgs = {
  id: Scalars['Int']['input'];
};


export type QueryLoginlessOrderItemListArgs = {
  id: Scalars['Int']['input'];
};


export type QueryLoginlessOrderListArgs = {
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
  order?: InputMaybe<SortOrder>;
  status?: InputMaybe<LoginlessOrderStatus>;
};


export type QueryLuckyDrawArgs = {
  id: Scalars['Int']['input'];
};


export type QueryLuckyDrawAvailableCustomerArgs = {
  luckyDrawId: Scalars['Int']['input'];
};


export type QueryLuckyDrawListArgs = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  joined?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
};


export type QueryLuckyDrawParticipantArgs = {
  id: Scalars['Int']['input'];
};


export type QueryMapPlaceLocationArgs = {
  placeId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryMapSuggestionLatLngArgs = {
  lat?: InputMaybe<Scalars['Float']['input']>;
  lng?: InputMaybe<Scalars['Float']['input']>;
};


export type QueryMapSuggestionPlaceArgs = {
  currentLocation?: InputMaybe<Coordinate>;
  keyword?: InputMaybe<Scalars['String']['input']>;
};


export type QueryMassUploadArgs = {
  batchId: Scalars['Int']['input'];
  supplierId: Scalars['Int']['input'];
};


export type QueryMassUploadListArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  supplierId: Scalars['Int']['input'];
};


export type QueryMediaListArgs = {
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  mediaType?: InputMaybe<MediaType>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  purpose?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryMerchantAnnouncementArgs = {
  id: Scalars['Int']['input'];
};


export type QueryMerchantAnnouncementListArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryMerchantAvailableDetailArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryMerchantBrandArgs = {
  id: Scalars['Int']['input'];
};


export type QueryMerchantBrandListArgs = {
  status?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryMerchantCheckSupplierListArgs = {
  supplier_code: Array<InputMaybe<Scalars['String']['input']>>;
};


export type QueryMerchantCustorderListArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryMerchantDisbursementProcessingDetailListArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryMerchantDisbursmentPaidDetailListArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryMerchantDiscountItemArgs = {
  campaign_id: Scalars['Int']['input'];
};


export type QueryMerchantDiscountItemCampaignArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryMerchantHoldDetailArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryMerchantInventoryFblArgs = {
  filter?: InputMaybe<FilterFbl>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryMerchantOnGoingOrderListArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryMerchantOrderByItemArgs = {
  itemid: Scalars['Int']['input'];
};


export type QueryMerchantOrderListArgs = {
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: Scalars['Int']['input'];
  merchantID?: InputMaybe<Scalars['Int']['input']>;
  offset?: Scalars['Int']['input'];
  shipperID?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Array<InputMaybe<CustomerOrderItemStatus>>>;
};


export type QueryMerchantOrderListBetaArgs = {
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: Scalars['Int']['input'];
  merchantID?: InputMaybe<Scalars['Int']['input']>;
  offset?: Scalars['Int']['input'];
  shipperID?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<CustomerOrderItemStatus>;
};


export type QueryMerchantOrderToPrepareListArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryMerchantPreparedOrdersListArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryMerchantProductAvailableListArgs = {
  code?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryMerchantProductQuantityListArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryMerchantProductViewArgs = {
  from: Scalars['String']['input'];
  to: Scalars['String']['input'];
};


export type QueryMerchantProductViewDateArgs = {
  from: Scalars['String']['input'];
  itemsID?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  to: Scalars['String']['input'];
};


export type QueryMerchantSaleAllTimeArgs = {
  status?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};


export type QueryMerchantSaleDayArgs = {
  day: Scalars['Int']['input'];
  status?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};


export type QueryMerchantSaleSummaryReportArgs = {
  from?: InputMaybe<Scalars['String']['input']>;
  to?: InputMaybe<Scalars['String']['input']>;
};


export type QueryMerchantSearchProductArgs = {
  keyword?: InputMaybe<Scalars['String']['input']>;
};


export type QueryMerchantShipmentDetailArgs = {
  id: Scalars['Int']['input'];
};


export type QueryMerchantShipmentItemHistoryArgs = {
  itemId: Scalars['Int']['input'];
};


export type QueryMerchantShipmentListArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<ShipmentLogStatus>;
};


export type QueryMerchantShippedOrdersListArgs = {
  filter?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryMerchantSponsorArgs = {
  campaign_id?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryMerchantSponsorDetailArgs = {
  campaign_id?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryMerchantSponsorListArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryMerchantTopupListArgs = {
  end: Scalars['String']['input'];
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
  start: Scalars['String']['input'];
};


export type QueryMerchantTotalDetailArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryMoneyTransferBatchArgs = {
  batchId?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<MoneyBatchTransferStatus>;
};


export type QueryMultiOffersTemplateDetailArgs = {
  id: Scalars['Int']['input'];
};


export type QueryMultiOffersTemplateListArgs = {
  keyword?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryMyActivatedPromotionListArgs = {
  customerID?: InputMaybe<Scalars['Int']['input']>;
  selectedId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryNewArrivalProductListArgs = {
  categoryId: Scalars['Int']['input'];
  filter?: InputMaybe<NewArrivalFilter>;
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
};


export type QueryNewPackageBreakdownArgs = {
  endDate: Scalars['String']['input'];
  startDate: Scalars['String']['input'];
};


export type QueryNextHubsPackageArgs = {
  hubId: Scalars['Int']['input'];
};


export type QueryNotificationDeliveryListArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryNotificationScheduleArgs = {
  id: Scalars['Int']['input'];
};


export type QueryNotificationScheduleListArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  mode?: InputMaybe<ScheduledNotificationType>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<KindOfNotification>;
};


export type QueryNotificationSegmentArgs = {
  id: Scalars['Int']['input'];
};


export type QueryNumberToWordsArgs = {
  n?: InputMaybe<Scalars['String']['input']>;
};


export type QueryOnlineStaffPerformanceArgs = {
  end?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  start?: InputMaybe<Scalars['String']['input']>;
};


export type QueryOnlineStaffPerformanceListArgs = {
  end?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['String']['input']>;
};


export type QueryOnlinemartReportArgs = {
  data?: InputMaybe<OnlinemartReportInput>;
};


export type QueryOrderDraftArgs = {
  id: Scalars['Int']['input'];
};


export type QueryOrderDraftListArgs = {
  endDate?: InputMaybe<Scalars['String']['input']>;
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<OrderDraftStatus>;
};


export type QueryOrderTemplateArgs = {
  code?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryOrderTemplateListArgs = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  isOwner?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<OrderTemplateType>;
};


export type QueryOrdersByLiveCampaignIdArgs = {
  campaignId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryPackageArgs = {
  barcode?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  uuid?: InputMaybe<Scalars['String']['input']>;
};


export type QueryPackageBlockingAreaArgs = {
  orange?: InputMaybe<Scalars['Boolean']['input']>;
  red?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryPackageCountByStatusArgs = {
  dateType?: InputMaybe<DateType>;
  end?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['String']['input']>;
};


export type QueryPackageCustomerListArgs = {
  end: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  start: Scalars['String']['input'];
};


export type QueryPackageDelivererMonitorArgs = {
  hubId: Scalars['Int']['input'];
};


export type QueryPackageInvoiceDetailArgs = {
  invoiceId: Scalars['Int']['input'];
};


export type QueryPackageInvoiceListArgs = {
  supplierId: Scalars['Int']['input'];
};


export type QueryPackageItemListArgs = {
  id: Scalars['Int']['input'];
};


export type QueryPackageListArgs = {
  agentFilter?: InputMaybe<AgentFilter>;
  agentId?: InputMaybe<Scalars['Int']['input']>;
  appointedDay?: InputMaybe<AppointedDay>;
  claimDeliveryBy?: InputMaybe<Scalars['Int']['input']>;
  claimPickupBy?: InputMaybe<Scalars['Int']['input']>;
  createdAtFrom?: InputMaybe<Scalars['String']['input']>;
  createdAtTo?: InputMaybe<Scalars['String']['input']>;
  currentLat?: InputMaybe<Scalars['Float']['input']>;
  currentLng?: InputMaybe<Scalars['Float']['input']>;
  customerId?: InputMaybe<Scalars['Int']['input']>;
  customerPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  hasBarcode?: InputMaybe<Scalars['Boolean']['input']>;
  hasStock?: InputMaybe<Scalars['Boolean']['input']>;
  isCancelRequestPickup?: InputMaybe<Scalars['Boolean']['input']>;
  isPackageWithLabel?: InputMaybe<Scalars['Boolean']['input']>;
  isSettledWithCashier?: InputMaybe<Scalars['Boolean']['input']>;
  isThirdPartyCod?: InputMaybe<Scalars['Boolean']['input']>;
  keyword?: InputMaybe<Scalars['String']['input']>;
  lastTransitBy?: InputMaybe<Scalars['Int']['input']>;
  limit?: Scalars['Int']['input'];
  nearby?: InputMaybe<Scalars['Boolean']['input']>;
  nextTransitHubId?: InputMaybe<Scalars['Int']['input']>;
  offset?: Scalars['Int']['input'];
  onlyWithCoordinate?: InputMaybe<Scalars['Boolean']['input']>;
  orderBy?: InputMaybe<PackageListSort>;
  overSize?: InputMaybe<Scalars['Boolean']['input']>;
  packageUUID?: InputMaybe<Scalars['String']['input']>;
  reachFinal?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<Array<InputMaybe<PackageStatus>>>;
  successDateRange?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  supplierId?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<Array<InputMaybe<PackageType>>>;
  useCurrentWarehouse?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryPackageListInternalArgs = {
  deletedOrderPickupWithLeftOverRequestPickup?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryPackagePerformanceReportArgs = {
  end: Scalars['String']['input'];
  hub?: Scalars['Int']['input'];
  start: Scalars['String']['input'];
};


export type QueryPackageReportArgs = {
  end: Scalars['String']['input'];
  internal?: InputMaybe<Scalars['Boolean']['input']>;
  start: Scalars['String']['input'];
};


export type QueryPackageTransitLogsArgs = {
  end: Scalars['String']['input'];
  start: Scalars['String']['input'];
};


export type QueryPageArgs = {
  id?: Scalars['Int']['input'];
};


export type QueryPageBetaArgs = {
  id?: Scalars['Int']['input'];
};


export type QueryPartnerAdsDibursementDetailArgs = {
  id: Scalars['Int']['input'];
};


export type QueryPartnerAdsDisbursementListArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  status: AffiliateDisbursementStatus;
};


export type QueryPartnerSellerArgs = {
  supplierId: Scalars['Int']['input'];
};


export type QueryPartnerSellerListArgs = {
  enabledOnly?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryPartnerStaffListArgs = {
  endDate?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
};


export type QueryPartnerSummaryOrderArgs = {
  endDate: Scalars['String']['input'];
  startDate: Scalars['String']['input'];
};


export type QueryPaymentChartOfAccountListArgs = {
  forCustomer?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryPaymentLogDetailArgs = {
  customerId: Scalars['Int']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryPaymentLogDetailByTransactionTypeArgs = {
  customerId: Scalars['Int']['input'];
  id: Scalars['Int']['input'];
  trxType: PaymentLogId;
};


export type QueryPaymentOptionsArgs = {
  cartOption?: InputMaybe<CartOptionInput>;
};


export type QueryPaymentReceivedArgs = {
  notifyKey: Scalars['String']['input'];
};


export type QueryPreorderListByExportIdArgs = {
  export_id?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryProductArgs = {
  id: Scalars['Int']['input'];
};


export type QueryProductByCodeArgs = {
  code: Scalars['String']['input'];
};


export type QueryProductClearanceStockByCodeArgs = {
  code?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryProductCommissionFeeArgs = {
  productId: Scalars['Int']['input'];
};


export type QueryProductGroupArgs = {
  id: Scalars['Int']['input'];
};


export type QueryProductImageSearchArgs = {
  file: Scalars['Upload']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryProductImageSearchResultArgs = {
  hash: Scalars['String']['input'];
};


export type QueryProductListArgs = {
  code?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ProductListFilter>;
  id?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
  orderBy?: InputMaybe<SortOrder>;
  sortByField?: InputMaybe<ProductOrderBy>;
  stockFrom?: InputMaybe<Scalars['Int']['input']>;
  stockTo?: InputMaybe<Scalars['Int']['input']>;
  totalRow?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<SupplierProductApproved>;
};


export type QueryProductListV2Args = {
  filter?: InputMaybe<ProductListFilterV2>;
  orderBy?: InputMaybe<ProductOrderByInput>;
  page?: InputMaybe<PaginationInput>;
  productListType: ProductListType;
  search?: InputMaybe<ProductSearch>;
  viewBySku?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryProductRecycleArgs = {
  hasPackage?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Array<InputMaybe<ProductRecycleStatusType>>>;
  uuid?: InputMaybe<Scalars['String']['input']>;
};


export type QueryProductReviewArgs = {
  customerId?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  productId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryProductReviewAttachmentListArgs = {
  productId: Scalars['Int']['input'];
};


export type QueryProductReviewListArgs = {
  atleastRating?: InputMaybe<Scalars['Int']['input']>;
  brandId?: InputMaybe<Scalars['Int']['input']>;
  customerId?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Scalars['String']['input']>;
  lastNDay?: InputMaybe<Scalars['Int']['input']>;
  limit?: Scalars['Int']['input'];
  merchantId?: InputMaybe<Scalars['Int']['input']>;
  offset?: Scalars['Int']['input'];
  productCode?: InputMaybe<Scalars['String']['input']>;
  productId?: InputMaybe<Scalars['Int']['input']>;
  productTitle?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<ReviewSortField>;
  sortOrder?: InputMaybe<SortOrder>;
  to?: InputMaybe<Scalars['String']['input']>;
};


export type QueryProductReviewOverviewArgs = {
  productId: Scalars['Int']['input'];
};


export type QueryProductReviewRankListArgs = {
  end?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: Scalars['Int']['input'];
  start?: InputMaybe<Scalars['String']['input']>;
};


export type QueryProductReviewReportArgs = {
  end?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['String']['input']>;
};


export type QueryProductSalesAnalyticListArgs = {
  end: Scalars['String']['input'];
  ids: Array<InputMaybe<Scalars['Int']['input']>>;
  start: Scalars['String']['input'];
};


export type QueryProductSearchArgs = {
  filter?: InputMaybe<ProductSearchFilter>;
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
  sort?: InputMaybe<ProductSearchSort>;
};


export type QueryProductSearchLegacyArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
};


export type QueryProductSearchSponsoredArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
};


export type QueryProductSkuBarcodeArgs = {
  code?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryProductStockArgs = {
  before?: InputMaybe<Scalars['String']['input']>;
  productId: Scalars['Int']['input'];
};


export type QueryProductStockStatusArgs = {
  productId: Scalars['Int']['input'];
};


export type QueryPromotionArgs = {
  id: Scalars['Int']['input'];
};


export type QueryPromotionCampaignArgs = {
  id: Scalars['Int']['input'];
};


export type QueryPromotionCampaignListArgs = {
  filters?: InputMaybe<PromotionCampaignFilter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<PromotionCampaignSearch>;
};


export type QueryPromotionListArgs = {
  campaignId?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryPromotionReportArgs = {
  id: Scalars['Int']['input'];
};


export type QueryPromotionTopListArgs = {
  from: Scalars['String']['input'];
  limit?: Scalars['Int']['input'];
  to: Scalars['String']['input'];
};


export type QueryPurchaseOrderArgs = {
  id: Scalars['Int']['input'];
};


export type QueryPurchaseOrderListArgs = {
  filter?: InputMaybe<PurchaseOrderFilterInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryPurchaseOrderLogArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
};


export type QueryRecommendBrandArgs = {
  keyword?: InputMaybe<Scalars['String']['input']>;
};


export type QueryRecommendCustomerProductListArgs = {
  before?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryRecommendCustomerProductListV2Args = {
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
  showBanner?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryRecommendFeaturedShopListArgs = {
  categoryId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryRecommendProductCategoryListArgs = {
  keyword: Scalars['String']['input'];
};


export type QueryRecommendProductListByCategoryArgs = {
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
  rootCategory: Scalars['Int']['input'];
};


export type QueryRecommendProductRestockArgs = {
  followedBy?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryRecommendRelatedProductListArgs = {
  productId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryRecommendUserPostsArgs = {
  fromPostId?: InputMaybe<Scalars['Int']['input']>;
  fromUserProfile?: InputMaybe<Scalars['Boolean']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};


export type QueryReferralListByReferrerArgs = {
  referrerId: Scalars['Int']['input'];
};


export type QueryReferrerAvailableEarningBalanceArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryReferrerDisbursementArgs = {
  filters?: InputMaybe<RefereeDisbursementInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryReportCheckoutLocationArgs = {
  customerID?: InputMaybe<Scalars['Int']['input']>;
  end?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['String']['input']>;
};


export type QueryReportCohortArgs = {
  type?: Scalars['String']['input'];
};


export type QueryReportDeliveryFeeListArgs = {
  month: Scalars['Int']['input'];
  year: Scalars['Int']['input'];
};


export type QueryReportFblSaleListArgs = {
  month: Scalars['Int']['input'];
  year: Scalars['Int']['input'];
};


export type QueryReportGmvArgs = {
  month: Scalars['Int']['input'];
  year: Scalars['Int']['input'];
};


export type QueryReportInventorySaleListArgs = {
  month: Scalars['Int']['input'];
  year: Scalars['Int']['input'];
};


export type QueryReportInvoiceListArgs = {
  month: Scalars['Int']['input'];
  shopID?: InputMaybe<Scalars['Int']['input']>;
  year: Scalars['Int']['input'];
};


export type QueryReportLiveProductListArgs = {
  categoryId?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  live?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryReportMerchantTotalSalesArgs = {
  end: Scalars['String']['input'];
  start: Scalars['String']['input'];
};


export type QueryReportMonthlyReturnedCustomerArgs = {
  type?: Scalars['String']['input'];
};


export type QueryReportOfflineKpiArgs = {
  from: Scalars['String']['input'];
  to: Scalars['String']['input'];
};


export type QueryReportOtherSaleListArgs = {
  month: Scalars['Int']['input'];
  year: Scalars['Int']['input'];
};


export type QueryReportSaleArgs = {
  month: Scalars['Int']['input'];
  year: Scalars['Int']['input'];
};


export type QueryReportSaleByCategoryArgs = {
  categoryID?: Scalars['Int']['input'];
  end: Scalars['String']['input'];
  start: Scalars['String']['input'];
};


export type QueryReportSaleListArgs = {
  month: Scalars['Int']['input'];
  shopID?: InputMaybe<Scalars['Int']['input']>;
  year: Scalars['Int']['input'];
};


export type QueryReportSearchBreakdownArgs = {
  end: Scalars['String']['input'];
  start: Scalars['String']['input'];
};


export type QueryReportServiceFeeListArgs = {
  month: Scalars['Int']['input'];
  year: Scalars['Int']['input'];
};


export type QueryReportStockKpiArgs = {
  endDate: Scalars['String']['input'];
  startDate: Scalars['String']['input'];
};


export type QueryReportedProductListArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryRunCustomReportArgs = {
  id: Scalars['Int']['input'];
  params: Scalars['JSON']['input'];
};


export type QuerySalesDetailBySalesStatusArgs = {
  day?: InputMaybe<Scalars['Int']['input']>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  salesStatus?: InputMaybe<Sales_Status>;
  startDate?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySearchPostArgs = {
  textInput?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySearchProductTagArgs = {
  tag?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySearchSuggestionArgs = {
  keyword?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySelectedSpinRewardArgs = {
  n?: InputMaybe<Scalars['Int']['input']>;
};


export type QuerySellerAdsCampaignArgs = {
  id: Scalars['Int']['input'];
};


export type QuerySellerAdsCampaignsArgs = {
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
  sellerId?: InputMaybe<Scalars['Int']['input']>;
};


export type QuerySellerAdsItemsArgs = {
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
  orderByHighestBiding?: InputMaybe<Scalars['Boolean']['input']>;
  sellerId?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<SellerAdsCampaignItemStatus>;
};


export type QuerySellerAdsV2DetailArgs = {
  id: Scalars['Int']['input'];
};


export type QuerySellerAdsV2ListArgs = {
  filters?: InputMaybe<SellerAdsV2Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QuerySellerLiveCampaignListArgs = {
  deliveryStatus?: InputMaybe<Array<InputMaybe<SellerAdsCampaignDeliveryStatus>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<SortOrder>;
  productCode?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Array<InputMaybe<SellerAdsCampaignItemStatus>>>;
};


export type QuerySellerNotificationListArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QuerySellerPackageArgs = {
  packageId: Scalars['Int']['input'];
};


export type QuerySellerSalesByDayArgs = {
  endDate?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySettingArgs = {
  option: SettingType;
};


export type QuerySettlementWithSellerArgs = {
  id: Scalars['Int']['input'];
};


export type QuerySettlementWithSellerListArgs = {
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
  orderBy?: InputMaybe<SettlementWithSellerListOrder>;
  sellerId?: InputMaybe<Scalars['Int']['input']>;
  sortOrder?: InputMaybe<SortOrder>;
  status?: InputMaybe<SettlementWithSellerStatus>;
};


export type QueryShipmentCountByStatusArgs = {
  end: Scalars['String']['input'];
  start: Scalars['String']['input'];
};


export type QueryShipmentTrackingCodeArgs = {
  tracking_code: Scalars['String']['input'];
};


export type QueryShipmentTrackingCodeListArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QuerySkuArgs = {
  id: Scalars['Int']['input'];
};


export type QuerySkuListArgs = {
  productID?: InputMaybe<Scalars['Int']['input']>;
};


export type QuerySkuV2Args = {
  barcode?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  supplierCode?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySpecialProductArgs = {
  id: Scalars['Int']['input'];
};


export type QuerySpecialProductListArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QuerySpinRewardDetailArgs = {
  id: Scalars['Int']['input'];
};


export type QuerySpinRewardListArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryStaffBalanceLogArgs = {
  end?: InputMaybe<Scalars['String']['input']>;
  isVerified?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  staffId?: InputMaybe<Scalars['Int']['input']>;
  start?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Array<InputMaybe<StaffBalanceType>>>;
};


export type QueryStaffDepositListArgs = {
  staffId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryStaffLocationLogArgs = {
  end?: InputMaybe<Scalars['String']['input']>;
  staffId?: InputMaybe<Scalars['Int']['input']>;
  start?: InputMaybe<Scalars['String']['input']>;
};


export type QueryStaffOpenAndCloseBalanceArgs = {
  end: Scalars['String']['input'];
  staffId: Scalars['Int']['input'];
  start: Scalars['String']['input'];
};


export type QueryStaffRegistrationListArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryStockTransactionListArgs = {
  batchId?: InputMaybe<Scalars['Int']['input']>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
  productId?: InputMaybe<Scalars['Int']['input']>;
  purchaseOrderId?: InputMaybe<Scalars['Int']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Array<InputMaybe<StockTransactionType>>>;
};


export type QueryStoreBrandListArgs = {
  brandId: Scalars['Int']['input'];
};


export type QuerySuccessPackageLocationArgs = {
  end: Scalars['String']['input'];
  start: Scalars['String']['input'];
};


export type QuerySuggestCustomerOrderItemFindingSlotArgs = {
  hubId?: InputMaybe<Scalars['Int']['input']>;
};


export type QuerySuggestShopRequestFindingSlotArgs = {
  hubId?: InputMaybe<Scalars['Int']['input']>;
};


export type QuerySuggestSupplierCustomerAddressArgs = {
  limit?: Scalars['Int']['input'];
  phoneNumber: Scalars['String']['input'];
};


export type QuerySuggestedPublicPromotionListArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QuerySupplierArgs = {
  id: Scalars['Int']['input'];
};


export type QuerySupplierAddressArgs = {
  id: Scalars['Int']['input'];
};


export type QuerySupplierAffiliateArgs = {
  phoneNumber: Scalars['String']['input'];
};


export type QuerySupplierAffiliateProductListArgs = {
  filters?: InputMaybe<AffiliateProductListFilter>;
  search?: InputMaybe<AffiliateProductListSearch>;
  sortBy?: InputMaybe<AffiliateProductListSortBy>;
};


export type QuerySupplierAvailableCategoryArgs = {
  supplierId: Scalars['Int']['input'];
};


export type QuerySupplierBankChangeLogArgs = {
  supplierId: Scalars['Int']['input'];
};


export type QuerySupplierBrandListArgs = {
  status?: InputMaybe<BrandStatus>;
};


export type QuerySupplierByPhoneArgs = {
  phone: Scalars['String']['input'];
};


export type QuerySupplierClickThroughRateByDateArgs = {
  fromDate?: InputMaybe<Scalars['String']['input']>;
  toDate?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySupplierClickThroughRateByProductArgs = {
  inputDate?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySupplierCustomerArgs = {
  id: Scalars['Int']['input'];
};


export type QuerySupplierCustomerListArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySupplierDisbursementAvailableListArgs = {
  balanceStatus?: InputMaybe<BalanceStatusType>;
};


export type QuerySupplierDisbursementDetailArgs = {
  uuid: Scalars['String']['input'];
};


export type QuerySupplierDisbursementListArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QuerySupplierFacebookOrderArgs = {
  end?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySupplierFbOrderListArgs = {
  endDate?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  linkId?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Array<InputMaybe<FbOrderStatus>>>;
};


export type QuerySupplierFeeListArgs = {
  dateType?: InputMaybe<SupplierFeeDateType>;
  endAt?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  startAt?: InputMaybe<Scalars['String']['input']>;
  supplierId?: InputMaybe<Scalars['Int']['input']>;
};


export type QuerySupplierHoldBalanceArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QuerySupplierInternalDisbursementListArgs = {
  directPayment?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  paymentGateway?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  sellerType?: InputMaybe<SellerType>;
  status?: InputMaybe<DisbursementStatus>;
  supplierId?: InputMaybe<Scalars['Int']['input']>;
};


export type QuerySupplierInventoryFblvtwoArgs = {
  filter?: InputMaybe<FilterFbl>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QuerySupplierInventoryMonitorArgs = {
  groupBy?: InputMaybe<SupplierInventoryMonitorGroupBy>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<SupplierInventoryMonitorSortBy>;
  sortDirection?: InputMaybe<SortOrder>;
};


export type QuerySupplierInventoryRemovalArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<SortOrder>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Array<InputMaybe<InventoryRemovalStatus>>>;
};


export type QuerySupplierInventoryRemovalItemArgs = {
  removalId: Scalars['Int']['input'];
};


export type QuerySupplierInventoryStorageFeeDailyArgs = {
  month?: InputMaybe<Scalars['Int']['input']>;
  year?: InputMaybe<Scalars['Int']['input']>;
};


export type QuerySupplierItemLiveArgs = {
  id: Scalars['Int']['input'];
};


export type QuerySupplierItemLiveListArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<ItemLiveStatus>;
  supplier?: InputMaybe<Scalars['Int']['input']>;
};


export type QuerySupplierListArgs = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  isSeller?: InputMaybe<Scalars['Boolean']['input']>;
  isVerified?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: Scalars['Int']['input'];
  myFollowwing?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  offset?: Scalars['Int']['input'];
  origin?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  recentUseDeliveryService?: InputMaybe<Scalars['Boolean']['input']>;
  reviewStatus?: InputMaybe<Array<InputMaybe<SupplierReviewStatus>>>;
  roles?: InputMaybe<Array<InputMaybe<SupplierRole>>>;
  sellerType?: InputMaybe<Array<InputMaybe<SellerType>>>;
  subscriptionPlan?: InputMaybe<Array<InputMaybe<SellerSuscriptionPlan>>>;
  supplierIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};


export type QuerySupplierListFromConsolidateArgs = {
  filter?: InputMaybe<SupplierOrderListFilters>;
  search?: InputMaybe<SupplierOrderListSearch>;
};


export type QuerySupplierListUploadDraftArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QuerySupplierLocalShipperListArgs = {
  code?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Array<InputMaybe<ShipperScanLogStatus>>>;
  success?: InputMaybe<Scalars['Boolean']['input']>;
  trackingCode?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<ShipperScanLogType>;
};


export type QuerySupplierMediaFolderArgs = {
  folderId?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QuerySupplierOrderBalanceArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<BalanceType>;
};


export type QuerySupplierOrderDetailArgs = {
  id: Scalars['String']['input'];
};


export type QuerySupplierOrderListArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  options?: InputMaybe<SupplierOrderListInput>;
};


export type QuerySupplierOrderListV2Args = {
  filter?: InputMaybe<SupplierOrderListFilters>;
  page?: InputMaybe<PaginationInput>;
  search?: InputMaybe<SupplierOrderListSearch>;
};


export type QuerySupplierPackageSalesReportArgs = {
  end: Scalars['String']['input'];
  start: Scalars['String']['input'];
};


export type QuerySupplierPosCustomerOrderArgs = {
  status?: InputMaybe<SupplierCustorderItemStatus>;
};


export type QuerySupplierProductAliasCodeArgs = {
  id: Scalars['Int']['input'];
};


export type QuerySupplierProductDefaultValueArgs = {
  productId?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};


export type QuerySupplierProductDraftArgs = {
  draftId: Scalars['Int']['input'];
};


export type QuerySupplierProductIdArgs = {
  id?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QuerySupplierProductPerformanceArgs = {
  groupBy?: InputMaybe<SupplierProudctPerformanceGroupBy>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<SupplierProductPerformanceSortBy>;
  sortDirection?: InputMaybe<SortOrder>;
};


export type QuerySupplierProductRankingArgs = {
  categoryId?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QuerySupplierProductRequestArgs = {
  id: Scalars['Int']['input'];
  type?: InputMaybe<SupplierStatusRequest>;
};


export type QuerySupplierProductRequestListArgs = {
  brand?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  categoryIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  filter?: InputMaybe<FilterSupplierRequest>;
  isUpload?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offerDiscount?: InputMaybe<Scalars['Boolean']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  remoteStock?: InputMaybe<Scalars['Boolean']['input']>;
  stock?: InputMaybe<FilterStock>;
  stockOnly?: InputMaybe<Scalars['Boolean']['input']>;
  supplierIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  vendor?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};


export type QuerySupplierProductValidationArgs = {
  content?: InputMaybe<ContentInputV2>;
};


export type QuerySupplierProductValidationV2Args = {
  content?: InputMaybe<Scalars['JSON']['input']>;
};


export type QuerySupplierPromoComboDetailArgs = {
  id: Scalars['Int']['input'];
};


export type QuerySupplierPromoComboListArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<SortOrder>;
};


export type QuerySupplierReachClickSalesInfoArgs = {
  fromDate?: InputMaybe<Scalars['String']['input']>;
  supplierId?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  toDate?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySupplierReachClickSalesProductArgs = {
  ctrType?: InputMaybe<SupplierCtrDetailType>;
  date?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  supplierId?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};


export type QuerySupplierRegisterReviewArgs = {
  verifyToken: Scalars['String']['input'];
};


export type QuerySupplierRestockingSkuArgs = {
  filters?: InputMaybe<SupplierRestockingFilterInput>;
  page?: InputMaybe<PaginationInput>;
};


export type QuerySupplierSaleDailyListArgs = {
  day: Scalars['Int']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};


export type QuerySupplierSaleSummaryArgs = {
  day?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<SaleSummaryType>;
};


export type QuerySupplierSalesReportArgs = {
  brands?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  end_date?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  product_codes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  start_date?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Array<InputMaybe<CustomerOrderItemStatus>>>;
  vendors?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};


export type QuerySupplierSearchProductByCodeArgs = {
  code?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySupplierShipmentAndPurchaseOrderReceivedArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  needTotal?: InputMaybe<Scalars['Boolean']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QuerySupplierShipmentDetailArgs = {
  shipmentId: Scalars['Int']['input'];
};


export type QuerySupplierShipmentListArgs = {
  abnormal?: InputMaybe<Scalars['Boolean']['input']>;
  abnormalStatus?: InputMaybe<Array<InputMaybe<AbnormalStatusType>>>;
  end?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<SortOrder>;
  origin?: InputMaybe<Scalars['Int']['input']>;
  shipmentId?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Array<InputMaybe<ShipmentLogStatus>>>;
  supplierId?: InputMaybe<Scalars['Int']['input']>;
};


export type QuerySupplierShipperListArgs = {
  code?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<ShipperScanLogStatus>;
  trackingCode?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySupplierTopUpBalanceListArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QuerySupplierTotalBalanceArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QuerySupplierVendorArgs = {
  id: Scalars['Int']['input'];
};


export type QuerySupplierVendorListArgs = {
  supplierId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryTagListArgs = {
  type: TagType;
};


export type QueryThirdPartyTrackingDataArgs = {
  trackingCode: Scalars['String']['input'];
  type: PackageThirdParty;
};


export type QueryThreadArgs = {
  id: Scalars['ID']['input'];
};


export type QueryThreadCommentsArgs = {
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
  sort?: InputMaybe<SortOrder>;
  taskCompleted?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<ThreadCommentType>;
};


export type QueryTopReviewerListArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  trending?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryTransitPackageCountByNextHubArgs = {
  transitDriverId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryUnsettlePackagePaymentsArgs = {
  endDate?: InputMaybe<Scalars['String']['input']>;
  hasSettledWithHq?: InputMaybe<Scalars['Boolean']['input']>;
  hasSettledWithHub?: InputMaybe<Scalars['Boolean']['input']>;
  hasSettledWithSeller?: InputMaybe<Scalars['Boolean']['input']>;
  hasSettledWithThirdParty?: InputMaybe<Scalars['Boolean']['input']>;
  hubId?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<PackageListSort>;
  sellerId?: InputMaybe<Scalars['Int']['input']>;
  sellerOnly?: InputMaybe<Scalars['Boolean']['input']>;
  sortOrder?: InputMaybe<SortOrder>;
  startDate?: InputMaybe<Scalars['String']['input']>;
};


export type QueryUnverifiedBankTransferListArgs = {
  customerId?: InputMaybe<Scalars['Int']['input']>;
  isNegativeBalance?: InputMaybe<Scalars['Boolean']['input']>;
  isPaymentLink?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  paymentType?: InputMaybe<PaymentType>;
  proofStatus?: BankTransferProofStatusType;
  supplierIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};


export type QueryUrlToPayloadArgs = {
  url: Scalars['String']['input'];
};


export type QueryUserPostCommentListArgs = {
  commentId?: InputMaybe<Scalars['Int']['input']>;
  postId?: InputMaybe<Scalars['Int']['input']>;
  userLikeId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryUserPostListArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  userId: Scalars['Int']['input'];
  userLikeId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryUserProfileArgs = {
  id: Scalars['Int']['input'];
};


export type QueryValidateNewSellerAccountPhoneNumberArgs = {
  phoneNumber: Scalars['String']['input'];
};


export type QueryWarehouseListArgs = {
  allowPickup?: InputMaybe<Scalars['Boolean']['input']>;
  communeCode?: InputMaybe<Scalars['String']['input']>;
  districtCode?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  provinceCode?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryWishlistArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type ReceivePaymentResponse = {
  __typename?: 'ReceivePaymentResponse';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type ReceivedShipmentAndPo = {
  __typename?: 'ReceivedShipmentAndPO';
  ReceivedDate?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  receivedQty?: Maybe<Scalars['Int']['output']>;
  sentQty?: Maybe<Scalars['Int']['output']>;
};

export type ReceivedShipmentAndPoList = {
  __typename?: 'ReceivedShipmentAndPOList';
  list?: Maybe<Array<Maybe<ReceivedShipmentAndPo>>>;
  totalReceivedPo?: Maybe<Scalars['Int']['output']>;
  totalReceivedPoUnits?: Maybe<Scalars['Int']['output']>;
  totalReceivedShipment?: Maybe<Scalars['Int']['output']>;
  totalReceivedShipmentUnits?: Maybe<Scalars['Int']['output']>;
};

export type RecommendStore = {
  __typename?: 'RecommendStore';
  blocks?: Maybe<Array<Maybe<StoreListBlock>>>;
  highlightStore?: Maybe<Supplier>;
};

export type RefereeDisbursementInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Array<InputMaybe<ReferrerDisbursementStatus>>>;
  supplierIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};

export type ReferrerAvailableEarningBalance = {
  __typename?: 'ReferrerAvailableEarningBalance';
  amount?: Maybe<Scalars['Decimal']['output']>;
  duration?: Maybe<Scalars['Int']['output']>;
  packages?: Maybe<Scalars['Int']['output']>;
  referee?: Maybe<Scalars['Int']['output']>;
  referrer?: Maybe<Supplier>;
};

export type ReferrerDisbursement = {
  __typename?: 'ReferrerDisbursement';
  amount?: Maybe<Scalars['Decimal']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  exportedAt?: Maybe<Scalars['String']['output']>;
  exportedBy?: Maybe<Admin>;
  id?: Maybe<Scalars['Int']['output']>;
  items?: Maybe<Array<Maybe<ReferrerDisbursementItem>>>;
  paidAt?: Maybe<Scalars['String']['output']>;
  paidBy?: Maybe<Admin>;
  paymentBatch?: Maybe<Scalars['Int']['output']>;
  proof?: Maybe<Scalars['String']['output']>;
  referrer?: Maybe<Supplier>;
  status?: Maybe<ReferrerDisbursementStatus>;
  verifiedAt?: Maybe<Scalars['String']['output']>;
  verifiedBy?: Maybe<Admin>;
};


export type ReferrerDisbursementItemsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type ReferrerDisbursementItem = {
  __typename?: 'ReferrerDisbursementItem';
  amount?: Maybe<Scalars['Decimal']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  package?: Maybe<Package>;
  supplier?: Maybe<Supplier>;
};

export enum ReferrerDisbursementStatus {
  Exported = 'EXPORTED',
  Paid = 'PAID',
  Pending = 'PENDING',
  Verified = 'VERIFIED'
}

export enum RegistrationStaffRole {
  Controller = 'CONTROLLER',
  Deliverer = 'DELIVERER'
}

export type RemoteDuration = {
  __typename?: 'RemoteDuration';
  from?: Maybe<Scalars['String']['output']>;
  to?: Maybe<Scalars['String']['output']>;
};

export type RepairCenter = {
  __typename?: 'RepairCenter';
  address?: Maybe<Scalars['String']['output']>;
  createdDate?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  lat?: Maybe<Scalars['String']['output']>;
  lng?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  supplier?: Maybe<Supplier>;
  updatedDate?: Maybe<Scalars['String']['output']>;
};

export enum RepeatedType {
  Day = 'DAY',
  Hour = 'HOUR',
  Month = 'MONTH'
}

export type ReportCheckoutLocationEntry = {
  __typename?: 'ReportCheckoutLocationEntry';
  createdAt?: Maybe<Scalars['String']['output']>;
  customerID?: Maybe<Scalars['Int']['output']>;
  distanceFromHq?: Maybe<Scalars['Float']['output']>;
  lat?: Maybe<Scalars['String']['output']>;
  lng?: Maybe<Scalars['String']['output']>;
  orderID?: Maybe<Scalars['Int']['output']>;
};

export type ReportGmvEntry = {
  __typename?: 'ReportGMVEntry';
  app?: Maybe<Scalars['String']['output']>;
  day?: Maybe<Scalars['String']['output']>;
  shop1?: Maybe<Scalars['String']['output']>;
  shop2?: Maybe<Scalars['String']['output']>;
  shop3?: Maybe<Scalars['String']['output']>;
  total?: Maybe<Scalars['String']['output']>;
};

export type ReportMerchantTotalSale = {
  __typename?: 'ReportMerchantTotalSale';
  sales?: Maybe<Array<Maybe<ReportMerchantTotalSaleItem>>>;
};

export type ReportMerchantTotalSaleItem = {
  __typename?: 'ReportMerchantTotalSaleItem';
  arrivedAtAgent?: Maybe<Scalars['Float']['output']>;
  date?: Maybe<Scalars['String']['output']>;
  delivered?: Maybe<Scalars['Float']['output']>;
  merchantCancelled?: Maybe<Scalars['Float']['output']>;
  merchantShipping?: Maybe<Scalars['Float']['output']>;
  prepared?: Maybe<Scalars['Float']['output']>;
  ready?: Maybe<Scalars['Float']['output']>;
  returned?: Maybe<Scalars['Float']['output']>;
  total?: Maybe<Scalars['Float']['output']>;
  uncollected?: Maybe<Scalars['Float']['output']>;
  waiting?: Maybe<Scalars['Float']['output']>;
  waitingApprove?: Maybe<Scalars['Float']['output']>;
};

export type ReportOfflineKpiEntry = {
  __typename?: 'ReportOfflineKPIEntry';
  assistedBy?: Maybe<Admin>;
  sales?: Maybe<Scalars['String']['output']>;
  store?: Maybe<Scalars['Int']['output']>;
};

export type ReportedProduct = {
  __typename?: 'ReportedProduct';
  item?: Maybe<BasicProduct>;
  reported?: Maybe<Array<Maybe<ReportedProductDetail>>>;
};

export type ReportedProductDetail = {
  __typename?: 'ReportedProductDetail';
  admin?: Maybe<Admin>;
  createdAt?: Maybe<Scalars['String']['output']>;
  customer?: Maybe<Customer>;
  id?: Maybe<Scalars['Int']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
  returnId?: Maybe<Scalars['Int']['output']>;
};

export type RequestCustomerVerificationResponse = {
  __typename?: 'RequestCustomerVerificationResponse';
  accountExists?: Maybe<Scalars['Boolean']['output']>;
  callTo?: Maybe<Scalars['String']['output']>;
};

export enum RequestCustomerVerificationType {
  Password = 'PASSWORD',
  ServerMissedCall = 'SERVER_MISSED_CALL',
  SmsOtp = 'SMS_OTP'
}

export type RequestPaymentLink = {
  __typename?: 'RequestPaymentLink';
  androidDeepLink?: Maybe<Scalars['String']['output']>;
  deepLink?: Maybe<Scalars['String']['output']>;
  expireAt?: Maybe<Scalars['Int']['output']>;
  hash?: Maybe<Scalars['String']['output']>;
  iosDeepLink?: Maybe<Scalars['String']['output']>;
  otherPayload?: Maybe<Scalars['JSON']['output']>;
  proxyWebViewEndpoint?: Maybe<Scalars['String']['output']>;
  qrCodeImage?: Maybe<Scalars['String']['output']>;
  qrCodeString?: Maybe<Scalars['String']['output']>;
};

export type RequestPaymentResponse = {
  __typename?: 'RequestPaymentResponse';
  androidBundleName?: Maybe<Scalars['String']['output']>;
  androidDeepLink?: Maybe<Scalars['String']['output']>;
  deepLink?: Maybe<Scalars['String']['output']>;
  iosBundleName?: Maybe<Scalars['String']['output']>;
  iosDeepLink?: Maybe<Scalars['String']['output']>;
  legacyNotifyToken?: Maybe<Scalars['String']['output']>;
  otherPayload?: Maybe<Scalars['JSON']['output']>;
  proxyWebViewEndpoint?: Maybe<Scalars['String']['output']>;
  qrCodeImage?: Maybe<Scalars['String']['output']>;
  qrCodeString?: Maybe<Scalars['String']['output']>;
  snapshotId?: Maybe<Scalars['Int']['output']>;
  webViewEndpoint?: Maybe<Scalars['String']['output']>;
};

export type ResponseStatus = {
  __typename?: 'ResponseStatus';
  message?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type RestockingList = {
  __typename?: 'RestockingList';
  data?: Maybe<Array<Maybe<SupplierRestockingList>>>;
  pagination?: Maybe<Pagination>;
};

export type RestockingSku = {
  qty?: InputMaybe<Scalars['Int']['input']>;
  referrence?: InputMaybe<Scalars['String']['input']>;
  skuId?: InputMaybe<Scalars['Int']['input']>;
};

export enum RestockingStatus {
  Cancelled = 'CANCELLED',
  Completed = 'COMPLETED',
  Restocking = 'RESTOCKING'
}

export enum ReturnItemTriage {
  DiscardedAtWarehouse = 'DISCARDED_AT_WAREHOUSE',
  RecycleIn = 'RECYCLE_IN'
}

export enum ReturnReasonType {
  Damage = 'DAMAGE',
  Faulty = 'FAULTY',
  Incomplete = 'INCOMPLETE',
  NotReceived = 'NOT_RECEIVED',
  Wrong = 'WRONG'
}

export enum ReturnStatusType {
  AdminAccepted = 'ADMIN_ACCEPTED',
  AdminRejeceted = 'ADMIN_REJECETED',
  Cancelled = 'CANCELLED',
  Pending = 'PENDING',
  Resolved = 'RESOLVED',
  Returned = 'RETURNED',
  SellerAccepted = 'SELLER_ACCEPTED',
  SellerDispute = 'SELLER_DISPUTE'
}

export enum ReturnableCaptionType {
  NotReturnable = 'NOT_RETURNABLE',
  Returnable = 'RETURNABLE',
  Tracking = 'TRACKING'
}

export enum ReviewSortField {
  Date = 'DATE',
  Rating = 'RATING',
  Useful = 'USEFUL'
}

export enum ReviewStatus {
  Approve = 'APPROVE',
  Reject = 'REJECT'
}

export type RewardGiftInput = {
  Qty?: InputMaybe<Scalars['Int']['input']>;
  skuId?: InputMaybe<Scalars['Int']['input']>;
};

export type RewardGiftOutput = {
  __typename?: 'RewardGiftOutput';
  Qty?: Maybe<Scalars['Int']['output']>;
  skuId?: Maybe<Scalars['Int']['output']>;
};

export type RewardInput = {
  FreeDeliveryFee?: InputMaybe<Scalars['Decimal']['input']>;
  promocodeValue?: InputMaybe<Scalars['Decimal']['input']>;
  rewardGift?: InputMaybe<Array<InputMaybe<RewardGiftInput>>>;
};

export type RewardOutput = {
  __typename?: 'RewardOutput';
  FreeDeliveryFee?: Maybe<Scalars['Decimal']['output']>;
  promocodeValue?: Maybe<Scalars['Decimal']['output']>;
  rewardGift?: Maybe<Array<Maybe<RewardGiftOutput>>>;
  spinPoint?: Maybe<Scalars['Int']['output']>;
};

export enum Sales_Status {
  All = 'ALL',
  Lost = 'LOST',
  Ongoing = 'ONGOING',
  Returned = 'RETURNED',
  Sold = 'SOLD'
}

export type Sku = {
  __typename?: 'SKU';
  barcode?: Maybe<Scalars['String']['output']>;
  barcodeOriginal?: Maybe<Scalars['String']['output']>;
  color?: Maybe<Scalars['String']['output']>;
  currentStock?: Maybe<Scalars['Int']['output']>;
  enabled?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  product?: Maybe<BasicProduct>;
  productID?: Maybe<Scalars['Int']['output']>;
  qty?: Maybe<Scalars['Int']['output']>;
  received?: Maybe<Scalars['Int']['output']>;
  shipperReceived?: Maybe<Scalars['Int']['output']>;
  size?: Maybe<Scalars['String']['output']>;
  supplierBarcode?: Maybe<Scalars['String']['output']>;
};

export type SkuInput = {
  barcodeOriginal?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SaleSummary = {
  __typename?: 'SaleSummary';
  amountReturn?: Maybe<Scalars['String']['output']>;
  completed?: Maybe<Scalars['String']['output']>;
  return?: Maybe<Scalars['String']['output']>;
  sale?: Maybe<Scalars['String']['output']>;
  sold?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  total?: Maybe<Scalars['String']['output']>;
};

export enum SaleSummaryType {
  Reminder = 'REMINDER',
  Return = 'RETURN',
  Sale = 'SALE',
  Sold = 'SOLD'
}

export type SalesDetailBySalesStatusList = {
  __typename?: 'SalesDetailBySalesStatusList';
  data?: Maybe<Array<Maybe<MerchantOrderItem>>>;
  page?: Maybe<Pagination>;
};

export type SalesFilter = {
  endDate?: InputMaybe<Scalars['String']['input']>;
  saleAmountGte?: InputMaybe<Scalars['Decimal']['input']>;
  saleAmountLte?: InputMaybe<Scalars['Decimal']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
};

export type SalesInfo = {
  __typename?: 'SalesInfo';
  amount?: Maybe<Scalars['Decimal']['output']>;
  qty?: Maybe<Scalars['Int']['output']>;
};

export type ScanInPackageResponse = {
  __typename?: 'ScanInPackageResponse';
  final?: Maybe<Scalars['Boolean']['output']>;
  messageBody?: Maybe<Scalars['String']['output']>;
  messageHeader?: Maybe<Scalars['String']['output']>;
  next?: Maybe<Warehouse>;
  nextAgent?: Maybe<Agent>;
  package?: Maybe<Package>;
  type?: Maybe<PackageType>;
};

export type ScanOutPackageResponse = {
  __typename?: 'ScanOutPackageResponse';
  message?: Maybe<Scalars['String']['output']>;
  package?: Maybe<Package>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export enum ScheduledNotificationType {
  Announcement = 'ANNOUNCEMENT',
  Normal = 'NORMAL'
}

export enum ScoreStatus {
  Complete = 'COMPLETE',
  Incomplete = 'INCOMPLETE'
}

export type SearchAffiliateProduct = {
  productCode?: InputMaybe<Scalars['String']['input']>;
  productName?: InputMaybe<Scalars['String']['input']>;
  supplierName?: InputMaybe<Scalars['String']['input']>;
};

export type SearchStoreSuggestion = {
  __typename?: 'SearchStoreSuggestion';
  id?: Maybe<Scalars['Int']['output']>;
  logo?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  navigate?: Maybe<Scalars['JSON']['output']>;
};

export type SearchSuggestion = {
  __typename?: 'SearchSuggestion';
  keywords?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  orderTemplate?: Maybe<Array<Maybe<OrderTemplate>>>;
  stores?: Maybe<Array<Maybe<SearchStoreSuggestion>>>;
};

export type SellerAdsCampaign = {
  __typename?: 'SellerAdsCampaign';
  endDate?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  items?: Maybe<Array<Maybe<SellerAdsCampaignItem>>>;
  name?: Maybe<Scalars['String']['output']>;
  seller?: Maybe<Supplier>;
  startDate?: Maybe<Scalars['String']['output']>;
  status?: Maybe<SellerAdsCampaignStatus>;
};

export enum SellerAdsCampaignDeliveryStatus {
  Complete = 'COMPLETE',
  Delivering = 'DELIVERING',
  NotStarted = 'NOT_STARTED'
}

export type SellerAdsCampaignInput = {
  endDate?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
};

export type SellerAdsCampaignItem = {
  __typename?: 'SellerAdsCampaignItem';
  activity?: Maybe<Scalars['JSON']['output']>;
  biding?: Maybe<Scalars['Float']['output']>;
  budget?: Maybe<Scalars['Float']['output']>;
  campaignId?: Maybe<Scalars['Int']['output']>;
  clicks?: Maybe<Scalars['Int']['output']>;
  clicksByApp?: Maybe<Scalars['Int']['output']>;
  clicksByWebsite?: Maybe<Scalars['Int']['output']>;
  deliveryStatus?: Maybe<SellerAdsCampaignDeliveryStatus>;
  id?: Maybe<Scalars['Int']['output']>;
  liveAt?: Maybe<Scalars['String']['output']>;
  liveBy?: Maybe<Admin>;
  liveUrl?: Maybe<Scalars['String']['output']>;
  product?: Maybe<BasicProduct>;
  reach?: Maybe<Scalars['Int']['output']>;
  saleQtyToPay?: Maybe<Scalars['Int']['output']>;
  salesAmount?: Maybe<Scalars['Float']['output']>;
  salesQty?: Maybe<Scalars['Int']['output']>;
  settled?: Maybe<Scalars['Int']['output']>;
  settledAmount?: Maybe<Scalars['String']['output']>;
  status?: Maybe<SellerAdsCampaignItemStatus>;
  supplier?: Maybe<Supplier>;
  type?: Maybe<SellerAdsCampaignItemType>;
};

export type SellerAdsCampaignItemInput = {
  biding?: InputMaybe<Scalars['Float']['input']>;
  budget?: InputMaybe<Scalars['Float']['input']>;
  productId?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<SellerAdsCampaignItemType>;
};

export enum SellerAdsCampaignItemStatus {
  Approve = 'APPROVE',
  Pending = 'PENDING',
  Reject = 'REJECT'
}

export enum SellerAdsCampaignItemType {
  Click = 'CLICK',
  Live = 'LIVE'
}

export enum SellerAdsCampaignStatus {
  Complete = 'COMPLETE',
  Delivering = 'DELIVERING',
  Pending = 'PENDING'
}

export type SellerAdsV2Filter = {
  end?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Array<InputMaybe<SellerAdsV2Status>>>;
};

export type SellerAdsV2Input = {
  budgetPerDay: Scalars['Int']['input'];
  end: Scalars['String']['input'];
  estimatedReach: Scalars['Int']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  start: Scalars['String']['input'];
};

export type SellerAdsV2Output = {
  __typename?: 'SellerAdsV2Output';
  adsCost?: Maybe<Scalars['Decimal']['output']>;
  adsType?: Maybe<SellerAdsV2Type>;
  banner?: Maybe<AdsBannerOutPut>;
  budgetPerDay?: Maybe<Scalars['Int']['output']>;
  click?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  disbursementId?: Maybe<Scalars['Int']['output']>;
  endAt?: Maybe<Scalars['String']['output']>;
  estimatedReach?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  productAds?: Maybe<Array<Maybe<ProductAdsV2Output>>>;
  reach?: Maybe<Scalars['Int']['output']>;
  rejectedAt?: Maybe<Scalars['String']['output']>;
  salesAmount?: Maybe<Scalars['Decimal']['output']>;
  salesQty?: Maybe<Scalars['Int']['output']>;
  startAt?: Maybe<Scalars['String']['output']>;
  status?: Maybe<SellerAdsV2Status>;
  supplier?: Maybe<Supplier>;
  suspendedAt?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
};

export enum SellerAdsV2Status {
  Completed = 'COMPLETED',
  Delivering = 'DELIVERING',
  Pending = 'PENDING',
  Rejected = 'REJECTED',
  Suspended = 'SUSPENDED'
}

export enum SellerAdsV2Type {
  FrontBanner = 'FRONT_BANNER',
  ProductBanner = 'PRODUCT_BANNER',
  ProductReach = 'PRODUCT_REACH'
}

export type SellerLiveCampaign = {
  __typename?: 'SellerLiveCampaign';
  activity?: Maybe<Scalars['String']['output']>;
  appSalesQty?: Maybe<Scalars['Int']['output']>;
  appliedDate?: Maybe<Scalars['String']['output']>;
  approvedDate?: Maybe<Scalars['String']['output']>;
  basedLineSalesQty?: Maybe<Scalars['Int']['output']>;
  biding?: Maybe<Scalars['Float']['output']>;
  budget?: Maybe<Scalars['Float']['output']>;
  campaignClicks?: Maybe<Scalars['Int']['output']>;
  campaignId?: Maybe<Scalars['Int']['output']>;
  campaignReach?: Maybe<Scalars['Int']['output']>;
  deliveryStatus?: Maybe<SellerAdsCampaignDeliveryStatus>;
  historyClicks?: Maybe<Scalars['Int']['output']>;
  historyLastSold?: Maybe<Scalars['String']['output']>;
  historyReach?: Maybe<Scalars['Int']['output']>;
  historyRevenue?: Maybe<Scalars['Float']['output']>;
  historySoldQty?: Maybe<Scalars['Int']['output']>;
  liveSalesQty?: Maybe<Scalars['Int']['output']>;
  product?: Maybe<BasicProduct>;
  saleQtyToPay?: Maybe<Scalars['Int']['output']>;
  settledAmount?: Maybe<Scalars['Float']['output']>;
  status?: Maybe<SellerAdsCampaignItemStatus>;
  supplier?: Maybe<Supplier>;
};

export type SellerLiveCampaignList = {
  __typename?: 'SellerLiveCampaignList';
  data?: Maybe<Array<Maybe<SellerLiveCampaign>>>;
  page?: Maybe<Pagination>;
};

export type SellerNotification = {
  __typename?: 'SellerNotification';
  attachedImage?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  data?: Maybe<Scalars['JSON']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  notificationType?: Maybe<Scalars['String']['output']>;
  read?: Maybe<Scalars['Boolean']['output']>;
  sellerId?: Maybe<Scalars['Int']['output']>;
  subTitle?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export enum SellerOrigin {
  China = 'CHINA',
  Local = 'LOCAL'
}

export type SellerPackage = {
  __typename?: 'SellerPackage';
  createdDate?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  international?: Maybe<Supplier>;
  internationalReceivedDate?: Maybe<Scalars['String']['output']>;
  local?: Maybe<Supplier>;
  localReceivedDate?: Maybe<Scalars['String']['output']>;
  nodes?: Maybe<Array<Maybe<NodeSellerPackage>>>;
  status?: Maybe<Scalars['String']['output']>;
  supplier?: Maybe<Supplier>;
};

export type SellerPackageList = {
  __typename?: 'SellerPackageList';
  data?: Maybe<Array<Maybe<SellerPackage>>>;
  page?: Maybe<Pagination>;
};

export type SellerRegisterReseller = {
  __typename?: 'SellerRegisterReseller';
  success?: Maybe<Scalars['Boolean']['output']>;
  verifyToken?: Maybe<Scalars['String']['output']>;
};

export type SellerResendResult = {
  __typename?: 'SellerResendResult';
  resendLeft?: Maybe<Scalars['Int']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export enum SellerRole {
  Agent = 'AGENT',
  FblVendor = 'FBL_VENDOR',
  LogisticShipper = 'LOGISTIC_SHIPPER',
  Recruiter = 'RECRUITER',
  Seller = 'SELLER',
  Shipper = 'SHIPPER',
  Store = 'STORE',
  Vendor = 'VENDOR'
}

export type SellerSalesByDay = {
  __typename?: 'SellerSalesByDay';
  date?: Maybe<Scalars['String']['output']>;
  lost?: Maybe<Scalars['Int']['output']>;
  lostAmount?: Maybe<Scalars['Float']['output']>;
  ongoing?: Maybe<Scalars['Int']['output']>;
  ongoingAmount?: Maybe<Scalars['Float']['output']>;
  returned?: Maybe<Scalars['Int']['output']>;
  returnedAmount?: Maybe<Scalars['Float']['output']>;
  sold?: Maybe<Scalars['Int']['output']>;
  soldAmount?: Maybe<Scalars['Float']['output']>;
};

export enum SellerSegment {
  DeliverySeller = 'DELIVERY_SELLER',
  ProductSeller = 'PRODUCT_SELLER'
}

export type SellerSubscription = {
  __typename?: 'SellerSubscription';
  autoRenew?: Maybe<Scalars['Boolean']['output']>;
  expiredDate?: Maybe<Scalars['String']['output']>;
  fee?: Maybe<Scalars['Decimal']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  interval?: Maybe<Scalars['String']['output']>;
  nextInterval?: Maybe<Scalars['String']['output']>;
  nextPlanId?: Maybe<Scalars['Int']['output']>;
  planId?: Maybe<Scalars['Int']['output']>;
  planName?: Maybe<SellerSuscriptionPlan>;
  subscriptedDate?: Maybe<Scalars['String']['output']>;
  unSubscrbedAt?: Maybe<Scalars['String']['output']>;
};

export enum SellerSuscriptionPlan {
  Basic = 'BASIC',
  Boost = 'BOOST',
  Elite = 'ELITE',
  Feature = 'FEATURE',
  Pro = 'PRO'
}

export enum SellerType {
  Is = 'IS',
  Isd = 'ISD',
  Normal = 'NORMAL'
}

export type SellerVerifyResult = {
  __typename?: 'SellerVerifyResult';
  loginToken?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
  triesLeft?: Maybe<Scalars['Int']['output']>;
};

export type ServiceItem = {
  __typename?: 'ServiceItem';
  contact?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  logo?: Maybe<Scalars['String']['output']>;
  menu?: Maybe<Array<Maybe<ServiceMenuItem>>>;
  name?: Maybe<Scalars['String']['output']>;
};

export type ServiceMenuItem = {
  __typename?: 'ServiceMenuItem';
  description?: Maybe<Scalars['String']['output']>;
  priceRange?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type Setting = {
  __typename?: 'Setting';
  option?: Maybe<SettingType>;
  value?: Maybe<Scalars['String']['output']>;
};

export enum SettingType {
  AffilateThirdPartyBank = 'AFFILATE_THIRD_PARTY_BANK',
  AllDiscount = 'ALL_DISCOUNT',
  AppDiscount = 'APP_DISCOUNT',
  BankTransferInfo = 'BANK_TRANSFER_INFO',
  DeliveryTermsAndConditions = 'DELIVERY_TERMS_AND_CONDITIONS',
  DisbursementEnabled = 'DISBURSEMENT_ENABLED',
  ExchangeRate = 'EXCHANGE_RATE',
  GlobalPromoCodeLimit = 'GLOBAL_PROMO_CODE_LIMIT',
  GoldDiscount = 'GOLD_DISCOUNT',
  LogisticInformation = 'LOGISTIC_INFORMATION',
  MsgTemplate = 'MSG_TEMPLATE',
  PackageGasolineDeliveryFee = 'PACKAGE_GASOLINE_DELIVERY_FEE',
  PackageGasolinePickupFee = 'PACKAGE_GASOLINE_PICKUP_FEE',
  Payments = 'PAYMENTS',
  SavingPointExchangeRate = 'SAVING_POINT_EXCHANGE_RATE',
  ServicesMenu = 'SERVICES_MENU',
  SponsorRatePerImpression = 'SPONSOR_RATE_PER_IMPRESSION',
  Store_1Discount = 'STORE_1_DISCOUNT',
  Store_2Discount = 'STORE_2_DISCOUNT',
  Store_3Discount = 'STORE_3_DISCOUNT',
  TransitDistanceFee = 'TRANSIT_DISTANCE_FEE',
  TransitGasolineFee = 'TRANSIT_GASOLINE_FEE',
  TransitPackageFee = 'TRANSIT_PACKAGE_FEE',
  VipSavingCost = 'VIP_SAVING_COST'
}

export type SettlementWithSeller = {
  __typename?: 'SettlementWithSeller';
  amount?: Maybe<Scalars['String']['output']>;
  attachment?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  fee?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  packages?: Maybe<Array<Maybe<UnsettlePackagePayment>>>;
  seller?: Maybe<Supplier>;
  settledAt?: Maybe<Scalars['String']['output']>;
  settledBy?: Maybe<Admin>;
  status?: Maybe<SettlementWithSellerStatus>;
};

export enum SettlementWithSellerListOrder {
  CreatedDate = 'CREATED_DATE',
  SuccessDate = 'SUCCESS_DATE'
}

export enum SettlementWithSellerStatus {
  Pending = 'PENDING',
  Settled = 'SETTLED'
}

export type ShipmentDetail = {
  __typename?: 'ShipmentDetail';
  items?: Maybe<Array<Maybe<ShipmentItemDetail>>>;
  shipment?: Maybe<ShipmentProduct>;
};

export type ShipmentItemDetail = {
  __typename?: 'ShipmentItemDetail';
  color?: Maybe<Scalars['String']['output']>;
  detailVerified?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  item?: Maybe<BasicProduct>;
  receivedQty?: Maybe<Scalars['Int']['output']>;
  sentQty?: Maybe<Scalars['Int']['output']>;
  shipmentId?: Maybe<Scalars['Int']['output']>;
  shipperReceived?: Maybe<Scalars['Int']['output']>;
  size?: Maybe<Scalars['String']['output']>;
  sku?: Maybe<StockKeepingUnit>;
};

export type ShipmentLog = {
  __typename?: 'ShipmentLog';
  admin?: Maybe<Admin>;
  date?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
};

export enum ShipmentLogStatus {
  Arrived = 'ARRIVED',
  ArrivedAtShipper = 'ARRIVED_AT_SHIPPER',
  Deleted = 'DELETED',
  Departed = 'DEPARTED',
  Pending = 'PENDING',
  PickedUp = 'PICKED_UP',
  Processed = 'PROCESSED',
  Processing = 'PROCESSING',
  Received = 'RECEIVED',
  Sent = 'SENT',
  Shipped = 'SHIPPED'
}

export type ShipmentProduct = {
  __typename?: 'ShipmentProduct';
  abnormal?: Maybe<Scalars['Boolean']['output']>;
  abnormalStatus?: Maybe<AbnormalStatusType>;
  arrivedAt?: Maybe<Warehouse>;
  arrivedBy?: Maybe<Admin>;
  arrivedDate?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  departedDate?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  package?: Maybe<Package>;
  qty?: Maybe<Scalars['Int']['output']>;
  received?: Maybe<Scalars['Int']['output']>;
  receivedAdmin?: Maybe<Scalars['String']['output']>;
  receivedBy?: Maybe<Admin>;
  receivedDate?: Maybe<Scalars['String']['output']>;
  requestDate?: Maybe<Scalars['String']['output']>;
  shipmentCode?: Maybe<Scalars['String']['output']>;
  shipmentLog?: Maybe<Array<Maybe<ShipmentLog>>>;
  shipperReceived?: Maybe<Scalars['Int']['output']>;
  solution?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  supplier?: Maybe<Supplier>;
  tracking_number?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type ShipmentProductList = {
  __typename?: 'ShipmentProductList';
  data?: Maybe<Array<Maybe<ShipmentProduct>>>;
  page?: Maybe<Pagination>;
};

export enum ShipperScanLogStatus {
  Arrived = 'ARRIVED',
  Departed = 'DEPARTED',
  Pending = 'PENDING'
}

export enum ShipperScanLogType {
  Order = 'ORDER',
  Package = 'PACKAGE',
  Shipment = 'SHIPMENT'
}

export type ShopRequestFindingSuggestion = {
  __typename?: 'ShopRequestFindingSuggestion';
  by?: Maybe<Admin>;
  id?: Maybe<Scalars['Int']['output']>;
  movedQty?: Maybe<Scalars['Int']['output']>;
  requestedAt?: Maybe<Scalars['String']['output']>;
  requestedHub?: Maybe<Warehouse>;
  requestedQty?: Maybe<Scalars['Int']['output']>;
  sku?: Maybe<StockKeepingUnit>;
  slot?: Maybe<InventorySlot>;
  status?: Maybe<ShopRequestStatus>;
  suggestedQty?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<ShopRequestType>;
};

export type ShopRequestInput = {
  hubId?: InputMaybe<Scalars['Int']['input']>;
  requestedQty?: InputMaybe<Scalars['Int']['input']>;
  skuId?: InputMaybe<Scalars['Int']['input']>;
  slotId?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<ShopRequestStatus>;
  type?: InputMaybe<ShopRequestType>;
};

export enum ShopRequestStatus {
  Done = 'DONE',
  None = 'NONE',
  Rejected = 'REJECTED'
}

export enum ShopRequestType {
  Model = 'MODEL',
  Store = 'STORE'
}

export type ShowClickToDoorMessage = {
  __typename?: 'ShowClickToDoorMessage';
  message?: Maybe<Scalars['String']['output']>;
  show?: Maybe<Scalars['Boolean']['output']>;
};

export enum SortOrder {
  Asc = 'ASC',
  Desc = 'DESC'
}

export enum SortProductRequest {
  Inputdate = 'INPUTDATE',
  Sale = 'SALE',
  Stock = 'STOCK'
}

export type SpecialProduct = {
  __typename?: 'SpecialProduct';
  active?: Maybe<Scalars['Boolean']['output']>;
  clicks?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  image?: Maybe<Scalars['String']['output']>;
  navigate?: Maybe<Scalars['JSON']['output']>;
  reach?: Maybe<Scalars['Int']['output']>;
  text?: Maybe<Scalars['String']['output']>;
};

export type SpecialProductInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  image?: InputMaybe<Scalars['String']['input']>;
  navigate?: InputMaybe<Scalars['JSON']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
};

export type SpecialProductlist = {
  __typename?: 'SpecialProductlist';
  id?: Maybe<Scalars['String']['output']>;
  image?: Maybe<Scalars['String']['output']>;
  navigate?: Maybe<Scalars['JSON']['output']>;
  text?: Maybe<Scalars['String']['output']>;
};

export type SpinReward = {
  __typename?: 'SpinReward';
  active?: Maybe<Scalars['Boolean']['output']>;
  created_at?: Maybe<Scalars['String']['output']>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  image?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  reward?: Maybe<RewardOutput>;
  spinOnRate?: Maybe<Scalars['Int']['output']>;
  totalSpin?: Maybe<Scalars['Int']['output']>;
  totalSpinOn?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<SpinRewardType>;
  updated_at?: Maybe<Scalars['String']['output']>;
};

export type SpinRewardInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  image?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  reward?: InputMaybe<RewardInput>;
  spinOnRate?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<SpinRewardType>;
};

export enum SpinRewardType {
  FreeDelivery = 'FREE_DELIVERY',
  Gift = 'GIFT',
  Promocode = 'PROMOCODE',
  SpinPoint = 'SPIN_POINT'
}

export type StaffBalance = {
  __typename?: 'StaffBalance';
  amount?: Maybe<Scalars['Float']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Admin>;
  id?: Maybe<Scalars['Int']['output']>;
  package?: Maybe<Package>;
  proofAttachment?: Maybe<Scalars['String']['output']>;
  reference?: Maybe<Scalars['Int']['output']>;
  staff?: Maybe<Admin>;
  transactionId?: Maybe<Scalars['String']['output']>;
  type?: Maybe<StaffBalanceType>;
  verifiedBy?: Maybe<Admin>;
};

export enum StaffBalanceType {
  Adjustment = 'ADJUSTMENT',
  Cod = 'COD',
  CodAdjustment = 'COD_ADJUSTMENT',
  OpeningTopup = 'OPENING_TOPUP',
  PrepaidFee = 'PREPAID_FEE',
  Topup = 'TOPUP',
  TopupViaController = 'TOPUP_VIA_CONTROLLER'
}

export type StaffDeposit = {
  __typename?: 'StaffDeposit';
  amount?: Maybe<Scalars['Float']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Admin>;
  id?: Maybe<Scalars['Int']['output']>;
  proof?: Maybe<Scalars['String']['output']>;
  staff?: Maybe<Admin>;
};

export type StaffLocation = {
  __typename?: 'StaffLocation';
  createdAt?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
};

export type StaffOpenAndCloseBalance = {
  __typename?: 'StaffOpenAndCloseBalance';
  closingBalance?: Maybe<Scalars['Float']['output']>;
  openingBalance?: Maybe<Scalars['Float']['output']>;
  totalCashCollected?: Maybe<Scalars['Float']['output']>;
  totalPackage?: Maybe<Scalars['Int']['output']>;
  totalPrepaid?: Maybe<Scalars['Float']['output']>;
  totalTopup?: Maybe<Scalars['Float']['output']>;
};

export type StaffRegistrationInfo = {
  __typename?: 'StaffRegistrationInfo';
  VRC?: Maybe<Scalars['String']['output']>;
  cv?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  idCard?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  registeredAt?: Maybe<Scalars['String']['output']>;
  role?: Maybe<RegistrationStaffRole>;
};

export type StaffRegistrationInfoInput = {
  VRC?: InputMaybe<Scalars['String']['input']>;
  cv?: InputMaybe<Scalars['String']['input']>;
  idCard?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<RegistrationStaffRole>;
};

export type StockKeepingUnit = {
  __typename?: 'StockKeepingUnit';
  barcode?: Maybe<Scalars['String']['output']>;
  barcodeOriginal?: Maybe<Scalars['String']['output']>;
  enabled?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  option1?: Maybe<Scalars['String']['output']>;
  option1Name?: Maybe<Scalars['String']['output']>;
  option2?: Maybe<Scalars['String']['output']>;
  option2Name?: Maybe<Scalars['String']['output']>;
  product?: Maybe<BasicProduct>;
  stockLocation?: Maybe<Array<Maybe<ProductStockLocation>>>;
  stockQty?: Maybe<Scalars['Int']['output']>;
  supplierStock?: Maybe<Scalars['Int']['output']>;
};

export type StockTransaction = {
  __typename?: 'StockTransaction';
  color?: Maybe<Scalars['String']['output']>;
  cost?: Maybe<Scalars['String']['output']>;
  costDescription?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  product?: Maybe<BasicProduct>;
  productID?: Maybe<Scalars['Int']['output']>;
  purchaseOrderID?: Maybe<Scalars['Int']['output']>;
  qty?: Maybe<Scalars['Int']['output']>;
  size?: Maybe<Scalars['String']['output']>;
  skuID?: Maybe<Scalars['Int']['output']>;
  slotID?: Maybe<Scalars['Int']['output']>;
  transactionType?: Maybe<StockTransactionType>;
};

export enum StockTransactionAction {
  Adjust = 'ADJUST',
  Fixed = 'FIXED',
  Missing = 'MISSING',
  Recycle = 'RECYCLE',
  StockIn = 'STOCK_IN',
  StockOut = 'STOCK_OUT',
  Transfer = 'TRANSFER'
}

export type StockTransactionInput = {
  cost?: InputMaybe<Scalars['String']['input']>;
  costDescription?: InputMaybe<Scalars['String']['input']>;
  expiredDate?: InputMaybe<Scalars['String']['input']>;
  fromSlotID?: InputMaybe<Scalars['Int']['input']>;
  printedDate?: InputMaybe<Scalars['String']['input']>;
  purchaseOrderID?: InputMaybe<Scalars['Int']['input']>;
  qty: Scalars['Int']['input'];
  shipmentId?: InputMaybe<Scalars['Int']['input']>;
  skuID: Scalars['Int']['input'];
  slotID: Scalars['Int']['input'];
  type: StockTransactionAction;
};

export enum StockTransactionType {
  Adjust = 'ADJUST',
  Damage = 'DAMAGE',
  Fixed = 'FIXED',
  InstorePurchase = 'INSTORE_PURCHASE',
  Missing = 'MISSING',
  OnlinePurchase = 'ONLINE_PURCHASE',
  Recycle = 'RECYCLE',
  StockIn = 'STOCK_IN',
  StockOut = 'STOCK_OUT',
  TransferIn = 'TRANSFER_IN',
  TransferOut = 'TRANSFER_OUT'
}

export type StockTransactionV2 = {
  __typename?: 'StockTransactionV2';
  batchId?: Maybe<Scalars['Int']['output']>;
  cost?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Admin>;
  id: Scalars['Int']['output'];
  originalCurrencyCost?: Maybe<Scalars['String']['output']>;
  purchaseOrderId?: Maybe<Scalars['Int']['output']>;
  qty?: Maybe<Scalars['Int']['output']>;
  sku?: Maybe<StockKeepingUnit>;
  slot?: Maybe<InventorySlot>;
  transactionType?: Maybe<StockTransactionType>;
};

export type StoreListBlock = {
  __typename?: 'StoreListBlock';
  stores?: Maybe<Array<Maybe<Supplier>>>;
  title?: Maybe<Scalars['String']['output']>;
  type?: Maybe<StoreListBlockType>;
};

export enum StoreListBlockType {
  Full = 'FULL',
  Landscape = 'LANDSCAPE',
  Portrait = 'PORTRAIT'
}

export type Subscription = {
  __typename?: 'Subscription';
  chatChannelLiveCounter?: Maybe<Scalars['Int']['output']>;
  chatMessageAdded?: Maybe<ChatMessage>;
  chatMessageSeen?: Maybe<ChatChannelSeen>;
  customerEventAdded?: Maybe<CustomerEventAdded>;
  customerOrderAdded?: Maybe<CustomerOrderAddedEvent>;
  generalEventAdded?: Maybe<GeneralEventAdded>;
  imagePackageCreated?: Maybe<ImagePackageCreated>;
  loginlessAdded?: Maybe<LoginlessAddedEvent>;
  loginlessEvent?: Maybe<LoginlessEvent>;
  packageEventAdded?: Maybe<PackageAddedEvent>;
  paymentLinkAdded?: Maybe<LinkedPayment>;
  paymentReceivedChanged?: Maybe<PaymentReceivedResponse>;
  supplierEventAdded?: Maybe<SupplierEventAdded>;
};


export type SubscriptionChatChannelLiveCounterArgs = {
  liveChannel?: InputMaybe<Scalars['String']['input']>;
};


export type SubscriptionChatMessageAddedArgs = {
  liveChannel?: InputMaybe<Scalars['String']['input']>;
  onlyDirectMessage?: InputMaybe<Scalars['Boolean']['input']>;
};


export type SubscriptionChatMessageSeenArgs = {
  channel?: InputMaybe<Scalars['String']['input']>;
};


export type SubscriptionCustomerEventAddedArgs = {
  type?: InputMaybe<Scalars['String']['input']>;
};


export type SubscriptionGeneralEventAddedArgs = {
  type?: InputMaybe<Scalars['String']['input']>;
};


export type SubscriptionPaymentReceivedChangedArgs = {
  notifyKey: Scalars['String']['input'];
};


export type SubscriptionSupplierEventAddedArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type SuccessPackageLocation = {
  __typename?: 'SuccessPackageLocation';
  city?: Maybe<Scalars['String']['output']>;
  lat?: Maybe<Scalars['String']['output']>;
  lng?: Maybe<Scalars['String']['output']>;
  package?: Maybe<Scalars['Int']['output']>;
};

export type Supplier = {
  __typename?: 'Supplier';
  MerchantAgreementChecked?: Maybe<Scalars['Boolean']['output']>;
  abaLink?: Maybe<Scalars['String']['output']>;
  abaQrcode?: Maybe<Scalars['String']['output']>;
  active?: Maybe<Scalars['Boolean']['output']>;
  address?: Maybe<Scalars['String']['output']>;
  affiliateBalance?: Maybe<Scalars['String']['output']>;
  approvedBy?: Maybe<Admin>;
  approvedDate?: Maybe<Scalars['String']['output']>;
  bankAccountHolderName?: Maybe<Scalars['String']['output']>;
  bankAccountNumber?: Maybe<Scalars['String']['output']>;
  bankName?: Maybe<Scalars['String']['output']>;
  bannedReason?: Maybe<SupplierBannedReason>;
  banner?: Maybe<Scalars['String']['output']>;
  bitlyLink?: Maybe<Scalars['String']['output']>;
  brand?: Maybe<Array<Maybe<Brand>>>;
  category?: Maybe<Array<Maybe<Category>>>;
  chargeDeliveryFee?: Maybe<Scalars['Boolean']['output']>;
  chargeHandlingFee?: Maybe<Scalars['Boolean']['output']>;
  chargePickupFee?: Maybe<Scalars['Boolean']['output']>;
  companyRegisterNumber?: Maybe<Scalars['String']['output']>;
  contact?: Maybe<Scalars['String']['output']>;
  coordLat?: Maybe<Scalars['String']['output']>;
  coordLng?: Maybe<Scalars['String']['output']>;
  defaultAddressId?: Maybe<Scalars['Int']['output']>;
  emails?: Maybe<Scalars['String']['output']>;
  enabledChat?: Maybe<Scalars['Boolean']['output']>;
  enabledNotificationDelivered?: Maybe<Scalars['Boolean']['output']>;
  enabledNotificationNoteAdded?: Maybe<Scalars['Boolean']['output']>;
  enabledNotificationPickup?: Maybe<Scalars['Boolean']['output']>;
  enabledReferral?: Maybe<Scalars['Int']['output']>;
  exposed?: Maybe<Scalars['Boolean']['output']>;
  fileUpload?: Maybe<Scalars['String']['output']>;
  firstCreatedPackageAt?: Maybe<Scalars['String']['output']>;
  fiscalCodeNumber?: Maybe<Scalars['String']['output']>;
  followed?: Maybe<Scalars['Boolean']['output']>;
  followedBy?: Maybe<Array<Maybe<Admin>>>;
  follower?: Maybe<Scalars['Int']['output']>;
  freeInventoryFee?: Maybe<Scalars['Boolean']['output']>;
  freePackage?: Maybe<Scalars['Int']['output']>;
  frontStoreImage?: Maybe<Scalars['String']['output']>;
  fulfilmentRate?: Maybe<Scalars['Float']['output']>;
  fulfilmentTime?: Maybe<Scalars['Int']['output']>;
  hasFollowed?: Maybe<Scalars['Boolean']['output']>;
  holdDuration?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  initial?: Maybe<Scalars['String']['output']>;
  isBrandedStore?: Maybe<Scalars['Boolean']['output']>;
  isPaymentGateway?: Maybe<Scalars['Boolean']['output']>;
  isSeller?: Maybe<Scalars['Boolean']['output']>;
  lastCreatedPackageAt?: Maybe<Scalars['String']['output']>;
  lastUsedUnixTimestamp?: Maybe<Scalars['Int']['output']>;
  level?: Maybe<Scalars['Int']['output']>;
  logo?: Maybe<Scalars['String']['output']>;
  madeInCambodia?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  origin?: Maybe<Origin>;
  ownerIDNumber?: Maybe<Scalars['String']['output']>;
  ownerIDType?: Maybe<Scalars['String']['output']>;
  ownerName?: Maybe<Scalars['String']['output']>;
  packageSettlementOption?: Maybe<PackageSettlementOption>;
  packageUI?: Maybe<PackageCreatedWith>;
  paymentGatewayID?: Maybe<Scalars['Int']['output']>;
  personalChannelId?: Maybe<Scalars['String']['output']>;
  prefix?: Maybe<Scalars['String']['output']>;
  prepaidPickup?: Maybe<Scalars['Boolean']['output']>;
  productAverageRating?: Maybe<Scalars['Float']['output']>;
  productRatingCount?: Maybe<Scalars['Int']['output']>;
  referralSupplier?: Maybe<Supplier>;
  registerDate?: Maybe<Scalars['String']['output']>;
  rejectedBy?: Maybe<Admin>;
  rejectedDate?: Maybe<Scalars['String']['output']>;
  rejectedReason?: Maybe<Scalars['String']['output']>;
  responsibleBy?: Maybe<Admin>;
  reviewStatus?: Maybe<SupplierReviewStatus>;
  role?: Maybe<SupplierRole>;
  sellerType?: Maybe<SellerType>;
  shellStore?: Maybe<OriginalSupplierSetting>;
  shipperID?: Maybe<Scalars['Int']['output']>;
  subscription?: Maybe<SellerSubscription>;
  subtitle?: Maybe<Scalars['String']['output']>;
  supplierFee?: Maybe<Scalars['String']['output']>;
  telegram?: Maybe<Scalars['String']['output']>;
  thread?: Maybe<Thread>;
  token?: Maybe<Scalars['String']['output']>;
  unlimitedShipment?: Maybe<Scalars['Boolean']['output']>;
  username?: Maybe<Scalars['String']['output']>;
  vat?: Maybe<Scalars['String']['output']>;
  verifiedBankAccount?: Maybe<Scalars['String']['output']>;
  verifiedBy?: Maybe<Admin>;
  verifiedDate?: Maybe<Scalars['String']['output']>;
  wechatID?: Maybe<Scalars['String']['output']>;
  zoneID?: Maybe<Scalars['Int']['output']>;
};

export type SupplierAddress = {
  __typename?: 'SupplierAddress';
  addressName?: Maybe<Scalars['String']['output']>;
  default?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type SupplierAddressInput = {
  addressName?: InputMaybe<Scalars['String']['input']>;
  lat?: InputMaybe<Scalars['Float']['input']>;
  lng?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type SupplierBalance = {
  __typename?: 'SupplierBalance';
  availableBalance?: Maybe<Scalars['Float']['output']>;
  data?: Maybe<Scalars['JSON']['output']>;
  holdBalance?: Maybe<Scalars['Float']['output']>;
  page?: Maybe<Pagination>;
  totalBalance?: Maybe<Scalars['Float']['output']>;
};

export type SupplierBalanceSummary = {
  __typename?: 'SupplierBalanceSummary';
  availableBalance?: Maybe<Scalars['Float']['output']>;
  holdBalance?: Maybe<Scalars['Float']['output']>;
  totalBalance?: Maybe<Scalars['Float']['output']>;
};

export type SupplierBankChangeLog = {
  __typename?: 'SupplierBankChangeLog';
  changedDate?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  newValue?: Maybe<Scalars['JSON']['output']>;
  oldValue?: Maybe<Scalars['JSON']['output']>;
  supplierId?: Maybe<Scalars['Int']['output']>;
};

export enum SupplierBannedReason {
  None = 'NONE',
  SuspensionOfService = 'SUSPENSION_OF_SERVICE'
}

export type SupplierClickThroughRate = {
  __typename?: 'SupplierClickThroughRate';
  clicks?: Maybe<Scalars['Int']['output']>;
  product?: Maybe<BasicProduct>;
  reach?: Maybe<Scalars['Int']['output']>;
  sales?: Maybe<Scalars['Float']['output']>;
  salesQty?: Maybe<Scalars['Int']['output']>;
};

export type SupplierConlidate = {
  __typename?: 'SupplierConlidate';
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  order?: Maybe<Scalars['Int']['output']>;
  supplier?: Maybe<Supplier>;
};

export enum SupplierCtrDetailType {
  Click = 'CLICK',
  Reach = 'REACH',
  Sales = 'SALES'
}

export type SupplierCustomer = {
  __typename?: 'SupplierCustomer';
  address?: Maybe<Scalars['String']['output']>;
  addressInstruction?: Maybe<Scalars['String']['output']>;
  anonymous?: Maybe<Scalars['Boolean']['output']>;
  balance?: Maybe<Scalars['String']['output']>;
  customerId?: Maybe<Scalars['Int']['output']>;
  fbName?: Maybe<Scalars['String']['output']>;
  gender?: Maybe<Gender>;
  id?: Maybe<Scalars['Int']['output']>;
  lat?: Maybe<Scalars['String']['output']>;
  lng?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  savingPoint?: Maybe<Scalars['Int']['output']>;
  supplierId?: Maybe<Scalars['Int']['output']>;
};

export type SupplierCustomerAddress = {
  __typename?: 'SupplierCustomerAddress';
  addressName?: Maybe<Scalars['String']['output']>;
  customerName?: Maybe<Scalars['String']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  packageId?: Maybe<Scalars['Int']['output']>;
  successAt?: Maybe<Scalars['String']['output']>;
};

export type SupplierCustomerInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  addressInstruction?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Gender>;
  lat?: InputMaybe<Scalars['String']['input']>;
  lng?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
};

export type SupplierCustorder = {
  address?: InputMaybe<Scalars['String']['input']>;
  audioAddress?: InputMaybe<Scalars['String']['input']>;
  deliveryFee?: InputMaybe<Scalars['Float']['input']>;
  items?: InputMaybe<Array<InputMaybe<SupplierCustorderItem>>>;
  paidAmount?: InputMaybe<Scalars['Float']['input']>;
  paymentLink?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  proof?: InputMaybe<Scalars['String']['input']>;
  sellerCustomerId?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<SupplierCustorderStatus>;
  totalAmount?: InputMaybe<Scalars['Float']['input']>;
};

export type SupplierCustorderItem = {
  coid?: InputMaybe<Scalars['Int']['input']>;
  discount?: InputMaybe<Scalars['Float']['input']>;
  itemId?: InputMaybe<Scalars['Int']['input']>;
  productPrice?: InputMaybe<Scalars['Float']['input']>;
  qty?: InputMaybe<Scalars['Int']['input']>;
  salePrice?: InputMaybe<Scalars['Float']['input']>;
  skuId?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<SupplierCustorderItemStatus>;
};

export enum SupplierCustorderItemStatus {
  Deleted = 'DELETED',
  Delivering = 'DELIVERING',
  Finding = 'FINDING',
  Found = 'FOUND',
  Ready = 'READY',
  Sold = 'SOLD'
}

export enum SupplierCustorderStatus {
  Deleted = 'DELETED',
  Delivering = 'DELIVERING',
  Paid = 'PAID',
  Print = 'PRINT',
  Sold = 'SOLD',
  Unpaid = 'UNPAID'
}

export type SupplierDisbursementItem = {
  __typename?: 'SupplierDisbursementItem';
  amount?: Maybe<Scalars['Float']['output']>;
  coid?: Maybe<Scalars['Int']['output']>;
  color?: Maybe<Scalars['String']['output']>;
  commission?: Maybe<Scalars['Float']['output']>;
  deliveryFee?: Maybe<Scalars['Float']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  handlingFee?: Maybe<Scalars['Float']['output']>;
  item?: Maybe<BasicProduct>;
  orderId?: Maybe<Scalars['String']['output']>;
  orderUUID?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  qty?: Maybe<Scalars['Int']['output']>;
  size?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type SupplierDisbursementList = {
  __typename?: 'SupplierDisbursementList';
  data?: Maybe<Array<Maybe<Scalars['JSON']['output']>>>;
  page?: Maybe<Pagination>;
};

export type SupplierEarningBalance = {
  __typename?: 'SupplierEarningBalance';
  amount?: Maybe<Scalars['String']['output']>;
};

export type SupplierEventAdded = {
  __typename?: 'SupplierEventAdded';
  message?: Maybe<Scalars['String']['output']>;
  payload?: Maybe<Scalars['JSON']['output']>;
  supplierId?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type SupplierFblInventoryList = {
  __typename?: 'SupplierFBLInventoryList';
  data?: Maybe<Array<Maybe<Product>>>;
  page?: Maybe<Pagination>;
};

export type SupplierFbOrder = {
  __typename?: 'SupplierFbOrder';
  address?: Maybe<Scalars['String']['output']>;
  amount?: Maybe<Scalars['Float']['output']>;
  audio?: Maybe<Scalars['String']['output']>;
  deletedDate?: Maybe<Scalars['String']['output']>;
  deliveryFee?: Maybe<Scalars['Float']['output']>;
  fbId?: Maybe<Scalars['String']['output']>;
  fbName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  items?: Maybe<Array<Maybe<SupplierFbOrderItem>>>;
  linkId?: Maybe<Scalars['String']['output']>;
  orderDate?: Maybe<Scalars['String']['output']>;
  package?: Maybe<Package>;
  paid?: Maybe<Scalars['Float']['output']>;
  paidDate?: Maybe<Scalars['String']['output']>;
  payments?: Maybe<Scalars['JSON']['output']>;
  printDate?: Maybe<Scalars['String']['output']>;
  soldDate?: Maybe<Scalars['String']['output']>;
  status?: Maybe<FbOrderStatus>;
  supplier?: Maybe<Supplier>;
  supplierCustomer?: Maybe<Scalars['JSON']['output']>;
};

export type SupplierFbOrderItem = {
  __typename?: 'SupplierFbOrderItem';
  alias?: Maybe<Scalars['JSON']['output']>;
  colorList?: Maybe<Array<Maybe<ProductOptionColor>>>;
  discount?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  item?: Maybe<BasicProduct>;
  orderId?: Maybe<Scalars['Int']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  qty?: Maybe<Scalars['Int']['output']>;
  sku?: Maybe<StockKeepingUnit>;
  skuId?: Maybe<Scalars['Int']['output']>;
};

export enum SupplierFeeDateType {
  InputDate = 'INPUT_DATE',
  Invoice = 'INVOICE'
}

export type SupplierFeeItem = {
  __typename?: 'SupplierFeeItem';
  addedBy?: Maybe<Admin>;
  amount?: Maybe<Scalars['Float']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
};

export type SupplierHoldList = {
  __typename?: 'SupplierHoldList';
  data?: Maybe<Array<Maybe<Scalars['JSON']['output']>>>;
  page?: Maybe<Pagination>;
  totalHoldAmount?: Maybe<Scalars['Float']['output']>;
};

export type SupplierInput = {
  MerchantAgreementChecked?: InputMaybe<Scalars['Boolean']['input']>;
  abaQrcode?: InputMaybe<Scalars['String']['input']>;
  active?: InputMaybe<Scalars['Boolean']['input']>;
  bannedReason?: InputMaybe<SupplierBannedReason>;
  chargeDeliveryFee?: InputMaybe<Scalars['Boolean']['input']>;
  chargeHandlingFee?: InputMaybe<Scalars['Boolean']['input']>;
  chargePickupFee?: InputMaybe<Scalars['Boolean']['input']>;
  enabledNotificationDelivered?: InputMaybe<Scalars['Boolean']['input']>;
  enabledNotificationNoteAdded?: InputMaybe<Scalars['Boolean']['input']>;
  enabledNotificationPickup?: InputMaybe<Scalars['Boolean']['input']>;
  enabledReferral?: InputMaybe<Scalars['Int']['input']>;
  exposed?: InputMaybe<Scalars['Boolean']['input']>;
  fixedDeliveryFee?: InputMaybe<Scalars['Boolean']['input']>;
  freeImagePackageFee?: InputMaybe<Scalars['Boolean']['input']>;
  freeInventoryFee?: InputMaybe<Scalars['Boolean']['input']>;
  freePackage?: InputMaybe<Scalars['Int']['input']>;
  holdDuration?: InputMaybe<Scalars['Int']['input']>;
  isSeller?: InputMaybe<Scalars['Boolean']['input']>;
  lat?: InputMaybe<Scalars['Float']['input']>;
  level?: InputMaybe<Scalars['Int']['input']>;
  lng?: InputMaybe<Scalars['Float']['input']>;
  madeInCambodia?: InputMaybe<Scalars['Boolean']['input']>;
  origin?: InputMaybe<Origin>;
  packageSettlementOption?: InputMaybe<PackageSettlementOption>;
  packageUI?: InputMaybe<PackageCreatedWith>;
  password?: InputMaybe<Scalars['String']['input']>;
  responsibleBy?: InputMaybe<Scalars['Int']['input']>;
  sellerType?: InputMaybe<SellerType>;
  shellStore?: InputMaybe<Scalars['Int']['input']>;
  sponsored?: InputMaybe<Scalars['Boolean']['input']>;
  telegram?: InputMaybe<Scalars['String']['input']>;
  unlimitedShipment?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SupplierInventoryFee = {
  __typename?: 'SupplierInventoryFee';
  fblProcessingFee?: Maybe<Scalars['String']['output']>;
  fblRemovalFee?: Maybe<Scalars['String']['output']>;
  storageFee?: Maybe<Scalars['String']['output']>;
};

export type SupplierInventoryInfo = {
  __typename?: 'SupplierInventoryInfo';
  fblProduct?: Maybe<Scalars['Int']['output']>;
  stockRetailPrice?: Maybe<Scalars['Float']['output']>;
  supplierFee?: Maybe<SupplierInventoryFee>;
  totalStock?: Maybe<Scalars['Int']['output']>;
  totalVolumes?: Maybe<Scalars['Float']['output']>;
  unpaidInventoryFee?: Maybe<Scalars['Float']['output']>;
  unpaidProcessingFee?: Maybe<Scalars['Float']['output']>;
  unpaidProcessingUnits?: Maybe<Scalars['Int']['output']>;
  unpaidRemovalFee?: Maybe<Scalars['Float']['output']>;
  unpaidRemovalUnits?: Maybe<Scalars['Int']['output']>;
};

export type SupplierInventoryMonitor = {
  __typename?: 'SupplierInventoryMonitor';
  brand?: Maybe<Brand>;
  currentStock?: Maybe<Scalars['Int']['output']>;
  damage?: Maybe<Scalars['Int']['output']>;
  lostQty?: Maybe<Scalars['Int']['output']>;
  product?: Maybe<BasicProduct>;
  recycleIn?: Maybe<Scalars['Int']['output']>;
  remoteSaleQty?: Maybe<Scalars['Int']['output']>;
  remoteSoldQty?: Maybe<Scalars['Int']['output']>;
  returned?: Maybe<Scalars['Int']['output']>;
  saleQty?: Maybe<Scalars['Int']['output']>;
  soldQty?: Maybe<Scalars['Int']['output']>;
  stockOut?: Maybe<Scalars['Int']['output']>;
  totalStockIn?: Maybe<Scalars['Int']['output']>;
  uncollected?: Maybe<Scalars['Int']['output']>;
  vendor?: Maybe<SupplierVendor>;
};

export enum SupplierInventoryMonitorGroupBy {
  Brand = 'BRAND',
  Item = 'ITEM',
  Vendor = 'VENDOR'
}

export type SupplierInventoryMonitorList = {
  __typename?: 'SupplierInventoryMonitorList';
  data?: Maybe<Array<Maybe<SupplierInventoryMonitor>>>;
  page?: Maybe<Pagination>;
};

export enum SupplierInventoryMonitorSortBy {
  Currentstock = 'CURRENTSTOCK',
  Lostqty = 'LOSTQTY',
  Recyclein = 'RECYCLEIN',
  Remotesaleqty = 'REMOTESALEQTY',
  Remotesoldqty = 'REMOTESOLDQTY',
  Returned = 'RETURNED',
  Saleqty = 'SALEQTY',
  Soldqty = 'SOLDQTY',
  Totalstockin = 'TOTALSTOCKIN',
  Uncollected = 'UNCOLLECTED'
}

export type SupplierInventoryStorageFeeDaily = {
  __typename?: 'SupplierInventoryStorageFeeDaily';
  amount?: Maybe<Scalars['Float']['output']>;
  date?: Maybe<Scalars['String']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

export type SupplierInventoryStorageFeeDailyList = {
  __typename?: 'SupplierInventoryStorageFeeDailyList';
  list?: Maybe<Array<Maybe<SupplierInventoryStorageFeeDaily>>>;
  totalAmount?: Maybe<Scalars['Float']['output']>;
};

export type SupplierList = {
  __typename?: 'SupplierList';
  data?: Maybe<Array<Maybe<Supplier>>>;
  page?: Maybe<Pagination>;
};

export type SupplierLocalShipper = {
  __typename?: 'SupplierLocalShipper';
  arrivedDate?: Maybe<Scalars['String']['output']>;
  createdDate?: Maybe<Scalars['String']['output']>;
  departedDate?: Maybe<Scalars['String']['output']>;
  items?: Maybe<Scalars['JSON']['output']>;
  reference?: Maybe<Scalars['String']['output']>;
  status?: Maybe<ShipperScanLogStatus>;
  success?: Maybe<Scalars['Boolean']['output']>;
  supplier?: Maybe<Supplier>;
  trackingCode?: Maybe<Scalars['String']['output']>;
};

export type SupplierLocalShipperList = {
  __typename?: 'SupplierLocalShipperList';
  data?: Maybe<Array<Maybe<SupplierLocalShipper>>>;
};

export type SupplierMediaFile = {
  __typename?: 'SupplierMediaFile';
  createdAt?: Maybe<Scalars['String']['output']>;
  folderId?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  size?: Maybe<Scalars['Int']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type SupplierMediaFolder = {
  __typename?: 'SupplierMediaFolder';
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  parentId?: Maybe<Scalars['Int']['output']>;
};

export type SupplierMediaFolderList = {
  __typename?: 'SupplierMediaFolderList';
  files?: Maybe<Array<Maybe<SupplierMediaFile>>>;
  folders?: Maybe<Array<Maybe<SupplierMediaFolder>>>;
  page?: Maybe<Pagination>;
};

export type SupplierMoreInformation = {
  __typename?: 'SupplierMoreInformation';
  address?: Maybe<Scalars['String']['output']>;
  bankAccHolderName?: Maybe<Scalars['String']['output']>;
  bankAccNumber?: Maybe<Scalars['String']['output']>;
  bankName?: Maybe<Scalars['String']['output']>;
  brandsNames?: Maybe<Scalars['String']['output']>;
  categoryIds?: Maybe<Scalars['String']['output']>;
  companyName?: Maybe<Scalars['String']['output']>;
  companyRegisterNumber?: Maybe<Scalars['String']['output']>;
  contact?: Maybe<Scalars['String']['output']>;
  coordLat?: Maybe<Scalars['String']['output']>;
  coordLng?: Maybe<Scalars['String']['output']>;
  fiscalCodeNumber?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  origin?: Maybe<Origin>;
  role?: Maybe<SupplierRole>;
  vat?: Maybe<Scalars['String']['output']>;
  zoneId?: Maybe<Scalars['Int']['output']>;
};

export type SupplierMoreInformationInput = {
  address: Scalars['String']['input'];
  bankAccHolderName?: InputMaybe<Scalars['String']['input']>;
  bankAccNumber?: InputMaybe<Scalars['String']['input']>;
  bankName?: InputMaybe<Scalars['String']['input']>;
  brandsNames?: InputMaybe<Scalars['String']['input']>;
  categoryIds?: InputMaybe<Scalars['String']['input']>;
  companyName: Scalars['String']['input'];
  companyRegisterNumber?: InputMaybe<Scalars['String']['input']>;
  contact?: InputMaybe<Scalars['String']['input']>;
  coordLat?: InputMaybe<Scalars['String']['input']>;
  coordLng?: InputMaybe<Scalars['String']['input']>;
  fiscalCodeNumber?: InputMaybe<Scalars['String']['input']>;
  isSeller?: InputMaybe<Scalars['Boolean']['input']>;
  vat?: InputMaybe<Scalars['String']['input']>;
  zoneId?: InputMaybe<Scalars['Int']['input']>;
};

export type SupplierOrderList = {
  __typename?: 'SupplierOrderList';
  code?: Maybe<Scalars['String']['output']>;
  items?: Maybe<Array<Maybe<CustomerOrderItemV2>>>;
  log?: Maybe<Array<Maybe<SupplierOrderLog>>>;
  totalDiscontinued?: Maybe<Scalars['Int']['output']>;
  totalItems?: Maybe<Scalars['Int']['output']>;
  totalOos?: Maybe<Scalars['Int']['output']>;
  totalPrepared?: Maybe<Scalars['Int']['output']>;
  totalWaiting?: Maybe<Scalars['Int']['output']>;
};

export type SupplierOrderListFilters = {
  isRemoteOrder?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<SupplierOrderListStatus>;
  supplierId?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};

export type SupplierOrderListInput = {
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<Array<InputMaybe<CustomerOrderItemStatus>>>;
  supplierId?: InputMaybe<Scalars['Int']['input']>;
  uuid?: InputMaybe<Scalars['String']['input']>;
};

export type SupplierOrderListResult = {
  __typename?: 'SupplierOrderListResult';
  data?: Maybe<Array<Maybe<SupplierOrderListV2>>>;
  instruction?: Maybe<Scalars['String']['output']>;
  pagination?: Maybe<Pagination>;
};

export type SupplierOrderListSearch = {
  orderId?: InputMaybe<Scalars['String']['input']>;
};

export enum SupplierOrderListStatus {
  Completed = 'COMPLETED',
  Prepared = 'PREPARED',
  Ready = 'READY',
  RequestedPickup = 'REQUESTED_PICKUP',
  ToPrepare = 'TO_PREPARE'
}

export type SupplierOrderListV2 = {
  __typename?: 'SupplierOrderListV2';
  date?: Maybe<Scalars['String']['output']>;
  items?: Maybe<Array<Maybe<CustomerOrderItemV2>>>;
  orderId?: Maybe<Scalars['String']['output']>;
  status?: Maybe<SupplierOrderListStatus>;
  supplier?: Maybe<Supplier>;
  totalAmount?: Maybe<Scalars['String']['output']>;
};

export type SupplierOrderLog = {
  __typename?: 'SupplierOrderLog';
  type?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type SupplierPosCustorder = {
  __typename?: 'SupplierPOSCustorder';
  customer?: Maybe<Scalars['JSON']['output']>;
  customerId?: Maybe<Scalars['Int']['output']>;
  deletedDate?: Maybe<Scalars['String']['output']>;
  deliveryFee?: Maybe<Scalars['Float']['output']>;
  items?: Maybe<Array<Maybe<SupplierPosCustorderItem>>>;
  orderDate?: Maybe<Scalars['String']['output']>;
  orderId?: Maybe<Scalars['Int']['output']>;
  paidAmount?: Maybe<Scalars['Float']['output']>;
  paidDate?: Maybe<Scalars['String']['output']>;
  soldDate?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  totalAmount?: Maybe<Scalars['Float']['output']>;
};

export type SupplierPosCustorderItem = {
  __typename?: 'SupplierPOSCustorderItem';
  coid?: Maybe<Scalars['Int']['output']>;
  deliveringDate?: Maybe<Scalars['String']['output']>;
  discount?: Maybe<Scalars['Float']['output']>;
  findingDate?: Maybe<Scalars['String']['output']>;
  foundDate?: Maybe<Scalars['String']['output']>;
  item?: Maybe<BasicProduct>;
  orderId?: Maybe<Scalars['Int']['output']>;
  package?: Maybe<Scalars['JSON']['output']>;
  productPrice?: Maybe<Scalars['Float']['output']>;
  qty?: Maybe<Scalars['Int']['output']>;
  readyDate?: Maybe<Scalars['String']['output']>;
  salePrice?: Maybe<Scalars['Float']['output']>;
  sku?: Maybe<Scalars['JSON']['output']>;
  soldDate?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

export type SupplierPackageSalesDaily = {
  __typename?: 'SupplierPackageSalesDaily';
  date?: Maybe<Scalars['String']['output']>;
  totalCustomer?: Maybe<Scalars['Int']['output']>;
  totalPackage?: Maybe<Scalars['Int']['output']>;
  totalRevenue?: Maybe<Scalars['Float']['output']>;
};

export type SupplierPackageSalesReport = {
  __typename?: 'SupplierPackageSalesReport';
  customerInfo?: Maybe<CustomerPackageInfoSummary>;
  dailyBreakdown?: Maybe<Array<Maybe<SupplierPackageSalesDaily>>>;
  pacakgeInfo?: Maybe<PackageInfoSummary>;
};

export type SupplierPaymentHistory = {
  __typename?: 'SupplierPaymentHistory';
  BrokerBalance?: Maybe<Scalars['Float']['output']>;
  addedDate?: Maybe<Scalars['String']['output']>;
  admin?: Maybe<Admin>;
  affiliate?: Maybe<CustomerBasic>;
  credit?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  paymentType?: Maybe<Scalars['String']['output']>;
  proof?: Maybe<Scalars['String']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
  supplier?: Maybe<Supplier>;
};

export type SupplierProduct = {
  __typename?: 'SupplierProduct';
  alias?: Maybe<Scalars['JSON']['output']>;
  color?: Maybe<Scalars['String']['output']>;
  count?: Maybe<Scalars['Int']['output']>;
  product?: Maybe<BasicProduct>;
  qty?: Maybe<Scalars['Int']['output']>;
  size?: Maybe<Scalars['String']['output']>;
  sku?: Maybe<Array<Maybe<StockKeepingUnit>>>;
  skuId?: Maybe<Scalars['Int']['output']>;
  supplierStock?: Maybe<Scalars['Int']['output']>;
  val?: Maybe<Scalars['String']['output']>;
};

export type SupplierProductAliasCode = {
  __typename?: 'SupplierProductAliasCode';
  items?: Maybe<Array<Maybe<SupplierProduct>>>;
  list?: Maybe<Array<Maybe<SupplierProduct>>>;
  summary?: Maybe<Scalars['JSON']['output']>;
};

export enum SupplierProductApproved {
  Available = 'AVAILABLE',
  Discontinue = 'DISCONTINUE',
  DiscountOffer = 'DISCOUNT_OFFER',
  NotApproved = 'NOT_APPROVED',
  OutOfStock = 'OUT_OF_STOCK'
}

export type SupplierProductPerformance = {
  __typename?: 'SupplierProductPerformance';
  addToCart?: Maybe<Scalars['Int']['output']>;
  brand?: Maybe<Brand>;
  category?: Maybe<Category>;
  clicks?: Maybe<Scalars['Int']['output']>;
  currentStock?: Maybe<Scalars['Int']['output']>;
  discountRate?: Maybe<Scalars['Float']['output']>;
  firstSold?: Maybe<Scalars['String']['output']>;
  hot?: Maybe<Scalars['Float']['output']>;
  inputDate?: Maybe<Scalars['String']['output']>;
  itemCount?: Maybe<Scalars['Int']['output']>;
  lastSold?: Maybe<Scalars['String']['output']>;
  mostSoldMonth?: Maybe<Scalars['String']['output']>;
  mostSoldPerMonth?: Maybe<Scalars['Int']['output']>;
  product?: Maybe<BasicProduct>;
  reach?: Maybe<Scalars['Int']['output']>;
  returnedRate?: Maybe<Scalars['Float']['output']>;
  revenue?: Maybe<Scalars['Float']['output']>;
  soldQty?: Maybe<Scalars['Int']['output']>;
  transactionCount?: Maybe<Scalars['Int']['output']>;
  uncollectedRate?: Maybe<Scalars['Float']['output']>;
  vendor?: Maybe<SupplierVendor>;
};

export type SupplierProductPerformanceList = {
  __typename?: 'SupplierProductPerformanceList';
  data?: Maybe<Array<Maybe<SupplierProductPerformance>>>;
  page?: Maybe<Pagination>;
};

export enum SupplierProductPerformanceSortBy {
  Addtocart = 'ADDTOCART',
  Clicks = 'CLICKS',
  Currentstock = 'CURRENTSTOCK',
  Discountrate = 'DISCOUNTRATE',
  Hot = 'HOT',
  Inputdate = 'INPUTDATE',
  Itemcount = 'ITEMCOUNT',
  Mostsoldpermonth = 'MOSTSOLDPERMONTH',
  Reach = 'REACH',
  Returnedrate = 'RETURNEDRATE',
  Revenue = 'REVENUE',
  Soldqty = 'SOLDQTY',
  Transactioncount = 'TRANSACTIONCOUNT',
  Uncollectedrate = 'UNCOLLECTEDRATE'
}

export type SupplierProductRequest = {
  __typename?: 'SupplierProductRequest';
  brand?: Maybe<SupplierProductRequestBrand>;
  colorLock?: Maybe<Scalars['String']['output']>;
  content?: Maybe<Scalars['JSON']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  itemid?: Maybe<Scalars['Int']['output']>;
  option?: Maybe<ProductOption>;
  rejectedReason?: Maybe<Scalars['String']['output']>;
  revenue?: Maybe<Scalars['String']['output']>;
  sizeLock?: Maybe<Scalars['String']['output']>;
  skuList?: Maybe<Array<Maybe<Sku>>>;
  soldQty?: Maybe<Scalars['String']['output']>;
  status?: Maybe<SupplierStatusRequest>;
  supplier?: Maybe<Supplier>;
  type?: Maybe<SupplierProductApproved>;
  vendor?: Maybe<SupplierProductRequestSupplierVendor>;
  warranty?: Maybe<DigitalWarranty>;
};

export type SupplierProductRequestBrand = {
  __typename?: 'SupplierProductRequestBrand';
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type SupplierProductRequestList = {
  __typename?: 'SupplierProductRequestList';
  data?: Maybe<Array<Maybe<SupplierProductRequest>>>;
  page?: Maybe<Pagination>;
};

export type SupplierProductRequestSupplierVendor = {
  __typename?: 'SupplierProductRequestSupplierVendor';
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export enum SupplierProudctPerformanceGroupBy {
  Brand = 'BRAND',
  Category = 'CATEGORY',
  Item = 'ITEM',
  Vendor = 'VENDOR'
}

export type SupplierReachClickSales = {
  __typename?: 'SupplierReachClickSales';
  clicks?: Maybe<Scalars['Int']['output']>;
  date?: Maybe<Scalars['String']['output']>;
  reach?: Maybe<Scalars['Int']['output']>;
  sales?: Maybe<Scalars['Int']['output']>;
};

export type SupplierReachClickSalesProduct = {
  __typename?: 'SupplierReachClickSalesProduct';
  clicks?: Maybe<Scalars['Int']['output']>;
  product?: Maybe<BasicProduct>;
  reach?: Maybe<Scalars['Int']['output']>;
  sales?: Maybe<Scalars['Int']['output']>;
};

export type SupplierRegisterInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  companyName?: InputMaybe<Scalars['String']['input']>;
  coordLat?: InputMaybe<Scalars['String']['input']>;
  coordLng?: InputMaybe<Scalars['String']['input']>;
  origin: Origin;
  password: Scalars['String']['input'];
  username: Scalars['String']['input'];
};

export type SupplierRequestPickupAbility = {
  __typename?: 'SupplierRequestPickupAbility';
  canPickup?: Maybe<Scalars['Boolean']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
};

export type SupplierRestockingFilterInput = {
  itemId?: InputMaybe<Scalars['Int']['input']>;
  productCode?: InputMaybe<Scalars['String']['input']>;
  reference?: InputMaybe<Scalars['String']['input']>;
  skudId?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<RestockingStatus>;
};

export type SupplierRestockingList = {
  __typename?: 'SupplierRestockingList';
  cancelledAt?: Maybe<Scalars['String']['output']>;
  completedAt?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  qty?: Maybe<Scalars['Int']['output']>;
  reference?: Maybe<Scalars['String']['output']>;
  sku?: Maybe<StockKeepingUnit>;
  skuId?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<RestockingStatus>;
};

export enum SupplierReviewStatus {
  Pending = 'PENDING',
  Rejected = 'REJECTED',
  Reviewed = 'REVIEWED'
}

export enum SupplierRole {
  Agent = 'AGENT',
  FblVendor = 'FBL_VENDOR',
  LogisticShipper = 'LOGISTIC_SHIPPER',
  Recruiter = 'RECRUITER',
  Seller = 'SELLER',
  Shipper = 'SHIPPER',
  Store = 'STORE',
  Vendor = 'VENDOR'
}

export type SupplierSale = {
  __typename?: 'SupplierSale';
  data?: Maybe<Array<Maybe<MerchantOrderItem>>>;
  page?: Maybe<Pagination>;
  summary?: Maybe<Array<Maybe<SupplierSaleSummary>>>;
};

export type SupplierSaleDailyList = {
  __typename?: 'SupplierSaleDailyList';
  data?: Maybe<Array<Maybe<Scalars['JSON']['output']>>>;
  page?: Maybe<Pagination>;
};

export type SupplierSaleSummary = {
  __typename?: 'SupplierSaleSummary';
  completed?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  return?: Maybe<SupplierSaleSummaryReturn>;
  sale?: Maybe<Scalars['Float']['output']>;
  sold?: Maybe<Scalars['Float']['output']>;
};

export type SupplierSaleSummaryReturn = {
  __typename?: 'SupplierSaleSummaryReturn';
  amount?: Maybe<Scalars['Float']['output']>;
  total?: Maybe<Scalars['Float']['output']>;
};

export type SupplierSetting = {
  __typename?: 'SupplierSetting';
  affiliateThirdPartyBank?: Maybe<Scalars['JSON']['output']>;
  enabledChat?: Maybe<Scalars['Boolean']['output']>;
  exchangeRate?: Maybe<Scalars['Int']['output']>;
  minimumDeliverTime?: Maybe<Scalars['Int']['output']>;
  packageReachLimitMessage?: Maybe<Scalars['String']['output']>;
  packageValueLimit?: Maybe<Scalars['Int']['output']>;
};

export type SupplierShipmentAndPurchaseOrderReceived = {
  __typename?: 'SupplierShipmentAndPurchaseOrderReceived';
  code?: Maybe<Scalars['String']['output']>;
  date?: Maybe<Scalars['String']['output']>;
  received?: Maybe<Scalars['Int']['output']>;
  sent?: Maybe<Scalars['Int']['output']>;
};

export type SupplierShipmentAndPurchaseOrderReceivedList = {
  __typename?: 'SupplierShipmentAndPurchaseOrderReceivedList';
  list?: Maybe<Array<Maybe<SupplierShipmentAndPurchaseOrderReceived>>>;
  totalReceived?: Maybe<Scalars['Int']['output']>;
  totalSent?: Maybe<Scalars['Int']['output']>;
};

export type SupplierShipper = {
  __typename?: 'SupplierShipper';
  code?: Maybe<Scalars['String']['output']>;
  items?: Maybe<Array<Maybe<SupplierShipperLog>>>;
  latestUpdate?: Maybe<Scalars['String']['output']>;
  order?: Maybe<Scalars['Int']['output']>;
  package?: Maybe<Scalars['Int']['output']>;
  shipment?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<ShipperScanLogStatus>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type SupplierShipperLog = {
  __typename?: 'SupplierShipperLog';
  arrivedDate?: Maybe<Scalars['String']['output']>;
  code?: Maybe<Scalars['String']['output']>;
  createdDate?: Maybe<Scalars['String']['output']>;
  departedDate?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
  reference?: Maybe<Scalars['String']['output']>;
  status?: Maybe<ShipperScanLogStatus>;
  supplier?: Maybe<Supplier>;
};

export enum SupplierStatusRequest {
  Approved = 'APPROVED',
  Availability = 'AVAILABILITY',
  Cancel = 'CANCEL',
  Drafting = 'DRAFTING',
  Duplicated = 'DUPLICATED',
  Incomplete = 'INCOMPLETE',
  Reject = 'REJECT',
  Template = 'TEMPLATE'
}

export type SupplierTopUpBalance = {
  __typename?: 'SupplierTopUpBalance';
  amount?: Maybe<Scalars['String']['output']>;
  topupDate?: Maybe<Scalars['String']['output']>;
};

export type SupplierTopUpBalanceList = {
  __typename?: 'SupplierTopUpBalanceList';
  data?: Maybe<Array<Maybe<SupplierTopUpBalance>>>;
  page?: Maybe<Pagination>;
};

export type SupplierTotalList = {
  __typename?: 'SupplierTotalList';
  data?: Maybe<Array<Maybe<Scalars['JSON']['output']>>>;
  page?: Maybe<Pagination>;
};

export type SupplierUploadDraftList = {
  __typename?: 'SupplierUploadDraftList';
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type SupplierVendor = {
  __typename?: 'SupplierVendor';
  address?: Maybe<Scalars['String']['output']>;
  contactInfo?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  margin?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  supplier?: Maybe<Supplier>;
};

export type SupplierVendorInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  contactInfo?: InputMaybe<Scalars['String']['input']>;
  margin?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
};

export type Tag = {
  __typename?: 'Tag';
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export enum TagType {
  PurchaseOrder = 'PURCHASE_ORDER'
}

export type TelegramMessageInput = {
  image?: InputMaybe<Scalars['String']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
};

export type ThirdPartyProviderFee = {
  __typename?: 'ThirdPartyProviderFee';
  fee?: Maybe<Scalars['Decimal']['output']>;
  provider?: Maybe<Scalars['String']['output']>;
};

export type Thread = {
  __typename?: 'Thread';
  comments?: Maybe<Array<Maybe<ThreadComment>>>;
  count?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['Int']['output']>;
  followUpAt?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
};


export type ThreadCommentsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortOrder>;
};

export type ThreadComment = {
  __typename?: 'ThreadComment';
  attachments?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  by?: Maybe<Entity>;
  content?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Int']['output']>;
  followUpAt?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  taskCompleted?: Maybe<Scalars['Boolean']['output']>;
  taskCompletedAt?: Maybe<Scalars['Int']['output']>;
  taskCompletedBy?: Maybe<Entity>;
  threadId?: Maybe<Scalars['String']['output']>;
  type?: Maybe<ThreadCommentType>;
};

export enum ThreadCommentType {
  Comment = 'COMMENT',
  Task = 'TASK'
}

export type TotalHoldBalance = {
  __typename?: 'TotalHoldBalance';
  availableBalance?: Maybe<Scalars['String']['output']>;
  disbursementBalance?: Maybe<Scalars['String']['output']>;
  disbursementPaid?: Maybe<Scalars['String']['output']>;
  disbursementProcess?: Maybe<Scalars['String']['output']>;
  feeBalance?: Maybe<Scalars['String']['output']>;
  holdBalance?: Maybe<Scalars['String']['output']>;
  lastUpdated?: Maybe<Scalars['String']['output']>;
  onOrdering?: Maybe<Scalars['String']['output']>;
  totalBalance?: Maybe<Scalars['String']['output']>;
};

export type TrackingCode = {
  __typename?: 'TrackingCode';
  createDate?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
  reference?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
  trackingCode?: Maybe<Scalars['String']['output']>;
};

export type TrackingCodeList = {
  __typename?: 'TrackingCodeList';
  end?: Maybe<Scalars['String']['output']>;
  fail?: Maybe<Scalars['Int']['output']>;
  from?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Int']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
  trackingCode?: Maybe<Scalars['String']['output']>;
};

export type TransitPackageBreakdown = {
  __typename?: 'TransitPackageBreakdown';
  hub?: Maybe<Warehouse>;
  nextHubs?: Maybe<Array<Maybe<HubPackage>>>;
};

export enum TrueFalse {
  F = 'F',
  T = 'T'
}

export type UnreadMessage = {
  __typename?: 'UnreadMessage';
  channelId?: Maybe<Scalars['String']['output']>;
  unreadCount?: Maybe<Scalars['Int']['output']>;
};

export type UnsettlePackagePayment = {
  __typename?: 'UnsettlePackagePayment';
  amount?: Maybe<Scalars['String']['output']>;
  appointedAt?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  customer?: Maybe<CustomerBasic>;
  customerName?: Maybe<Scalars['String']['output']>;
  deliveryPerson?: Maybe<Admin>;
  expectedAmount?: Maybe<Scalars['String']['output']>;
  fee?: Maybe<Scalars['String']['output']>;
  hub?: Maybe<Warehouse>;
  isPrepayment?: Maybe<Scalars['Boolean']['output']>;
  isSettledWithHq?: Maybe<Scalars['Boolean']['output']>;
  isSettledWithHub?: Maybe<Scalars['Boolean']['output']>;
  isSettledWithSeller?: Maybe<Scalars['Boolean']['output']>;
  package?: Maybe<Package>;
  packageId?: Maybe<Scalars['Int']['output']>;
  requestPickupAt?: Maybe<Scalars['String']['output']>;
  seller?: Maybe<Supplier>;
  settledWithHubAt?: Maybe<Scalars['String']['output']>;
  settledWithThirdPartyAt?: Maybe<Scalars['String']['output']>;
  settledWithThirdPartyBy?: Maybe<Admin>;
  successAt?: Maybe<Scalars['String']['output']>;
};

export type UnverifiedBankTransfer = {
  __typename?: 'UnverifiedBankTransfer';
  accountant?: Maybe<Admin>;
  accountantReviewDate?: Maybe<Scalars['String']['output']>;
  agentApproveDate?: Maybe<Scalars['String']['output']>;
  agentRejectedDate?: Maybe<Scalars['String']['output']>;
  amount?: Maybe<Scalars['String']['output']>;
  batchId?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  customer?: Maybe<CustomerBasic>;
  id?: Maybe<Scalars['Int']['output']>;
  isAgentApproved?: Maybe<Scalars['Boolean']['output']>;
  isAgentRejected?: Maybe<Scalars['Boolean']['output']>;
  iskhAmount?: Maybe<Scalars['Boolean']['output']>;
  khAmount?: Maybe<Scalars['String']['output']>;
  onlineReviewDate?: Maybe<Scalars['String']['output']>;
  onlineStaff?: Maybe<Admin>;
  paymentLink?: Maybe<Scalars['String']['output']>;
  paymentType?: Maybe<PaymentType>;
  proof?: Maybe<Scalars['String']['output']>;
  secretCode?: Maybe<Scalars['String']['output']>;
  service?: Maybe<Scalars['String']['output']>;
  status?: Maybe<BankTransferProofStatusType>;
  supplier?: Maybe<Supplier>;
  uploader?: Maybe<Admin>;
};

export type UpdateCartResponse = {
  __typename?: 'UpdateCartResponse';
  count: Scalars['Int']['output'];
};

export type UploadAdditionalOptions = {
  fileName?: InputMaybe<Scalars['String']['input']>;
  folderId?: InputMaybe<Scalars['Int']['input']>;
};

export type UploadedFile = {
  __typename?: 'UploadedFile';
  filename: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type UsedCustomerPayment = {
  __typename?: 'UsedCustomerPayment';
  createdAt?: Maybe<Scalars['String']['output']>;
  payment?: Maybe<CustomerPaymentHistory>;
  usedAmount?: Maybe<Scalars['Float']['output']>;
};

export type UserPost = {
  __typename?: 'UserPost';
  attachments?: Maybe<Array<Maybe<UserPostAttachment>>>;
  category?: Maybe<Category>;
  commentCount?: Maybe<Scalars['Int']['output']>;
  condition?: Maybe<UserPostConditionType>;
  createdAt?: Maybe<Scalars['Int']['output']>;
  createdBy?: Maybe<CustomerBasic>;
  hasLiked?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  isService?: Maybe<Scalars['Boolean']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  likeCount?: Maybe<Scalars['Int']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  products?: Maybe<Array<Maybe<BasicProduct>>>;
  provinceName?: Maybe<Scalars['String']['output']>;
  shareCount?: Maybe<Scalars['Int']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  viewCount?: Maybe<Scalars['Int']['output']>;
};

export type UserPostAttachment = {
  __typename?: 'UserPostAttachment';
  src?: Maybe<Scalars['String']['output']>;
  thumbnail?: Maybe<Scalars['String']['output']>;
  type?: Maybe<UserPostAttachmentType>;
};

export type UserPostAttachmentInput = {
  src: Scalars['String']['input'];
  thumbnail?: InputMaybe<Scalars['String']['input']>;
  type: UserPostAttachmentType;
};

export enum UserPostAttachmentType {
  Image = 'IMAGE',
  Video = 'VIDEO'
}

export type UserPostComment = {
  __typename?: 'UserPostComment';
  attachments?: Maybe<Array<Maybe<UserPostAttachment>>>;
  createdAt?: Maybe<Scalars['Int']['output']>;
  createdBy?: Maybe<CustomerBasic>;
  hasLiked?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  likeCount?: Maybe<Scalars['Int']['output']>;
  parentCommentId?: Maybe<Scalars['Int']['output']>;
  postId?: Maybe<Scalars['Int']['output']>;
  replyCount?: Maybe<Scalars['Int']['output']>;
  text?: Maybe<Scalars['String']['output']>;
};

export type UserPostCommentInput = {
  attachments?: InputMaybe<Array<InputMaybe<UserPostAttachmentInput>>>;
  text: Scalars['String']['input'];
};

export enum UserPostConditionType {
  New = 'NEW',
  UsedFair = 'USED_FAIR',
  UsedGood = 'USED_GOOD',
  UsedLikeNew = 'USED_LIKE_NEW'
}

export type UserPostInput = {
  attachments?: InputMaybe<Array<InputMaybe<UserPostAttachmentInput>>>;
  categoryId?: InputMaybe<Scalars['Int']['input']>;
  condition?: InputMaybe<UserPostConditionType>;
  isService?: InputMaybe<Scalars['Boolean']['input']>;
  lat?: InputMaybe<Scalars['Float']['input']>;
  lng?: InputMaybe<Scalars['Float']['input']>;
  price?: InputMaybe<Scalars['Float']['input']>;
  productIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  provinceName?: InputMaybe<Scalars['String']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
};

export type UserPostPagination = {
  __typename?: 'UserPostPagination';
  items?: Maybe<Array<Maybe<UserPost>>>;
  nextPageToken?: Maybe<Scalars['String']['output']>;
};

export type UserProfile = {
  __typename?: 'UserProfile';
  bio?: Maybe<Scalars['String']['output']>;
  chatChannel?: Maybe<Scalars['String']['output']>;
  followerCount?: Maybe<Scalars['Int']['output']>;
  followingCount?: Maybe<Scalars['Int']['output']>;
  hasFollowed?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  image?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  totalLikes?: Maybe<Scalars['Int']['output']>;
};

export type ValidationResult = {
  __typename?: 'ValidationResult';
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type VerifyCustomerResponse = {
  __typename?: 'VerifyCustomerResponse';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type VerifyPackageAddressInput = {
  attachment?: InputMaybe<Scalars['String']['input']>;
  coordinate?: InputMaybe<MapCoordinateInput>;
};

export type Video = {
  __typename?: 'Video';
  id?: Maybe<Scalars['Int']['output']>;
  src?: Maybe<Scalars['String']['output']>;
  thumbnail?: Maybe<Scalars['String']['output']>;
};

export type Warehouse = {
  __typename?: 'Warehouse';
  canCustomerPickup?: Maybe<Scalars['Boolean']['output']>;
  canDeliveryPickup?: Maybe<Scalars['Boolean']['output']>;
  canTransit?: Maybe<Scalars['Boolean']['output']>;
  commune?: Maybe<Commune>;
  connectedHubs?: Maybe<Array<Maybe<Warehouse>>>;
  contacts?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  description?: Maybe<Scalars['String']['output']>;
  district?: Maybe<District>;
  driverBonus?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  isAgentHub?: Maybe<Scalars['Boolean']['output']>;
  isHub?: Maybe<Scalars['Boolean']['output']>;
  lat?: Maybe<Scalars['String']['output']>;
  lng?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  polygon?: Maybe<Scalars['JSON']['output']>;
  province?: Maybe<Province>;
  shortName?: Maybe<Scalars['String']['output']>;
  telegram?: Maybe<Scalars['String']['output']>;
  trafficLevel?: Maybe<Scalars['Int']['output']>;
  trafficMessage?: Maybe<MultiLangString>;
};

export type WarehouseInput = {
  canCustomerPickup?: InputMaybe<Scalars['Boolean']['input']>;
  canDeliveryPickup?: InputMaybe<Scalars['Boolean']['input']>;
  canTransit?: InputMaybe<Scalars['Boolean']['input']>;
  driverBonus?: InputMaybe<Scalars['String']['input']>;
  trafficLevel?: InputMaybe<Scalars['Int']['input']>;
  trafficMessage?: InputMaybe<MultiLangStringInput>;
};

export enum WarrantyDurationType {
  Day = 'DAY',
  Month = 'MONTH',
  Year = 'YEAR'
}

export type WinSpinReward = {
  __typename?: 'WinSpinReward';
  message?: Maybe<Scalars['String']['output']>;
  reward?: Maybe<SpinReward>;
};

export type Wishlist = {
  __typename?: 'Wishlist';
  custid?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  inputdate?: Maybe<Scalars['String']['output']>;
  product?: Maybe<BasicProduct>;
};

export type DiscountTier = {
  __typename?: 'discountTier';
  discount?: Maybe<Scalars['Float']['output']>;
  freeDelivery?: Maybe<Scalars['Float']['output']>;
  freeGift?: Maybe<Array<Maybe<PromoComboGift>>>;
  reach?: Maybe<Scalars['Int']['output']>;
};

export type DiscountTierInput = {
  discount?: InputMaybe<Scalars['Float']['input']>;
  freeDelivery?: InputMaybe<Scalars['Float']['input']>;
  freeGift?: InputMaybe<Array<InputMaybe<PromoComboSkuInput>>>;
  reach?: InputMaybe<Scalars['Int']['input']>;
};

export type LuckyDrawCustomerInformation = {
  __typename?: 'luckyDrawCustomerInformation';
  avilableCustomers?: Maybe<Scalars['Int']['output']>;
  notifiedCustomers?: Maybe<Scalars['Int']['output']>;
};

export type MerchantOrderDetail = {
  __typename?: 'merchantOrderDetail';
  code?: Maybe<Scalars['String']['output']>;
  color?: Maybe<Scalars['String']['output']>;
  commission?: Maybe<Scalars['String']['output']>;
  deliveryFee?: Maybe<Scalars['String']['output']>;
  handlingFee?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  netSale?: Maybe<Scalars['String']['output']>;
  orderDate?: Maybe<Scalars['String']['output']>;
  picture?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['String']['output']>;
  qty?: Maybe<Scalars['Int']['output']>;
  size?: Maybe<Scalars['String']['output']>;
  supplierCode?: Maybe<Scalars['String']['output']>;
};

export type MultiLanguageInput = {
  en?: InputMaybe<Scalars['String']['input']>;
  km?: InputMaybe<Scalars['String']['input']>;
  zh?: InputMaybe<Scalars['String']['input']>;
};

export type MultiLanguageType = {
  __typename?: 'multiLanguageType';
  en?: Maybe<Scalars['String']['output']>;
  km?: Maybe<Scalars['String']['output']>;
  zh?: Maybe<Scalars['String']['output']>;
};

export type NextHubsPackage = {
  __typename?: 'nextHubsPackage';
  hub?: Maybe<Warehouse>;
  packageCount?: Maybe<Scalars['Int']['output']>;
};

export enum NotificationType {
  AffiliateEarning = 'AFFILIATE_EARNING',
  Chat = 'CHAT',
  Comment = 'COMMENT',
  Information = 'INFORMATION',
  Like = 'LIKE',
  MarkReviewHelpful = 'MARK_REVIEW_HELPFUL',
  Other = 'OTHER',
  Promotion = 'PROMOTION'
}

export enum PartnerPermissionType {
  Admin = 'ADMIN',
  Consolidate = 'CONSOLIDATE',
  Online = 'ONLINE',
  Stock = 'STOCK'
}

export enum SellerListType {
  FeaturedStore = 'FEATURED_STORE',
  PartnerStore = 'PARTNER_STORE'
}

export type ShipmentItem = {
  receivedQty?: InputMaybe<Scalars['Int']['input']>;
  skuId?: InputMaybe<Scalars['Int']['input']>;
};

export type MerchantProductShipmentMutationVariables = Exact<{
  data?: InputMaybe<Array<InputMaybe<ProductShipmentInput>> | InputMaybe<ProductShipmentInput>>;
}>;


export type MerchantProductShipmentMutation = { __typename?: 'Mutation', merchantProductShipment?: string | null };

export type CreateSellerProductAdsV2MutationVariables = Exact<{
  data: SellerAdsV2Input;
  items: Array<InputMaybe<Scalars['Int']['input']>> | InputMaybe<Scalars['Int']['input']>;
}>;


export type CreateSellerProductAdsV2Mutation = { __typename?: 'Mutation', createSellerProductAdsV2?: number | null };

export type CreateSellerFrontBannerAdsV2MutationVariables = Exact<{
  data: SellerAdsV2Input;
  banner: AdsBannerInput;
}>;


export type CreateSellerFrontBannerAdsV2Mutation = { __typename?: 'Mutation', createSellerFrontBannerAdsV2?: number | null };

export type CreateSellerProductBannerAdsV2MutationVariables = Exact<{
  data: SellerAdsV2Input;
  banner: AdsBannerInput;
}>;


export type CreateSellerProductBannerAdsV2Mutation = { __typename?: 'Mutation', createSellerProductBannerAdsV2?: number | null };

export type UpdateSellerProductAdsV2MutationVariables = Exact<{
  updateSellerProductAdsV2Id: Scalars['Int']['input'];
  data: SellerAdsV2Input;
  items: Array<InputMaybe<Scalars['Int']['input']>> | InputMaybe<Scalars['Int']['input']>;
}>;


export type UpdateSellerProductAdsV2Mutation = { __typename?: 'Mutation', updateSellerProductAdsV2?: boolean | null };

export type UpdateSellerFrontBannerAdsV2MutationVariables = Exact<{
  updateSellerFrontBannerAdsV2Id: Scalars['Int']['input'];
  data: SellerAdsV2Input;
  banner: AdsBannerInput;
}>;


export type UpdateSellerFrontBannerAdsV2Mutation = { __typename?: 'Mutation', updateSellerFrontBannerAdsV2?: boolean | null };

export type UpdateSellerProductBannerAdsV2MutationVariables = Exact<{
  updateSellerProductBannerAdsV2Id: Scalars['Int']['input'];
  data: SellerAdsV2Input;
  banner: AdsBannerInput;
}>;


export type UpdateSellerProductBannerAdsV2Mutation = { __typename?: 'Mutation', updateSellerProductBannerAdsV2?: boolean | null };

export type SuspendSellerAdsV2MutationVariables = Exact<{
  suspendSellerAdsV2Id: Scalars['Int']['input'];
}>;


export type SuspendSellerAdsV2Mutation = { __typename?: 'Mutation', suspendSellerAdsV2?: boolean | null };

export type MerchantCreateDiscountItemMutationVariables = Exact<{
  start_date: Scalars['String']['input'];
  end_date: Scalars['String']['input'];
  data?: InputMaybe<Array<InputMaybe<ItemDiscountInput>> | InputMaybe<ItemDiscountInput>>;
}>;


export type MerchantCreateDiscountItemMutation = { __typename?: 'Mutation', merchantCreateDiscountItem?: boolean | null };

export type MerchantUpdateDiscountMutationVariables = Exact<{
  start_date: Scalars['String']['input'];
  end_date: Scalars['String']['input'];
  data?: InputMaybe<Array<InputMaybe<ItemDiscountInput>> | InputMaybe<ItemDiscountInput>>;
  campaign_id: Scalars['Int']['input'];
  delete_id?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>> | InputMaybe<Scalars['Int']['input']>>;
}>;


export type MerchantUpdateDiscountMutation = { __typename?: 'Mutation', merchantUpdateDiscount?: boolean | null };

export type MerchantInactiveDiscountCampaignMutationVariables = Exact<{
  campaignId: Scalars['Int']['input'];
}>;


export type MerchantInactiveDiscountCampaignMutation = { __typename?: 'Mutation', merchantInactiveDiscountCampaign?: boolean | null };

export type ChangeCustomerOrderItemStatusMutationVariables = Exact<{
  orderId?: InputMaybe<Scalars['String']['input']>;
  status: CustomerOrderItemStatus;
}>;


export type ChangeCustomerOrderItemStatusMutation = { __typename?: 'Mutation', changeCustomerOrderItemStatus?: { __typename?: 'CustomerOrderItemStatusResult', success?: boolean | null, assignedSlot?: string | null } | null };

export type RequestPackagePickupMutationVariables = Exact<{
  ids?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>> | InputMaybe<Scalars['Int']['input']>>;
  scheduleAt?: InputMaybe<Scalars['String']['input']>;
}>;


export type RequestPackagePickupMutation = { __typename?: 'Mutation', requestPackagePickup?: boolean | null };

export type VoidPackageMutationVariables = Exact<{
  id?: InputMaybe<Scalars['Int']['input']>;
}>;


export type VoidPackageMutation = { __typename?: 'Mutation', voidPackage?: boolean | null };

export type MassUpdateProductMutationVariables = Exact<{
  massUpdateProductId: Array<InputMaybe<Scalars['Int']['input']>> | InputMaybe<Scalars['Int']['input']>;
  data: MassProductInput;
}>;


export type MassUpdateProductMutation = { __typename?: 'Mutation', massUpdateProduct?: boolean | null };

export type ToggleSupplierChatMutationVariables = Exact<{ [key: string]: never; }>;


export type ToggleSupplierChatMutation = { __typename?: 'Mutation', toggleSupplierChat?: boolean | null };

export type RegisterSupplierMutationVariables = Exact<{
  data?: InputMaybe<SupplierRegisterInput>;
}>;


export type RegisterSupplierMutation = { __typename?: 'Mutation', registerSupplier?: { __typename?: 'LoginSupplierResponse', message?: string | null, status?: LoginSupplierResponseStatus | null, success?: boolean | null, token?: string | null, useDeliveryService?: boolean | null } | null };

export type VerifySupplierOtpMutationVariables = Exact<{
  secretCode: Scalars['String']['input'];
  verifyToken: Scalars['String']['input'];
  verifyForgeted?: InputMaybe<Scalars['Boolean']['input']>;
  isSeller?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type VerifySupplierOtpMutation = { __typename?: 'Mutation', verifySupplierOtp?: { __typename?: 'LoginSupplierResponse', message?: string | null, status?: LoginSupplierResponseStatus | null, success?: boolean | null, token?: string | null, useDeliveryService?: boolean | null } | null };

export type ResendSupplierOtpMutationVariables = Exact<{
  verifyToken: Scalars['String']['input'];
  verifyForgeted?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type ResendSupplierOtpMutation = { __typename?: 'Mutation', resendSupplierOtp?: { __typename?: 'LoginSupplierResponse', message?: string | null, status?: LoginSupplierResponseStatus | null, success?: boolean | null, token?: string | null, useDeliveryService?: boolean | null } | null };

export type UpdateSupplierMoreInformationMutationVariables = Exact<{
  verifyToken: Scalars['String']['input'];
  data?: InputMaybe<SupplierMoreInformationInput>;
  supplierId?: InputMaybe<Scalars['Int']['input']>;
}>;


export type UpdateSupplierMoreInformationMutation = { __typename?: 'Mutation', updateSupplierMoreInformation?: any | null };

export type CreateProductGroupMutationVariables = Exact<{
  data: ProductGroupInput;
}>;


export type CreateProductGroupMutation = { __typename?: 'Mutation', createProductGroup?: boolean | null };

export type UpdateProductGroupMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  data: ProductGroupInput;
}>;


export type UpdateProductGroupMutation = { __typename?: 'Mutation', updateProductGroup?: boolean | null };

export type UploadMutationVariables = Exact<{
  file: Scalars['Upload']['input'];
}>;


export type UploadMutation = { __typename?: 'Mutation', upload: { __typename?: 'UploadedFile', filename: string, url: string } };

export type UpdateMerchantInfoMutationVariables = Exact<{
  data?: InputMaybe<MerchantInput>;
}>;


export type UpdateMerchantInfoMutation = { __typename?: 'Mutation', updateMerchantInfo?: boolean | null };

export type ForgetSupplierPasswordMutationVariables = Exact<{
  username: Scalars['String']['input'];
}>;


export type ForgetSupplierPasswordMutation = { __typename?: 'Mutation', forgetSupplierPassword?: { __typename?: 'LoginSupplierResponse', success?: boolean | null, token?: string | null, message?: string | null, status?: LoginSupplierResponseStatus | null } | null };

export type ResetSupplierPasswordMutationVariables = Exact<{
  newPassword: Scalars['String']['input'];
}>;


export type ResetSupplierPasswordMutation = { __typename?: 'Mutation', resetSupplierPassword?: boolean | null };

export type PayTransitDisbursementMutationVariables = Exact<{
  disburseId: Scalars['Int']['input'];
  proof: Scalars['String']['input'];
  exchangeRate: Scalars['Decimal']['input'];
  fee?: InputMaybe<Scalars['Decimal']['input']>;
}>;


export type PayTransitDisbursementMutation = { __typename?: 'Mutation', payTransitDisbursement?: boolean | null };

export type AddToReplenishmentWishlistMutationVariables = Exact<{
  itemid: Scalars['Int']['input'];
}>;


export type AddToReplenishmentWishlistMutation = { __typename?: 'Mutation', addToReplenishmentWishlist?: number | null };

export type RemoveFromReplenishmentWishlistMutationVariables = Exact<{
  itemid: Scalars['Int']['input'];
}>;


export type RemoveFromReplenishmentWishlistMutation = { __typename?: 'Mutation', removeFromReplenishmentWishlist?: boolean | null };

export type MakeACopyProductMutationVariables = Exact<{
  itemid: Scalars['Int']['input'];
}>;


export type MakeACopyProductMutation = { __typename?: 'Mutation', makeACopyProduct?: number | null };

export type MarkRestockingSkuMutationVariables = Exact<{
  skuIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>> | InputMaybe<Scalars['Int']['input']>>;
  restocking?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type MarkRestockingSkuMutation = { __typename?: 'Mutation', markRestockingSku?: boolean | null };

export type CreateSupplierRestockingSkuMutationVariables = Exact<{
  data?: InputMaybe<Array<InputMaybe<RestockingSku>> | InputMaybe<RestockingSku>>;
}>;


export type CreateSupplierRestockingSkuMutation = { __typename?: 'Mutation', createSupplierRestockingSku?: boolean | null };

export type SetupSellerTelegramGroupMutationVariables = Exact<{
  groupId: Scalars['String']['input'];
}>;


export type SetupSellerTelegramGroupMutation = { __typename?: 'Mutation', setupSellerTelegramGroup?: boolean | null };

export type RemoveSellerTelegramGroupMutationVariables = Exact<{ [key: string]: never; }>;


export type RemoveSellerTelegramGroupMutation = { __typename?: 'Mutation', removeSellerTelegramGroup?: boolean | null };

export type MerchantQueryVariables = Exact<{ [key: string]: never; }>;


export type MerchantQuery = { __typename?: 'Query', supplierSettingList?: any | null, merchant?: { __typename?: 'Merchant', id?: number | null, name?: string | null, logo?: string | null, banner?: string | null, origin?: Origin | null, address?: string | null, contact?: string | null, emails?: string | null, registerNumber?: string | null, vat?: string | null, role?: string | null, fiscalCodeNumber?: string | null, bankAccountHoldName?: string | null, bankAccountNumber?: string | null, bankName?: string | null, ownerName?: string | null, ownerType?: string | null, ownerNumber?: string | null, coordLat?: string | null, coordLng?: string | null, approvedDate?: string | null, approvedBy?: number | null, balance?: string | null, frontStoreImage?: string | null, pos?: boolean | null, userType?: string | null, isMoreSecurity?: boolean | null, recruiterId?: number | null, abaLink?: string | null, enabledChat?: boolean | null, verifiedBankAccount?: string | null, telegramGroupId?: string | null } | null, supplierSetting?: { __typename?: 'SupplierSetting', minimumDeliverTime?: number | null, exchangeRate?: number | null, packageValueLimit?: number | null, packageReachLimitMessage?: string | null, enabledChat?: boolean | null, affiliateThirdPartyBank?: any | null } | null };

export type SupplierInventoryMonitorQueryVariables = Exact<{
  groupBy?: InputMaybe<SupplierInventoryMonitorGroupBy>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<SupplierInventoryMonitorSortBy>;
  sortDirection?: InputMaybe<SortOrder>;
  search?: InputMaybe<Scalars['String']['input']>;
}>;


export type SupplierInventoryMonitorQuery = { __typename?: 'Query', supplierInventoryMonitor?: { __typename?: 'SupplierInventoryMonitorList', data?: Array<{ __typename?: 'SupplierInventoryMonitor', totalStockIn?: number | null, currentStock?: number | null, soldQty?: number | null, saleQty?: number | null, lostQty?: number | null, recycleIn?: number | null, remoteSoldQty?: number | null, remoteSaleQty?: number | null, uncollected?: number | null, returned?: number | null, damage?: number | null, stockOut?: number | null, product?: { __typename?: 'BasicProduct', id?: number | null, code?: string | null, thumbnail?: string | null, title?: string | null } | null, brand?: { __typename?: 'Brand', id: number, name?: string | null, picture?: string | null } | null, vendor?: { __typename?: 'SupplierVendor', id: number, name?: string | null } | null } | null> | null, page?: { __typename?: 'Pagination', current?: number | null, size?: number | null, total?: number | null } | null } | null };

export type SupplierProductPerformanceQueryVariables = Exact<{
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  groupBy?: InputMaybe<SupplierProudctPerformanceGroupBy>;
  sortBy?: InputMaybe<SupplierProductPerformanceSortBy>;
  sortDirection?: InputMaybe<SortOrder>;
}>;


export type SupplierProductPerformanceQuery = { __typename?: 'Query', supplierProductPerformance?: { __typename?: 'SupplierProductPerformanceList', data?: Array<{ __typename?: 'SupplierProductPerformance', currentStock?: number | null, itemCount?: number | null, hot?: number | null, inputDate?: string | null, firstSold?: string | null, lastSold?: string | null, soldQty?: number | null, mostSoldMonth?: string | null, mostSoldPerMonth?: number | null, transactionCount?: number | null, returnedRate?: number | null, uncollectedRate?: number | null, discountRate?: number | null, revenue?: number | null, addToCart?: number | null, reach?: number | null, clicks?: number | null, product?: { __typename?: 'BasicProduct', id?: number | null, code?: string | null, title?: string | null, thumbnail?: string | null } | null, brand?: { __typename?: 'Brand', id: number, name?: string | null, picture?: string | null } | null, vendor?: { __typename?: 'SupplierVendor', id: number, name?: string | null } | null, category?: { __typename?: 'Category', currentLanguageName?: string | null } | null } | null> | null, page?: { __typename?: 'Pagination', current?: number | null, size?: number | null, total?: number | null } | null } | null };

export type SupplierPromoComboListQueryVariables = Exact<{
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<SortOrder>;
}>;


export type SupplierPromoComboListQuery = { __typename?: 'Query', supplierPromoComboList?: { __typename?: 'PromoComboList', data?: Array<{ __typename?: 'PromoCombo', id?: number | null, availableQty?: number | null, dealCriteria?: DealCriteria | null, discountType?: DiscountType | null, endDate?: string | null, minOrder?: number | null, promoName?: string | null, saleQty?: number | null, scope?: PromoComboScope | null, startDate?: string | null, status?: PromoComboStatus | null, checkoutQty?: number | null, discountTier?: Array<{ __typename?: 'discountTier', reach?: number | null, discount?: number | null, freeDelivery?: number | null, freeGift?: Array<{ __typename?: 'PromoComboGift', qty?: number | null, sku?: { __typename?: 'SKU', barcode?: string | null, id?: number | null, color?: string | null, size?: string | null } | null } | null> | null } | null> | null, products?: Array<{ __typename?: 'PromoComboItems', comboId?: number | null, createdAt?: string | null, item?: { __typename?: 'DisplayProduct', id: number, code?: string | null, title?: string | null, thumbnail?: string | null } | null } | null> | null } | null> | null, page?: { __typename?: 'Pagination', total?: number | null } | null } | null };

export type EventCampaignListQueryVariables = Exact<{
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  registered?: InputMaybe<Scalars['Boolean']['input']>;
  upcoming?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type EventCampaignListQuery = { __typename?: 'Query', eventCampaignList?: Array<{ __typename?: 'EventCampaign', id?: number | null, campaignBanner?: string | null, campaignName?: string | null, status?: string | null, registrationClosedDate?: string | null, startDate?: string | null, endDate?: string | null, minimumDiscount?: number | null } | null> | null };

export type SupplierShipmentListQueryVariables = Exact<{
  orderBy?: InputMaybe<SortOrder>;
  status?: InputMaybe<Array<InputMaybe<ShipmentLogStatus>> | InputMaybe<ShipmentLogStatus>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  abnormalStatus?: InputMaybe<Array<InputMaybe<AbnormalStatusType>> | InputMaybe<AbnormalStatusType>>;
  shipmentId?: InputMaybe<Scalars['String']['input']>;
}>;


export type SupplierShipmentListQuery = { __typename?: 'Query', supplierShipmentList?: { __typename?: 'ShipmentProductList', data?: Array<{ __typename?: 'ShipmentProduct', id?: number | null, createdAt?: string | null, qty?: number | null, received?: number | null, receivedDate?: string | null, shipperReceived?: number | null, requestDate?: string | null, tracking_number?: Array<string | null> | null, departedDate?: string | null, status?: string | null, receivedAdmin?: string | null, shipmentCode?: string | null, shipmentLog?: Array<{ __typename?: 'ShipmentLog', description?: string | null, date?: string | null } | null> | null, supplier?: { __typename?: 'Supplier', id?: number | null, name?: string | null } | null, package?: { __typename?: 'Package', id: number, uuid?: string | null } | null } | null> | null, page?: { __typename?: 'Pagination', current?: number | null, size?: number | null, total?: number | null } | null } | null };

export type SupplierDisbursementAvailableListQueryVariables = Exact<{ [key: string]: never; }>;


export type SupplierDisbursementAvailableListQuery = { __typename?: 'Query', supplierDisbursementAvailableList?: Array<{ __typename?: 'SupplierDisbursementItem', orderId?: string | null, orderUUID?: string | null, price?: number | null, color?: string | null, size?: string | null, commission?: number | null, deliveryFee?: number | null, handlingFee?: number | null, type?: string | null, amount?: number | null, description?: string | null, item?: { __typename?: 'BasicProduct', id?: number | null, code?: string | null, price?: any | null, priceAfterDiscount?: number | null, thumbnail?: string | null, supplierCode?: string | null } | null } | null> | null };

export type SupplierInternalDisbursementListQueryVariables = Exact<{
  status?: InputMaybe<DisbursementStatus>;
  supplierInternalDisbursementListId?: InputMaybe<Scalars['String']['input']>;
  supplierId?: InputMaybe<Scalars['Int']['input']>;
}>;


export type SupplierInternalDisbursementListQuery = { __typename?: 'Query', supplierInternalDisbursementList?: { __typename?: 'DisbursementItemList', data?: Array<{ __typename?: 'DisbursementItem', id?: string | null, uuid?: string | null, amount?: number | null, proof?: string | null, requestedDate?: string | null, gatewayProof?: string | null, status?: string | null, publicStatus?: string | null, supplier?: { __typename?: 'Supplier', name?: string | null, vat?: string | null, bankAccountHolderName?: string | null, bankAccountNumber?: string | null, bankName?: string | null, contact?: string | null } | null, log?: Array<{ __typename?: 'DisbursementItemLog', date?: string | null, value?: string | null, admin?: { __typename?: 'Admin', name?: string | null } | null } | null> | null } | null> | null } | null };

export type SellerAdsV2ListQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  filters?: InputMaybe<SellerAdsV2Filter>;
}>;


export type SellerAdsV2ListQuery = { __typename?: 'Query', sellerAdsV2List?: Array<{ __typename?: 'SellerAdsV2Output', id?: number | null, name?: string | null, createdAt?: string | null, updatedAt?: string | null, startAt?: string | null, endAt?: string | null, suspendedAt?: string | null, rejectedAt?: string | null, status?: SellerAdsV2Status | null, budgetPerDay?: number | null, estimatedReach?: number | null, reach?: number | null, click?: number | null, salesQty?: number | null, salesAmount?: any | null, adsType?: SellerAdsV2Type | null, disbursementId?: number | null, adsCost?: any | null } | null> | null };

export type SellerAdsV2DetailQueryVariables = Exact<{
  sellerAdsV2DetailId: Scalars['Int']['input'];
}>;


export type SellerAdsV2DetailQuery = { __typename?: 'Query', sellerAdsV2Detail?: { __typename?: 'SellerAdsV2Output', id?: number | null, name?: string | null, createdAt?: string | null, updatedAt?: string | null, startAt?: string | null, endAt?: string | null, suspendedAt?: string | null, rejectedAt?: string | null, status?: SellerAdsV2Status | null, budgetPerDay?: number | null, estimatedReach?: number | null, reach?: number | null, click?: number | null, salesQty?: number | null, salesAmount?: any | null, adsType?: SellerAdsV2Type | null, disbursementId?: number | null, adsCost?: any | null, productAds?: Array<{ __typename?: 'ProductAdsV2Output', reach?: number | null, click?: number | null, salesQty?: number | null, salesAmount?: any | null, item?: { __typename?: 'BasicProduct', id?: number | null, thumbnail?: string | null, title?: string | null, code?: string | null, priceAfterDiscount?: number | null, price?: any | null, discount?: number | null } | null } | null> | null, banner?: { __typename?: 'AdsBannerOutPut', src?: string | null, navigate?: any | null, reach?: number | null, click?: number | null } | null } | null };

export type MerchantDiscountItemQueryVariables = Exact<{
  campaign_id: Scalars['Int']['input'];
}>;


export type MerchantDiscountItemQuery = { __typename?: 'Query', merchantDiscountItem?: any | null };

export type MerchantDiscountItemCampaignQueryVariables = Exact<{
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type MerchantDiscountItemCampaignQuery = { __typename?: 'Query', merchantDiscountItemCampaign?: Array<{ __typename?: 'ItemDiscountCampaign', id?: number | null, start_date?: string | null, end_date?: string | null, actived?: boolean | null } | null> | null };

export type SkuListQueryVariables = Exact<{
  productID?: InputMaybe<Scalars['Int']['input']>;
}>;


export type SkuListQuery = { __typename?: 'Query', skuList?: Array<{ __typename?: 'SKU', id?: number | null, productID?: number | null, size?: string | null, color?: string | null, barcode?: string | null, product?: { __typename?: 'BasicProduct', id?: number | null, code?: string | null, title?: string | null, thumbnail?: string | null } | null } | null> | null };

export type ProductListV2QueryVariables = Exact<{
  productListType: ProductListType;
  filter?: InputMaybe<ProductListFilterV2>;
  search?: InputMaybe<ProductSearch>;
  page?: InputMaybe<PaginationInput>;
  orderBy?: InputMaybe<ProductOrderByInput>;
  viewBySku?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type ProductListV2Query = { __typename?: 'Query', productListV2?: { __typename?: 'ProductListResult', data?: Array<{ __typename?: 'ProductV2', id?: number | null, picture?: string | null, code?: string | null, supplierCode?: string | null, mark?: string | null, remoted?: boolean | null, status?: string | null, tags?: Array<string | null> | null, price?: number | null, discount?: number | null, color?: Array<string | null> | null, size?: Array<string | null> | null, reach?: number | null, clicks?: number | null, soldQty?: number | null, revenue?: number | null, stockQty?: number | null, weight?: number | null, boxSize?: string | null, inputDate?: string | null, lastStockIn?: string | null, title?: { __typename?: 'MultiLangString', en?: string | null, km?: string | null, zh?: string | null } | null, category?: { __typename?: 'Category', id: number, name?: { __typename?: 'MultiLangString', en?: string | null } | null } | null, brand?: { __typename?: 'Brand', id: number, name?: string | null } | null, vendor?: { __typename?: 'SupplierVendor', id: number, name?: string | null } | null, skuList?: Array<{ __typename?: 'StockKeepingUnit', id?: number | null, option1?: string | null, option2?: string | null, barcode?: string | null, enabled?: boolean | null, stockQty?: number | null, barcodeOriginal?: string | null } | null> | null, productReview?: { __typename?: 'ProductReviewInfo', reviews?: number | null, rating?: any | null } | null } | null> | null, pagination?: { __typename?: 'Pagination', total?: number | null } | null } | null };

export type SupplierShipmentDetailQueryVariables = Exact<{
  shipmentId: Scalars['Int']['input'];
}>;


export type SupplierShipmentDetailQuery = { __typename?: 'Query', supplierShipmentDetail?: { __typename?: 'ShipmentDetail', shipment?: { __typename?: 'ShipmentProduct', id?: number | null, createdAt?: string | null, qty?: number | null, received?: number | null, shipperReceived?: number | null, requestDate?: string | null, status?: string | null, receivedAdmin?: string | null, shipmentCode?: string | null, receivedDate?: string | null, arrivedDate?: string | null, shipmentLog?: Array<{ __typename?: 'ShipmentLog', description?: string | null, date?: string | null } | null> | null, receivedBy?: { __typename?: 'Admin', id: number, name?: string | null } | null, package?: { __typename?: 'Package', id: number, uuid?: string | null } | null, arrivedBy?: { __typename?: 'Admin', id: number, name?: string | null } | null, arrivedAt?: { __typename?: 'Warehouse', id?: number | null, name?: string | null, shortName?: string | null } | null } | null, items?: Array<{ __typename?: 'ShipmentItemDetail', id?: number | null, shipmentId?: number | null, color?: string | null, size?: string | null, sentQty?: number | null, receivedQty?: number | null, shipperReceived?: number | null, sku?: { __typename?: 'StockKeepingUnit', id?: number | null, option1?: string | null, option2?: string | null, product?: { __typename?: 'BasicProduct', id?: number | null, code?: string | null, supplierCode?: string | null, price?: any | null, priceAfterDiscount?: number | null, title?: string | null, thumbnail?: string | null, discount?: number | null, weight?: number | null, boxSize?: string | null } | null } | null } | null> | null } | null };

export type PackageCountByStatusQueryVariables = Exact<{
  dateType?: InputMaybe<DateType>;
  start?: InputMaybe<Scalars['String']['input']>;
  end?: InputMaybe<Scalars['String']['input']>;
}>;


export type PackageCountByStatusQuery = { __typename?: 'Query', packageCountByStatus?: Array<{ __typename?: 'PackagesByStatus', status?: string | null, packages?: number | null } | null> | null };

export type PackageListQueryVariables = Exact<{
  keyword?: InputMaybe<Scalars['String']['input']>;
  createdAtFrom?: InputMaybe<Scalars['String']['input']>;
  createdAtTo?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Array<InputMaybe<PackageStatus>> | InputMaybe<PackageStatus>>;
  customerPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  packageUUID?: InputMaybe<Scalars['String']['input']>;
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
  successDateRange?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;


export type PackageListQuery = { __typename?: 'Query', packageList?: Array<{ __typename?: 'Package', id: number, createdAt?: string | null, appointedAt?: string | null, customerName?: string | null, addressName?: string | null, cashCollected?: number | null, cash?: number | null, barcode?: string | null, status?: PackageStatus | null, attempt?: number | null, useInsurance?: boolean | null, isPrepayment?: boolean | null, isDropbox?: boolean | null, value?: number | null, x?: number | null, y?: number | null, z?: number | null, weight?: number | null, hasReturningItem?: boolean | null, returningFromPackageId?: number | null, additionalInstruction?: string | null, fee?: number | null, isReturning?: boolean | null, isPickup?: boolean | null, customer?: { __typename?: 'CustomerBasic', id: number, name?: string | null, phoneNumber?: string | null } | null, currentWarehouse?: { __typename?: 'Warehouse', shortName?: string | null } | null, nextWarehouse?: { __typename?: 'Warehouse', shortName?: string | null } | null } | null> | null };

export type DisplayProductMediaListQueryVariables = Exact<{
  displayProductMediaListId: Scalars['Int']['input'];
}>;


export type DisplayProductMediaListQuery = { __typename?: 'Query', displayProductMediaList?: Array<{ __typename?: 'DisplayProductMedia', id: number, thumbnail?: string | null, src?: string | null, type?: DisplayProductMediaType | null, width?: number | null, height?: number | null, originalSource?: string | null } | null> | null };

export type CategoryListQueryVariables = Exact<{ [key: string]: never; }>;


export type CategoryListQuery = { __typename?: 'Query', categoryList?: Array<{ __typename?: 'Category', id: number, parentID?: number | null, subCategory?: string | null, name?: { __typename?: 'MultiLangString', en?: string | null } | null } | null> | null };

export type RecommendProductCategoryListQueryVariables = Exact<{
  keyword: Scalars['String']['input'];
}>;


export type RecommendProductCategoryListQuery = { __typename?: 'Query', recommendProductCategoryList?: any | null };

export type ProductListCountQueryVariables = Exact<{ [key: string]: never; }>;


export type ProductListCountQuery = { __typename?: 'Query', productListCount?: { __typename?: 'ProductListCountTab', approved?: number | null, unverified?: number | null, reviewing?: number | null, rejected?: number | null, toRestock?: number | null, restocking?: number | null } | null };

export type SupplierRegisterReviewQueryVariables = Exact<{
  verifyToken: Scalars['String']['input'];
}>;


export type SupplierRegisterReviewQuery = { __typename?: 'Query', supplierRegisterReview?: { __typename?: 'SupplierMoreInformation', address?: string | null, bankAccHolderName?: string | null, bankAccNumber?: string | null, bankName?: string | null, brandsNames?: string | null, categoryIds?: string | null, companyName?: string | null, companyRegisterNumber?: string | null, contact?: string | null, coordLat?: string | null, coordLng?: string | null, fiscalCodeNumber?: string | null, id?: number | null, origin?: Origin | null, role?: SupplierRole | null, vat?: string | null, zoneId?: number | null } | null };

export type GeocodeAddressQueryVariables = Exact<{
  lat?: InputMaybe<Scalars['String']['input']>;
  lng?: InputMaybe<Scalars['String']['input']>;
}>;


export type GeocodeAddressQuery = { __typename?: 'Query', geocodeAddress?: string | null };

export type MapSuggestionLatLngQueryVariables = Exact<{
  lat?: InputMaybe<Scalars['Float']['input']>;
  lng?: InputMaybe<Scalars['Float']['input']>;
}>;


export type MapSuggestionLatLngQuery = { __typename?: 'Query', mapSuggestionLatLng?: Array<{ __typename?: 'MapSuggestionLatLngResponse', lat?: number | null, lng?: number | null, name?: string | null, placeId?: string | null } | null> | null };

export type MapSuggestionPlaceQueryVariables = Exact<{
  keyword?: InputMaybe<Scalars['String']['input']>;
}>;


export type MapSuggestionPlaceQuery = { __typename?: 'Query', mapSuggestionPlace?: Array<{ __typename?: 'MapPlaceSuggestion', name?: string | null, placeId?: string | null } | null> | null };

export type MerchantAnnouncementListQueryVariables = Exact<{
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type MerchantAnnouncementListQuery = { __typename?: 'Query', merchantAnnouncementList?: Array<{ __typename?: 'MerchantAnnouncement', id?: number | null, createdAt?: string | null, title?: string | null, pushNotification?: boolean | null, contentInMarkdown?: string | null } | null> | null };

export type SupplierQueryVariables = Exact<{
  supplierId: Scalars['Int']['input'];
}>;


export type SupplierQuery = { __typename?: 'Query', supplier?: { __typename?: 'Supplier', id?: number | null, fulfilmentRate?: number | null, fulfilmentTime?: number | null, productAverageRating?: number | null, productRatingCount?: number | null, follower?: number | null, bankName?: string | null, bankAccountHolderName?: string | null, bankAccountNumber?: string | null, name?: string | null, logo?: string | null, isPaymentGateway?: boolean | null, paymentGatewayID?: number | null } | null };

export type ProductGroupQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type ProductGroupQuery = { __typename?: 'Query', productGroup?: { __typename?: 'ProductGroup', id?: number | null, name?: string | null, products?: Array<{ __typename?: 'BasicProduct', id?: number | null, code?: string | null, thumbnail?: string | null, title?: string | null, price?: any | null, discount?: number | null } | null> | null } | null };

export type ProductListV2OnlyCodeQueryVariables = Exact<{
  productListType: ProductListType;
  filter?: InputMaybe<ProductListFilterV2>;
  search?: InputMaybe<ProductSearch>;
  page?: InputMaybe<PaginationInput>;
  orderBy?: InputMaybe<ProductOrderByInput>;
  viewBySku?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type ProductListV2OnlyCodeQuery = { __typename?: 'Query', productListV2?: { __typename?: 'ProductListResult', data?: Array<{ __typename?: 'ProductV2', id?: number | null, code?: string | null, picture?: string | null, price?: number | null, discount?: number | null, title?: { __typename?: 'MultiLangString', en?: string | null } | null } | null> | null } | null };

export type ProductGroupListQueryVariables = Exact<{ [key: string]: never; }>;


export type ProductGroupListQuery = { __typename?: 'Query', productGroupList?: Array<{ __typename?: 'ProductGroup', id?: number | null, itemsCount?: number | null, name?: string | null, products?: Array<{ __typename?: 'BasicProduct', code?: string | null, id?: number | null, price?: any | null, discount?: number | null, title?: string | null, thumbnail?: string | null } | null> | null } | null> | null };

export type ProductReviewListQueryVariables = Exact<{
  productId?: InputMaybe<Scalars['Int']['input']>;
  merchantId?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ProductReviewListQuery = { __typename?: 'Query', productReviewList?: Array<{ __typename?: 'ProductReview', comment?: string | null, rating?: number | null, id: number, createdAt?: string | null, updatedAt?: string | null, customer?: { __typename?: 'CustomerBasic', id: number, image?: string | null, name?: string | null } | null, attachments?: Array<{ __typename?: 'ProductReviewAttachment', src?: string | null, thumbnail?: string | null } | null> | null } | null> | null };

export type SupplierAdminQueryVariables = Exact<{
  supplierId: Scalars['Int']['input'];
}>;


export type SupplierAdminQuery = { __typename?: 'Query', supplier?: { __typename?: 'Supplier', id?: number | null, fulfilmentRate?: number | null, fulfilmentTime?: number | null, productAverageRating?: number | null, productRatingCount?: number | null, follower?: number | null, bankName?: string | null, bankAccountHolderName?: string | null, bankAccountNumber?: string | null, name?: string | null, logo?: string | null, isPaymentGateway?: boolean | null, paymentGatewayID?: number | null, subscription?: { __typename?: 'SellerSubscription', id?: number | null, planId?: number | null, planName?: SellerSuscriptionPlan | null, fee?: any | null, subscriptedDate?: string | null, expiredDate?: string | null, interval?: string | null } | null } | null };

export type SupplierProductValidationV2QueryVariables = Exact<{
  content?: InputMaybe<Scalars['JSON']['input']>;
}>;


export type SupplierProductValidationV2Query = { __typename?: 'Query', supplierProductValidationV2?: { __typename?: 'ValidationResult', message?: string | null, success?: boolean | null } | null };

export type SalesDetailBySalesStatusQueryVariables = Exact<{
  salesStatus?: InputMaybe<Sales_Status>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  day?: InputMaybe<Scalars['Int']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['String']['input']>;
}>;


export type SalesDetailBySalesStatusQuery = { __typename?: 'Query', salesDetailBySalesStatus?: { __typename?: 'SalesDetailBySalesStatusList', data?: Array<{ __typename?: 'MerchantOrderItem', skuStock?: number | null, uuid?: string | null, itemID?: number | null, status?: CustomerOrderItemStatus | null, customerID?: number | null, code?: string | null, title?: string | null, supplierCode?: string | null, picture?: string | null, color?: string | null, size?: string | null, orderDate?: string | null, fullPrice?: number | null, prepaidAmount?: number | null, deliveryFee?: number | null, handlingFee?: number | null, commission?: number | null, discount?: number | null, fbl?: boolean | null, remoteStock?: boolean | null, log?: Array<{ __typename?: 'OrderItemLog', description?: string | null, date?: string | null } | null> | null } | null> | null, page?: { __typename?: 'Pagination', total?: number | null } | null } | null };

export type SupplierBankChangeLogQueryVariables = Exact<{
  supplierId: Scalars['Int']['input'];
}>;


export type SupplierBankChangeLogQuery = { __typename?: 'Query', supplierBankChangeLog?: Array<{ __typename?: 'SupplierBankChangeLog', id?: number | null, supplierId?: number | null, oldValue?: any | null, newValue?: any | null, changedDate?: string | null } | null> | null };

export type BrandListQueryVariables = Exact<{
  status?: InputMaybe<BrandStatus>;
  limit: Scalars['Int']['input'];
  owned?: InputMaybe<Scalars['Boolean']['input']>;
  merchantId?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  verified?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type BrandListQuery = { __typename?: 'Query', brandList?: Array<{ __typename?: 'Brand', id: number, alias?: string | null, name?: string | null, banner?: string | null, picture?: string | null, description?: string | null, status?: BrandStatus | null } | null> | null };

export type ProductQueryVariables = Exact<{
  productId: Scalars['Int']['input'];
}>;


export type ProductQuery = { __typename?: 'Query', product?: { __typename?: 'Product', id?: number | null, code?: string | null, price?: number | null, discount?: number | null, picture?: string | null, title?: { __typename?: 'MultiLangString', en?: string | null, km?: string | null, zh?: string | null } | null } | null };

export type CategoryAnalyticsQueryVariables = Exact<{
  categoryId?: InputMaybe<Scalars['Int']['input']>;
}>;


export type CategoryAnalyticsQuery = { __typename?: 'Query', categoryAnalytics?: Array<{ __typename?: 'CategoryAnalytic', active?: number | null, inStock?: number | null, sale?: any | null, category?: { __typename?: 'Category', id: number, parentId?: number | null, name?: { __typename?: 'MultiLangString', en?: string | null } | null } | null } | null> | null };

export type SupplierOrderCountByStatusQueryVariables = Exact<{ [key: string]: never; }>;


export type SupplierOrderCountByStatusQuery = { __typename?: 'Query', supplierOrderCountByStatus?: any | null };

export type ProductImageSearchQueryVariables = Exact<{
  file: Scalars['Upload']['input'];
}>;


export type ProductImageSearchQuery = { __typename?: 'Query', productImageSearch?: string | null };

export type ProductImageSearchResultQueryVariables = Exact<{
  hash: Scalars['String']['input'];
}>;


export type ProductImageSearchResultQuery = { __typename?: 'Query', productImageSearchResult?: Array<{ __typename?: 'ProductRawJson', id?: number | null } | null> | null };


export const MerchantProductShipmentDocument = gql`
    mutation merchantProductShipment($data: [ProductShipmentInput]) {
  merchantProductShipment(data: $data)
}
    `;
export type MerchantProductShipmentMutationFn = Apollo.MutationFunction<MerchantProductShipmentMutation, MerchantProductShipmentMutationVariables>;

/**
 * __useMerchantProductShipmentMutation__
 *
 * To run a mutation, you first call `useMerchantProductShipmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMerchantProductShipmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [merchantProductShipmentMutation, { data, loading, error }] = useMerchantProductShipmentMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useMerchantProductShipmentMutation(baseOptions?: Apollo.MutationHookOptions<MerchantProductShipmentMutation, MerchantProductShipmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MerchantProductShipmentMutation, MerchantProductShipmentMutationVariables>(MerchantProductShipmentDocument, options);
      }
export type MerchantProductShipmentMutationHookResult = ReturnType<typeof useMerchantProductShipmentMutation>;
export type MerchantProductShipmentMutationResult = Apollo.MutationResult<MerchantProductShipmentMutation>;
export type MerchantProductShipmentMutationOptions = Apollo.BaseMutationOptions<MerchantProductShipmentMutation, MerchantProductShipmentMutationVariables>;
export const CreateSellerProductAdsV2Document = gql`
    mutation createSellerProductAdsV2($data: SellerAdsV2Input!, $items: [Int]!) {
  createSellerProductAdsV2(data: $data, items: $items)
}
    `;
export type CreateSellerProductAdsV2MutationFn = Apollo.MutationFunction<CreateSellerProductAdsV2Mutation, CreateSellerProductAdsV2MutationVariables>;

/**
 * __useCreateSellerProductAdsV2Mutation__
 *
 * To run a mutation, you first call `useCreateSellerProductAdsV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSellerProductAdsV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSellerProductAdsV2Mutation, { data, loading, error }] = useCreateSellerProductAdsV2Mutation({
 *   variables: {
 *      data: // value for 'data'
 *      items: // value for 'items'
 *   },
 * });
 */
export function useCreateSellerProductAdsV2Mutation(baseOptions?: Apollo.MutationHookOptions<CreateSellerProductAdsV2Mutation, CreateSellerProductAdsV2MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSellerProductAdsV2Mutation, CreateSellerProductAdsV2MutationVariables>(CreateSellerProductAdsV2Document, options);
      }
export type CreateSellerProductAdsV2MutationHookResult = ReturnType<typeof useCreateSellerProductAdsV2Mutation>;
export type CreateSellerProductAdsV2MutationResult = Apollo.MutationResult<CreateSellerProductAdsV2Mutation>;
export type CreateSellerProductAdsV2MutationOptions = Apollo.BaseMutationOptions<CreateSellerProductAdsV2Mutation, CreateSellerProductAdsV2MutationVariables>;
export const CreateSellerFrontBannerAdsV2Document = gql`
    mutation createSellerFrontBannerAdsV2($data: SellerAdsV2Input!, $banner: AdsBannerInput!) {
  createSellerFrontBannerAdsV2(data: $data, banner: $banner)
}
    `;
export type CreateSellerFrontBannerAdsV2MutationFn = Apollo.MutationFunction<CreateSellerFrontBannerAdsV2Mutation, CreateSellerFrontBannerAdsV2MutationVariables>;

/**
 * __useCreateSellerFrontBannerAdsV2Mutation__
 *
 * To run a mutation, you first call `useCreateSellerFrontBannerAdsV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSellerFrontBannerAdsV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSellerFrontBannerAdsV2Mutation, { data, loading, error }] = useCreateSellerFrontBannerAdsV2Mutation({
 *   variables: {
 *      data: // value for 'data'
 *      banner: // value for 'banner'
 *   },
 * });
 */
export function useCreateSellerFrontBannerAdsV2Mutation(baseOptions?: Apollo.MutationHookOptions<CreateSellerFrontBannerAdsV2Mutation, CreateSellerFrontBannerAdsV2MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSellerFrontBannerAdsV2Mutation, CreateSellerFrontBannerAdsV2MutationVariables>(CreateSellerFrontBannerAdsV2Document, options);
      }
export type CreateSellerFrontBannerAdsV2MutationHookResult = ReturnType<typeof useCreateSellerFrontBannerAdsV2Mutation>;
export type CreateSellerFrontBannerAdsV2MutationResult = Apollo.MutationResult<CreateSellerFrontBannerAdsV2Mutation>;
export type CreateSellerFrontBannerAdsV2MutationOptions = Apollo.BaseMutationOptions<CreateSellerFrontBannerAdsV2Mutation, CreateSellerFrontBannerAdsV2MutationVariables>;
export const CreateSellerProductBannerAdsV2Document = gql`
    mutation createSellerProductBannerAdsV2($data: SellerAdsV2Input!, $banner: AdsBannerInput!) {
  createSellerProductBannerAdsV2(data: $data, banner: $banner)
}
    `;
export type CreateSellerProductBannerAdsV2MutationFn = Apollo.MutationFunction<CreateSellerProductBannerAdsV2Mutation, CreateSellerProductBannerAdsV2MutationVariables>;

/**
 * __useCreateSellerProductBannerAdsV2Mutation__
 *
 * To run a mutation, you first call `useCreateSellerProductBannerAdsV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSellerProductBannerAdsV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSellerProductBannerAdsV2Mutation, { data, loading, error }] = useCreateSellerProductBannerAdsV2Mutation({
 *   variables: {
 *      data: // value for 'data'
 *      banner: // value for 'banner'
 *   },
 * });
 */
export function useCreateSellerProductBannerAdsV2Mutation(baseOptions?: Apollo.MutationHookOptions<CreateSellerProductBannerAdsV2Mutation, CreateSellerProductBannerAdsV2MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSellerProductBannerAdsV2Mutation, CreateSellerProductBannerAdsV2MutationVariables>(CreateSellerProductBannerAdsV2Document, options);
      }
export type CreateSellerProductBannerAdsV2MutationHookResult = ReturnType<typeof useCreateSellerProductBannerAdsV2Mutation>;
export type CreateSellerProductBannerAdsV2MutationResult = Apollo.MutationResult<CreateSellerProductBannerAdsV2Mutation>;
export type CreateSellerProductBannerAdsV2MutationOptions = Apollo.BaseMutationOptions<CreateSellerProductBannerAdsV2Mutation, CreateSellerProductBannerAdsV2MutationVariables>;
export const UpdateSellerProductAdsV2Document = gql`
    mutation updateSellerProductAdsV2($updateSellerProductAdsV2Id: Int!, $data: SellerAdsV2Input!, $items: [Int]!) {
  updateSellerProductAdsV2(
    id: $updateSellerProductAdsV2Id
    data: $data
    items: $items
  )
}
    `;
export type UpdateSellerProductAdsV2MutationFn = Apollo.MutationFunction<UpdateSellerProductAdsV2Mutation, UpdateSellerProductAdsV2MutationVariables>;

/**
 * __useUpdateSellerProductAdsV2Mutation__
 *
 * To run a mutation, you first call `useUpdateSellerProductAdsV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSellerProductAdsV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSellerProductAdsV2Mutation, { data, loading, error }] = useUpdateSellerProductAdsV2Mutation({
 *   variables: {
 *      updateSellerProductAdsV2Id: // value for 'updateSellerProductAdsV2Id'
 *      data: // value for 'data'
 *      items: // value for 'items'
 *   },
 * });
 */
export function useUpdateSellerProductAdsV2Mutation(baseOptions?: Apollo.MutationHookOptions<UpdateSellerProductAdsV2Mutation, UpdateSellerProductAdsV2MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSellerProductAdsV2Mutation, UpdateSellerProductAdsV2MutationVariables>(UpdateSellerProductAdsV2Document, options);
      }
export type UpdateSellerProductAdsV2MutationHookResult = ReturnType<typeof useUpdateSellerProductAdsV2Mutation>;
export type UpdateSellerProductAdsV2MutationResult = Apollo.MutationResult<UpdateSellerProductAdsV2Mutation>;
export type UpdateSellerProductAdsV2MutationOptions = Apollo.BaseMutationOptions<UpdateSellerProductAdsV2Mutation, UpdateSellerProductAdsV2MutationVariables>;
export const UpdateSellerFrontBannerAdsV2Document = gql`
    mutation updateSellerFrontBannerAdsV2($updateSellerFrontBannerAdsV2Id: Int!, $data: SellerAdsV2Input!, $banner: AdsBannerInput!) {
  updateSellerFrontBannerAdsV2(
    id: $updateSellerFrontBannerAdsV2Id
    data: $data
    banner: $banner
  )
}
    `;
export type UpdateSellerFrontBannerAdsV2MutationFn = Apollo.MutationFunction<UpdateSellerFrontBannerAdsV2Mutation, UpdateSellerFrontBannerAdsV2MutationVariables>;

/**
 * __useUpdateSellerFrontBannerAdsV2Mutation__
 *
 * To run a mutation, you first call `useUpdateSellerFrontBannerAdsV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSellerFrontBannerAdsV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSellerFrontBannerAdsV2Mutation, { data, loading, error }] = useUpdateSellerFrontBannerAdsV2Mutation({
 *   variables: {
 *      updateSellerFrontBannerAdsV2Id: // value for 'updateSellerFrontBannerAdsV2Id'
 *      data: // value for 'data'
 *      banner: // value for 'banner'
 *   },
 * });
 */
export function useUpdateSellerFrontBannerAdsV2Mutation(baseOptions?: Apollo.MutationHookOptions<UpdateSellerFrontBannerAdsV2Mutation, UpdateSellerFrontBannerAdsV2MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSellerFrontBannerAdsV2Mutation, UpdateSellerFrontBannerAdsV2MutationVariables>(UpdateSellerFrontBannerAdsV2Document, options);
      }
export type UpdateSellerFrontBannerAdsV2MutationHookResult = ReturnType<typeof useUpdateSellerFrontBannerAdsV2Mutation>;
export type UpdateSellerFrontBannerAdsV2MutationResult = Apollo.MutationResult<UpdateSellerFrontBannerAdsV2Mutation>;
export type UpdateSellerFrontBannerAdsV2MutationOptions = Apollo.BaseMutationOptions<UpdateSellerFrontBannerAdsV2Mutation, UpdateSellerFrontBannerAdsV2MutationVariables>;
export const UpdateSellerProductBannerAdsV2Document = gql`
    mutation updateSellerProductBannerAdsV2($updateSellerProductBannerAdsV2Id: Int!, $data: SellerAdsV2Input!, $banner: AdsBannerInput!) {
  updateSellerProductBannerAdsV2(
    id: $updateSellerProductBannerAdsV2Id
    data: $data
    banner: $banner
  )
}
    `;
export type UpdateSellerProductBannerAdsV2MutationFn = Apollo.MutationFunction<UpdateSellerProductBannerAdsV2Mutation, UpdateSellerProductBannerAdsV2MutationVariables>;

/**
 * __useUpdateSellerProductBannerAdsV2Mutation__
 *
 * To run a mutation, you first call `useUpdateSellerProductBannerAdsV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSellerProductBannerAdsV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSellerProductBannerAdsV2Mutation, { data, loading, error }] = useUpdateSellerProductBannerAdsV2Mutation({
 *   variables: {
 *      updateSellerProductBannerAdsV2Id: // value for 'updateSellerProductBannerAdsV2Id'
 *      data: // value for 'data'
 *      banner: // value for 'banner'
 *   },
 * });
 */
export function useUpdateSellerProductBannerAdsV2Mutation(baseOptions?: Apollo.MutationHookOptions<UpdateSellerProductBannerAdsV2Mutation, UpdateSellerProductBannerAdsV2MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSellerProductBannerAdsV2Mutation, UpdateSellerProductBannerAdsV2MutationVariables>(UpdateSellerProductBannerAdsV2Document, options);
      }
export type UpdateSellerProductBannerAdsV2MutationHookResult = ReturnType<typeof useUpdateSellerProductBannerAdsV2Mutation>;
export type UpdateSellerProductBannerAdsV2MutationResult = Apollo.MutationResult<UpdateSellerProductBannerAdsV2Mutation>;
export type UpdateSellerProductBannerAdsV2MutationOptions = Apollo.BaseMutationOptions<UpdateSellerProductBannerAdsV2Mutation, UpdateSellerProductBannerAdsV2MutationVariables>;
export const SuspendSellerAdsV2Document = gql`
    mutation suspendSellerAdsV2($suspendSellerAdsV2Id: Int!) {
  suspendSellerAdsV2(id: $suspendSellerAdsV2Id)
}
    `;
export type SuspendSellerAdsV2MutationFn = Apollo.MutationFunction<SuspendSellerAdsV2Mutation, SuspendSellerAdsV2MutationVariables>;

/**
 * __useSuspendSellerAdsV2Mutation__
 *
 * To run a mutation, you first call `useSuspendSellerAdsV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSuspendSellerAdsV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [suspendSellerAdsV2Mutation, { data, loading, error }] = useSuspendSellerAdsV2Mutation({
 *   variables: {
 *      suspendSellerAdsV2Id: // value for 'suspendSellerAdsV2Id'
 *   },
 * });
 */
export function useSuspendSellerAdsV2Mutation(baseOptions?: Apollo.MutationHookOptions<SuspendSellerAdsV2Mutation, SuspendSellerAdsV2MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SuspendSellerAdsV2Mutation, SuspendSellerAdsV2MutationVariables>(SuspendSellerAdsV2Document, options);
      }
export type SuspendSellerAdsV2MutationHookResult = ReturnType<typeof useSuspendSellerAdsV2Mutation>;
export type SuspendSellerAdsV2MutationResult = Apollo.MutationResult<SuspendSellerAdsV2Mutation>;
export type SuspendSellerAdsV2MutationOptions = Apollo.BaseMutationOptions<SuspendSellerAdsV2Mutation, SuspendSellerAdsV2MutationVariables>;
export const MerchantCreateDiscountItemDocument = gql`
    mutation merchantCreateDiscountItem($start_date: String!, $end_date: String!, $data: [ItemDiscountInput]) {
  merchantCreateDiscountItem(
    start_date: $start_date
    end_date: $end_date
    data: $data
  )
}
    `;
export type MerchantCreateDiscountItemMutationFn = Apollo.MutationFunction<MerchantCreateDiscountItemMutation, MerchantCreateDiscountItemMutationVariables>;

/**
 * __useMerchantCreateDiscountItemMutation__
 *
 * To run a mutation, you first call `useMerchantCreateDiscountItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMerchantCreateDiscountItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [merchantCreateDiscountItemMutation, { data, loading, error }] = useMerchantCreateDiscountItemMutation({
 *   variables: {
 *      start_date: // value for 'start_date'
 *      end_date: // value for 'end_date'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useMerchantCreateDiscountItemMutation(baseOptions?: Apollo.MutationHookOptions<MerchantCreateDiscountItemMutation, MerchantCreateDiscountItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MerchantCreateDiscountItemMutation, MerchantCreateDiscountItemMutationVariables>(MerchantCreateDiscountItemDocument, options);
      }
export type MerchantCreateDiscountItemMutationHookResult = ReturnType<typeof useMerchantCreateDiscountItemMutation>;
export type MerchantCreateDiscountItemMutationResult = Apollo.MutationResult<MerchantCreateDiscountItemMutation>;
export type MerchantCreateDiscountItemMutationOptions = Apollo.BaseMutationOptions<MerchantCreateDiscountItemMutation, MerchantCreateDiscountItemMutationVariables>;
export const MerchantUpdateDiscountDocument = gql`
    mutation merchantUpdateDiscount($start_date: String!, $end_date: String!, $data: [ItemDiscountInput], $campaign_id: Int!, $delete_id: [Int]) {
  merchantUpdateDiscount(
    start_date: $start_date
    end_date: $end_date
    data: $data
    campaign_id: $campaign_id
    delete_id: $delete_id
  )
}
    `;
export type MerchantUpdateDiscountMutationFn = Apollo.MutationFunction<MerchantUpdateDiscountMutation, MerchantUpdateDiscountMutationVariables>;

/**
 * __useMerchantUpdateDiscountMutation__
 *
 * To run a mutation, you first call `useMerchantUpdateDiscountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMerchantUpdateDiscountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [merchantUpdateDiscountMutation, { data, loading, error }] = useMerchantUpdateDiscountMutation({
 *   variables: {
 *      start_date: // value for 'start_date'
 *      end_date: // value for 'end_date'
 *      data: // value for 'data'
 *      campaign_id: // value for 'campaign_id'
 *      delete_id: // value for 'delete_id'
 *   },
 * });
 */
export function useMerchantUpdateDiscountMutation(baseOptions?: Apollo.MutationHookOptions<MerchantUpdateDiscountMutation, MerchantUpdateDiscountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MerchantUpdateDiscountMutation, MerchantUpdateDiscountMutationVariables>(MerchantUpdateDiscountDocument, options);
      }
export type MerchantUpdateDiscountMutationHookResult = ReturnType<typeof useMerchantUpdateDiscountMutation>;
export type MerchantUpdateDiscountMutationResult = Apollo.MutationResult<MerchantUpdateDiscountMutation>;
export type MerchantUpdateDiscountMutationOptions = Apollo.BaseMutationOptions<MerchantUpdateDiscountMutation, MerchantUpdateDiscountMutationVariables>;
export const MerchantInactiveDiscountCampaignDocument = gql`
    mutation merchantInactiveDiscountCampaign($campaignId: Int!) {
  merchantInactiveDiscountCampaign(campaign_id: $campaignId)
}
    `;
export type MerchantInactiveDiscountCampaignMutationFn = Apollo.MutationFunction<MerchantInactiveDiscountCampaignMutation, MerchantInactiveDiscountCampaignMutationVariables>;

/**
 * __useMerchantInactiveDiscountCampaignMutation__
 *
 * To run a mutation, you first call `useMerchantInactiveDiscountCampaignMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMerchantInactiveDiscountCampaignMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [merchantInactiveDiscountCampaignMutation, { data, loading, error }] = useMerchantInactiveDiscountCampaignMutation({
 *   variables: {
 *      campaignId: // value for 'campaignId'
 *   },
 * });
 */
export function useMerchantInactiveDiscountCampaignMutation(baseOptions?: Apollo.MutationHookOptions<MerchantInactiveDiscountCampaignMutation, MerchantInactiveDiscountCampaignMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MerchantInactiveDiscountCampaignMutation, MerchantInactiveDiscountCampaignMutationVariables>(MerchantInactiveDiscountCampaignDocument, options);
      }
export type MerchantInactiveDiscountCampaignMutationHookResult = ReturnType<typeof useMerchantInactiveDiscountCampaignMutation>;
export type MerchantInactiveDiscountCampaignMutationResult = Apollo.MutationResult<MerchantInactiveDiscountCampaignMutation>;
export type MerchantInactiveDiscountCampaignMutationOptions = Apollo.BaseMutationOptions<MerchantInactiveDiscountCampaignMutation, MerchantInactiveDiscountCampaignMutationVariables>;
export const ChangeCustomerOrderItemStatusDocument = gql`
    mutation changeCustomerOrderItemStatus($orderId: String, $status: CustomerOrderItemStatus!) {
  changeCustomerOrderItemStatus(orderId: $orderId, status: $status) {
    success
    assignedSlot
  }
}
    `;
export type ChangeCustomerOrderItemStatusMutationFn = Apollo.MutationFunction<ChangeCustomerOrderItemStatusMutation, ChangeCustomerOrderItemStatusMutationVariables>;

/**
 * __useChangeCustomerOrderItemStatusMutation__
 *
 * To run a mutation, you first call `useChangeCustomerOrderItemStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeCustomerOrderItemStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeCustomerOrderItemStatusMutation, { data, loading, error }] = useChangeCustomerOrderItemStatusMutation({
 *   variables: {
 *      orderId: // value for 'orderId'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useChangeCustomerOrderItemStatusMutation(baseOptions?: Apollo.MutationHookOptions<ChangeCustomerOrderItemStatusMutation, ChangeCustomerOrderItemStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChangeCustomerOrderItemStatusMutation, ChangeCustomerOrderItemStatusMutationVariables>(ChangeCustomerOrderItemStatusDocument, options);
      }
export type ChangeCustomerOrderItemStatusMutationHookResult = ReturnType<typeof useChangeCustomerOrderItemStatusMutation>;
export type ChangeCustomerOrderItemStatusMutationResult = Apollo.MutationResult<ChangeCustomerOrderItemStatusMutation>;
export type ChangeCustomerOrderItemStatusMutationOptions = Apollo.BaseMutationOptions<ChangeCustomerOrderItemStatusMutation, ChangeCustomerOrderItemStatusMutationVariables>;
export const RequestPackagePickupDocument = gql`
    mutation requestPackagePickup($ids: [Int], $scheduleAt: String) {
  requestPackagePickup(ids: $ids, scheduleAt: $scheduleAt)
}
    `;
export type RequestPackagePickupMutationFn = Apollo.MutationFunction<RequestPackagePickupMutation, RequestPackagePickupMutationVariables>;

/**
 * __useRequestPackagePickupMutation__
 *
 * To run a mutation, you first call `useRequestPackagePickupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestPackagePickupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestPackagePickupMutation, { data, loading, error }] = useRequestPackagePickupMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *      scheduleAt: // value for 'scheduleAt'
 *   },
 * });
 */
export function useRequestPackagePickupMutation(baseOptions?: Apollo.MutationHookOptions<RequestPackagePickupMutation, RequestPackagePickupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RequestPackagePickupMutation, RequestPackagePickupMutationVariables>(RequestPackagePickupDocument, options);
      }
export type RequestPackagePickupMutationHookResult = ReturnType<typeof useRequestPackagePickupMutation>;
export type RequestPackagePickupMutationResult = Apollo.MutationResult<RequestPackagePickupMutation>;
export type RequestPackagePickupMutationOptions = Apollo.BaseMutationOptions<RequestPackagePickupMutation, RequestPackagePickupMutationVariables>;
export const VoidPackageDocument = gql`
    mutation voidPackage($id: Int) {
  voidPackage(id: $id)
}
    `;
export type VoidPackageMutationFn = Apollo.MutationFunction<VoidPackageMutation, VoidPackageMutationVariables>;

/**
 * __useVoidPackageMutation__
 *
 * To run a mutation, you first call `useVoidPackageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVoidPackageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [voidPackageMutation, { data, loading, error }] = useVoidPackageMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useVoidPackageMutation(baseOptions?: Apollo.MutationHookOptions<VoidPackageMutation, VoidPackageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<VoidPackageMutation, VoidPackageMutationVariables>(VoidPackageDocument, options);
      }
export type VoidPackageMutationHookResult = ReturnType<typeof useVoidPackageMutation>;
export type VoidPackageMutationResult = Apollo.MutationResult<VoidPackageMutation>;
export type VoidPackageMutationOptions = Apollo.BaseMutationOptions<VoidPackageMutation, VoidPackageMutationVariables>;
export const MassUpdateProductDocument = gql`
    mutation massUpdateProduct($massUpdateProductId: [Int]!, $data: MassProductInput!) {
  massUpdateProduct(id: $massUpdateProductId, data: $data)
}
    `;
export type MassUpdateProductMutationFn = Apollo.MutationFunction<MassUpdateProductMutation, MassUpdateProductMutationVariables>;

/**
 * __useMassUpdateProductMutation__
 *
 * To run a mutation, you first call `useMassUpdateProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMassUpdateProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [massUpdateProductMutation, { data, loading, error }] = useMassUpdateProductMutation({
 *   variables: {
 *      massUpdateProductId: // value for 'massUpdateProductId'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useMassUpdateProductMutation(baseOptions?: Apollo.MutationHookOptions<MassUpdateProductMutation, MassUpdateProductMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MassUpdateProductMutation, MassUpdateProductMutationVariables>(MassUpdateProductDocument, options);
      }
export type MassUpdateProductMutationHookResult = ReturnType<typeof useMassUpdateProductMutation>;
export type MassUpdateProductMutationResult = Apollo.MutationResult<MassUpdateProductMutation>;
export type MassUpdateProductMutationOptions = Apollo.BaseMutationOptions<MassUpdateProductMutation, MassUpdateProductMutationVariables>;
export const ToggleSupplierChatDocument = gql`
    mutation toggleSupplierChat {
  toggleSupplierChat
}
    `;
export type ToggleSupplierChatMutationFn = Apollo.MutationFunction<ToggleSupplierChatMutation, ToggleSupplierChatMutationVariables>;

/**
 * __useToggleSupplierChatMutation__
 *
 * To run a mutation, you first call `useToggleSupplierChatMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useToggleSupplierChatMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [toggleSupplierChatMutation, { data, loading, error }] = useToggleSupplierChatMutation({
 *   variables: {
 *   },
 * });
 */
export function useToggleSupplierChatMutation(baseOptions?: Apollo.MutationHookOptions<ToggleSupplierChatMutation, ToggleSupplierChatMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ToggleSupplierChatMutation, ToggleSupplierChatMutationVariables>(ToggleSupplierChatDocument, options);
      }
export type ToggleSupplierChatMutationHookResult = ReturnType<typeof useToggleSupplierChatMutation>;
export type ToggleSupplierChatMutationResult = Apollo.MutationResult<ToggleSupplierChatMutation>;
export type ToggleSupplierChatMutationOptions = Apollo.BaseMutationOptions<ToggleSupplierChatMutation, ToggleSupplierChatMutationVariables>;
export const RegisterSupplierDocument = gql`
    mutation registerSupplier($data: SupplierRegisterInput) {
  registerSupplier(data: $data) {
    message
    status
    success
    token
    useDeliveryService
  }
}
    `;
export type RegisterSupplierMutationFn = Apollo.MutationFunction<RegisterSupplierMutation, RegisterSupplierMutationVariables>;

/**
 * __useRegisterSupplierMutation__
 *
 * To run a mutation, you first call `useRegisterSupplierMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegisterSupplierMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [registerSupplierMutation, { data, loading, error }] = useRegisterSupplierMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useRegisterSupplierMutation(baseOptions?: Apollo.MutationHookOptions<RegisterSupplierMutation, RegisterSupplierMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RegisterSupplierMutation, RegisterSupplierMutationVariables>(RegisterSupplierDocument, options);
      }
export type RegisterSupplierMutationHookResult = ReturnType<typeof useRegisterSupplierMutation>;
export type RegisterSupplierMutationResult = Apollo.MutationResult<RegisterSupplierMutation>;
export type RegisterSupplierMutationOptions = Apollo.BaseMutationOptions<RegisterSupplierMutation, RegisterSupplierMutationVariables>;
export const VerifySupplierOtpDocument = gql`
    mutation verifySupplierOtp($secretCode: String!, $verifyToken: String!, $verifyForgeted: Boolean, $isSeller: Boolean) {
  verifySupplierOtp(
    secretCode: $secretCode
    verifyToken: $verifyToken
    verifyForgeted: $verifyForgeted
    isSeller: $isSeller
  ) {
    message
    status
    success
    token
    useDeliveryService
  }
}
    `;
export type VerifySupplierOtpMutationFn = Apollo.MutationFunction<VerifySupplierOtpMutation, VerifySupplierOtpMutationVariables>;

/**
 * __useVerifySupplierOtpMutation__
 *
 * To run a mutation, you first call `useVerifySupplierOtpMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVerifySupplierOtpMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [verifySupplierOtpMutation, { data, loading, error }] = useVerifySupplierOtpMutation({
 *   variables: {
 *      secretCode: // value for 'secretCode'
 *      verifyToken: // value for 'verifyToken'
 *      verifyForgeted: // value for 'verifyForgeted'
 *      isSeller: // value for 'isSeller'
 *   },
 * });
 */
export function useVerifySupplierOtpMutation(baseOptions?: Apollo.MutationHookOptions<VerifySupplierOtpMutation, VerifySupplierOtpMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<VerifySupplierOtpMutation, VerifySupplierOtpMutationVariables>(VerifySupplierOtpDocument, options);
      }
export type VerifySupplierOtpMutationHookResult = ReturnType<typeof useVerifySupplierOtpMutation>;
export type VerifySupplierOtpMutationResult = Apollo.MutationResult<VerifySupplierOtpMutation>;
export type VerifySupplierOtpMutationOptions = Apollo.BaseMutationOptions<VerifySupplierOtpMutation, VerifySupplierOtpMutationVariables>;
export const ResendSupplierOtpDocument = gql`
    mutation resendSupplierOtp($verifyToken: String!, $verifyForgeted: Boolean) {
  resendSupplierOtp(verifyToken: $verifyToken, verifyForgeted: $verifyForgeted) {
    message
    status
    success
    token
    useDeliveryService
  }
}
    `;
export type ResendSupplierOtpMutationFn = Apollo.MutationFunction<ResendSupplierOtpMutation, ResendSupplierOtpMutationVariables>;

/**
 * __useResendSupplierOtpMutation__
 *
 * To run a mutation, you first call `useResendSupplierOtpMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResendSupplierOtpMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resendSupplierOtpMutation, { data, loading, error }] = useResendSupplierOtpMutation({
 *   variables: {
 *      verifyToken: // value for 'verifyToken'
 *      verifyForgeted: // value for 'verifyForgeted'
 *   },
 * });
 */
export function useResendSupplierOtpMutation(baseOptions?: Apollo.MutationHookOptions<ResendSupplierOtpMutation, ResendSupplierOtpMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResendSupplierOtpMutation, ResendSupplierOtpMutationVariables>(ResendSupplierOtpDocument, options);
      }
export type ResendSupplierOtpMutationHookResult = ReturnType<typeof useResendSupplierOtpMutation>;
export type ResendSupplierOtpMutationResult = Apollo.MutationResult<ResendSupplierOtpMutation>;
export type ResendSupplierOtpMutationOptions = Apollo.BaseMutationOptions<ResendSupplierOtpMutation, ResendSupplierOtpMutationVariables>;
export const UpdateSupplierMoreInformationDocument = gql`
    mutation updateSupplierMoreInformation($verifyToken: String!, $data: SupplierMoreInformationInput, $supplierId: Int) {
  updateSupplierMoreInformation(
    verifyToken: $verifyToken
    data: $data
    supplierId: $supplierId
  )
}
    `;
export type UpdateSupplierMoreInformationMutationFn = Apollo.MutationFunction<UpdateSupplierMoreInformationMutation, UpdateSupplierMoreInformationMutationVariables>;

/**
 * __useUpdateSupplierMoreInformationMutation__
 *
 * To run a mutation, you first call `useUpdateSupplierMoreInformationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSupplierMoreInformationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSupplierMoreInformationMutation, { data, loading, error }] = useUpdateSupplierMoreInformationMutation({
 *   variables: {
 *      verifyToken: // value for 'verifyToken'
 *      data: // value for 'data'
 *      supplierId: // value for 'supplierId'
 *   },
 * });
 */
export function useUpdateSupplierMoreInformationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSupplierMoreInformationMutation, UpdateSupplierMoreInformationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSupplierMoreInformationMutation, UpdateSupplierMoreInformationMutationVariables>(UpdateSupplierMoreInformationDocument, options);
      }
export type UpdateSupplierMoreInformationMutationHookResult = ReturnType<typeof useUpdateSupplierMoreInformationMutation>;
export type UpdateSupplierMoreInformationMutationResult = Apollo.MutationResult<UpdateSupplierMoreInformationMutation>;
export type UpdateSupplierMoreInformationMutationOptions = Apollo.BaseMutationOptions<UpdateSupplierMoreInformationMutation, UpdateSupplierMoreInformationMutationVariables>;
export const CreateProductGroupDocument = gql`
    mutation createProductGroup($data: ProductGroupInput!) {
  createProductGroup(data: $data)
}
    `;
export type CreateProductGroupMutationFn = Apollo.MutationFunction<CreateProductGroupMutation, CreateProductGroupMutationVariables>;

/**
 * __useCreateProductGroupMutation__
 *
 * To run a mutation, you first call `useCreateProductGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProductGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProductGroupMutation, { data, loading, error }] = useCreateProductGroupMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateProductGroupMutation(baseOptions?: Apollo.MutationHookOptions<CreateProductGroupMutation, CreateProductGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateProductGroupMutation, CreateProductGroupMutationVariables>(CreateProductGroupDocument, options);
      }
export type CreateProductGroupMutationHookResult = ReturnType<typeof useCreateProductGroupMutation>;
export type CreateProductGroupMutationResult = Apollo.MutationResult<CreateProductGroupMutation>;
export type CreateProductGroupMutationOptions = Apollo.BaseMutationOptions<CreateProductGroupMutation, CreateProductGroupMutationVariables>;
export const UpdateProductGroupDocument = gql`
    mutation updateProductGroup($id: Int!, $data: ProductGroupInput!) {
  updateProductGroup(id: $id, data: $data)
}
    `;
export type UpdateProductGroupMutationFn = Apollo.MutationFunction<UpdateProductGroupMutation, UpdateProductGroupMutationVariables>;

/**
 * __useUpdateProductGroupMutation__
 *
 * To run a mutation, you first call `useUpdateProductGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProductGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProductGroupMutation, { data, loading, error }] = useUpdateProductGroupMutation({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateProductGroupMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProductGroupMutation, UpdateProductGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProductGroupMutation, UpdateProductGroupMutationVariables>(UpdateProductGroupDocument, options);
      }
export type UpdateProductGroupMutationHookResult = ReturnType<typeof useUpdateProductGroupMutation>;
export type UpdateProductGroupMutationResult = Apollo.MutationResult<UpdateProductGroupMutation>;
export type UpdateProductGroupMutationOptions = Apollo.BaseMutationOptions<UpdateProductGroupMutation, UpdateProductGroupMutationVariables>;
export const UploadDocument = gql`
    mutation upload($file: Upload!) {
  upload(file: $file) {
    filename
    url
  }
}
    `;
export type UploadMutationFn = Apollo.MutationFunction<UploadMutation, UploadMutationVariables>;

/**
 * __useUploadMutation__
 *
 * To run a mutation, you first call `useUploadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadMutation, { data, loading, error }] = useUploadMutation({
 *   variables: {
 *      file: // value for 'file'
 *   },
 * });
 */
export function useUploadMutation(baseOptions?: Apollo.MutationHookOptions<UploadMutation, UploadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UploadMutation, UploadMutationVariables>(UploadDocument, options);
      }
export type UploadMutationHookResult = ReturnType<typeof useUploadMutation>;
export type UploadMutationResult = Apollo.MutationResult<UploadMutation>;
export type UploadMutationOptions = Apollo.BaseMutationOptions<UploadMutation, UploadMutationVariables>;
export const UpdateMerchantInfoDocument = gql`
    mutation updateMerchantInfo($data: MerchantInput) {
  updateMerchantInfo(data: $data)
}
    `;
export type UpdateMerchantInfoMutationFn = Apollo.MutationFunction<UpdateMerchantInfoMutation, UpdateMerchantInfoMutationVariables>;

/**
 * __useUpdateMerchantInfoMutation__
 *
 * To run a mutation, you first call `useUpdateMerchantInfoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMerchantInfoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMerchantInfoMutation, { data, loading, error }] = useUpdateMerchantInfoMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateMerchantInfoMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMerchantInfoMutation, UpdateMerchantInfoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMerchantInfoMutation, UpdateMerchantInfoMutationVariables>(UpdateMerchantInfoDocument, options);
      }
export type UpdateMerchantInfoMutationHookResult = ReturnType<typeof useUpdateMerchantInfoMutation>;
export type UpdateMerchantInfoMutationResult = Apollo.MutationResult<UpdateMerchantInfoMutation>;
export type UpdateMerchantInfoMutationOptions = Apollo.BaseMutationOptions<UpdateMerchantInfoMutation, UpdateMerchantInfoMutationVariables>;
export const ForgetSupplierPasswordDocument = gql`
    mutation forgetSupplierPassword($username: String!) {
  forgetSupplierPassword(username: $username) {
    success
    token
    message
    status
  }
}
    `;
export type ForgetSupplierPasswordMutationFn = Apollo.MutationFunction<ForgetSupplierPasswordMutation, ForgetSupplierPasswordMutationVariables>;

/**
 * __useForgetSupplierPasswordMutation__
 *
 * To run a mutation, you first call `useForgetSupplierPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useForgetSupplierPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [forgetSupplierPasswordMutation, { data, loading, error }] = useForgetSupplierPasswordMutation({
 *   variables: {
 *      username: // value for 'username'
 *   },
 * });
 */
export function useForgetSupplierPasswordMutation(baseOptions?: Apollo.MutationHookOptions<ForgetSupplierPasswordMutation, ForgetSupplierPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ForgetSupplierPasswordMutation, ForgetSupplierPasswordMutationVariables>(ForgetSupplierPasswordDocument, options);
      }
export type ForgetSupplierPasswordMutationHookResult = ReturnType<typeof useForgetSupplierPasswordMutation>;
export type ForgetSupplierPasswordMutationResult = Apollo.MutationResult<ForgetSupplierPasswordMutation>;
export type ForgetSupplierPasswordMutationOptions = Apollo.BaseMutationOptions<ForgetSupplierPasswordMutation, ForgetSupplierPasswordMutationVariables>;
export const ResetSupplierPasswordDocument = gql`
    mutation resetSupplierPassword($newPassword: String!) {
  resetSupplierPassword(newPassword: $newPassword)
}
    `;
export type ResetSupplierPasswordMutationFn = Apollo.MutationFunction<ResetSupplierPasswordMutation, ResetSupplierPasswordMutationVariables>;

/**
 * __useResetSupplierPasswordMutation__
 *
 * To run a mutation, you first call `useResetSupplierPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetSupplierPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetSupplierPasswordMutation, { data, loading, error }] = useResetSupplierPasswordMutation({
 *   variables: {
 *      newPassword: // value for 'newPassword'
 *   },
 * });
 */
export function useResetSupplierPasswordMutation(baseOptions?: Apollo.MutationHookOptions<ResetSupplierPasswordMutation, ResetSupplierPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResetSupplierPasswordMutation, ResetSupplierPasswordMutationVariables>(ResetSupplierPasswordDocument, options);
      }
export type ResetSupplierPasswordMutationHookResult = ReturnType<typeof useResetSupplierPasswordMutation>;
export type ResetSupplierPasswordMutationResult = Apollo.MutationResult<ResetSupplierPasswordMutation>;
export type ResetSupplierPasswordMutationOptions = Apollo.BaseMutationOptions<ResetSupplierPasswordMutation, ResetSupplierPasswordMutationVariables>;
export const PayTransitDisbursementDocument = gql`
    mutation payTransitDisbursement($disburseId: Int!, $proof: String!, $exchangeRate: Decimal!, $fee: Decimal) {
  payTransitDisbursement(
    disburseId: $disburseId
    proof: $proof
    exchangeRate: $exchangeRate
    fee: $fee
  )
}
    `;
export type PayTransitDisbursementMutationFn = Apollo.MutationFunction<PayTransitDisbursementMutation, PayTransitDisbursementMutationVariables>;

/**
 * __usePayTransitDisbursementMutation__
 *
 * To run a mutation, you first call `usePayTransitDisbursementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePayTransitDisbursementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [payTransitDisbursementMutation, { data, loading, error }] = usePayTransitDisbursementMutation({
 *   variables: {
 *      disburseId: // value for 'disburseId'
 *      proof: // value for 'proof'
 *      exchangeRate: // value for 'exchangeRate'
 *      fee: // value for 'fee'
 *   },
 * });
 */
export function usePayTransitDisbursementMutation(baseOptions?: Apollo.MutationHookOptions<PayTransitDisbursementMutation, PayTransitDisbursementMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PayTransitDisbursementMutation, PayTransitDisbursementMutationVariables>(PayTransitDisbursementDocument, options);
      }
export type PayTransitDisbursementMutationHookResult = ReturnType<typeof usePayTransitDisbursementMutation>;
export type PayTransitDisbursementMutationResult = Apollo.MutationResult<PayTransitDisbursementMutation>;
export type PayTransitDisbursementMutationOptions = Apollo.BaseMutationOptions<PayTransitDisbursementMutation, PayTransitDisbursementMutationVariables>;
export const AddToReplenishmentWishlistDocument = gql`
    mutation addToReplenishmentWishlist($itemid: Int!) {
  addToReplenishmentWishlist(itemid: $itemid)
}
    `;
export type AddToReplenishmentWishlistMutationFn = Apollo.MutationFunction<AddToReplenishmentWishlistMutation, AddToReplenishmentWishlistMutationVariables>;

/**
 * __useAddToReplenishmentWishlistMutation__
 *
 * To run a mutation, you first call `useAddToReplenishmentWishlistMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddToReplenishmentWishlistMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addToReplenishmentWishlistMutation, { data, loading, error }] = useAddToReplenishmentWishlistMutation({
 *   variables: {
 *      itemid: // value for 'itemid'
 *   },
 * });
 */
export function useAddToReplenishmentWishlistMutation(baseOptions?: Apollo.MutationHookOptions<AddToReplenishmentWishlistMutation, AddToReplenishmentWishlistMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddToReplenishmentWishlistMutation, AddToReplenishmentWishlistMutationVariables>(AddToReplenishmentWishlistDocument, options);
      }
export type AddToReplenishmentWishlistMutationHookResult = ReturnType<typeof useAddToReplenishmentWishlistMutation>;
export type AddToReplenishmentWishlistMutationResult = Apollo.MutationResult<AddToReplenishmentWishlistMutation>;
export type AddToReplenishmentWishlistMutationOptions = Apollo.BaseMutationOptions<AddToReplenishmentWishlistMutation, AddToReplenishmentWishlistMutationVariables>;
export const RemoveFromReplenishmentWishlistDocument = gql`
    mutation removeFromReplenishmentWishlist($itemid: Int!) {
  removeFromReplenishmentWishlist(itemid: $itemid)
}
    `;
export type RemoveFromReplenishmentWishlistMutationFn = Apollo.MutationFunction<RemoveFromReplenishmentWishlistMutation, RemoveFromReplenishmentWishlistMutationVariables>;

/**
 * __useRemoveFromReplenishmentWishlistMutation__
 *
 * To run a mutation, you first call `useRemoveFromReplenishmentWishlistMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveFromReplenishmentWishlistMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeFromReplenishmentWishlistMutation, { data, loading, error }] = useRemoveFromReplenishmentWishlistMutation({
 *   variables: {
 *      itemid: // value for 'itemid'
 *   },
 * });
 */
export function useRemoveFromReplenishmentWishlistMutation(baseOptions?: Apollo.MutationHookOptions<RemoveFromReplenishmentWishlistMutation, RemoveFromReplenishmentWishlistMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveFromReplenishmentWishlistMutation, RemoveFromReplenishmentWishlistMutationVariables>(RemoveFromReplenishmentWishlistDocument, options);
      }
export type RemoveFromReplenishmentWishlistMutationHookResult = ReturnType<typeof useRemoveFromReplenishmentWishlistMutation>;
export type RemoveFromReplenishmentWishlistMutationResult = Apollo.MutationResult<RemoveFromReplenishmentWishlistMutation>;
export type RemoveFromReplenishmentWishlistMutationOptions = Apollo.BaseMutationOptions<RemoveFromReplenishmentWishlistMutation, RemoveFromReplenishmentWishlistMutationVariables>;
export const MakeACopyProductDocument = gql`
    mutation makeACopyProduct($itemid: Int!) {
  makeACopyProduct(itemid: $itemid)
}
    `;
export type MakeACopyProductMutationFn = Apollo.MutationFunction<MakeACopyProductMutation, MakeACopyProductMutationVariables>;

/**
 * __useMakeACopyProductMutation__
 *
 * To run a mutation, you first call `useMakeACopyProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMakeACopyProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [makeACopyProductMutation, { data, loading, error }] = useMakeACopyProductMutation({
 *   variables: {
 *      itemid: // value for 'itemid'
 *   },
 * });
 */
export function useMakeACopyProductMutation(baseOptions?: Apollo.MutationHookOptions<MakeACopyProductMutation, MakeACopyProductMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MakeACopyProductMutation, MakeACopyProductMutationVariables>(MakeACopyProductDocument, options);
      }
export type MakeACopyProductMutationHookResult = ReturnType<typeof useMakeACopyProductMutation>;
export type MakeACopyProductMutationResult = Apollo.MutationResult<MakeACopyProductMutation>;
export type MakeACopyProductMutationOptions = Apollo.BaseMutationOptions<MakeACopyProductMutation, MakeACopyProductMutationVariables>;
export const MarkRestockingSkuDocument = gql`
    mutation markRestockingSku($skuIds: [Int], $restocking: Boolean) {
  markRestockingSku(skuIds: $skuIds, restocking: $restocking)
}
    `;
export type MarkRestockingSkuMutationFn = Apollo.MutationFunction<MarkRestockingSkuMutation, MarkRestockingSkuMutationVariables>;

/**
 * __useMarkRestockingSkuMutation__
 *
 * To run a mutation, you first call `useMarkRestockingSkuMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkRestockingSkuMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markRestockingSkuMutation, { data, loading, error }] = useMarkRestockingSkuMutation({
 *   variables: {
 *      skuIds: // value for 'skuIds'
 *      restocking: // value for 'restocking'
 *   },
 * });
 */
export function useMarkRestockingSkuMutation(baseOptions?: Apollo.MutationHookOptions<MarkRestockingSkuMutation, MarkRestockingSkuMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkRestockingSkuMutation, MarkRestockingSkuMutationVariables>(MarkRestockingSkuDocument, options);
      }
export type MarkRestockingSkuMutationHookResult = ReturnType<typeof useMarkRestockingSkuMutation>;
export type MarkRestockingSkuMutationResult = Apollo.MutationResult<MarkRestockingSkuMutation>;
export type MarkRestockingSkuMutationOptions = Apollo.BaseMutationOptions<MarkRestockingSkuMutation, MarkRestockingSkuMutationVariables>;
export const CreateSupplierRestockingSkuDocument = gql`
    mutation createSupplierRestockingSku($data: [RestockingSku]) {
  createSupplierRestockingSku(data: $data)
}
    `;
export type CreateSupplierRestockingSkuMutationFn = Apollo.MutationFunction<CreateSupplierRestockingSkuMutation, CreateSupplierRestockingSkuMutationVariables>;

/**
 * __useCreateSupplierRestockingSkuMutation__
 *
 * To run a mutation, you first call `useCreateSupplierRestockingSkuMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSupplierRestockingSkuMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSupplierRestockingSkuMutation, { data, loading, error }] = useCreateSupplierRestockingSkuMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateSupplierRestockingSkuMutation(baseOptions?: Apollo.MutationHookOptions<CreateSupplierRestockingSkuMutation, CreateSupplierRestockingSkuMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSupplierRestockingSkuMutation, CreateSupplierRestockingSkuMutationVariables>(CreateSupplierRestockingSkuDocument, options);
      }
export type CreateSupplierRestockingSkuMutationHookResult = ReturnType<typeof useCreateSupplierRestockingSkuMutation>;
export type CreateSupplierRestockingSkuMutationResult = Apollo.MutationResult<CreateSupplierRestockingSkuMutation>;
export type CreateSupplierRestockingSkuMutationOptions = Apollo.BaseMutationOptions<CreateSupplierRestockingSkuMutation, CreateSupplierRestockingSkuMutationVariables>;
export const SetupSellerTelegramGroupDocument = gql`
    mutation SetupSellerTelegramGroup($groupId: String!) {
  setupSellerTelegramGroup(groupId: $groupId)
}
    `;
export type SetupSellerTelegramGroupMutationFn = Apollo.MutationFunction<SetupSellerTelegramGroupMutation, SetupSellerTelegramGroupMutationVariables>;

/**
 * __useSetupSellerTelegramGroupMutation__
 *
 * To run a mutation, you first call `useSetupSellerTelegramGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetupSellerTelegramGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setupSellerTelegramGroupMutation, { data, loading, error }] = useSetupSellerTelegramGroupMutation({
 *   variables: {
 *      groupId: // value for 'groupId'
 *   },
 * });
 */
export function useSetupSellerTelegramGroupMutation(baseOptions?: Apollo.MutationHookOptions<SetupSellerTelegramGroupMutation, SetupSellerTelegramGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetupSellerTelegramGroupMutation, SetupSellerTelegramGroupMutationVariables>(SetupSellerTelegramGroupDocument, options);
      }
export type SetupSellerTelegramGroupMutationHookResult = ReturnType<typeof useSetupSellerTelegramGroupMutation>;
export type SetupSellerTelegramGroupMutationResult = Apollo.MutationResult<SetupSellerTelegramGroupMutation>;
export type SetupSellerTelegramGroupMutationOptions = Apollo.BaseMutationOptions<SetupSellerTelegramGroupMutation, SetupSellerTelegramGroupMutationVariables>;
export const RemoveSellerTelegramGroupDocument = gql`
    mutation RemoveSellerTelegramGroup {
  removeSellerTelegramGroup
}
    `;
export type RemoveSellerTelegramGroupMutationFn = Apollo.MutationFunction<RemoveSellerTelegramGroupMutation, RemoveSellerTelegramGroupMutationVariables>;

/**
 * __useRemoveSellerTelegramGroupMutation__
 *
 * To run a mutation, you first call `useRemoveSellerTelegramGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveSellerTelegramGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeSellerTelegramGroupMutation, { data, loading, error }] = useRemoveSellerTelegramGroupMutation({
 *   variables: {
 *   },
 * });
 */
export function useRemoveSellerTelegramGroupMutation(baseOptions?: Apollo.MutationHookOptions<RemoveSellerTelegramGroupMutation, RemoveSellerTelegramGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveSellerTelegramGroupMutation, RemoveSellerTelegramGroupMutationVariables>(RemoveSellerTelegramGroupDocument, options);
      }
export type RemoveSellerTelegramGroupMutationHookResult = ReturnType<typeof useRemoveSellerTelegramGroupMutation>;
export type RemoveSellerTelegramGroupMutationResult = Apollo.MutationResult<RemoveSellerTelegramGroupMutation>;
export type RemoveSellerTelegramGroupMutationOptions = Apollo.BaseMutationOptions<RemoveSellerTelegramGroupMutation, RemoveSellerTelegramGroupMutationVariables>;
export const MerchantDocument = gql`
    query merchant {
  merchant {
    id
    name
    logo
    banner
    origin
    address
    contact
    emails
    registerNumber
    vat
    role
    fiscalCodeNumber
    bankAccountHoldName
    bankAccountNumber
    bankName
    ownerName
    ownerType
    ownerNumber
    coordLat
    coordLng
    approvedDate
    approvedBy
    balance
    frontStoreImage
    pos
    userType
    isMoreSecurity
    recruiterId
    abaLink
    enabledChat
    verifiedBankAccount
    telegramGroupId
  }
  supplierSetting {
    minimumDeliverTime
    exchangeRate
    packageValueLimit
    packageReachLimitMessage
    enabledChat
    affiliateThirdPartyBank
  }
  supplierSettingList
}
    `;

/**
 * __useMerchantQuery__
 *
 * To run a query within a React component, call `useMerchantQuery` and pass it any options that fit your needs.
 * When your component renders, `useMerchantQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMerchantQuery({
 *   variables: {
 *   },
 * });
 */
export function useMerchantQuery(baseOptions?: Apollo.QueryHookOptions<MerchantQuery, MerchantQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MerchantQuery, MerchantQueryVariables>(MerchantDocument, options);
      }
export function useMerchantLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MerchantQuery, MerchantQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MerchantQuery, MerchantQueryVariables>(MerchantDocument, options);
        }
export type MerchantQueryHookResult = ReturnType<typeof useMerchantQuery>;
export type MerchantLazyQueryHookResult = ReturnType<typeof useMerchantLazyQuery>;
export type MerchantQueryResult = Apollo.QueryResult<MerchantQuery, MerchantQueryVariables>;
export const SupplierInventoryMonitorDocument = gql`
    query supplierInventoryMonitor($groupBy: SupplierInventoryMonitorGroupBy, $offset: Int = 0, $limit: Int = 20, $sortBy: SupplierInventoryMonitorSortBy = TOTALSTOCKIN, $sortDirection: SortOrder = DESC, $search: String = "") {
  supplierInventoryMonitor(
    groupBy: $groupBy
    offset: $offset
    limit: $limit
    sortBy: $sortBy
    sortDirection: $sortDirection
    search: $search
  ) {
    data {
      product {
        id
        code
        thumbnail
        title
      }
      brand {
        id
        name
        picture
      }
      vendor {
        id
        name
      }
      totalStockIn
      currentStock
      soldQty
      saleQty
      lostQty
      recycleIn
      remoteSoldQty
      remoteSaleQty
      uncollected
      returned
      recycleIn
      damage
      stockOut
    }
    page {
      current
      size
      total
    }
  }
}
    `;

/**
 * __useSupplierInventoryMonitorQuery__
 *
 * To run a query within a React component, call `useSupplierInventoryMonitorQuery` and pass it any options that fit your needs.
 * When your component renders, `useSupplierInventoryMonitorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSupplierInventoryMonitorQuery({
 *   variables: {
 *      groupBy: // value for 'groupBy'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      sortBy: // value for 'sortBy'
 *      sortDirection: // value for 'sortDirection'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useSupplierInventoryMonitorQuery(baseOptions?: Apollo.QueryHookOptions<SupplierInventoryMonitorQuery, SupplierInventoryMonitorQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SupplierInventoryMonitorQuery, SupplierInventoryMonitorQueryVariables>(SupplierInventoryMonitorDocument, options);
      }
export function useSupplierInventoryMonitorLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SupplierInventoryMonitorQuery, SupplierInventoryMonitorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SupplierInventoryMonitorQuery, SupplierInventoryMonitorQueryVariables>(SupplierInventoryMonitorDocument, options);
        }
export type SupplierInventoryMonitorQueryHookResult = ReturnType<typeof useSupplierInventoryMonitorQuery>;
export type SupplierInventoryMonitorLazyQueryHookResult = ReturnType<typeof useSupplierInventoryMonitorLazyQuery>;
export type SupplierInventoryMonitorQueryResult = Apollo.QueryResult<SupplierInventoryMonitorQuery, SupplierInventoryMonitorQueryVariables>;
export const SupplierProductPerformanceDocument = gql`
    query supplierProductPerformance($offset: Int = 0, $limit: Int = 20, $search: String = "", $groupBy: SupplierProudctPerformanceGroupBy = ITEM, $sortBy: SupplierProductPerformanceSortBy = HOT, $sortDirection: SortOrder = DESC) {
  supplierProductPerformance(
    offset: $offset
    limit: $limit
    search: $search
    groupBy: $groupBy
    sortBy: $sortBy
    sortDirection: $sortDirection
  ) {
    data {
      product {
        id
        code
        title
        thumbnail
      }
      brand {
        id
        name
        picture
      }
      vendor {
        id
        name
      }
      category {
        currentLanguageName
      }
      currentStock
      itemCount
      hot
      inputDate
      firstSold
      lastSold
      soldQty
      mostSoldMonth
      mostSoldPerMonth
      transactionCount
      returnedRate
      uncollectedRate
      discountRate
      revenue
      addToCart
      reach
      clicks
    }
    page {
      current
      size
      total
    }
  }
}
    `;

/**
 * __useSupplierProductPerformanceQuery__
 *
 * To run a query within a React component, call `useSupplierProductPerformanceQuery` and pass it any options that fit your needs.
 * When your component renders, `useSupplierProductPerformanceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSupplierProductPerformanceQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      search: // value for 'search'
 *      groupBy: // value for 'groupBy'
 *      sortBy: // value for 'sortBy'
 *      sortDirection: // value for 'sortDirection'
 *   },
 * });
 */
export function useSupplierProductPerformanceQuery(baseOptions?: Apollo.QueryHookOptions<SupplierProductPerformanceQuery, SupplierProductPerformanceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SupplierProductPerformanceQuery, SupplierProductPerformanceQueryVariables>(SupplierProductPerformanceDocument, options);
      }
export function useSupplierProductPerformanceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SupplierProductPerformanceQuery, SupplierProductPerformanceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SupplierProductPerformanceQuery, SupplierProductPerformanceQueryVariables>(SupplierProductPerformanceDocument, options);
        }
export type SupplierProductPerformanceQueryHookResult = ReturnType<typeof useSupplierProductPerformanceQuery>;
export type SupplierProductPerformanceLazyQueryHookResult = ReturnType<typeof useSupplierProductPerformanceLazyQuery>;
export type SupplierProductPerformanceQueryResult = Apollo.QueryResult<SupplierProductPerformanceQuery, SupplierProductPerformanceQueryVariables>;
export const SupplierPromoComboListDocument = gql`
    query supplierPromoComboList($offset: Int = 0, $limit: Int = 25, $orderBy: SortOrder = DESC) {
  supplierPromoComboList(offset: $offset, limit: $limit, orderBy: $orderBy) {
    data {
      id
      availableQty
      dealCriteria
      discountTier {
        reach
        discount
        freeDelivery
        freeGift {
          qty
          sku {
            barcode
            id
            color
            size
          }
        }
      }
      discountType
      endDate
      id
      minOrder
      products {
        comboId
        createdAt
        item {
          id
          code
          title
          thumbnail
        }
      }
      promoName
      saleQty
      scope
      startDate
      status
      checkoutQty
    }
    page {
      total
    }
  }
}
    `;

/**
 * __useSupplierPromoComboListQuery__
 *
 * To run a query within a React component, call `useSupplierPromoComboListQuery` and pass it any options that fit your needs.
 * When your component renders, `useSupplierPromoComboListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSupplierPromoComboListQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useSupplierPromoComboListQuery(baseOptions?: Apollo.QueryHookOptions<SupplierPromoComboListQuery, SupplierPromoComboListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SupplierPromoComboListQuery, SupplierPromoComboListQueryVariables>(SupplierPromoComboListDocument, options);
      }
export function useSupplierPromoComboListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SupplierPromoComboListQuery, SupplierPromoComboListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SupplierPromoComboListQuery, SupplierPromoComboListQueryVariables>(SupplierPromoComboListDocument, options);
        }
export type SupplierPromoComboListQueryHookResult = ReturnType<typeof useSupplierPromoComboListQuery>;
export type SupplierPromoComboListLazyQueryHookResult = ReturnType<typeof useSupplierPromoComboListLazyQuery>;
export type SupplierPromoComboListQueryResult = Apollo.QueryResult<SupplierPromoComboListQuery, SupplierPromoComboListQueryVariables>;
export const EventCampaignListDocument = gql`
    query eventCampaignList($offset: Int = 0, $limit: Int = 10, $registered: Boolean = false, $upcoming: Boolean) {
  eventCampaignList(
    offset: $offset
    limit: $limit
    registered: $registered
    upcoming: $upcoming
  ) {
    id
    campaignBanner
    campaignName
    status
    registrationClosedDate
    startDate
    endDate
    minimumDiscount
  }
}
    `;

/**
 * __useEventCampaignListQuery__
 *
 * To run a query within a React component, call `useEventCampaignListQuery` and pass it any options that fit your needs.
 * When your component renders, `useEventCampaignListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEventCampaignListQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      registered: // value for 'registered'
 *      upcoming: // value for 'upcoming'
 *   },
 * });
 */
export function useEventCampaignListQuery(baseOptions?: Apollo.QueryHookOptions<EventCampaignListQuery, EventCampaignListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EventCampaignListQuery, EventCampaignListQueryVariables>(EventCampaignListDocument, options);
      }
export function useEventCampaignListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EventCampaignListQuery, EventCampaignListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EventCampaignListQuery, EventCampaignListQueryVariables>(EventCampaignListDocument, options);
        }
export type EventCampaignListQueryHookResult = ReturnType<typeof useEventCampaignListQuery>;
export type EventCampaignListLazyQueryHookResult = ReturnType<typeof useEventCampaignListLazyQuery>;
export type EventCampaignListQueryResult = Apollo.QueryResult<EventCampaignListQuery, EventCampaignListQueryVariables>;
export const SupplierShipmentListDocument = gql`
    query supplierShipmentList($orderBy: SortOrder = DESC, $status: [ShipmentLogStatus], $offset: Int, $limit: Int, $abnormalStatus: [AbnormalStatusType], $shipmentId: String) {
  supplierShipmentList(
    orderBy: $orderBy
    status: $status
    offset: $offset
    limit: $limit
    abnormalStatus: $abnormalStatus
    shipmentId: $shipmentId
  ) {
    data {
      id
      createdAt
      qty
      received
      receivedDate
      shipperReceived
      requestDate
      tracking_number
      departedDate
      shipmentLog {
        description
        date
      }
      status
      receivedAdmin
      shipmentCode
      supplier {
        id
        name
      }
      package {
        id
        uuid
      }
    }
    page {
      current
      size
      total
    }
  }
}
    `;

/**
 * __useSupplierShipmentListQuery__
 *
 * To run a query within a React component, call `useSupplierShipmentListQuery` and pass it any options that fit your needs.
 * When your component renders, `useSupplierShipmentListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSupplierShipmentListQuery({
 *   variables: {
 *      orderBy: // value for 'orderBy'
 *      status: // value for 'status'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      abnormalStatus: // value for 'abnormalStatus'
 *      shipmentId: // value for 'shipmentId'
 *   },
 * });
 */
export function useSupplierShipmentListQuery(baseOptions?: Apollo.QueryHookOptions<SupplierShipmentListQuery, SupplierShipmentListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SupplierShipmentListQuery, SupplierShipmentListQueryVariables>(SupplierShipmentListDocument, options);
      }
export function useSupplierShipmentListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SupplierShipmentListQuery, SupplierShipmentListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SupplierShipmentListQuery, SupplierShipmentListQueryVariables>(SupplierShipmentListDocument, options);
        }
export type SupplierShipmentListQueryHookResult = ReturnType<typeof useSupplierShipmentListQuery>;
export type SupplierShipmentListLazyQueryHookResult = ReturnType<typeof useSupplierShipmentListLazyQuery>;
export type SupplierShipmentListQueryResult = Apollo.QueryResult<SupplierShipmentListQuery, SupplierShipmentListQueryVariables>;
export const SupplierDisbursementAvailableListDocument = gql`
    query supplierDisbursementAvailableList {
  supplierDisbursementAvailableList {
    orderId
    orderUUID
    item {
      id
      code
      price
      priceAfterDiscount
      thumbnail
      supplierCode
    }
    price
    color
    size
    commission
    deliveryFee
    handlingFee
    type
    amount
    description
  }
}
    `;

/**
 * __useSupplierDisbursementAvailableListQuery__
 *
 * To run a query within a React component, call `useSupplierDisbursementAvailableListQuery` and pass it any options that fit your needs.
 * When your component renders, `useSupplierDisbursementAvailableListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSupplierDisbursementAvailableListQuery({
 *   variables: {
 *   },
 * });
 */
export function useSupplierDisbursementAvailableListQuery(baseOptions?: Apollo.QueryHookOptions<SupplierDisbursementAvailableListQuery, SupplierDisbursementAvailableListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SupplierDisbursementAvailableListQuery, SupplierDisbursementAvailableListQueryVariables>(SupplierDisbursementAvailableListDocument, options);
      }
export function useSupplierDisbursementAvailableListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SupplierDisbursementAvailableListQuery, SupplierDisbursementAvailableListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SupplierDisbursementAvailableListQuery, SupplierDisbursementAvailableListQueryVariables>(SupplierDisbursementAvailableListDocument, options);
        }
export type SupplierDisbursementAvailableListQueryHookResult = ReturnType<typeof useSupplierDisbursementAvailableListQuery>;
export type SupplierDisbursementAvailableListLazyQueryHookResult = ReturnType<typeof useSupplierDisbursementAvailableListLazyQuery>;
export type SupplierDisbursementAvailableListQueryResult = Apollo.QueryResult<SupplierDisbursementAvailableListQuery, SupplierDisbursementAvailableListQueryVariables>;
export const SupplierInternalDisbursementListDocument = gql`
    query supplierInternalDisbursementList($status: DisbursementStatus, $supplierInternalDisbursementListId: String, $supplierId: Int) {
  supplierInternalDisbursementList(
    status: $status
    id: $supplierInternalDisbursementListId
    supplierId: $supplierId
  ) {
    data {
      id
      uuid
      amount
      supplier {
        name
        vat
        bankAccountHolderName
        bankAccountNumber
        bankName
        contact
      }
      log {
        date
        value
        admin {
          name
        }
      }
      proof
      requestedDate
      gatewayProof
      status
      publicStatus
    }
  }
}
    `;

/**
 * __useSupplierInternalDisbursementListQuery__
 *
 * To run a query within a React component, call `useSupplierInternalDisbursementListQuery` and pass it any options that fit your needs.
 * When your component renders, `useSupplierInternalDisbursementListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSupplierInternalDisbursementListQuery({
 *   variables: {
 *      status: // value for 'status'
 *      supplierInternalDisbursementListId: // value for 'supplierInternalDisbursementListId'
 *      supplierId: // value for 'supplierId'
 *   },
 * });
 */
export function useSupplierInternalDisbursementListQuery(baseOptions?: Apollo.QueryHookOptions<SupplierInternalDisbursementListQuery, SupplierInternalDisbursementListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SupplierInternalDisbursementListQuery, SupplierInternalDisbursementListQueryVariables>(SupplierInternalDisbursementListDocument, options);
      }
export function useSupplierInternalDisbursementListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SupplierInternalDisbursementListQuery, SupplierInternalDisbursementListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SupplierInternalDisbursementListQuery, SupplierInternalDisbursementListQueryVariables>(SupplierInternalDisbursementListDocument, options);
        }
export type SupplierInternalDisbursementListQueryHookResult = ReturnType<typeof useSupplierInternalDisbursementListQuery>;
export type SupplierInternalDisbursementListLazyQueryHookResult = ReturnType<typeof useSupplierInternalDisbursementListLazyQuery>;
export type SupplierInternalDisbursementListQueryResult = Apollo.QueryResult<SupplierInternalDisbursementListQuery, SupplierInternalDisbursementListQueryVariables>;
export const SellerAdsV2ListDocument = gql`
    query sellerAdsV2List($limit: Int, $offset: Int, $filters: SellerAdsV2Filter) {
  sellerAdsV2List(limit: $limit, offset: $offset, filters: $filters) {
    id
    name
    createdAt
    updatedAt
    startAt
    endAt
    suspendedAt
    rejectedAt
    status
    budgetPerDay
    estimatedReach
    reach
    click
    salesQty
    salesAmount
    adsType
    disbursementId
    adsCost
  }
}
    `;

/**
 * __useSellerAdsV2ListQuery__
 *
 * To run a query within a React component, call `useSellerAdsV2ListQuery` and pass it any options that fit your needs.
 * When your component renders, `useSellerAdsV2ListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSellerAdsV2ListQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useSellerAdsV2ListQuery(baseOptions?: Apollo.QueryHookOptions<SellerAdsV2ListQuery, SellerAdsV2ListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SellerAdsV2ListQuery, SellerAdsV2ListQueryVariables>(SellerAdsV2ListDocument, options);
      }
export function useSellerAdsV2ListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SellerAdsV2ListQuery, SellerAdsV2ListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SellerAdsV2ListQuery, SellerAdsV2ListQueryVariables>(SellerAdsV2ListDocument, options);
        }
export type SellerAdsV2ListQueryHookResult = ReturnType<typeof useSellerAdsV2ListQuery>;
export type SellerAdsV2ListLazyQueryHookResult = ReturnType<typeof useSellerAdsV2ListLazyQuery>;
export type SellerAdsV2ListQueryResult = Apollo.QueryResult<SellerAdsV2ListQuery, SellerAdsV2ListQueryVariables>;
export const SellerAdsV2DetailDocument = gql`
    query sellerAdsV2Detail($sellerAdsV2DetailId: Int!) {
  sellerAdsV2Detail(id: $sellerAdsV2DetailId) {
    id
    name
    createdAt
    updatedAt
    startAt
    endAt
    suspendedAt
    rejectedAt
    status
    budgetPerDay
    estimatedReach
    reach
    click
    salesQty
    salesAmount
    adsType
    disbursementId
    productAds {
      item {
        id
        thumbnail
        title
        code
        priceAfterDiscount
        price
        discount
      }
      reach
      click
      salesQty
      salesAmount
    }
    banner {
      src
      navigate
      reach
      click
    }
    adsCost
  }
}
    `;

/**
 * __useSellerAdsV2DetailQuery__
 *
 * To run a query within a React component, call `useSellerAdsV2DetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useSellerAdsV2DetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSellerAdsV2DetailQuery({
 *   variables: {
 *      sellerAdsV2DetailId: // value for 'sellerAdsV2DetailId'
 *   },
 * });
 */
export function useSellerAdsV2DetailQuery(baseOptions: Apollo.QueryHookOptions<SellerAdsV2DetailQuery, SellerAdsV2DetailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SellerAdsV2DetailQuery, SellerAdsV2DetailQueryVariables>(SellerAdsV2DetailDocument, options);
      }
export function useSellerAdsV2DetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SellerAdsV2DetailQuery, SellerAdsV2DetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SellerAdsV2DetailQuery, SellerAdsV2DetailQueryVariables>(SellerAdsV2DetailDocument, options);
        }
export type SellerAdsV2DetailQueryHookResult = ReturnType<typeof useSellerAdsV2DetailQuery>;
export type SellerAdsV2DetailLazyQueryHookResult = ReturnType<typeof useSellerAdsV2DetailLazyQuery>;
export type SellerAdsV2DetailQueryResult = Apollo.QueryResult<SellerAdsV2DetailQuery, SellerAdsV2DetailQueryVariables>;
export const MerchantDiscountItemDocument = gql`
    query merchantDiscountItem($campaign_id: Int!) {
  merchantDiscountItem(campaign_id: $campaign_id)
}
    `;

/**
 * __useMerchantDiscountItemQuery__
 *
 * To run a query within a React component, call `useMerchantDiscountItemQuery` and pass it any options that fit your needs.
 * When your component renders, `useMerchantDiscountItemQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMerchantDiscountItemQuery({
 *   variables: {
 *      campaign_id: // value for 'campaign_id'
 *   },
 * });
 */
export function useMerchantDiscountItemQuery(baseOptions: Apollo.QueryHookOptions<MerchantDiscountItemQuery, MerchantDiscountItemQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MerchantDiscountItemQuery, MerchantDiscountItemQueryVariables>(MerchantDiscountItemDocument, options);
      }
export function useMerchantDiscountItemLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MerchantDiscountItemQuery, MerchantDiscountItemQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MerchantDiscountItemQuery, MerchantDiscountItemQueryVariables>(MerchantDiscountItemDocument, options);
        }
export type MerchantDiscountItemQueryHookResult = ReturnType<typeof useMerchantDiscountItemQuery>;
export type MerchantDiscountItemLazyQueryHookResult = ReturnType<typeof useMerchantDiscountItemLazyQuery>;
export type MerchantDiscountItemQueryResult = Apollo.QueryResult<MerchantDiscountItemQuery, MerchantDiscountItemQueryVariables>;
export const MerchantDiscountItemCampaignDocument = gql`
    query merchantDiscountItemCampaign($offset: Int = 0, $limit: Int = 10) {
  merchantDiscountItemCampaign(offset: $offset, limit: $limit) {
    id
    start_date
    end_date
    actived
  }
}
    `;

/**
 * __useMerchantDiscountItemCampaignQuery__
 *
 * To run a query within a React component, call `useMerchantDiscountItemCampaignQuery` and pass it any options that fit your needs.
 * When your component renders, `useMerchantDiscountItemCampaignQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMerchantDiscountItemCampaignQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useMerchantDiscountItemCampaignQuery(baseOptions?: Apollo.QueryHookOptions<MerchantDiscountItemCampaignQuery, MerchantDiscountItemCampaignQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MerchantDiscountItemCampaignQuery, MerchantDiscountItemCampaignQueryVariables>(MerchantDiscountItemCampaignDocument, options);
      }
export function useMerchantDiscountItemCampaignLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MerchantDiscountItemCampaignQuery, MerchantDiscountItemCampaignQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MerchantDiscountItemCampaignQuery, MerchantDiscountItemCampaignQueryVariables>(MerchantDiscountItemCampaignDocument, options);
        }
export type MerchantDiscountItemCampaignQueryHookResult = ReturnType<typeof useMerchantDiscountItemCampaignQuery>;
export type MerchantDiscountItemCampaignLazyQueryHookResult = ReturnType<typeof useMerchantDiscountItemCampaignLazyQuery>;
export type MerchantDiscountItemCampaignQueryResult = Apollo.QueryResult<MerchantDiscountItemCampaignQuery, MerchantDiscountItemCampaignQueryVariables>;
export const SkuListDocument = gql`
    query skuList($productID: Int) {
  skuList(productID: $productID) {
    id
    productID
    size
    color
    barcode
    product {
      id
      code
      title
      thumbnail
    }
  }
}
    `;

/**
 * __useSkuListQuery__
 *
 * To run a query within a React component, call `useSkuListQuery` and pass it any options that fit your needs.
 * When your component renders, `useSkuListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSkuListQuery({
 *   variables: {
 *      productID: // value for 'productID'
 *   },
 * });
 */
export function useSkuListQuery(baseOptions?: Apollo.QueryHookOptions<SkuListQuery, SkuListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SkuListQuery, SkuListQueryVariables>(SkuListDocument, options);
      }
export function useSkuListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SkuListQuery, SkuListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SkuListQuery, SkuListQueryVariables>(SkuListDocument, options);
        }
export type SkuListQueryHookResult = ReturnType<typeof useSkuListQuery>;
export type SkuListLazyQueryHookResult = ReturnType<typeof useSkuListLazyQuery>;
export type SkuListQueryResult = Apollo.QueryResult<SkuListQuery, SkuListQueryVariables>;
export const ProductListV2Document = gql`
    query productListV2($productListType: ProductListType!, $filter: ProductListFilterV2, $search: ProductSearch, $page: PaginationInput, $orderBy: ProductOrderByInput, $viewBySku: Boolean) {
  productListV2(
    productListType: $productListType
    filter: $filter
    search: $search
    page: $page
    orderBy: $orderBy
    viewBySku: $viewBySku
  ) {
    data {
      id
      picture
      code
      supplierCode
      title {
        en
        km
        zh
      }
      mark
      remoted
      status
      category {
        id
        name {
          en
        }
      }
      brand {
        id
        name
      }
      vendor {
        id
        name
      }
      tags
      price
      discount
      color
      size
      skuList {
        id
        option1
        option2
        barcode
        enabled
        stockQty
        barcodeOriginal
      }
      reach
      clicks
      soldQty
      revenue
      stockQty
      weight
      boxSize
      inputDate
      lastStockIn
      productReview {
        reviews
        rating
      }
    }
    pagination {
      total
    }
  }
}
    `;

/**
 * __useProductListV2Query__
 *
 * To run a query within a React component, call `useProductListV2Query` and pass it any options that fit your needs.
 * When your component renders, `useProductListV2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductListV2Query({
 *   variables: {
 *      productListType: // value for 'productListType'
 *      filter: // value for 'filter'
 *      search: // value for 'search'
 *      page: // value for 'page'
 *      orderBy: // value for 'orderBy'
 *      viewBySku: // value for 'viewBySku'
 *   },
 * });
 */
export function useProductListV2Query(baseOptions: Apollo.QueryHookOptions<ProductListV2Query, ProductListV2QueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductListV2Query, ProductListV2QueryVariables>(ProductListV2Document, options);
      }
export function useProductListV2LazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductListV2Query, ProductListV2QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductListV2Query, ProductListV2QueryVariables>(ProductListV2Document, options);
        }
export type ProductListV2QueryHookResult = ReturnType<typeof useProductListV2Query>;
export type ProductListV2LazyQueryHookResult = ReturnType<typeof useProductListV2LazyQuery>;
export type ProductListV2QueryResult = Apollo.QueryResult<ProductListV2Query, ProductListV2QueryVariables>;
export const SupplierShipmentDetailDocument = gql`
    query supplierShipmentDetail($shipmentId: Int!) {
  supplierShipmentDetail(shipmentId: $shipmentId) {
    shipment {
      id
      createdAt
      qty
      received
      shipperReceived
      requestDate
      shipmentLog {
        description
        date
      }
      status
      receivedAdmin
      receivedBy {
        id
        name
      }
      shipmentCode
      receivedDate
      package {
        id
        uuid
      }
      arrivedDate
      arrivedBy {
        id
        name
      }
      arrivedAt {
        id
        name
        shortName
      }
    }
    items {
      id
      shipmentId
      sku {
        id
        option1
        option2
        product {
          id
          code
          supplierCode
          price
          priceAfterDiscount
          title
          thumbnail
          discount
          weight
          boxSize
        }
      }
      color
      size
      sentQty
      receivedQty
      shipperReceived
    }
  }
}
    `;

/**
 * __useSupplierShipmentDetailQuery__
 *
 * To run a query within a React component, call `useSupplierShipmentDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useSupplierShipmentDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSupplierShipmentDetailQuery({
 *   variables: {
 *      shipmentId: // value for 'shipmentId'
 *   },
 * });
 */
export function useSupplierShipmentDetailQuery(baseOptions: Apollo.QueryHookOptions<SupplierShipmentDetailQuery, SupplierShipmentDetailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SupplierShipmentDetailQuery, SupplierShipmentDetailQueryVariables>(SupplierShipmentDetailDocument, options);
      }
export function useSupplierShipmentDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SupplierShipmentDetailQuery, SupplierShipmentDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SupplierShipmentDetailQuery, SupplierShipmentDetailQueryVariables>(SupplierShipmentDetailDocument, options);
        }
export type SupplierShipmentDetailQueryHookResult = ReturnType<typeof useSupplierShipmentDetailQuery>;
export type SupplierShipmentDetailLazyQueryHookResult = ReturnType<typeof useSupplierShipmentDetailLazyQuery>;
export type SupplierShipmentDetailQueryResult = Apollo.QueryResult<SupplierShipmentDetailQuery, SupplierShipmentDetailQueryVariables>;
export const PackageCountByStatusDocument = gql`
    query packageCountByStatus($dateType: DateType, $start: String, $end: String) {
  packageCountByStatus(dateType: $dateType, start: $start, end: $end) {
    status
    packages
  }
}
    `;

/**
 * __usePackageCountByStatusQuery__
 *
 * To run a query within a React component, call `usePackageCountByStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `usePackageCountByStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePackageCountByStatusQuery({
 *   variables: {
 *      dateType: // value for 'dateType'
 *      start: // value for 'start'
 *      end: // value for 'end'
 *   },
 * });
 */
export function usePackageCountByStatusQuery(baseOptions?: Apollo.QueryHookOptions<PackageCountByStatusQuery, PackageCountByStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PackageCountByStatusQuery, PackageCountByStatusQueryVariables>(PackageCountByStatusDocument, options);
      }
export function usePackageCountByStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PackageCountByStatusQuery, PackageCountByStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PackageCountByStatusQuery, PackageCountByStatusQueryVariables>(PackageCountByStatusDocument, options);
        }
export type PackageCountByStatusQueryHookResult = ReturnType<typeof usePackageCountByStatusQuery>;
export type PackageCountByStatusLazyQueryHookResult = ReturnType<typeof usePackageCountByStatusLazyQuery>;
export type PackageCountByStatusQueryResult = Apollo.QueryResult<PackageCountByStatusQuery, PackageCountByStatusQueryVariables>;
export const PackageListDocument = gql`
    query packageList($keyword: String, $createdAtFrom: String, $createdAtTo: String, $status: [PackageStatus], $customerPhoneNumber: String, $packageUUID: String, $limit: Int! = 100, $offset: Int! = 0, $successDateRange: [String]) {
  packageList(
    keyword: $keyword
    createdAtFrom: $createdAtFrom
    createdAtTo: $createdAtTo
    status: $status
    customerPhoneNumber: $customerPhoneNumber
    packageUUID: $packageUUID
    limit: $limit
    offset: $offset
    successDateRange: $successDateRange
  ) {
    id
    createdAt
    appointedAt
    customerName
    addressName
    cashCollected
    cash
    barcode
    customer {
      id
      name
      phoneNumber
    }
    status
    attempt
    useInsurance
    isPrepayment
    isDropbox
    value
    x
    y
    z
    weight
    hasReturningItem
    returningFromPackageId
    additionalInstruction
    fee
    currentWarehouse {
      shortName
    }
    nextWarehouse {
      shortName
    }
    isReturning
    isPickup
  }
}
    `;

/**
 * __usePackageListQuery__
 *
 * To run a query within a React component, call `usePackageListQuery` and pass it any options that fit your needs.
 * When your component renders, `usePackageListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePackageListQuery({
 *   variables: {
 *      keyword: // value for 'keyword'
 *      createdAtFrom: // value for 'createdAtFrom'
 *      createdAtTo: // value for 'createdAtTo'
 *      status: // value for 'status'
 *      customerPhoneNumber: // value for 'customerPhoneNumber'
 *      packageUUID: // value for 'packageUUID'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      successDateRange: // value for 'successDateRange'
 *   },
 * });
 */
export function usePackageListQuery(baseOptions?: Apollo.QueryHookOptions<PackageListQuery, PackageListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PackageListQuery, PackageListQueryVariables>(PackageListDocument, options);
      }
export function usePackageListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PackageListQuery, PackageListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PackageListQuery, PackageListQueryVariables>(PackageListDocument, options);
        }
export type PackageListQueryHookResult = ReturnType<typeof usePackageListQuery>;
export type PackageListLazyQueryHookResult = ReturnType<typeof usePackageListLazyQuery>;
export type PackageListQueryResult = Apollo.QueryResult<PackageListQuery, PackageListQueryVariables>;
export const DisplayProductMediaListDocument = gql`
    query displayProductMediaList($displayProductMediaListId: Int!) {
  displayProductMediaList(id: $displayProductMediaListId) {
    id
    thumbnail
    src
    type
    width
    height
    originalSource
  }
}
    `;

/**
 * __useDisplayProductMediaListQuery__
 *
 * To run a query within a React component, call `useDisplayProductMediaListQuery` and pass it any options that fit your needs.
 * When your component renders, `useDisplayProductMediaListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDisplayProductMediaListQuery({
 *   variables: {
 *      displayProductMediaListId: // value for 'displayProductMediaListId'
 *   },
 * });
 */
export function useDisplayProductMediaListQuery(baseOptions: Apollo.QueryHookOptions<DisplayProductMediaListQuery, DisplayProductMediaListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DisplayProductMediaListQuery, DisplayProductMediaListQueryVariables>(DisplayProductMediaListDocument, options);
      }
export function useDisplayProductMediaListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DisplayProductMediaListQuery, DisplayProductMediaListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DisplayProductMediaListQuery, DisplayProductMediaListQueryVariables>(DisplayProductMediaListDocument, options);
        }
export type DisplayProductMediaListQueryHookResult = ReturnType<typeof useDisplayProductMediaListQuery>;
export type DisplayProductMediaListLazyQueryHookResult = ReturnType<typeof useDisplayProductMediaListLazyQuery>;
export type DisplayProductMediaListQueryResult = Apollo.QueryResult<DisplayProductMediaListQuery, DisplayProductMediaListQueryVariables>;
export const CategoryListDocument = gql`
    query categoryList {
  categoryList {
    id
    name {
      en
    }
    parentID
    subCategory
  }
}
    `;

/**
 * __useCategoryListQuery__
 *
 * To run a query within a React component, call `useCategoryListQuery` and pass it any options that fit your needs.
 * When your component renders, `useCategoryListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCategoryListQuery({
 *   variables: {
 *   },
 * });
 */
export function useCategoryListQuery(baseOptions?: Apollo.QueryHookOptions<CategoryListQuery, CategoryListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CategoryListQuery, CategoryListQueryVariables>(CategoryListDocument, options);
      }
export function useCategoryListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CategoryListQuery, CategoryListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CategoryListQuery, CategoryListQueryVariables>(CategoryListDocument, options);
        }
export type CategoryListQueryHookResult = ReturnType<typeof useCategoryListQuery>;
export type CategoryListLazyQueryHookResult = ReturnType<typeof useCategoryListLazyQuery>;
export type CategoryListQueryResult = Apollo.QueryResult<CategoryListQuery, CategoryListQueryVariables>;
export const RecommendProductCategoryListDocument = gql`
    query recommendProductCategoryList($keyword: String!) {
  recommendProductCategoryList(keyword: $keyword)
}
    `;

/**
 * __useRecommendProductCategoryListQuery__
 *
 * To run a query within a React component, call `useRecommendProductCategoryListQuery` and pass it any options that fit your needs.
 * When your component renders, `useRecommendProductCategoryListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRecommendProductCategoryListQuery({
 *   variables: {
 *      keyword: // value for 'keyword'
 *   },
 * });
 */
export function useRecommendProductCategoryListQuery(baseOptions: Apollo.QueryHookOptions<RecommendProductCategoryListQuery, RecommendProductCategoryListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RecommendProductCategoryListQuery, RecommendProductCategoryListQueryVariables>(RecommendProductCategoryListDocument, options);
      }
export function useRecommendProductCategoryListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RecommendProductCategoryListQuery, RecommendProductCategoryListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RecommendProductCategoryListQuery, RecommendProductCategoryListQueryVariables>(RecommendProductCategoryListDocument, options);
        }
export type RecommendProductCategoryListQueryHookResult = ReturnType<typeof useRecommendProductCategoryListQuery>;
export type RecommendProductCategoryListLazyQueryHookResult = ReturnType<typeof useRecommendProductCategoryListLazyQuery>;
export type RecommendProductCategoryListQueryResult = Apollo.QueryResult<RecommendProductCategoryListQuery, RecommendProductCategoryListQueryVariables>;
export const ProductListCountDocument = gql`
    query productListCount {
  productListCount {
    approved
    unverified
    reviewing
    rejected
    toRestock
    restocking
  }
}
    `;

/**
 * __useProductListCountQuery__
 *
 * To run a query within a React component, call `useProductListCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductListCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductListCountQuery({
 *   variables: {
 *   },
 * });
 */
export function useProductListCountQuery(baseOptions?: Apollo.QueryHookOptions<ProductListCountQuery, ProductListCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductListCountQuery, ProductListCountQueryVariables>(ProductListCountDocument, options);
      }
export function useProductListCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductListCountQuery, ProductListCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductListCountQuery, ProductListCountQueryVariables>(ProductListCountDocument, options);
        }
export type ProductListCountQueryHookResult = ReturnType<typeof useProductListCountQuery>;
export type ProductListCountLazyQueryHookResult = ReturnType<typeof useProductListCountLazyQuery>;
export type ProductListCountQueryResult = Apollo.QueryResult<ProductListCountQuery, ProductListCountQueryVariables>;
export const SupplierRegisterReviewDocument = gql`
    query supplierRegisterReview($verifyToken: String!) {
  supplierRegisterReview(verifyToken: $verifyToken) {
    address
    bankAccHolderName
    bankAccNumber
    bankName
    brandsNames
    categoryIds
    companyName
    companyRegisterNumber
    contact
    coordLat
    coordLng
    fiscalCodeNumber
    id
    origin
    role
    vat
    zoneId
  }
}
    `;

/**
 * __useSupplierRegisterReviewQuery__
 *
 * To run a query within a React component, call `useSupplierRegisterReviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useSupplierRegisterReviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSupplierRegisterReviewQuery({
 *   variables: {
 *      verifyToken: // value for 'verifyToken'
 *   },
 * });
 */
export function useSupplierRegisterReviewQuery(baseOptions: Apollo.QueryHookOptions<SupplierRegisterReviewQuery, SupplierRegisterReviewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SupplierRegisterReviewQuery, SupplierRegisterReviewQueryVariables>(SupplierRegisterReviewDocument, options);
      }
export function useSupplierRegisterReviewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SupplierRegisterReviewQuery, SupplierRegisterReviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SupplierRegisterReviewQuery, SupplierRegisterReviewQueryVariables>(SupplierRegisterReviewDocument, options);
        }
export type SupplierRegisterReviewQueryHookResult = ReturnType<typeof useSupplierRegisterReviewQuery>;
export type SupplierRegisterReviewLazyQueryHookResult = ReturnType<typeof useSupplierRegisterReviewLazyQuery>;
export type SupplierRegisterReviewQueryResult = Apollo.QueryResult<SupplierRegisterReviewQuery, SupplierRegisterReviewQueryVariables>;
export const GeocodeAddressDocument = gql`
    query geocodeAddress($lat: String, $lng: String) {
  geocodeAddress(lat: $lat, lng: $lng)
}
    `;

/**
 * __useGeocodeAddressQuery__
 *
 * To run a query within a React component, call `useGeocodeAddressQuery` and pass it any options that fit your needs.
 * When your component renders, `useGeocodeAddressQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGeocodeAddressQuery({
 *   variables: {
 *      lat: // value for 'lat'
 *      lng: // value for 'lng'
 *   },
 * });
 */
export function useGeocodeAddressQuery(baseOptions?: Apollo.QueryHookOptions<GeocodeAddressQuery, GeocodeAddressQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GeocodeAddressQuery, GeocodeAddressQueryVariables>(GeocodeAddressDocument, options);
      }
export function useGeocodeAddressLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GeocodeAddressQuery, GeocodeAddressQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GeocodeAddressQuery, GeocodeAddressQueryVariables>(GeocodeAddressDocument, options);
        }
export type GeocodeAddressQueryHookResult = ReturnType<typeof useGeocodeAddressQuery>;
export type GeocodeAddressLazyQueryHookResult = ReturnType<typeof useGeocodeAddressLazyQuery>;
export type GeocodeAddressQueryResult = Apollo.QueryResult<GeocodeAddressQuery, GeocodeAddressQueryVariables>;
export const MapSuggestionLatLngDocument = gql`
    query mapSuggestionLatLng($lat: Float, $lng: Float) {
  mapSuggestionLatLng(lat: $lat, lng: $lng) {
    lat
    lng
    name
    placeId
  }
}
    `;

/**
 * __useMapSuggestionLatLngQuery__
 *
 * To run a query within a React component, call `useMapSuggestionLatLngQuery` and pass it any options that fit your needs.
 * When your component renders, `useMapSuggestionLatLngQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMapSuggestionLatLngQuery({
 *   variables: {
 *      lat: // value for 'lat'
 *      lng: // value for 'lng'
 *   },
 * });
 */
export function useMapSuggestionLatLngQuery(baseOptions?: Apollo.QueryHookOptions<MapSuggestionLatLngQuery, MapSuggestionLatLngQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MapSuggestionLatLngQuery, MapSuggestionLatLngQueryVariables>(MapSuggestionLatLngDocument, options);
      }
export function useMapSuggestionLatLngLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MapSuggestionLatLngQuery, MapSuggestionLatLngQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MapSuggestionLatLngQuery, MapSuggestionLatLngQueryVariables>(MapSuggestionLatLngDocument, options);
        }
export type MapSuggestionLatLngQueryHookResult = ReturnType<typeof useMapSuggestionLatLngQuery>;
export type MapSuggestionLatLngLazyQueryHookResult = ReturnType<typeof useMapSuggestionLatLngLazyQuery>;
export type MapSuggestionLatLngQueryResult = Apollo.QueryResult<MapSuggestionLatLngQuery, MapSuggestionLatLngQueryVariables>;
export const MapSuggestionPlaceDocument = gql`
    query mapSuggestionPlace($keyword: String) {
  mapSuggestionPlace(keyword: $keyword) {
    name
    placeId
  }
}
    `;

/**
 * __useMapSuggestionPlaceQuery__
 *
 * To run a query within a React component, call `useMapSuggestionPlaceQuery` and pass it any options that fit your needs.
 * When your component renders, `useMapSuggestionPlaceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMapSuggestionPlaceQuery({
 *   variables: {
 *      keyword: // value for 'keyword'
 *   },
 * });
 */
export function useMapSuggestionPlaceQuery(baseOptions?: Apollo.QueryHookOptions<MapSuggestionPlaceQuery, MapSuggestionPlaceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MapSuggestionPlaceQuery, MapSuggestionPlaceQueryVariables>(MapSuggestionPlaceDocument, options);
      }
export function useMapSuggestionPlaceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MapSuggestionPlaceQuery, MapSuggestionPlaceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MapSuggestionPlaceQuery, MapSuggestionPlaceQueryVariables>(MapSuggestionPlaceDocument, options);
        }
export type MapSuggestionPlaceQueryHookResult = ReturnType<typeof useMapSuggestionPlaceQuery>;
export type MapSuggestionPlaceLazyQueryHookResult = ReturnType<typeof useMapSuggestionPlaceLazyQuery>;
export type MapSuggestionPlaceQueryResult = Apollo.QueryResult<MapSuggestionPlaceQuery, MapSuggestionPlaceQueryVariables>;
export const MerchantAnnouncementListDocument = gql`
    query merchantAnnouncementList($offset: Int, $limit: Int) {
  merchantAnnouncementList(offset: $offset, limit: $limit) {
    id
    createdAt
    title
    pushNotification
    contentInMarkdown
  }
}
    `;

/**
 * __useMerchantAnnouncementListQuery__
 *
 * To run a query within a React component, call `useMerchantAnnouncementListQuery` and pass it any options that fit your needs.
 * When your component renders, `useMerchantAnnouncementListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMerchantAnnouncementListQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useMerchantAnnouncementListQuery(baseOptions?: Apollo.QueryHookOptions<MerchantAnnouncementListQuery, MerchantAnnouncementListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MerchantAnnouncementListQuery, MerchantAnnouncementListQueryVariables>(MerchantAnnouncementListDocument, options);
      }
export function useMerchantAnnouncementListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MerchantAnnouncementListQuery, MerchantAnnouncementListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MerchantAnnouncementListQuery, MerchantAnnouncementListQueryVariables>(MerchantAnnouncementListDocument, options);
        }
export type MerchantAnnouncementListQueryHookResult = ReturnType<typeof useMerchantAnnouncementListQuery>;
export type MerchantAnnouncementListLazyQueryHookResult = ReturnType<typeof useMerchantAnnouncementListLazyQuery>;
export type MerchantAnnouncementListQueryResult = Apollo.QueryResult<MerchantAnnouncementListQuery, MerchantAnnouncementListQueryVariables>;
export const SupplierDocument = gql`
    query supplier($supplierId: Int!) {
  supplier(id: $supplierId) {
    id
    fulfilmentRate
    fulfilmentTime
    productAverageRating
    productRatingCount
    follower
    bankName
    bankAccountHolderName
    bankAccountNumber
    name
    logo
    isPaymentGateway
    paymentGatewayID
  }
}
    `;

/**
 * __useSupplierQuery__
 *
 * To run a query within a React component, call `useSupplierQuery` and pass it any options that fit your needs.
 * When your component renders, `useSupplierQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSupplierQuery({
 *   variables: {
 *      supplierId: // value for 'supplierId'
 *   },
 * });
 */
export function useSupplierQuery(baseOptions: Apollo.QueryHookOptions<SupplierQuery, SupplierQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SupplierQuery, SupplierQueryVariables>(SupplierDocument, options);
      }
export function useSupplierLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SupplierQuery, SupplierQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SupplierQuery, SupplierQueryVariables>(SupplierDocument, options);
        }
export type SupplierQueryHookResult = ReturnType<typeof useSupplierQuery>;
export type SupplierLazyQueryHookResult = ReturnType<typeof useSupplierLazyQuery>;
export type SupplierQueryResult = Apollo.QueryResult<SupplierQuery, SupplierQueryVariables>;
export const ProductGroupDocument = gql`
    query productGroup($id: Int!) {
  productGroup(id: $id) {
    id
    name
    products {
      id
      code
      thumbnail
      title
      price
      discount
    }
  }
}
    `;

/**
 * __useProductGroupQuery__
 *
 * To run a query within a React component, call `useProductGroupQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductGroupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductGroupQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useProductGroupQuery(baseOptions: Apollo.QueryHookOptions<ProductGroupQuery, ProductGroupQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductGroupQuery, ProductGroupQueryVariables>(ProductGroupDocument, options);
      }
export function useProductGroupLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductGroupQuery, ProductGroupQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductGroupQuery, ProductGroupQueryVariables>(ProductGroupDocument, options);
        }
export type ProductGroupQueryHookResult = ReturnType<typeof useProductGroupQuery>;
export type ProductGroupLazyQueryHookResult = ReturnType<typeof useProductGroupLazyQuery>;
export type ProductGroupQueryResult = Apollo.QueryResult<ProductGroupQuery, ProductGroupQueryVariables>;
export const ProductListV2OnlyCodeDocument = gql`
    query productListV2OnlyCode($productListType: ProductListType!, $filter: ProductListFilterV2, $search: ProductSearch, $page: PaginationInput, $orderBy: ProductOrderByInput, $viewBySku: Boolean) {
  productListV2(
    productListType: $productListType
    filter: $filter
    search: $search
    page: $page
    orderBy: $orderBy
    viewBySku: $viewBySku
  ) {
    data {
      id
      code
      picture
      title {
        en
      }
      price
      discount
    }
  }
}
    `;

/**
 * __useProductListV2OnlyCodeQuery__
 *
 * To run a query within a React component, call `useProductListV2OnlyCodeQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductListV2OnlyCodeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductListV2OnlyCodeQuery({
 *   variables: {
 *      productListType: // value for 'productListType'
 *      filter: // value for 'filter'
 *      search: // value for 'search'
 *      page: // value for 'page'
 *      orderBy: // value for 'orderBy'
 *      viewBySku: // value for 'viewBySku'
 *   },
 * });
 */
export function useProductListV2OnlyCodeQuery(baseOptions: Apollo.QueryHookOptions<ProductListV2OnlyCodeQuery, ProductListV2OnlyCodeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductListV2OnlyCodeQuery, ProductListV2OnlyCodeQueryVariables>(ProductListV2OnlyCodeDocument, options);
      }
export function useProductListV2OnlyCodeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductListV2OnlyCodeQuery, ProductListV2OnlyCodeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductListV2OnlyCodeQuery, ProductListV2OnlyCodeQueryVariables>(ProductListV2OnlyCodeDocument, options);
        }
export type ProductListV2OnlyCodeQueryHookResult = ReturnType<typeof useProductListV2OnlyCodeQuery>;
export type ProductListV2OnlyCodeLazyQueryHookResult = ReturnType<typeof useProductListV2OnlyCodeLazyQuery>;
export type ProductListV2OnlyCodeQueryResult = Apollo.QueryResult<ProductListV2OnlyCodeQuery, ProductListV2OnlyCodeQueryVariables>;
export const ProductGroupListDocument = gql`
    query productGroupList {
  productGroupList {
    products {
      code
      id
      price
      discount
      title
      thumbnail
    }
    id
    itemsCount
    name
  }
}
    `;

/**
 * __useProductGroupListQuery__
 *
 * To run a query within a React component, call `useProductGroupListQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductGroupListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductGroupListQuery({
 *   variables: {
 *   },
 * });
 */
export function useProductGroupListQuery(baseOptions?: Apollo.QueryHookOptions<ProductGroupListQuery, ProductGroupListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductGroupListQuery, ProductGroupListQueryVariables>(ProductGroupListDocument, options);
      }
export function useProductGroupListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductGroupListQuery, ProductGroupListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductGroupListQuery, ProductGroupListQueryVariables>(ProductGroupListDocument, options);
        }
export type ProductGroupListQueryHookResult = ReturnType<typeof useProductGroupListQuery>;
export type ProductGroupListLazyQueryHookResult = ReturnType<typeof useProductGroupListLazyQuery>;
export type ProductGroupListQueryResult = Apollo.QueryResult<ProductGroupListQuery, ProductGroupListQueryVariables>;
export const ProductReviewListDocument = gql`
    query productReviewList($productId: Int, $merchantId: Int) {
  productReviewList(productId: $productId, merchantId: $merchantId) {
    comment
    rating
    customer {
      id
      image
      name
    }
    id
    createdAt
    updatedAt
    attachments {
      src
      thumbnail
    }
  }
}
    `;

/**
 * __useProductReviewListQuery__
 *
 * To run a query within a React component, call `useProductReviewListQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductReviewListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductReviewListQuery({
 *   variables: {
 *      productId: // value for 'productId'
 *      merchantId: // value for 'merchantId'
 *   },
 * });
 */
export function useProductReviewListQuery(baseOptions?: Apollo.QueryHookOptions<ProductReviewListQuery, ProductReviewListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductReviewListQuery, ProductReviewListQueryVariables>(ProductReviewListDocument, options);
      }
export function useProductReviewListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductReviewListQuery, ProductReviewListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductReviewListQuery, ProductReviewListQueryVariables>(ProductReviewListDocument, options);
        }
export type ProductReviewListQueryHookResult = ReturnType<typeof useProductReviewListQuery>;
export type ProductReviewListLazyQueryHookResult = ReturnType<typeof useProductReviewListLazyQuery>;
export type ProductReviewListQueryResult = Apollo.QueryResult<ProductReviewListQuery, ProductReviewListQueryVariables>;
export const SupplierAdminDocument = gql`
    query supplierAdmin($supplierId: Int!) {
  supplier(id: $supplierId) {
    id
    subscription {
      id
      planId
      planName
      fee
      subscriptedDate
      expiredDate
      interval
    }
    fulfilmentRate
    fulfilmentTime
    productAverageRating
    productRatingCount
    follower
    bankName
    bankAccountHolderName
    bankAccountNumber
    name
    logo
    isPaymentGateway
    paymentGatewayID
  }
}
    `;

/**
 * __useSupplierAdminQuery__
 *
 * To run a query within a React component, call `useSupplierAdminQuery` and pass it any options that fit your needs.
 * When your component renders, `useSupplierAdminQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSupplierAdminQuery({
 *   variables: {
 *      supplierId: // value for 'supplierId'
 *   },
 * });
 */
export function useSupplierAdminQuery(baseOptions: Apollo.QueryHookOptions<SupplierAdminQuery, SupplierAdminQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SupplierAdminQuery, SupplierAdminQueryVariables>(SupplierAdminDocument, options);
      }
export function useSupplierAdminLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SupplierAdminQuery, SupplierAdminQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SupplierAdminQuery, SupplierAdminQueryVariables>(SupplierAdminDocument, options);
        }
export type SupplierAdminQueryHookResult = ReturnType<typeof useSupplierAdminQuery>;
export type SupplierAdminLazyQueryHookResult = ReturnType<typeof useSupplierAdminLazyQuery>;
export type SupplierAdminQueryResult = Apollo.QueryResult<SupplierAdminQuery, SupplierAdminQueryVariables>;
export const SupplierProductValidationV2Document = gql`
    query supplierProductValidationV2($content: JSON) {
  supplierProductValidationV2(content: $content) {
    message
    success
  }
}
    `;

/**
 * __useSupplierProductValidationV2Query__
 *
 * To run a query within a React component, call `useSupplierProductValidationV2Query` and pass it any options that fit your needs.
 * When your component renders, `useSupplierProductValidationV2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSupplierProductValidationV2Query({
 *   variables: {
 *      content: // value for 'content'
 *   },
 * });
 */
export function useSupplierProductValidationV2Query(baseOptions?: Apollo.QueryHookOptions<SupplierProductValidationV2Query, SupplierProductValidationV2QueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SupplierProductValidationV2Query, SupplierProductValidationV2QueryVariables>(SupplierProductValidationV2Document, options);
      }
export function useSupplierProductValidationV2LazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SupplierProductValidationV2Query, SupplierProductValidationV2QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SupplierProductValidationV2Query, SupplierProductValidationV2QueryVariables>(SupplierProductValidationV2Document, options);
        }
export type SupplierProductValidationV2QueryHookResult = ReturnType<typeof useSupplierProductValidationV2Query>;
export type SupplierProductValidationV2LazyQueryHookResult = ReturnType<typeof useSupplierProductValidationV2LazyQuery>;
export type SupplierProductValidationV2QueryResult = Apollo.QueryResult<SupplierProductValidationV2Query, SupplierProductValidationV2QueryVariables>;
export const SalesDetailBySalesStatusDocument = gql`
    query salesDetailBySalesStatus($salesStatus: SALES_STATUS, $offset: Int = 0, $limit: Int = 30, $day: Int, $startDate: String, $endDate: String) {
  salesDetailBySalesStatus(
    offset: $offset
    limit: $limit
    day: $day
    salesStatus: $salesStatus
    startDate: $startDate
    endDate: $endDate
  ) {
    data {
      skuStock
      uuid
      itemID
      status
      customerID
      code
      title
      supplierCode
      picture
      color
      size
      orderDate
      fullPrice
      prepaidAmount
      log {
        description
        date
      }
      deliveryFee
      handlingFee
      commission
      discount
      fbl
      remoteStock
    }
    page {
      total
    }
  }
}
    `;

/**
 * __useSalesDetailBySalesStatusQuery__
 *
 * To run a query within a React component, call `useSalesDetailBySalesStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useSalesDetailBySalesStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSalesDetailBySalesStatusQuery({
 *   variables: {
 *      salesStatus: // value for 'salesStatus'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      day: // value for 'day'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useSalesDetailBySalesStatusQuery(baseOptions?: Apollo.QueryHookOptions<SalesDetailBySalesStatusQuery, SalesDetailBySalesStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SalesDetailBySalesStatusQuery, SalesDetailBySalesStatusQueryVariables>(SalesDetailBySalesStatusDocument, options);
      }
export function useSalesDetailBySalesStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SalesDetailBySalesStatusQuery, SalesDetailBySalesStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SalesDetailBySalesStatusQuery, SalesDetailBySalesStatusQueryVariables>(SalesDetailBySalesStatusDocument, options);
        }
export type SalesDetailBySalesStatusQueryHookResult = ReturnType<typeof useSalesDetailBySalesStatusQuery>;
export type SalesDetailBySalesStatusLazyQueryHookResult = ReturnType<typeof useSalesDetailBySalesStatusLazyQuery>;
export type SalesDetailBySalesStatusQueryResult = Apollo.QueryResult<SalesDetailBySalesStatusQuery, SalesDetailBySalesStatusQueryVariables>;
export const SupplierBankChangeLogDocument = gql`
    query supplierBankChangeLog($supplierId: Int!) {
  supplierBankChangeLog(supplierId: $supplierId) {
    id
    supplierId
    oldValue
    newValue
    changedDate
  }
}
    `;

/**
 * __useSupplierBankChangeLogQuery__
 *
 * To run a query within a React component, call `useSupplierBankChangeLogQuery` and pass it any options that fit your needs.
 * When your component renders, `useSupplierBankChangeLogQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSupplierBankChangeLogQuery({
 *   variables: {
 *      supplierId: // value for 'supplierId'
 *   },
 * });
 */
export function useSupplierBankChangeLogQuery(baseOptions: Apollo.QueryHookOptions<SupplierBankChangeLogQuery, SupplierBankChangeLogQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SupplierBankChangeLogQuery, SupplierBankChangeLogQueryVariables>(SupplierBankChangeLogDocument, options);
      }
export function useSupplierBankChangeLogLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SupplierBankChangeLogQuery, SupplierBankChangeLogQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SupplierBankChangeLogQuery, SupplierBankChangeLogQueryVariables>(SupplierBankChangeLogDocument, options);
        }
export type SupplierBankChangeLogQueryHookResult = ReturnType<typeof useSupplierBankChangeLogQuery>;
export type SupplierBankChangeLogLazyQueryHookResult = ReturnType<typeof useSupplierBankChangeLogLazyQuery>;
export type SupplierBankChangeLogQueryResult = Apollo.QueryResult<SupplierBankChangeLogQuery, SupplierBankChangeLogQueryVariables>;
export const BrandListDocument = gql`
    query brandList($status: BrandStatus, $limit: Int!, $owned: Boolean, $merchantId: Int, $name: String, $verified: Boolean) {
  brandList(
    status: $status
    limit: $limit
    owned: $owned
    merchantId: $merchantId
    name: $name
    verified: $verified
  ) {
    id
    alias
    name
    banner
    picture
    description
    status
  }
}
    `;

/**
 * __useBrandListQuery__
 *
 * To run a query within a React component, call `useBrandListQuery` and pass it any options that fit your needs.
 * When your component renders, `useBrandListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBrandListQuery({
 *   variables: {
 *      status: // value for 'status'
 *      limit: // value for 'limit'
 *      owned: // value for 'owned'
 *      merchantId: // value for 'merchantId'
 *      name: // value for 'name'
 *      verified: // value for 'verified'
 *   },
 * });
 */
export function useBrandListQuery(baseOptions: Apollo.QueryHookOptions<BrandListQuery, BrandListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BrandListQuery, BrandListQueryVariables>(BrandListDocument, options);
      }
export function useBrandListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BrandListQuery, BrandListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BrandListQuery, BrandListQueryVariables>(BrandListDocument, options);
        }
export type BrandListQueryHookResult = ReturnType<typeof useBrandListQuery>;
export type BrandListLazyQueryHookResult = ReturnType<typeof useBrandListLazyQuery>;
export type BrandListQueryResult = Apollo.QueryResult<BrandListQuery, BrandListQueryVariables>;
export const ProductDocument = gql`
    query product($productId: Int!) {
  product(id: $productId) {
    id
    code
    title {
      en
      km
      zh
    }
    price
    discount
    picture
  }
}
    `;

/**
 * __useProductQuery__
 *
 * To run a query within a React component, call `useProductQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductQuery({
 *   variables: {
 *      productId: // value for 'productId'
 *   },
 * });
 */
export function useProductQuery(baseOptions: Apollo.QueryHookOptions<ProductQuery, ProductQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductQuery, ProductQueryVariables>(ProductDocument, options);
      }
export function useProductLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductQuery, ProductQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductQuery, ProductQueryVariables>(ProductDocument, options);
        }
export type ProductQueryHookResult = ReturnType<typeof useProductQuery>;
export type ProductLazyQueryHookResult = ReturnType<typeof useProductLazyQuery>;
export type ProductQueryResult = Apollo.QueryResult<ProductQuery, ProductQueryVariables>;
export const CategoryAnalyticsDocument = gql`
    query categoryAnalytics($categoryId: Int) {
  categoryAnalytics(categoryId: $categoryId) {
    active
    inStock
    sale
    category {
      id
      name {
        en
      }
      parentId
    }
  }
}
    `;

/**
 * __useCategoryAnalyticsQuery__
 *
 * To run a query within a React component, call `useCategoryAnalyticsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCategoryAnalyticsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCategoryAnalyticsQuery({
 *   variables: {
 *      categoryId: // value for 'categoryId'
 *   },
 * });
 */
export function useCategoryAnalyticsQuery(baseOptions?: Apollo.QueryHookOptions<CategoryAnalyticsQuery, CategoryAnalyticsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CategoryAnalyticsQuery, CategoryAnalyticsQueryVariables>(CategoryAnalyticsDocument, options);
      }
export function useCategoryAnalyticsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CategoryAnalyticsQuery, CategoryAnalyticsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CategoryAnalyticsQuery, CategoryAnalyticsQueryVariables>(CategoryAnalyticsDocument, options);
        }
export type CategoryAnalyticsQueryHookResult = ReturnType<typeof useCategoryAnalyticsQuery>;
export type CategoryAnalyticsLazyQueryHookResult = ReturnType<typeof useCategoryAnalyticsLazyQuery>;
export type CategoryAnalyticsQueryResult = Apollo.QueryResult<CategoryAnalyticsQuery, CategoryAnalyticsQueryVariables>;
export const SupplierOrderCountByStatusDocument = gql`
    query supplierOrderCountByStatus {
  supplierOrderCountByStatus
}
    `;

/**
 * __useSupplierOrderCountByStatusQuery__
 *
 * To run a query within a React component, call `useSupplierOrderCountByStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useSupplierOrderCountByStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSupplierOrderCountByStatusQuery({
 *   variables: {
 *   },
 * });
 */
export function useSupplierOrderCountByStatusQuery(baseOptions?: Apollo.QueryHookOptions<SupplierOrderCountByStatusQuery, SupplierOrderCountByStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SupplierOrderCountByStatusQuery, SupplierOrderCountByStatusQueryVariables>(SupplierOrderCountByStatusDocument, options);
      }
export function useSupplierOrderCountByStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SupplierOrderCountByStatusQuery, SupplierOrderCountByStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SupplierOrderCountByStatusQuery, SupplierOrderCountByStatusQueryVariables>(SupplierOrderCountByStatusDocument, options);
        }
export type SupplierOrderCountByStatusQueryHookResult = ReturnType<typeof useSupplierOrderCountByStatusQuery>;
export type SupplierOrderCountByStatusLazyQueryHookResult = ReturnType<typeof useSupplierOrderCountByStatusLazyQuery>;
export type SupplierOrderCountByStatusQueryResult = Apollo.QueryResult<SupplierOrderCountByStatusQuery, SupplierOrderCountByStatusQueryVariables>;
export const ProductImageSearchDocument = gql`
    query productImageSearch($file: Upload!) {
  productImageSearch(file: $file)
}
    `;

/**
 * __useProductImageSearchQuery__
 *
 * To run a query within a React component, call `useProductImageSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductImageSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductImageSearchQuery({
 *   variables: {
 *      file: // value for 'file'
 *   },
 * });
 */
export function useProductImageSearchQuery(baseOptions: Apollo.QueryHookOptions<ProductImageSearchQuery, ProductImageSearchQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductImageSearchQuery, ProductImageSearchQueryVariables>(ProductImageSearchDocument, options);
      }
export function useProductImageSearchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductImageSearchQuery, ProductImageSearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductImageSearchQuery, ProductImageSearchQueryVariables>(ProductImageSearchDocument, options);
        }
export type ProductImageSearchQueryHookResult = ReturnType<typeof useProductImageSearchQuery>;
export type ProductImageSearchLazyQueryHookResult = ReturnType<typeof useProductImageSearchLazyQuery>;
export type ProductImageSearchQueryResult = Apollo.QueryResult<ProductImageSearchQuery, ProductImageSearchQueryVariables>;
export const ProductImageSearchResultDocument = gql`
    query productImageSearchResult($hash: String!) {
  productImageSearchResult(hash: $hash) {
    id
  }
}
    `;

/**
 * __useProductImageSearchResultQuery__
 *
 * To run a query within a React component, call `useProductImageSearchResultQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductImageSearchResultQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductImageSearchResultQuery({
 *   variables: {
 *      hash: // value for 'hash'
 *   },
 * });
 */
export function useProductImageSearchResultQuery(baseOptions: Apollo.QueryHookOptions<ProductImageSearchResultQuery, ProductImageSearchResultQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductImageSearchResultQuery, ProductImageSearchResultQueryVariables>(ProductImageSearchResultDocument, options);
      }
export function useProductImageSearchResultLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductImageSearchResultQuery, ProductImageSearchResultQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductImageSearchResultQuery, ProductImageSearchResultQueryVariables>(ProductImageSearchResultDocument, options);
        }
export type ProductImageSearchResultQueryHookResult = ReturnType<typeof useProductImageSearchResultQuery>;
export type ProductImageSearchResultLazyQueryHookResult = ReturnType<typeof useProductImageSearchResultLazyQuery>;
export type ProductImageSearchResultQueryResult = Apollo.QueryResult<ProductImageSearchResultQuery, ProductImageSearchResultQueryVariables>;